webpackJsonp([1],Array(18).concat([
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1005),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Full__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Full___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__containers_Full__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_coreui_Charts__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_coreui_Charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_coreui_Charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_coreui_Widgets__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_coreui_Widgets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_coreui_Widgets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_coreui_Buttons__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_coreui_Buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_coreui_Buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_coreui_SocialButtons__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_coreui_SocialButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_coreui_SocialButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_coreui_Cards__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_coreui_Cards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_coreui_Cards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_coreui_Forms__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_coreui_Forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_coreui_Forms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_coreui_Modals__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_coreui_Modals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_coreui_Modals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_coreui_Switches__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_coreui_Switches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_coreui_Switches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_coreui_Tables__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_coreui_Tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_coreui_Tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_coreui_icons_FontAwesome__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_coreui_icons_FontAwesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_coreui_icons_FontAwesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_coreui_icons_SimpleLineIcons__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_coreui_icons_SimpleLineIcons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_coreui_icons_SimpleLineIcons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_other_Page404__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_other_Page404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_other_Page404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_other_Page500__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_other_Page500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_other_Page500__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_other_Register__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_other_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_other_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_dashboard_Dashboard__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_dashboard_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_dashboard_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_doctor_steps_General__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_doctor_steps_General___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_doctor_steps_General__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_doctor_steps_Experience__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_doctor_steps_Experience___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_doctor_steps_Experience__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_doctor_steps_Schedules__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_doctor_steps_Schedules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_doctor_steps_Schedules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_doctor_steps_Education__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_doctor_steps_Education___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_doctor_steps_Education__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_doctor_steps_Info__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_doctor_steps_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_doctor_steps_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_doctor_Setting__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_doctor_Setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_doctor_Setting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_clinic_steps_Clinic__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_clinic_steps_Clinic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_clinic_steps_Clinic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_clinic_steps_SingleForm__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_clinic_steps_SingleForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_clinic_steps_SingleForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_clinic_Setting__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_clinic_Setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_clinic_Setting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_clinic_leave_LeaveList__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_clinic_leave_LeaveList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_clinic_leave_LeaveList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_clinic_leave_LeaveDetail__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_clinic_leave_LeaveDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_clinic_leave_LeaveDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_patient_Patient__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_patient_Patient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_patient_Patient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_article_Article__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_article_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__pages_article_Article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_appointment_Appointment__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_appointment_Appointment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__pages_appointment_Appointment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_appointment_AppointmentCalendar__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_appointment_AppointmentCalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__pages_appointment_AppointmentCalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_appointment_AppointmentDetail__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_appointment_AppointmentDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__pages_appointment_AppointmentDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_feedback_Feedback__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_feedback_Feedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__pages_feedback_Feedback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_report_Report__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_report_Report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__pages_report_Report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_auth_Login__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__pages_auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_package_Package__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_package_Package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__pages_package_Package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_dashboard_ClinicMulti__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_dashboard_ClinicMulti___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__pages_dashboard_ClinicMulti__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_package_payment_step1__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_package_payment_step1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__pages_package_payment_step1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_package_payment_step2__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_package_payment_step2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__pages_package_payment_step2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_package_payment_step3__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_package_payment_step3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__pages_package_payment_step3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_package_payment_direct__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_package_payment_direct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__pages_package_payment_direct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_package_MySubscription__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_package_MySubscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__pages_package_MySubscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_broadcast_Broadcast__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_broadcast_Broadcast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__pages_broadcast_Broadcast__);







































































__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_4__containers_Full___default.a,
    children: [{
      path: 'clinic_multi',
      name: 'Clinic Multi',
      component: __WEBPACK_IMPORTED_MODULE_40__pages_dashboard_ClinicMulti___default.a,
      props: true
    }, {
      path: 'doctor',
      redirect: '/doctor/step1/me',
      name: 'Doctor',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'step1/:id',
        name: 'Step 1',
        component: __WEBPACK_IMPORTED_MODULE_20__pages_doctor_steps_General___default.a,
        props: true
      }, {
        path: 'step2/:id',
        name: 'Step 2',
        component: __WEBPACK_IMPORTED_MODULE_21__pages_doctor_steps_Experience___default.a,
        props: true
      }, {
        path: 'step3/:id',
        name: 'Step 3',
        component: __WEBPACK_IMPORTED_MODULE_22__pages_doctor_steps_Schedules___default.a,
        props: true
      }, {
        path: 'step4/:id',
        name: 'Step 4',
        props: true,
        component: __WEBPACK_IMPORTED_MODULE_23__pages_doctor_steps_Education___default.a
      }, {
        path: 'step5/:id',
        name: 'Step 5',
        props: true,
        component: __WEBPACK_IMPORTED_MODULE_24__pages_doctor_steps_Info___default.a
      }]
    }, {
      path: 'doctor/leave',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '',
        name: 'DoctorLeaveList',
        component: __WEBPACK_IMPORTED_MODULE_29__pages_clinic_leave_LeaveList___default.a
      }, {
        path: 'add',
        props: true,
        name: 'DoctorLeaveAdd',
        component: __WEBPACK_IMPORTED_MODULE_30__pages_clinic_leave_LeaveDetail___default.a
      }, {
        path: ':id',
        props: true,
        name: 'DoctorLeaveDetail',
        component: __WEBPACK_IMPORTED_MODULE_30__pages_clinic_leave_LeaveDetail___default.a
      }]
    }, {
      path: 'doctor/setting',
      props: true,
      name: 'DoctorSetting',
      component: __WEBPACK_IMPORTED_MODULE_25__pages_doctor_Setting___default.a
    }, {
      path: 'clinic/setting',
      props: true,
      name: 'ClinicSetting',
      component: __WEBPACK_IMPORTED_MODULE_28__pages_clinic_Setting___default.a
    }, {
      path: 'clinic/leave',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '',
        name: 'LeaveList',
        component: __WEBPACK_IMPORTED_MODULE_29__pages_clinic_leave_LeaveList___default.a
      }, {
        path: 'add',
        props: true,
        name: 'LeaveAdd',
        component: __WEBPACK_IMPORTED_MODULE_30__pages_clinic_leave_LeaveDetail___default.a
      }, {
        path: ':doctor_id/:id',
        props: true,
        name: 'LeaveDetail',
        component: __WEBPACK_IMPORTED_MODULE_30__pages_clinic_leave_LeaveDetail___default.a
      }]
    }, {
      path: 'clinic/steps/:step',
      props: true,
      name: 'Clinic',
      component: __WEBPACK_IMPORTED_MODULE_26__pages_clinic_steps_Clinic___default.a
    }, {
      path: 'clinic/:page',
      props: true,
      name: 'ClinicSingleForm',
      component: __WEBPACK_IMPORTED_MODULE_27__pages_clinic_steps_SingleForm___default.a
    }, {
      path: 'patient',
      name: 'Patient',
      component: __WEBPACK_IMPORTED_MODULE_31__pages_patient_Patient___default.a
    }, {
      path: 'patient/:id',
      props: true,
      name: 'PatientId',
      component: __WEBPACK_IMPORTED_MODULE_31__pages_patient_Patient___default.a
    }, {
      path: 'article',
      name: 'article',
      component: __WEBPACK_IMPORTED_MODULE_32__pages_article_Article___default.a
    }, {
      path: 'article/:id',
      props: true,
      name: 'ArticleDetail',
      component: __WEBPACK_IMPORTED_MODULE_32__pages_article_Article___default.a
    }, {
      path: 'appointments',
      name: 'appointments',
      component: __WEBPACK_IMPORTED_MODULE_34__pages_appointment_AppointmentCalendar___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        next();
      }
    }, {
      path: 'appointment',
      name: 'appointments_calendar',
      component: __WEBPACK_IMPORTED_MODULE_34__pages_appointment_AppointmentCalendar___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        next();
      }
    }, {
      path: 'appointment_m',
      name: 'appointment_mobile',
      component: __WEBPACK_IMPORTED_MODULE_33__pages_appointment_Appointment___default.a
    }, {
      path: 'appointments/:id',
      name: 'appointment_detail',
      component: __WEBPACK_IMPORTED_MODULE_35__pages_appointment_AppointmentDetail___default.a
    }, {
      path: 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_19__pages_dashboard_Dashboard___default.a
    }, {
      path: 'report',
      name: 'Report',
      component: __WEBPACK_IMPORTED_MODULE_37__pages_report_Report___default.a
    }, {
      path: 'package',
      name: 'Package',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/',
        name: 'Package',
        component: __WEBPACK_IMPORTED_MODULE_39__pages_package_Package___default.a
      }, {
        path: 'me',
        name: 'MySubscription',
        component: __WEBPACK_IMPORTED_MODULE_45__pages_package_MySubscription___default.a
      }, {
        path: 'payment/direct',
        name: 'DirectPayment',
        component: __WEBPACK_IMPORTED_MODULE_44__pages_package_payment_direct___default.a
      }, {
        path: 'payment/step1',
        name: 'PaymentStep1',
        component: __WEBPACK_IMPORTED_MODULE_41__pages_package_payment_step1___default.a
      }, {
        path: 'payment/step2',
        name: 'PaymentStep2',
        component: __WEBPACK_IMPORTED_MODULE_42__pages_package_payment_step2___default.a
      }, {
        path: 'payment/step3',
        name: 'PaymentStep3',
        component: __WEBPACK_IMPORTED_MODULE_43__pages_package_payment_step3___default.a
      }]
    }, {
      path: 'feedback',
      props: true,
      name: 'Feedback',
      component: __WEBPACK_IMPORTED_MODULE_36__pages_feedback_Feedback___default.a
    }, {
      path: 'broadcast',
      props: true,
      name: 'Broadcast',
      component: __WEBPACK_IMPORTED_MODULE_46__pages_broadcast_Broadcast___default.a
    }, {
      path: 'charts',
      name: 'Charts',
      component: __WEBPACK_IMPORTED_MODULE_5__pages_coreui_Charts___default.a
    }, {
      path: 'widgets',
      name: 'Widgets',
      component: __WEBPACK_IMPORTED_MODULE_6__pages_coreui_Widgets___default.a
    }, {
      path: 'components',
      redirect: '/components/buttons',
      name: 'Components',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'buttons',
        name: 'Buttons',
        component: __WEBPACK_IMPORTED_MODULE_7__pages_coreui_Buttons___default.a
      }, {
        path: 'social-buttons',
        name: 'Social Buttons',
        component: __WEBPACK_IMPORTED_MODULE_8__pages_coreui_SocialButtons___default.a
      }, {
        path: 'cards',
        name: 'Cards',
        component: __WEBPACK_IMPORTED_MODULE_9__pages_coreui_Cards___default.a
      }, {
        path: 'forms',
        name: 'Forms',
        component: __WEBPACK_IMPORTED_MODULE_10__pages_coreui_Forms___default.a
      }, {
        path: 'modals',
        name: 'Modals',
        component: __WEBPACK_IMPORTED_MODULE_11__pages_coreui_Modals___default.a
      }, {
        path: 'switches',
        name: 'Switches',
        component: __WEBPACK_IMPORTED_MODULE_12__pages_coreui_Switches___default.a
      }, {
        path: 'tables',
        name: 'Tables',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_coreui_Tables___default.a
      }]
    }, {
      path: 'icons',
      redirect: '/icons/font-awesome',
      name: 'Icons',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'font-awesome',
        name: 'Font Awesome',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_coreui_icons_FontAwesome___default.a
      }, {
        path: 'simple-line-icons',
        name: 'Simple Line Icons',
        component: __WEBPACK_IMPORTED_MODULE_15__pages_coreui_icons_SimpleLineIcons___default.a
      }]
    }]
  }, {
    path: '/pages',
    redirect: '/pages/p404',
    name: 'Pages',
    component: {
      render: function render(c) {
        return c('router-view');
      }
    },
    children: [{
      path: '404',
      name: 'Page404',
      component: __WEBPACK_IMPORTED_MODULE_16__pages_other_Page404___default.a
    }, {
      path: '500',
      name: 'Page500',
      component: __WEBPACK_IMPORTED_MODULE_17__pages_other_Page500___default.a
    }, {
      path: 'register',
      name: 'Register',
      component: __WEBPACK_IMPORTED_MODULE_18__pages_other_Register___default.a
    }]
  }, {
    path: '/auth/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_38__pages_auth_Login___default.a
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.query.lang) {
    UserStore.changeLang(to.query.lang);
  }

  var fetchedUser = false;
  var user = UserStore.getUser();

  if (!UserStore.signedIn()) {
    fetchedUser = true;
  }if (to.query.ref_clinic_id && UserStore.store.isClinicMulti() && !UserStore.store.user.clinic) {
    fetchedUser = true;
  } else if (to.query.ref_clinic_id && user && user.clinic && user.clinic.id && parseInt(user.clinic.id) !== parseInt(to.query.ref_clinic_id)) {
    fetchedUser = true;
  }

  if (fetchedUser) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get("https://zeekdoc.com" + '/api/v1/users/me', { params: {
        clinic_id: to.query.ref_clinic_id
      } }).then(function (res) {
      UserStore.setUser(res.data);
      if (to.path === '/' && UserStore.store.isClinicMulti()) {
        next({ path: '/clinic_multi' });
      } else if (to.path === '/' && UserStore.store.isDoctor()) {
        next({ path: '/doctor' });
      } else if (to.path === '/' && UserStore.store.isClinic()) {
        next({ path: '/clinic/general' });
      } else {
        next();
      }
    }).catch(function () {
      UserStore.store.redirectPath = to.path;

      if (to.path === '/auth/login') {
        next();
      } else {
        next({ path: '/auth/login' });
      }
    });
  } else {
    if (to.path === '/' && UserStore.store.isClinicMulti()) {
      next({ path: '/clinic_multi' });
    } else if (to.path === '/' && UserStore.store.isDoctor()) {
      next({ path: '/doctor' });
    } else if (to.path === '/' && UserStore.store.isClinic()) {
      next({ path: '/clinic/general' });
    } else {
      next();
    }
  }
});

/* harmony default export */ __webpack_exports__["b"] = (router);

var UserStore = {
  install: function install(_Vue, options) {
    _Vue.prototype.$guser = UserStore.store;
  },
  setUser: function setUser(user) {
    UserStore.store.user = user;
  },
  getUser: function getUser() {
    return UserStore.store.user;
  },
  signedIn: function signedIn() {
    try {
      return !!UserStore.store.user.id;
    } catch (e) {
      return false;
    }
  },

  store: {
    user: {},
    signout: function signout(redirectUrl) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post("https://zeekdoc.com" + '/api/v1/users/signout');

              case 3:
                UserStore.store.user = {};
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                console.info(_context.t0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    isDoctor: function isDoctor() {
      try {
        return !!UserStore.store.user.roles.find(function (r) {
          return r.role_name === 'Doctor';
        }).id;
      } catch (e) {
        return false;
      }
    },
    isClinic: function isClinic(router) {
      try {
        if (router && router.query.ref_clinic_id) {
          return this.isClinicMulti;
        } else {
          return !!UserStore.store.user.roles.find(function (r) {
            return r.role_name === 'Clinic';
          }).id;
        }
      } catch (e) {
        return false;
      }
    },
    isClinicMulti: function isClinicMulti() {
      try {
        return !!UserStore.store.user.roles.find(function (r) {
          return r.role_name === 'ClinicMulti';
        }).id;
      } catch (e) {
        return false;
      }
    },
    isActive: function isActive() {
      if (UserStore.store.isDoctor() && UserStore.store.user.doctor.active) {
        return true;
      } else if (UserStore.store.user.clinic && UserStore.store.user.clinic.active) {
        return true;
      }
      return false;
    },
    isPremiumAccount: function isPremiumAccount() {
      if (UserStore.store.isDoctor() && UserStore.store.user.doctor.account_status === 'premium') {
        return true;
      } else if (UserStore.store.user.clinic && UserStore.store.user.clinic.account_status === 'premium') {
        return true;
      }
      return false;
    },
    hasSignedIn: function hasSignedIn() {
      try {
        return !!UserStore.store.user.id;
      } catch (e) {
        return false;
      }
    },
    changeLang: function changeLang(lang) {}
  }
};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(980),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(1000),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(724)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(1034),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  computed: {
    doctor_key: function doctor_key() {
      if (this.id && this.id !== 'me') {
        return this.id;
      } else {
        return 'me';
      }
    },
    doctor_uri: function doctor_uri() {
      return this.$APP_CONFIG.api.admin.doctors_id(this.doctor_key);
    }
  },
  methods: {
    gotoPage: function gotoPage(step) {
      __WEBPACK_IMPORTED_MODULE_0__router__["b" /* default */].push({
        path: this.next_uri(step),
        query: {
          action: this.$route.query.action,
          ref_clinic_id: this.$route.query.ref_clinic_id
        }
      });
    },
    next_uri: function next_uri(step) {
      if (this.$route.query.ref_clinic_id) {
        return '/doctor/step' + (step + 1) + '/' + this.doctor_key + '?ref_clinic_id=' + this.$route.query.ref_clinic_id;
      } else {
        return '/doctor/step' + (step + 1) + '/' + this.doctor_key;
      }
    }
  }
});

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(718)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1025),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(996),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(736)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(1045),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(738)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1047),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(985),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var remarkTemplates = [{ name: 'New Patient', text: 'Please register new patient with your passport at registration counter first,then queue will be arranged once arrived. First come first serve. Apologise in advance for any inconvenience . Thank you' }, { name: 'ประวัติใหม่', text: 'เนื่องจากท่านเป็นประวัติใหม่ กรุณาติดต่อแผนกเวชระเบียนเพื่อทำประวัติด้วยบัตรประชาชน และรับคิวที่แผนกอีกครั้ง พยาบาลจะลำดับคิวให้ท่านอีกครั้งเมื่อไปถึง มาก่อนได้ตรวจก่อน ขอบคุณค่ะ' }];
    return {
      remarkTemplates: remarkTemplates
    };
  },

  methods: {}
});

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(683)
  __webpack_require__(682)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(987),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(680)
  __webpack_require__(679)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(984),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1003),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(709)
  __webpack_require__(708)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1016),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(514),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(721)
  __webpack_require__(720)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1027),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(704)
  __webpack_require__(703)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1011),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1008),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(733)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1043),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(741)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1049),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(994),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f917e27",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */,
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i18n; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__localization_en__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__localization_th__ = __webpack_require__(489);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = {
  en: __WEBPACK_IMPORTED_MODULE_2__localization_en__["a" /* messages */],
  th: __WEBPACK_IMPORTED_MODULE_3__localization_th__["a" /* messages */]
};

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'th',
  messages: messages });

/***/ }),
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(1052),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
var messages = {
  message: {
    login: {
      title: 'Login',
      header: 'Sign In to ZeekDoc clinical account',
      user_placeholder: 'Username',
      password_placeholder: 'Password',
      submit: 'Login',
      forgot_password: 'Forgot password?'
    },
    menu: {
      dashboard: 'Dashboard',
      appointment_pending: 'Pending',
      appointments: 'Appointments',
      patient: 'Patients',
      clinic_info: 'Clinic',
      clinic_information: 'Information',
      clinic_address: 'Address',
      clinic_schedule: 'Schedules',
      clinic_services: 'Services',
      clinic_settings: 'Settings',
      clinic_leave: 'Leave',
      sms_broadcast: 'SMS broadcast',
      doctor: 'Doctor',
      doctors: 'Doctors',
      article: 'Articles',
      feedback: 'Feedbacks',
      report: 'Report',
      clinic_view: 'Go to Clinic',
      doctor_view: 'Go to Doctor',
      my_subcription: 'My subscription',
      sign_out: 'Sign Out'
    },
    menu_message: {
      in_active_feature: 'This feature is inactive.'
    },
    clinic: {
      step_title: 'Create Profile',
      step_info: 'Information',
      step_address: 'Contact',
      step_schedule: 'Schedule',
      step_services: 'Services',
      step_doctors: 'Doctors',
      create_clinic_success: 'Profile was created successfully'
    },
    clinic_address: {
      title: 'Contact',
      address: 'Address',
      address_th: 'Address (Thai)',
      address_en: 'Address (English)',
      province: 'Province',
      district: 'District',
      insurances: 'Insurance',
      contact_info: 'Contact',
      email: 'Email',
      facebook: 'Facebook',
      website: 'Website',
      clinic_map: 'Map',
      nearby_search: 'Nearby'
    },
    pagination: {
      show: 'show',
      from: 'from',
      prev: 'Prev',
      next: 'Next',
      rows: 'rows'
    },
    doctors: {
      title: 'Doctors',
      search_doctor: 'search name',
      doctor_unit: 'doctors',
      no_doctor: 'no doctors',
      name_th: 'Name (Thai)',
      name_en: 'Name (English)',
      prefix: 'Prefix',
      firstname: 'Firstname',
      lastname: 'Lastname',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      specialty: 'Specialty',
      specialty_placeholder: 'select specialty',
      subspecialty: 'Subspecialty',
      subspecialty_placeholder: 'select subspecialty',
      prefix_required: 'The prefix field is required.',
      firstname_required: 'The firstname field is required.',
      lastname_required: 'The lastname field is required.',
      specialty_required: 'The specialty field is required.',
      filter_specialty: 'Specialty',
      filter_subspecialty: 'Subspecialty',
      qr_code: 'QR'
    },
    clinic_info: {
      title: 'Information',
      clinic_name: 'Name',
      clinic_name_th: 'Name (Thai)',
      clinic_name_en: 'Name (English)',
      clinic_logo: 'Logo',
      clinic_albums: 'Albums',
      clinic_detail: 'Detail',
      clinic_detail_th: 'Detail (Thai)',
      clinic_detail_en: 'Detail (English)',
      clinic_info: 'Information',
      clinic_info_th: 'Information (Thai)',
      clinic_info_en: 'Information (English)',
      clinic_info_placeholder_th: 'Information about clinic',
      clinic_info_placeholder_en: 'Information about clinic',
      clinic_picture_ph: 'select your photo',
      video_links: 'Related Video',
      youtube_link: 'Youtube Link'
    },
    schedules: {
      title: 'Schedules',
      schedule_for: 'Schedules of ',
      online_appointment_on: 'Online Appointment',
      select_time_slot: 'Select Time',
      to: 'to',
      add_time_slot: 'Add Time',
      hide: 'Hide',
      show: 'Show',
      options: 'Options',
      week: 'Week',
      last_week: 'Last week of a month',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      select_time_slot_number: 'Select Time Slot',
      time_slot_e_g: 'E.g. if you choose 30 minutes, system will display 8.00, 8.30, 9.00, 9.30',
      example: 'Example',
      booking_number: 'Booking number is',
      booking_unit: 'persons',
      booking_number_per_time_slot: 'Booking number per time slot',
      booking_number_per_time_slot_e_g: 'E.g. if time slot is 30 minutes and booking number per time slot is 4 persons, system will show you can serve 4 persons in 30 minutes'
    },
    services: {
      title: 'Services',
      price: 'Price',
      price_from: 'Start Price',
      price_to: 'End Price',
      price_range: 'Price Range',
      no_services: 'No service',
      add_new_service: 'Add service',
      service_name_th: 'Name (Thai)',
      service_name_en: 'Name (English)',
      select_duration: 'Select duration',
      service_duration: 'Duration',
      minutes: 'minutes',
      baht: 'บาท',
      service_detail: 'Detail',
      service_detail_th: 'Detail (Thai)',
      service_detail_en: 'Detail (English)',
      service_name_require: 'The name field is required.',
      service_duration_require: 'The duration field is required.',
      service_price_require: 'The price field is required.'
    },
    settings: {
      title: 'Settings',
      notification: 'Notification',
      notify_when_appointment: 'Notify SMS when admin created appointment',
      new_appointment_fwd_to_mail: 'Forward an appointment to email for a new appointment',
      email: 'Email',
      notify_sms: 'Notify SMS',
      notify_before_one_day: 'Notify appointment before 1 day of appointment day',
      notify_appointment_day: 'Notify appointment in appointment day',
      notify_time: 'Appointment notification time',
      credit_remain: 'Credit Remain',
      auto_create_patient: 'Auto create patient',
      feedback: 'Feedback',
      show_feedback: 'Show Feedback',
      time: 'at',
      search: 'Search',
      search_display: 'Display my profile in search algorithm'
    },
    leave: {
      title: 'Leave',
      date: 'Date',
      name: 'Name',
      remark: 'Remark',
      no_leave: 'No leave',
      title_add: 'Add Leave',
      title_edit: 'Edit Leave',
      doctor: 'Doctor',
      doctor_placeholder: 'Select Doctor',
      leave_date: 'Date',
      to: 'To',
      all_time: 'All Time',
      leave_date_placeholder: 'Select date',
      leave_time_placeholder: 'Select time',
      doctor_require: 'The doctor field is required.',
      time_require: 'The time field is required.',
      time_invalid: 'The time is invalid.',
      search_doctor: 'search name',
      calendar: 'Calendar',
      list: 'List'
    },
    article: {
      title: 'Article',
      search_article: 'Search article',
      no_article: 'No article',
      title_article_add: 'Add Article',
      name: 'Name',
      name_placeholder: 'Name',
      featured_image: 'Featured Image',
      or_use_link: 'Or Use Image Link',
      author: 'By',
      doctor: 'Doctor',
      clinic: 'Clinic',
      status: 'Status',
      unpublished: 'unpublished',
      published: 'published',
      title_require: 'The title field is required.',
      content_require: 'The content field is required.',
      select_featured_image: 'Select featured image',
      create_success: 'Create Article Successful',
      update_success: 'Update Article Successful'
    },
    patient: {
      title: 'Patient',
      search_by: 'Search name, id card, phone',
      patient_list: 'Patients',
      no_patient: 'No patient',
      required_info: 'Information',
      firstname: 'Firstname',
      lastname: 'Lastname',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      phone_no: 'Phone',
      contact: 'Contact',
      email: 'Email',
      address: 'Address',
      personal_info: 'Personal Information',
      id_card: 'ID Card',
      birthdate: 'Birthdate',
      allergy: 'Allergy',
      diseases: 'Diseases',
      relative_info: 'Relative',
      relative_name: 'Relative Name',
      relative_relation: 'Relative Relation',
      relative_phone: 'Relation Phone',
      create_success: 'Create new patient successful!',
      firstname_require: 'The firstname field is required.',
      lastname_require: 'The lastname field is required.',
      phone_require: 'The phone field is required.',
      birthday_require: 'The birthday field is required.',
      prefix: 'Prefix',
      prefix_placeholder: 'Prefix',
      prefix_mrs: 'Mrs',
      prefix_mr: 'Mr',
      prefix_ms: 'Ms',
      prefix_master: 'Master',
      prefix_miss: 'Miss',
      hn: 'HN'
    },
    report: {
      title: 'Statistics',
      view_and_appointment: 'Visitor and Appointment',
      visitor_detail: 'Visitor Detail',
      male: 'Male',
      female: 'Female',
      article: 'Article',
      popular_article: 'Popular Article',
      article_visitor: 'visitor',
      article_appointment: 'appointment',
      no_article: 'No article',
      popular_doctor: 'Popular Doctor',
      doctor_rank: 'Rank',
      doctor_name: 'Name',
      doctor_appointment_count: 'Appointment',
      today: 'Today',
      week: 'This week',
      month: 'This month',
      year: 'This year',
      status_summary: 'Status Summary',
      status_pending: 'Pending',
      status_checkin: 'Check-in',
      status_cancel: 'Cancel',
      status_scheduled: 'Scheduled'
    },
    dashboard: {
      title: 'Dashboard',
      notification: 'Notifications',
      appointment_m: 'Appointments in 30 days',
      appointment: 'Appointment',
      view_all_appointment: 'View all apppointments on this day',
      visitor_m: 'Visitors in 30 days',
      visitor: 'Visitor',
      view_all_visitor: 'View all statistics on this day',
      notification_appointment_first: 'Pending <strong>',
      notification_appointment_last: ' Appointments</strong>',
      notification_action: 'View appointments'
    },
    doctor_header: {
      title_new: 'Create Profile',
      title_edit: 'Edit Profile',
      personal_info: 'Personal Information',
      experience: 'Experience',
      schedules: 'Schedules',
      education: 'Education',
      other_info: 'Other Information'
    },
    doctor_general: {
      name_th: 'Name (Thai)',
      prefix: 'Prefix',
      prefix_placeholder_th: 'นพ., พญ.',
      firstname: 'Firstname',
      lastname: 'Lastname',
      name_en: 'Name (English)',
      prefix_placeholder_en: 'Dr..',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      image: 'Photo',
      select_image: 'Select your photo',
      albums: 'Albums'
    },
    doctor_experience: {
      specialty: 'Specialty',
      specialty_placeholder: 'Select specialty',
      subspecialty: 'Subspecialty',
      subspecialty_placeholder: 'Select subspecialty',
      medical_procedure_th: 'Medical Procedure (Thai)',
      medical_procedure_en: 'Medical Procedure (English)',
      medical_procedure_placeholder: 'Medical procedure',
      place: 'Work Addresses',
      clinic_place: 'Clinic',
      clinic_place_placeholder: 'Select or typing clinic name',
      institute_place: 'Institute',
      institute_place_placeholder: 'Select institute'
    },
    doctor_education: {
      education_info: 'Educations',
      education_info_th: 'Education (Thai)',
      education_info_en: 'Education (English)',
      certifications: 'Certifications',
      certifications_th: 'Certification (Thai)',
      certifications_en: 'Certification (English)',
      license_number: 'License Number',
      professional_memberships: 'Professional Memberships',
      professional_memberships_th: 'Professional Membership (Thai)',
      professional_memberships_en: 'Professional Membership (English)'
    },
    doctor_schedules: {
      schedule: 'Schedules',
      online_appointment_on: 'Online Appointment',
      select_time_slot_for: 'Select Time of '
    },
    doctor_info: {
      language: 'Language',
      language_placeholder: 'Allows to select more than one language',
      video_links: 'Related Video',
      youtube_link: 'Youtube Link',
      addition_info: 'Additional Information',
      addition_info_th: 'Information (Thai)',
      addition_info_en: 'Information (English)',
      save_success: 'Update Profile Successful',
      create_success: 'Create Profile Successful'
    },
    alert_bar: {
      title: 'Please complete your profile',
      message: 'Please complete the form to activate your account or contact administrator for additional information.',
      contact: 'Tel: 092-462-6633 (Fah)'
    },
    alert_bar_payment: {
      message: 'Your profile is not list in the search result. To active profile go to',
      contact: 'Tel: 092-462-6633 (Fah)'
    },
    alert_bar_sms_warning: {
      title: 'Your Sms credit is running out',
      message: 'In your account, there are ',
      contact: 'To top up the credit, please contact 092-462-6633 (Fah)'
    },
    drop_zone: {
      place_holder: 'Drag your file(s) here to begin<br> or click to browse'
    },
    appointment: {
      title_edit: 'Appointment',
      title_add: 'New Appointment',
      status_scheduled: 'Scheduled',
      status_cancel: 'Cancel',
      status_checkin: 'Check-In',
      status_patient_confirm: 'Patient Confirm',
      status_patient_confirm_3hr: 'Patient Confirm (3 Hours)',
      label_date_time_appointment: 'Appointment Date',
      doctor: 'Doctor',
      doctor_placeholder: 'Select Doctor',
      search_patient_placeholder: 'Search patient name, email, phone',
      prefix: 'Prefix',
      prefix_placeholder: 'Prefix',
      firstname: 'Firstname',
      firstname_placeholder: 'Firstname',
      lastname: 'Lastname',
      lastname_placeholder: 'Lastname',
      phone: 'Phone',
      email: 'Email',
      email_placeholder: 'Email',
      seen_doctor: 'Have you ever visited a doctor?',
      have: 'Yes, I have.',
      have_not: 'No, I haven\'t',
      medical_record: 'Have you had a medical record?',
      have_yes: 'Yes, I have.',
      have_no: 'No, I haven\'t',
      booking_for: 'For',
      myself: 'Myself',
      another: 'Another',
      id_card: 'ID Card / Passport',
      birthdate: 'Birthday',
      service: 'Service',
      service_placeholder: 'Select service',
      duration: 'Duration',
      duration_placeholder: 'Select duration',
      duration_unit: 'Minutes',
      addition: 'Chief Complain',
      addition_placeholder: 'Chief Complain',
      remark: 'Email/SMS remark',
      remark_placeholder: 'For patient notification',
      admin_remark: 'Admin remark',
      admin_remark_placeholder: 'Admin remark',
      are_you_wath_to_cancel: 'Do you want to cancel this appointment?',
      cancel_appointment_success: 'Cancel Appointment Successful!',
      firstname_require: 'The firstname field is required.',
      lastname_require: 'The lastname field is required.',
      phone_require: 'The phone field is required.',
      email_require: 'The email field is required.',
      doctor_require: 'The doctor field is required.',
      prefix_mrs: 'Mrs',
      prefix_mr: 'Mr',
      prefix_ms: 'Ms',
      prefix_master: 'Master',
      prefix_miss: 'Miss',
      pending_view: 'Pending',
      appointment_view: 'Appointment',
      search_appointment: 'Search name, email, phone',
      no_appointment: 'No appointment',
      add_appointment: 'New Appointment',
      appointment_date: 'Appointment Date',
      title_appointmemt: 'Appointment',
      daily_view: 'Daily',
      weekly_view: 'Weekly',
      monthly_view: 'Monthly',
      list_view: 'List',
      filter_date_all: 'All',
      filter_date_range: 'Range',
      filter_date_range_placeholder: 'Range',
      filter_specialty: 'Specialty',
      filter_doctor: 'Doctor',
      filter_clinic: 'Clinic',
      filter_status: 'Status',
      filter_service: 'Service',
      filter_hn: 'HN',
      filter_search: 'Patient name, Phone, HN or ID card',
      order: 'No',
      date: 'Date',
      patient: 'Patient',
      doctor_name: 'Doctor',
      service_name: 'Service',
      patient_status: 'Scheduled',
      appointment_status: 'Status',
      no_appointment_with_filter: 'No appointment',
      new_patient: 'New Patient',
      old_patient: 'Old Patient',
      view_more: 'More details',
      cancel_appointment: 'Cancel Appointment',
      doctor_list: 'Doctors',
      confirm_status: 'Confirmed',
      not_confirm_status: 'Not confirm',
      latest_reminded_time: 'Latest Reminded Time',
      locale: 'Language',
      locale_placeholder: 'Language',
      hn: 'HN',
      export_appointments: 'Export'
    },
    feedback: {
      title: 'Feedback',
      appointment_no: 'No.',
      appointment_date: 'Date',
      patient_name: 'Patient',
      doctor_name: 'Doctor',
      score: 'Score',
      comment: 'Comment',
      no_comment: 'No feedback'
    },
    remarks: {
      title_remark_editor: 'Edit Remark Template',
      name: 'Name',
      remark: 'Remark'
    }
  },
  action_message: {
    cancel: 'Cancel',
    ok: 'OK',
    save: 'Save',
    back: 'Back',
    edit: 'Edit',
    add: 'Add',
    remove: 'Remove',
    list: 'List',
    view: 'View',
    are_you_sure: 'Are you sure?',
    close: 'Close',
    view_more: 'More',
    save_success: 'Save Successful',
    save_not_success: 'Save Failure',
    download_qr_code: 'Download QR Code'
  }
};

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
var messages = {
  message: {
    login: {
      title: 'ลงชื่อเข้าใช้',
      header: 'ลงชื่อเข้าใช้บัญชีคลินิกของ ZeekDoc',
      user_placeholder: 'ชื่อผู้ใช้',
      password_placeholder: 'รหัสผ่าน',
      submit: 'ลงชื่อเข้าใช้',
      forgot_password: 'ลืมรหัสผ่าน?'
    },
    menu: {
      dashboard: 'แดชบอร์ด',
      appointment_pending: 'รอการยืนยัน',
      appointments: 'การนัดหมาย',
      patient: 'คนไข้',
      clinic_info: 'ข้อมูลคลินิก',
      clinic_information: 'ข้อมูลคลินิก',
      clinic_address: 'ที่่อยู่คลินิก',
      clinic_schedule: 'ตารางเวลาทำการ',
      clinic_services: 'บริการของคลินิก',
      clinic_settings: 'การตั้งค่า',
      clinic_leave: 'วันหยุดแพทย์',
      sms_broadcast: 'SMS broadcast',
      doctor: 'แพทย์',
      doctors: 'แพทย์',
      article: 'บทความ',
      feedback: 'ความคิดเห็น',
      report: 'รายงาน',
      clinic_view: 'ไปหน้าคลีนิก',
      doctor_view: 'ไปหน้าแพทย์',
      my_subcription: 'ดูแพลนสมาชิก',
      sign_out: 'ออกจากระบบ'
    },
    menu_message: {
      in_active_feature: 'ยังไม่ทำการเปิดใช้งาน'
    },
    clinic: {
      step_title: 'สร้างหน้าประวัติ',
      step_info: 'ข้อมูลคลินิก',
      step_address: 'วิธีการติดต่อ',
      step_schedule: 'ตารางเวลา',
      step_services: 'บริการของคลินิก',
      step_doctors: 'แพทย์ในคลินิก',
      create_clinic_success: 'หน้าประวิติของคุณได้ถูกสร้างแล้ว'
    },
    clinic_address: {
      title: 'วิธีการติดต่อ',
      address: 'ที่อยู่คลินิก',
      address_th: 'ที่อยู่คลินิกภาษาไทย',
      address_en: 'ที่อยู่คลินิกภาษาอังกฤษ',
      province: 'จังหวัด',
      district: 'อำเภอ',
      insurances: 'ประกันที่รับ',
      contact_info: 'ข้อมูลติดต่อคลินิก',
      email: 'อีเมล์',
      facebook: 'เฟซบุ๊ก',
      website: 'เว็บไซต์',
      clinic_map: 'แผนที่คลินิก',
      nearby_search: 'ค้นหาพื้นที่ใกล้เคียง'
    },
    pagination: {
      show: 'แสดง',
      from: 'จาก',
      prev: 'ก่อนหน้า',
      next: 'ถัดไป',
      rows: 'รายการ'
    },
    doctors: {
      title: 'แพทย์ในคลินิก',
      search_doctor: 'ค้นหาแพทย์',
      doctor_unit: 'แพทย์',
      no_doctor: 'ยังไม่มีแพทย์ในคลินิก',
      name_th: 'ชื่อภาษาไทย',
      name_en: 'ชื่อภาษาอังกฤษ',
      prefix: 'คำนำหน้า',
      firstname: 'ชื่อ',
      lastname: 'นามสกุล',
      gender: 'เพศ',
      male: 'ชาย',
      female: 'หญิง',
      specialty: 'สาขาเฉพาะทาง',
      specialty_placeholder: 'เลือกหรือพิมพ์ชื่อสาขาเฉพาะทาง',
      subspecialty: 'อนุสาขา',
      subspecialty_placeholder: 'เลือกอนุสาขาเฉพาะทาง',
      prefix_required: 'ต้องการคำนำหน้า',
      firstname_required: 'ต้องการชื่อ',
      lastname_required: 'ต้องการนามสกุล',
      specialty_required: 'ต้องการสาขาเฉพาะทาง',
      filter_specialty: 'สาขาเฉพาะทาง',
      filter_subspecialty: 'อนุสาขา',
      qr_code: 'QR'
    },
    clinic_info: {
      title: 'ข้อมูลคลินิก',
      clinic_name: 'ชื่อคลินิก',
      clinic_name_th: 'ชื่อคลินิกภาษาไทย',
      clinic_name_en: 'ชื่อคลินิกภาษาอังกฤษ',
      clinic_logo: 'โลโก้ของคลินิก',
      clinic_albums: 'อัลบั้มภาพของคลินิก',
      clinic_detail: 'รายละเอียดคลินิก',
      clinic_detail_th: 'รายละเอียดภาษาไทย',
      clinic_detail_en: 'รายละเอียดภาษาอังกฤษ',
      clinic_info: 'ข้อมูลคลินิก',
      clinic_info_th: 'ข้อมูลคลินิกภาษาไทย',
      clinic_info_en: 'ข้อมูลคลินิกภาษาอังกฤษ',
      clinic_info_placeholder_th: 'ข้อมูลต่างๆเกี่ยวกับคลินิก',
      clinic_info_placeholder_en: 'ข้อมูลต่างๆเกี่ยวกับคลินิก',
      clinic_picture_ph: 'เลือกรูปถ่ายของคุณ',
      video_links: 'วิดีโอที่เกี่ยวข้อง',
      youtube_link: 'Youtube Link'
    },
    schedules: {
      title: 'ตารางเวลา',
      schedule_for: 'ตารางออกตรวจของ',
      online_appointment_on: 'เปิดนัดหมายออนไลน์',
      select_time_slot: 'เลือกเวลาออกตรวจ',
      to: 'ถึง',
      add_time_slot: 'เพิ่มช่วงเวลาออกตรวจ',
      hide: 'ซ่อน',
      show: 'แสดง',
      options: 'ตัวเลือก',
      week: 'สัปดาห์ที่',
      last_week: 'สัปดาห์สุดท้ายของเดือน',
      monday: 'วันจันทร์',
      tuesday: 'วันอังคาร',
      wednesday: 'วันพุธ',
      thursday: 'วันพฤ',
      friday: 'วันศุกร์',
      saturday: 'วันเสาร์',
      sunday: 'วันอาทิตย์',
      select_time_slot_number: 'เลือก Slot เวลา',
      time_slot_e_g: 'ตัวอย่าง :หากเลือกระยะเวลาการตรวจเป็นเวลา 30 นาที ระบบจะแสดงผลเป็น 8.00, 8.30, 9.00, 9.30 เป็นต้น',
      example: 'ตัวอย่าง',
      booking_number: 'จองได้',
      booking_unit: 'คน',
      booking_number_per_time_slot: 'จำนวนคนไข้ใน 1 Slot เวลา',
      booking_number_per_time_slot_e_g: 'ตัวอย่าง :หากเลือก slot เวลา 30 นาที และจำนวนคนไข้ใน 1 slot เวลา 4 คน ระบบจะแสดงผลว่าคุณสามารถตรวจคนไข้ได้มากที่สุด 4 คนในเวลา 30 นาที'
    },
    services: {
      title: 'บริการของคลินิก',
      price: 'ราคา',
      price_from: 'ราคาเริ่มต้น',
      price_to: 'ราคาสูงสุด',
      price_range: 'แสดงราคาเป็นช่วง',
      no_services: 'ยังไม่มีบริการ',
      add_new_service: 'เพิ่มบริการของคลินิก',
      service_name_th: 'ชื่อบริการภาษาไทย',
      service_name_en: 'ชื่อบริการภาษาอังกฤษ',
      select_duration: 'เลือกระยะเวลา',
      service_duration: 'ระยะเวลาในการ',
      minutes: 'นาที',
      baht: 'บาท',
      service_detail: 'รายละเอียดบริการ',
      service_detail_th: 'รายละเอียดภาษาไทย',
      service_detail_en: 'รายละเอียดภาษาอังกฤษ',
      service_name_require: 'ต้องการชื่อ',
      service_duration_require: 'ต้องการระยะเวลา',
      service_price_require: 'ต้องการราคา'
    },
    settings: {
      title: 'การตั้งค่า',
      notification: 'การแจ้งเตือน',
      notify_when_appointment: 'แจ้งเตือนทาง SMS เมื่อ Admin สร้างนัดหมาย',
      new_appointment_fwd_to_mail: 'เมื่อมีนัดหมายแล้วให้ส่งไปที่ Email',
      email: 'Email',
      notify_sms: 'แจ้งเตือน SMS',
      notify_before_one_day: 'แจ้งเตือน 1 วันก่อนนัดหมาย',
      notify_appointment_day: 'แจ้งเตือนวันที่นัดหมาย ',
      notify_time: 'แจ้งคนไข้วันที่นัดหมายเวลา',
      credit_remain: 'จำนวน credit ที่เหลือ',
      auto_create_patient: 'บันทึกชื่อคนไข้อัตโนมัติ',
      feedback: 'ความคิดเห็น',
      show_feedback: 'แสดงความคิดเห็น',
      time: 'เวลา',
      search: 'การค้นหา',
      search_display: 'แสดงผลในหน้าการค้นหา'
    },
    leave: {
      title: 'วันหยุดแพทย์',
      date: 'วันที่',
      name: 'ชื่อแพทย์',
      remark: 'หมายเหตุ',
      no_leave: 'ไม่พบวันหยุด',
      title_add: 'เพิ่มวันหยุดแพทย์',
      title_edit: 'แก้ไขวันหยุดแพทย์',
      doctor: 'แพทย์',
      doctor_placeholder: 'เลือกแพทย์',
      leave_date: 'วันที่',
      to: 'ถึง',
      all_time: 'ทั้งวัน',
      leave_date_placeholder: 'เลือกช่วงวัน',
      leave_time_placeholder: 'เวลา',
      doctor_require: 'ต้องการข้อมูลแพทย์',
      time_require: 'ต้องการข้อมูลวันที่',
      time_invalid: 'วันที่ไม่ถูกต้อง',
      search_doctor: 'ค้นหาแพทย์',
      calendar: 'ปฏิทิน',
      list: 'รายการ'
    },
    article: {
      title: 'บทความ',
      search_article: 'ค้นหาบทความ',
      no_article: 'ไม่มีบทความ',
      title_article_add: 'เพิ่มบทความ',
      name: 'ชื่อบทความ',
      name_placeholder: 'ชื่อ',
      featured_image: 'รูปหัวข้อ',
      or_use_link: 'หรือ link ของภาพ',
      author: 'เขียนโดย',
      doctor: 'แพทย์',
      clinic: 'คลีนิก',
      status: 'สถานะ',
      unpublished: 'ยังไม่เผยแพร่',
      published: 'เผยแพร่',
      title_require: 'ต้องการข้อมูลชื่อ',
      content_require: 'ต้องการข้อมูลบทความ',
      select_featured_image: 'เลือกรูปของหัวข้อ',
      create_success: 'สร้างบทความสำเร็จ',
      update_success: 'บันทึกบทความสำเร็จ'
    },
    patient: {
      title: 'คนไข้',
      search_by: 'ค้นหาจากชื่อ, เลขประจำตัวประชาชน หรือเบอร์โทรศัพท์',
      patient_list: 'รายชื่อคนไข้',
      no_patient: 'ไม่มีรายการคนไข้',
      required_info: 'ข้อมูลที่จำเป็น',
      firstname: 'ชื่อ',
      lastname: 'นามสกุล',
      gender: 'เพศ',
      male: 'ชาย',
      female: 'หญิง',
      phone_no: 'เบอร์มือถือ',
      contact: 'ข้อมูลสำหรับติดต่อ',
      email: 'อีเมล',
      address: 'ที่อยู่',
      personal_info: 'ข้อมูลส่วนตัว',
      id_card: 'เลขประจำตัวประชาชนหรือเลขหนังสือเดินทาง',
      birthdate: 'วันเกิด',
      allergy: 'ประวัติการแพ้ยา',
      diseases: 'โรคประจำตัว',
      relative_info: 'ข้อมูลญาติกรณีฉุกเฉิน',
      relative_name: 'ชื่อญาติ',
      relative_relation: 'ความสัมพันธ์',
      relative_phone: 'เบอร์โทรศัพท์ของญาติ',
      create_success: 'บันทึกคนไข้สำเร็จ',
      firstname_require: 'ต้องการชื่อ',
      lastname_require: 'ต้องการนามสกุล',
      phone_require: 'ต้องการเบอร์',
      birthday_require: 'ต้องการวันเกิด',
      prefix: 'คำนำหน้า',
      prefix_placeholder: 'คำนำหน้า',
      prefix_mrs: 'นาง',
      prefix_mr: 'นาย',
      prefix_ms: 'นางสาว',
      prefix_master: 'ด.ช.',
      prefix_miss: 'ด.ญ.',
      hn: 'HN'
    },
    report: {
      title: 'สถิติ',
      view_and_appointment: 'จำนวนผู้เยี่ยมชมและนัดหมาย',
      visitor_detail: 'ลักษณะผู้เยี่ยมชม',
      male: 'ชาย',
      female: 'หญิง',
      article: 'บทความ',
      popular_article: 'บทความที่ได้รับความนิยม',
      article_visitor: 'ผู้เยี่ยมชม',
      article_appointment: 'นัดหมาย',
      no_article: 'ไม่พบบทความ',
      popular_doctor: 'หมอที่ได้รับความนิยม',
      doctor_rank: 'อันดับ',
      doctor_name: 'ชื่อหมอ',
      doctor_appointment_count: 'นัดหมาย',
      today: 'วันนี้',
      week: 'สัปดาห์นี้',
      month: 'เดือนนี้',
      year: 'ปีนี้',
      status_summary: 'สรุปสถานะนัดหมาย',
      status_pending: 'รอการยืนยัน',
      status_checkin: 'เช็คอิิน',
      status_cancel: 'ยกเลิก',
      status_scheduled: 'นัดหมาย'
    },
    dashboard: {
      title: 'หน้าแรก',
      notification: 'แจ้งเตือน',
      appointment_m: 'จำนวนนัดหมายย้อนหลัง 30 วัน',
      appointment: 'นัดหมาย',
      view_all_appointment: 'ดูนัดหมายวันนี้ทั้งหมด',
      visitor_m: 'จำนวนผู้เยี่ยมชมย้อนหลัง 30 วัน',
      visitor: 'ผู้เยี่ยมชม',
      view_all_visitor: 'ดูสถิติทั้งหมด',
      notification_appointment_first: 'มีนัดหมายใหม่ที่รอการยืนยัน <strong>',
      notification_appointment_last: ' นัดหมาย</strong> กรุณายืนยันนัดหมาย',
      notification_action: 'ดูนัดหมาย'
    },
    doctor_header: {
      title_new: 'สร้างประวัติ',
      title_edit: 'แก้ไขประวัติ',
      personal_info: 'ข้อมูลส่วนตัว',
      experience: 'การทำงาน',
      schedules: 'ตารางออกตรวจ',
      education: 'การศึกษา',
      other_info: 'ข้อมูลอื่นๆ'
    },
    doctor_general: {
      name_th: 'ชื่อภาษาไทย',
      prefix: 'คำนำหน้า',
      prefix_placeholder_th: 'นพ., พญ.',
      firstname: 'ชื่อ',
      lastname: 'นามสกุล',
      name_en: 'ชื่อภาษาอังกฤษ',
      prefix_placeholder_en: 'Dr..',
      gender: 'เพศ',
      male: 'ชาย',
      female: 'หญิง',
      image: 'รูปถ่ายของคุณ',
      select_image: 'เลือกรูปถ่ายของคุณ',
      albums: 'อัลบั้มของคุณ'
    },
    doctor_experience: {
      specialty: 'สาขาเฉพาะทาง',
      specialty_placeholder: 'เลือกหรือพิมพ์ชื่อสาขาเฉพาะทาง',
      subspecialty: 'อนุสาขาเฉพาะทาง',
      subspecialty_placeholder: 'เลือกอนุสาขาเฉพาะทาง',
      medical_procedure_th: 'หัตถการภาษาไทย',
      medical_procedure_en: 'หัตถการภาษาอังกฤษ',
      medical_procedure_placeholder: 'กรุณาใส่หัตถการที่เชี่ยวชาญ 3 อันดับแรก เช่น จัดฟัน ฟันปลอม ใส่ฟัน',
      place: 'สถานพยาบาลที่ทำงานอยู่',
      clinic_place: 'สถานพยาบาลเอกชน',
      clinic_place_placeholder: 'เลือกหรือพิมพ์ชื่อสถานพยาบาลเอกชน',
      institute_place: 'สถานพยาบาลภาครัฐ',
      institute_place_placeholder: 'เลือกสถานพยาบาลภาครัฐ'
    },
    doctor_education: {
      education_info: 'ข้อมูลการศึกษา',
      education_info_th: 'ข้อมูลการศึกษา (ภาษาไทย)',
      education_info_en: 'ข้อมูลการศึกษา (ภาษาอังกฤษ)',
      certifications: 'วุฒิบัตร',
      certifications_th: 'ชื่อวุฒิบัตร (ภาษาไทย)',
      certifications_en: 'ชื่อวุฒิบัตร (ภาษาอังกฤษ)',
      license_number: 'เลขที่ใบประกอบวิชาชีพ',
      professional_memberships: 'สมาชิกสมาคมแพทย์',
      professional_memberships_th: 'ชื่อสมาคมแพทย์ (ภาษาไทย)',
      professional_memberships_en: 'ชื่อสมาคมแพทย์ (ภาษาอังกฤษ)'
    },
    doctor_schedules: {
      schedule: 'ตารางออกตรวจ',
      online_appointment_on: 'เปิดนัดหมายออนไลน์',
      select_time_slot_for: 'เลือกเวลาออกตรวจสำหรับที่'
    },
    doctor_info: {
      language: 'ภาษา',
      language_placeholder: 'เลือกหรือพิมพ์ภาษาได้มากกว่า 1',
      video_links: 'วิดีโอที่เกี่ยวข้อง',
      youtube_link: 'Youtube Link',
      addition_info: 'ข้อมูลเพิ่มเติม',
      addition_info_th: 'ข้อมูลเพิ่มเติม (ภาษาไทย)',
      addition_info_en: 'ข้อมูลเพิ่มเติม (อังกฤษ)',
      save_success: 'ได้บันทึกหน้าประวิติของคุณแล้ว',
      create_success: 'หน้าประวิติของคุณได้ถูกสร้างแล้ว'
    },
    alert_bar: {
      title: 'กรุณากรอกข้อมูลให้ครบ',
      message: 'แอดเคาท์ของท่านจะได้รับการ active เมื่อข้อมูลถูกต้องครบถ้วน ติดต่อ สอบถามเพิ่มเติม',
      contact: 'ได้ที่ 092-462-6633 (คุณ ฟ้า)'
    },
    alert_bar_payment: {
      message: 'ข้อมูลของท่านยังไม่อยู่ในหน้าค้นหา ต้องการเปิดการค้นหากรุณา ไปที่',
      contact: 'ได้ที่ 092-462-6633 (คุณ ฟ้า)'
    },
    alert_bar_sms_warning: {
      title: 'Sms credit ของท่านใกล้หมดแล้ว',
      message: 'sms credit ในแอดเคาท์ของท่าน เหลืออยู่',
      contact: 'ติดต่อเติม credit ได้ที่ 092-462-6633 (คุณ ฟ้า)'
    },
    drop_zone: {
      place_holder: 'ลากไฟล์ลงมาตรงนี้<br> หรือกดเพื่อเลือกไฟล์'
    },
    appointment: {
      title_edit: 'แก้ไขรายการนัดหมาย',
      title_add: 'เพิ่มรายการนัดหมาย',
      status_scheduled: 'Scheduled',
      status_cancel: 'ยกเลิกนัดหมาย',
      status_checkin: 'Check-In',
      status_patient_confirm: 'คนไข้ยืนยัน',
      status_patient_confirm_3hr: 'คนไข้ยืนยัน (3 ชั่วโมง)',
      label_date_time_appointment: 'วัน เวลา ที่นัดหมาย',
      doctor: 'แพทย์',
      doctor_placeholder: 'เลือกแพทย์',
      search_patient_placeholder: 'ค้นหาคนไข้ด้วย ชื่อ, นามสกุล, อีเมล, เบอร์โทรศัพท์, HN',
      prefix: 'คำนำหน้า',
      prefix_placeholder: 'คำนำหน้า',
      firstname: 'ชื่อ',
      firstname_placeholder: 'ชื่อ',
      lastname: 'นามสกุล',
      lastname_placeholder: 'นามสกุล',
      phone: 'เบอร์มือถือ',
      email: 'อีเมล',
      email_placeholder: 'อีเมล',
      seen_doctor: 'เคยพบแพทย์',
      have: 'เคย',
      have_not: 'ไม่เคย',
      medical_record: 'มีประวัติ',
      have_yes: 'มี',
      have_no: 'ไม่มี',
      booking_for: 'เพื่อ',
      myself: 'ตัวเอง',
      another: 'คนอื่น',
      id_card: 'หมายเลขบัตรประชาชนหรือหมายเลขหนังสือเดินทาง',
      birthdate: 'วันเกิด',
      service: 'บริการ',
      service_placeholder: 'เลือกบริการ',
      duration: 'ระยะเวลา',
      duration_placeholder: 'เลือกระยะเวลา',
      duration_unit: 'นาที',
      addition: 'คนไข้เล่าอาการ',
      addition_placeholder: 'คนไข้เล่าอาการ',
      remark: 'อีเมล/SMS หมายเหตุ',
      remark_placeholder: 'สำหรับแจ้งเตือนคนไข้ เช่น กรุณางดยาละลายลิ่มเลือดก่อนล่วงหน้า 7 วัน',
      admin_remark: 'สำหรับเจ้าหน้าที่',
      admin_remark_placeholder: 'หมายเหตุ',
      are_you_wath_to_cancel: 'ต้องการที่จะยกเลิกนัดหมายนี้ ?',
      cancel_appointment_success: 'ยกเลิกนัดหมายสำเร็จ',
      firstname_require: 'ต้องการข้อมูลชื่อ',
      lastname_require: 'ต้องการข้อมูลนามสกุล',
      phone_require: 'ต้องการข้อมูลหมายเลขโทรศัพท์',
      email_require: 'ต้องการข้อมูลอีเมล',
      doctor_require: 'ต้องการข้อมูลแพทย์',
      prefix_mrs: 'นาง',
      prefix_mr: 'นาย',
      prefix_ms: 'นางสาว',
      prefix_master: 'ด.ช.',
      prefix_miss: 'ด.ญ.',
      pending_view: 'รอการยืนยัน',
      appointment_view: 'การนัดหมาย',
      search_appointment: 'ค้นหาการนัดหมายจากชื่อ เลขบัตรประชาชน เบอร์โทรศัพท์',
      no_appointment: 'ไม่มีการนัดหมาย',
      add_appointment: 'เพิ่มรายการนัดหมาย',
      appointment_date: 'วันที่นัดหมาย',
      title_appointmemt: 'การนัดหมาย',
      daily_view: 'รายวัน',
      weekly_view: 'รายสัปดาห์',
      monthly_view: 'รายเดือน',
      list_view: 'รายชื่อ',
      filter_date_all: 'ทั้งหมด',
      filter_date_range: 'เลือกตามวัน',
      filter_date_range_placeholder: 'เลือกช่วงเวลา',
      filter_specialty: 'สาขาเฉพาะทาง',
      filter_doctor: 'แพทย์',
      filter_clinic: 'คลินิก',
      filter_status: 'สถานะ',
      filter_service: 'บริการ',
      filter_hn: 'HN',
      filter_search: 'ค้นหาจากชื่อคนไข้, เบอร์โทร, HN หรือ ID card',
      order: 'หมายเลข',
      date: 'วันนัดหมาย',
      patient: 'ชื่อคนไข้',
      doctor_name: 'ชื่อแพทย์',
      service_name: 'บริการ',
      patient_status: 'คนไข้ยืนยัน',
      appointment_status: 'สถานะนัดหมาย',
      no_appointment_with_filter: 'ไม่พบการนัดหมายภายในเงื่อนไขที่กำหนด',
      new_patient: 'คนไข้ใหม่',
      old_patient: 'คนไข้เก่าในระบบ',
      view_more: 'ดูรายละเอียดเพิ่มเติม',
      cancel_appointment: 'ยกเลิกนัดหมาย',
      doctor_list: 'รายชื่อแพทย์',
      confirm_status: 'ยืนยัน',
      not_confirm_status: 'ไม่ยืนยัน',
      latest_reminded_time: 'แจ้งเตือนล่าสุด',
      locale: 'ภาษา',
      locale_placeholder: 'ภาษา',
      hn: 'HN',
      export_appointments: 'บันทึกเป็นไฟล์'
    },
    feedback: {
      title: 'ความคิดเห็น',
      appointment_no: 'หมายเลขนัดหมาย',
      appointment_date: 'วันนัดหมาย',
      patient_name: 'ชื่อคนไข้',
      doctor_name: 'ชื่อแพทย์',
      score: 'คะแนน',
      comment: 'ความคิดเห็น',
      no_comment: 'ไม่พบความคิดเห็น'
    },
    remarks: {
      title_remark_editor: 'แก้ไขเทมเพลต',
      name: 'ชื่อ',
      remark: 'ข้อความ'
    }
  },
  action_message: {
    cancel: 'ยกเลิก',
    ok: 'ตกลง',
    save: 'บันทึก',
    back: 'ย้อนกลับ',
    edit: 'แก้ไข',
    add: 'เพิ่ม',
    remove: 'ลบ',
    list: 'รายการ',
    view: 'แสดง',
    are_you_sure: 'คุณแน่ใจแล้วใช่ไหม?',
    close: 'ปิด',
    view_more: 'ดูเพิ่มเติม',
    save_success: 'บันทึกแล้ว',
    save_not_success: 'บันทึกไม่สำเร็จ',
    download_qr_code: 'โหลด QR Code'
  }
};

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ls__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_toastr__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_zydialog__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_zydialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_zydialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_croppie__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_croppie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_croppie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_filters__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_numeral__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vee_validate__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_resource__ = __webpack_require__(410);


















var AppConfig = {};
AppConfig.install = function (_Vue, options) {
  var _APP_CONFIG = {
    api: {
      domain: "https://zeekdoc.com",
      admin: {}
    }
  };

  _APP_CONFIG.api.login = function () {
    return _APP_CONFIG.api.domain + '/api/v1/users/web/signin';
  };
  _APP_CONFIG.api.logout = function () {
    return _APP_CONFIG.api.domain + '/auth/logout';
  };
  _APP_CONFIG.api.userinfo = function () {
    return _APP_CONFIG.api.domain + '/api/v1/users/me';
  };

  _APP_CONFIG.api.specialties = function () {
    return _APP_CONFIG.api.domain + '/api/v1/specialties';
  };
  _APP_CONFIG.api.sub_specialities = function (specialityId) {
    return _APP_CONFIG.api.domain + '/api/v1/subspecialties?speciality_id=' + specialityId;
  };
  _APP_CONFIG.api.institutes = function () {
    return _APP_CONFIG.api.domain + '/api/v1/institutes';
  };
  _APP_CONFIG.api.languages = function () {
    return _APP_CONFIG.api.domain + '/api/v1/languages';
  };
  _APP_CONFIG.api.provinces = function () {
    return _APP_CONFIG.api.domain + '/api/v1/provinces';
  };
  _APP_CONFIG.api.districts = function () {
    return _APP_CONFIG.api.domain + '/api/v1/districts';
  };
  _APP_CONFIG.api.config = function () {
    return _APP_CONFIG.api.domain + '/api/v1/config';
  };

  _APP_CONFIG.api.clinics = function () {
    return _APP_CONFIG.api.domain + '/api/v1/clinics';
  };

  _APP_CONFIG.api.appointments = function () {
    return _APP_CONFIG.api.domain + '/api/v1/appointments/list';
  };
  _APP_CONFIG.api.appointment = function () {
    return _APP_CONFIG.api.domain + '/api/v1/appointments';
  };
  _APP_CONFIG.api.appointment_id = function (id) {
    return _APP_CONFIG.api.domain + '/api/v1/appointments/' + id;
  };
  _APP_CONFIG.api.appointmentsExport = function () {
    return _APP_CONFIG.api.domain + '/export/appointments';
  };
  _APP_CONFIG.api.appointmentsExportFields = function () {
    return _APP_CONFIG.api.domain + '/export/allfields';
  };
  _APP_CONFIG.api.appointment_patient = function () {
    return _APP_CONFIG.api.domain + '/api/v1/appointments/patient';
  };

  _APP_CONFIG.api.insurance = function () {
    return _APP_CONFIG.api.domain + '/api/v1/insurances';
  };

  _APP_CONFIG.api.admin.domain = function () {
    return _APP_CONFIG.api.domain + '/admin/api/v1';
  };
  _APP_CONFIG.api.admin.doctors = function () {
    return _APP_CONFIG.api.admin.domain() + '/doctors';
  };
  _APP_CONFIG.api.admin.doctors_id = function (id) {
    return _APP_CONFIG.api.admin.domain() + '/doctors/' + id;
  };
  _APP_CONFIG.api.admin.doctors_clinic = function (clinicId) {
    return _APP_CONFIG.api.admin.domain() + '/doctors?clinic_id=' + clinicId;
  };
  _APP_CONFIG.api.admin.doctorme = function () {
    return _APP_CONFIG.api.admin.domain() + '/doctors/me';
  };
  _APP_CONFIG.api.admin.remove_image = function (id) {
    return _APP_CONFIG.api.admin.domain() + '/me/image/' + id;
  };
  _APP_CONFIG.api.admin.upload_doctorme_image = function (id) {
    return _APP_CONFIG.api.admin.domain() + '/doctors/' + id + '/image?is_active=1';
  };
  _APP_CONFIG.api.admin.upload_doctorme_alblum = function (id) {
    return _APP_CONFIG.api.admin.domain() + '/doctors/' + id + '/image';
  };
  _APP_CONFIG.api.admin.doctor_stats = function (id) {
    return _APP_CONFIG.api.admin.domain() + '/doctors/' + id + '/stats';
  };

  _APP_CONFIG.api.admin.clinics = function () {
    return _APP_CONFIG.api.admin.domain() + '/clinics';
  };
  _APP_CONFIG.api.admin.clinic_stats = function (id) {
    return _APP_CONFIG.api.admin.domain() + '/clinics/' + id + '/stats';
  };
  _APP_CONFIG.api.admin.clinicme = function (route, user) {
    var url = _APP_CONFIG.api.admin.domain() + '/clinics/me';

    if (route !== undefined && user !== undefined && route.query.ref_clinic_id && user.isClinicMulti()) {
      url = _APP_CONFIG.api.admin.domain() + '/clinics/' + route.query.ref_clinic_id;
    }
    return url;
  };
  _APP_CONFIG.api.admin.upload_clinicme_image = function () {
    return _APP_CONFIG.api.admin.domain() + '/clinics/me/image?is_active=1';
  };
  _APP_CONFIG.api.admin.upload_clinicme_alblum = function () {
    return _APP_CONFIG.api.admin.domain() + '/clinics/me/image';
  };
  _APP_CONFIG.api.admin.upload_clinicme_alblum_id = function (id) {
    return _APP_CONFIG.api.admin.domain() + '/clinics/me/image/' + id;
  };
  _APP_CONFIG.api.admin.clinic_services_id = function (id) {
    return _APP_CONFIG.api.admin.domain() + '/clinics/services/' + id;
  };
  _APP_CONFIG.api.admin.clinicme_services = function (route, user) {
    var url = _APP_CONFIG.api.admin.domain() + '/clinics/me/services';

    if (route !== undefined && user !== undefined && route.query.ref_clinic_id && user.isClinicMulti()) {
      url = _APP_CONFIG.api.admin.domain() + '/clinics/' + route.query.ref_clinic_id + '/services';
    }
    return url;
  };
  _APP_CONFIG.api.admin.clinicme_services_id = function (id, route, user) {
    var url = _APP_CONFIG.api.admin.domain() + '/clinics/me/services/' + id;

    if (route !== undefined && user !== undefined && route.query.ref_clinic_id && user.isClinicMulti()) {
      url = _APP_CONFIG.api.admin.domain() + '/clinics/' + route.query.ref_clinic_id + '/services/' + id;
    }

    return url;
  };

  _APP_CONFIG.api.admin.patient = function (route, user) {
    return _APP_CONFIG.api.admin.domain() + '/ehr_patient';
  };
  _APP_CONFIG.api.admin.patient_id = function (id) {
    return _APP_CONFIG.api.admin.domain() + '/ehr_patient/' + id;
  };
  _APP_CONFIG.api.admin.articles = function () {
    return _APP_CONFIG.api.admin.domain() + '/articles';
  };
  _APP_CONFIG.api.admin.articles_id = function (id) {
    return _APP_CONFIG.api.admin.domain() + '/articles/' + id;
  };
  _APP_CONFIG.api.admin.appointment = function () {
    return _APP_CONFIG.api.admin.domain() + '/appointments';
  };
  _APP_CONFIG.api.admin.appointment_id = function (id) {
    return _APP_CONFIG.api.admin.appointment() + '/' + id;
  };
  _APP_CONFIG.api.admin.appointment_action = function (id, action) {
    return _APP_CONFIG.api.admin.appointment_id(id) + '/' + action;
  };
  _APP_CONFIG.api.admin.appointment_status = function () {
    return _APP_CONFIG.api.admin.appointment() + '/all_status';
  };

  _APP_CONFIG.api.admin.reviews = function () {
    return _APP_CONFIG.api.admin.domain() + '/reviews';
  };

  _APP_CONFIG.api.admin.timeoffs = function () {
    return _APP_CONFIG.api.admin.domain() + '/timeoffs';
  };

  _APP_CONFIG.api.admin.payment_token = function () {
    return _APP_CONFIG.api.admin.domain() + '/users/payment_token';
  };
  _APP_CONFIG.api.admin.subscription = function () {
    return _APP_CONFIG.api.admin.domain() + '/doctors/me/subscribe';
  };

  _APP_CONFIG.api.admin.broadcast = function () {
    return _APP_CONFIG.api.admin.domain() + '/broadcast';
  };
  _APP_CONFIG.api.admin.broadcast_check = function () {
    return _APP_CONFIG.api.admin.domain() + '/broadcast/check';
  };

  _Vue.prototype.$APP_CONFIG = _APP_CONFIG;
};

var AppUtils = {};
AppUtils.install = function (_Vue, options) {
  var ismobile = function ismobile() {
    if (navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)) {
      return true;
    } else {
      return false;
    }
  };

  var loadFile = function loadFile(f, callback) {
    if (File && FileReader && FileList && Blob) {

      var reader = new FileReader();

      reader.onload = function () {
        callback(reader.result);
      };

      reader.readAsDataURL(f);
    } else {
      console.log('The File APIs are not fully supported in this browser.');
    }
  };

  var b64toBlob = function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  var processB64ToBlob = function processB64ToBlob(data) {
    var block = data.split(';');

    var contentType = block[0].split(':')[1];
    var realData = block[1].split(',')[1];
    return b64toBlob(realData, contentType);
  };

  var formatDateTimeFull = function formatDateTimeFull(dateString) {
    if (dateString) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(dateString, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY HH:mm');
    }
    return '';
  };

  var formatDateFull = function formatDateFull(dateString) {
    if (dateString) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(dateString, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY');
    }
    return '';
  };

  var formatTimeFull = function formatTimeFull(dateString) {
    if (dateString) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(dateString, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
    }
    return '';
  };

  _Vue.prototype.$ismobile = ismobile;
  _Vue.prototype.$loadFile = loadFile;
  _Vue.prototype.$b64toBlob = b64toBlob;
  _Vue.prototype.$processB64ToBlob = processB64ToBlob;
  _Vue.filter('formatDateTimeFull', formatDateTimeFull);
  _Vue.filter('formatDateFull', formatDateFull);
  _Vue.filter('formatTimeFull', formatTimeFull);
};

var RealtimeDb = {};
RealtimeDb.install = function (_Vue, options) {
  var firebaseApp = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.initializeApp({"apiKey":"AIzaSyBkZZHm5K9eJWoW2XP4zsTQTEVelKRLMG8","authDomain":"zeekdoc-1470731393727.firebaseio.com","databaseURL":"https://zeekdoc-1470731393727.firebaseio.com","projectId":"zeekdoc-1470731393727","storageBucket":"zeekdoc-1470731393727.appspot.com","messagingSenderId":"669552663734"});
  firebaseApp.auth().signInAnonymously();

  var db = firebaseApp.database();
  _Vue.prototype.$firebaseApp = firebaseApp;
  _Vue.prototype.$rtdb = db;
};

var Toastr = {};
Toastr.install = function (_Vue, options) {
  _Vue.prototype.$toastr = __WEBPACK_IMPORTED_MODULE_8_toastr___default.a;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_ls___default.a, { namespace: 'app_zeekdoc__' });
__WEBPACK_IMPORTED_MODULE_6__lang__["a" /* i18n */].locale = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].ls.get('lang', 'th');

__WEBPACK_IMPORTED_MODULE_7__router__["a" /* UserStore */].changeLang = function (lang) {
  __WEBPACK_IMPORTED_MODULE_6__lang__["a" /* i18n */].locale = lang;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(AppConfig);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(RealtimeDb);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(AppUtils);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__router__["a" /* UserStore */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(Toastr);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_croppie___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_zydialog___default.a, { lbLabel: __WEBPACK_IMPORTED_MODULE_6__lang__["a" /* i18n */].t('action_message.cancel'), rbLabel: __WEBPACK_IMPORTED_MODULE_6__lang__["a" /* i18n */].t('action_message.ok') });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.credentials = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.headers.common['content-type'] = 'application/json';

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.push(function (request, next) {
  if (request.method === 'GET') {
    request.params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, request.params, {
      translate: __WEBPACK_IMPORTED_MODULE_6__lang__["a" /* i18n */].locale
    });
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('formatNumber', function (value) {
  return __WEBPACK_IMPORTED_MODULE_13_numeral___default()(value).format('0,0');
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["b" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_6__lang__["a" /* i18n */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
	name: 'SweetModal',

	props: {
		title: {
			type: String,
			required: false,
			default: ''
		},

		overlayTheme: {
			type: String,
			required: false,
			default: 'light'
		},

		modalTheme: {
			type: String,
			required: false,
			default: 'light'
		},

		blocking: {
			type: Boolean,
			required: false,
			default: false
		},

		pulseOnBlock: {
			type: Boolean,
			required: false,
			default: true
		},

		icon: {
			type: String,
			required: false,
			default: ''
		},

		hideCloseButton: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	mounted: function mounted() {
		this.tabs = this.$children.filter(function (c) {
			return c.cmpName && c.cmpName == 'tab';
		});

		if (this.has_tabs) {
			this.currentTab = this._changeTab(this.tabs[0]);
		}

		document.addEventListener('keyup', this._onDocumentKeyup);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keyup', this._onDocumentKeyup);
	},
	data: function data() {
		return {
			visible: false,
			is_open: false,
			is_bouncing: false,
			tabs: [],

			backups: {
				body: {
					height: null,
					overflow: null
				}
			}
		};
	},


	computed: {
		has_title: function has_title() {
			return this.title || this.$slots.title;
		},
		has_tabs: function has_tabs() {
			return this.tabs.length > 0;
		},
		has_content: function has_content() {
			return this.$slots.default;
		},
		current_tab: function current_tab() {
			return this.tabs.filter(function (t) {
				return t.active === true;
			})[0];
		},
		overlay_classes: function overlay_classes() {
			return ['sweet-modal-overlay', 'theme-' + this.overlayTheme, 'sweet-modal-clickable', {
				'is-visible': this.visible,
				blocking: this.blocking
			}];
		},
		modal_classes: function modal_classes() {
			return ['sweet-modal', 'theme-' + this.modalTheme, {
				'has-title': this.has_title,
				'has-tabs': this.has_tabs,
				'has-content': this.has_content,
				'has-icon': this.icon,
				'is-visible': this.visible,
				'sweet-alert': this.icon && !this.has_tabs || !this.icon && !this.title && !this.$slots.title,
				bounce: this.is_bouncing
			}];
		}
	},

	methods: {
		open: function open() {
			var _this = this;

			var tabId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (tabId && this.has_tabs) {
				var openingTabs = this.tabs.filter(function (tab) {
					return tab.id === tabId;
				});
				if (openingTabs.length > 0) {
					this.currentTab = this._changeTab(openingTabs[0]);
				} else {
					var openingTab = this.tabs[tabId];
					if (openingTab) {
						this.currentTab = this._changeTab(openingTab);
					}
				}
			}

			this.is_open = true;
			this._lockBody();
			this._animateIcon();

			setTimeout(function () {
				return _this.visible = true;
			}, 30);
			this.$emit('open');
		},
		close: function close() {
			var _this2 = this;

			this.visible = false;
			this._unlockBody();

			setTimeout(function () {
				return _this2.is_open = false;
			}, 300);
			this.$emit('close');
		},
		bounce: function bounce() {
			var _this3 = this;

			this.is_bouncing = true;

			setTimeout(function () {
				return _this3.is_bouncing = false;
			}, 330);
		},
		_lockBody: function _lockBody() {
			this.backups.body.height = document.body.style.height;
			this.backups.body.overflow = document.body.style.overflow;

			document.body.style.height = '100%';
			document.body.style.overflow = 'hidden';
		},
		_unlockBody: function _unlockBody() {
			document.body.style.height = this.backups.body.height;
			document.body.style.overflow = this.backups.body.overflow;
		},
		_onOverlayClick: function _onOverlayClick(event) {
			if (!event.target.classList || event.target.classList.contains('sweet-modal-clickable')) {
				if (this.blocking) {
					if (this.pulseOnBlock) this.bounce();
				} else {
					this.close();
				}
			}
		},
		_onDocumentKeyup: function _onDocumentKeyup(event) {
			if (event.keyCode == 27) {
				if (this.blocking) {
					if (this.pulseOnBlock) this.bounce();
				} else {
					this.close();
				}
			}
		},
		_changeTab: function _changeTab(tab) {
			this.tabs.map(function (t) {
				return t.active = t == tab;
			});
			this.currentTab = tab;
		},
		_getClassesForTab: function _getClassesForTab(tab) {
			return ['sweet-modal-tab', {
				active: tab.active,
				disabled: tab.disabled
			}];
		},
		_animateIcon: function _animateIcon() {
			var _this4 = this;

			if (!this.icon) return;

			switch (this.icon) {
				case 'success':
					setTimeout(function () {
						_this4._applyClasses(_this4.$refs.icon_success, {
							'': ['animate'],
							'.sweet-modal-tip': ['animateSuccessTip'],
							'.sweet-modal-long': ['animateSuccessLong']
						});
					}, 80);

					break;

				case 'warning':
					this._applyClasses(this.$refs.icon_warning, {
						'': ['pulseWarning'],
						'.sweet-modal-body': ['pulseWarningIns'],
						'.sweet-modal-dot': ['pulseWarningIns']
					});

					break;

				case 'error':
					setTimeout(function () {
						_this4._applyClasses(_this4.$refs.icon_error, {
							'': ['animateErrorIcon'],
							'.sweet-modal-x-mark': ['animateXMark']
						});
					}, 80);

					break;
			}
		},
		_applyClasses: function _applyClasses($ref, classMap) {
			for (var cl in classMap) {
				var _$el$classList, _$el$classList2;

				var classes = classMap[cl];
				var $el = void 0;

				if (cl == '') {
					$el = $ref;
				} else {
					$el = $ref.querySelector(cl);
				}

				(_$el$classList = $el.classList).remove.apply(_$el$classList, _toConsumableArray(classes));
				(_$el$classList2 = $el.classList).add.apply(_$el$classList2, _toConsumableArray(classes));
			}
		}
	}
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		title: {
			type: String,
			required: true
		},

		id: {
			type: String,
			required: true
		},

		icon: {
			type: String,
			required: false,
			default: null
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data: function data() {
		return {
			active: false
		};
	},


	computed: {
		cmpName: function cmpName() {
			return 'tab';
		}
	}
};

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_drag__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_drag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_drag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_resize__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_resize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_loading_gif__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lib_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_helper__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lib_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resize_bar_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resize_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__resize_bar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue__);










var CROPBOX_PERCENT = 75;
var isMobile = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile;
var areaWidth = window.innerWidth - 60;
var areaHeight = window.innerHeight - 110;
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ResizeBar: __WEBPACK_IMPORTED_MODULE_5__resize_bar_vue___default.a,
    RotateBar: __WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue___default.a
  },
  props: {
    ratio: {
      type: String,
      default: '1:1'
    },
    minWidth: {
      type: Number,
      default: 50
    },
    minHeight: {
      type: Number,
      default: 50
    },
    isResize: {
      type: [Boolean],
      default: false
    },
    isRotate: {
      type: [Boolean],
      default: true
    }
  },

  data: function data() {
    return {
      src: __WEBPACK_IMPORTED_MODULE_2__lib_loading_gif___default.a,
      width: 24,
      height: 24,
      initWidth: 24,
      initHeight: 24,
      left: 0,
      top: 0,
      cropCSS: {}
    };
  },


  methods: {
    setImage: function setImage(src, w, h) {
      this.src = src;
      if (!this.originSrc) {
        this.setOriginalSrc(this.src);
      }
      if (this.ratio.indexOf(':') > 0) {
        this.ratioW = this.ratio.split(':')[0];
        this.ratioH = this.ratio.split(':')[1];
        this.ratioVal = this.ratioW / this.ratioH;
      } else {
        this.ratioW = 1;
        this.ratioH = 1;
        this.ratioVal = this.ratio;
      }
      this.natrualWidth = w;
      this.natrualHeight = h;
      this.setLayout(w, h);
      var resizeBar = this.$refs.resizeBar;
      if (this.isResize) {
        resizeBar.setProgress(100);
      } else {
        resizeBar.setProgress(50);
      }
      return this.imgChangeRatio;
    },
    setOriginalSrc: function setOriginalSrc(src) {
      this.originSrc = src;
    },
    resizeImage: function resizeImage(progress) {
      var w = void 0,
          h = void 0;
      if (this.isResize) {
        w = this.natrualWidth * this.imgChangeRatio * progress;
        h = this.natrualHeight * this.imgChangeRatio * progress;
      } else {
        w = this.initWidth + progress * (this.natrualWidth - this.initWidth);
        h = this.initHeight + progress * (this.natrualHeight - this.initHeight);
      }
      if (w <= this.minWidth || h < this.minHeight) {
        return;
      }
      this.left += (this.width - w) / 2;
      this.top += (this.height - h) / 2;
      this.width = w;
      this.height = h;
      this.imgChangeRatio = this.width / this.natrualWidth;
    },
    rotateImage: function rotateImage(degress) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper___default.a.rotate2(this.originSrc, degress, function (data, w, h) {
        _this.setImage(data, w, h);
      });
    },
    setLayout: function setLayout(w, h) {
      var H = areaHeight,
          W = areaWidth,
          width = w,
          height = h,
          marginLeft = 0,
          marginTop = 0;

      var R = width / height;
      var Rs = W / H;
      if (R > Rs) {
        height = H;
        width = H * R;
        marginLeft = (W - H * R) / 2;
      } else {
        width = H * R, height = H;
        marginLeft = (W - H * R) / 2;
      }
      this._setStyle(width, height, marginLeft, marginTop, R, true);
    },
    _setStyle: function _setStyle(w, h, ml, mt, r, isInit) {
      var $container = this.$el.querySelector('.g-crop-image-principal');
      if (!isInit) {
        this.marginLeft = this.marginLeft + (this.width - w) / 2;
        this.marginTop = this.marginTop + (this.height - h) / 2;
      }
      $container.style.cssText = 'width:' + w + 'px;height:' + h + 'px;margin-left:' + ml + 'px;' + 'margin-top:' + mt + 'px';
      this.setCropBox(w, h);
      if (this.isResize) {
        this.width = w;
        this.height = h;
      } else {
        if (r >= this.cropCSS.width / this.cropCSS.height) {
          this.height = this.cropCSS.height;
          this.width = this.height * r;
        } else {
          this.width = this.cropCSS.width;
          this.height = this.width / r;
        }
        this.initWidth = this.width;
        this.initHeight = this.height;
        this.left = (w - this.width) / 2;
        this.top = (h - this.height) / 2;
      }
      this.imgChangeRatio = this.width / this.natrualWidth;
    },
    setCropBox: function setCropBox(w, h, r) {
      if (this.isResize) {
        return;
      }
      var $selectCropBox = this.__find('.crop-box');
      var $wrap = this.$el;
      var imageWidth = w,
          imageHeight = h,
          ratioW = this.ratioW,
          ratioH = this.ratioH;
      var cropWidth = imageWidth;
      if (areaWidth < w) {
        cropWidth = areaWidth;
      }
      var baseCropWidth = cropWidth / 100 * CROPBOX_PERCENT;
      var CSSObj = {
        width: baseCropWidth,
        height: baseCropWidth / ratioW * ratioH
      };
      CSSObj.left = (imageWidth - baseCropWidth) / 2;
      CSSObj.top = (imageHeight - CSSObj.height) / 2;
      $selectCropBox.style.cssText = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.setCssText(CSSObj);
      if (CSSObj.height > imageHeight) {
        var baseCropHeight = imageHeight / 100 * CROPBOX_PERCENT;
        CSSObj.height = baseCropHeight;
        CSSObj.width = CSSObj.height * ratioW / ratioH;
        CSSObj.left = (imageWidth - CSSObj.width) / 2, CSSObj.top = (imageHeight - CSSObj.height) / 2, $selectCropBox.style.cssText = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.setCssText(CSSObj);
      };
      this.cropCSS = CSSObj;
    },
    getCropData: function getCropData() {
      if (this.isResize) {
        return {
          imgChangeRatio: this.imgChangeRatio,
          toCropImgX: 0,
          toCropImgY: 0,
          toCropImgW: this.natrualWidth,
          toCropImgH: this.natrualHeight
        };
      }
      return {
        toCropImgX: (this.cropCSS.left - this.left) / this.imgChangeRatio,
        toCropImgY: (this.cropCSS.top - this.top) / this.imgChangeRatio,
        toCropImgW: this.cropCSS.width / this.imgChangeRatio,
        toCropImgH: this.cropCSS.height / this.imgChangeRatio
      };
    },
    getCropImage: function getCropImage() {
      return this.$refs['crop-image'];
    },
    __find: function __find(str) {
      var dq = this.$el;
      return dq.querySelector(str);
    },
    resize: function resize(e) {
      e.stopPropagation();
      if (!this.ratio.indexOf(':')) {
        return;
      }
      var $el = e.target.parentElement;
      var $container = this.__find('.g-crop-image-principal');
      if (this._$container) {
        this._$container = container;
      }
      var self = this;
      var coor = {
        x: __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile ? e.touches[0].clientX : e.clientX,
        y: __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile ? e.touches[0].clientY : e.clientY,
        w: $el.offsetWidth,
        h: $el.offsetHeight
      };
      this.el = $el;
      this.container = $container;
      var maxCoor = this._getMaxCropAreaWidth();
      var move = function move(ev) {
        var newCropStyle = __WEBPACK_IMPORTED_MODULE_1__lib_resize___default()(ev, self.el, $container, coor, self.ratioVal);
        if (newCropStyle && (newCropStyle.width <= maxCoor.maxWidth || newCropStyle.height <= maxCoor.maxHeight)) {
          self.cropCSS.width = newCropStyle.width;
          self.cropCSS.height = newCropStyle.height;
        }
      };
      var end = function end(ev) {
        this.el = null;
        if (__WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', end, false);
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', end, false);
      };
      if (__WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', end, false);
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', end, false);
    },
    _getMaxCropAreaWidth: function _getMaxCropAreaWidth() {
      var $cropBox = this.__find('.crop-box');
      if (this.width > this.height) {
        return {
          maxWidth: this.height * this.ratioW / this.ratioH,
          maxHeight: this.height
        };
      }
      return {
        maxWidth: this.width,
        maxHeight: this.width * this.ratioH / this.ratioW
      };
    },
    drag: function drag(e) {
      e.preventDefault();
      var $el = this.__find('.image-wrap');
      this.el = $el;
      var $cropBox = this.__find('.crop-box');
      var $container = e.currentTarget;
      var self = this;
      var isMobile = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile;
      var coor = {
        x: (isMobile ? e.touches[0]['clientX'] : e.clientX) - $el.offsetLeft,
        y: (isMobile ? e.touches[0]['clientY'] : e.clientY) - $el.offsetTop,
        maxLeft: $cropBox.offsetLeft,
        maxTop: $cropBox.offsetTop,
        minLeft: $cropBox.offsetWidth + $cropBox.offsetLeft - $el.offsetWidth,
        minTop: $cropBox.offsetHeight + $cropBox.offsetTop - $el.offsetHeight
      };
      var move = function move(ev) {
        var newCropStyle = __WEBPACK_IMPORTED_MODULE_0__lib_drag___default()(ev, self.el, coor);
        if (newCropStyle) {
          self.left = newCropStyle.left;
          self.top = newCropStyle.top;
        }
      };
      var stopMove = function stopMove(ev) {
        self.el = null;
        if (isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', stopMove, false);
          return;
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', stopMove, false);
      };
      if (isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', stopMove, false);
        return;
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', stopMove, false);
    }
  }

});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_helper__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_drag__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_drag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_drag__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    minProgress: {
      type: [Number, String],
      default: 0
    }

  },
  data: function data() {
    return {
      progress: 100,
      left: 100
    };
  },


  methods: {
    setProgress: function setProgress(num) {
      this.left = num;
    },
    drag: function drag(e) {
      e.preventDefault();
      e.stopPropagation();
      var $el = e.target;
      this.el = $el;
      var $container = this.$el.parentElement;
      var self = this;
      var isMobile = __WEBPACK_IMPORTED_MODULE_0__lib_helper___default.a.isMobile;
      var width = 200;
      var coor = {
        x: (isMobile ? e.touches[0]['clientX'] : e.clientX) - $el.offsetLeft,
        y: (isMobile ? e.touches[0]['clientY'] : e.clientY) - $el.offsetTop,
        maxLeft: width,
        maxTop: parseInt($container.style.height) - parseInt($el.style.height),
        minLeft: 0,
        minTop: 0
      };
      var move = function move(ev) {
        var newCoor = __WEBPACK_IMPORTED_MODULE_1__lib_drag___default()(ev, self.el, coor);
        if (newCoor) {
          if (newCoor.left / width < self.minProgress) {
            return;
          }
          self.progress = (newCoor.left - width / 2) / width;
          self.left = newCoor.left / width * 100;

          self.$emit('resize', self.progress);
        }
      };
      var stopMove = function stopMove(ev) {
        self.el = null;
        if (isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', stopMove, false);
          return;
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', stopMove, false);
      };
      if (isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', stopMove, false);
        return;
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', stopMove, false);
    }
  }

});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      rotateDegree: 0
    };
  },


  methods: {
    rotateRight: function rotateRight() {
      this.rotateDegree += 90;
      this.$emit('rotate', this.rotateDegree);
    },
    rotateLeft: function rotateLeft() {
      this.rotateDegree -= 90;
      this.$emit('rotate', this.rotateDegree);
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_image_xhr__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_image_xhr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_image_xhr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_loading_gif__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lib_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__props__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crop_vue__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__crop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resize_bar_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resize_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__resize_bar_vue__);













var overflowVal = '';
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Crop: __WEBPACK_IMPORTED_MODULE_8__crop_vue___default.a,
    ResizeBar: __WEBPACK_IMPORTED_MODULE_9__resize_bar_vue___default.a
  },
  props: __WEBPACK_IMPORTED_MODULE_7__props___default.a,
  data: function data() {
    return {
      files: [],
      hasImage: false,
      options: this.props,
      uploading: false,
      formID: (Math.random() * 10000 + '').split('.')[0],
      image: {
        src: __WEBPACK_IMPORTED_MODULE_5__lib_loading_gif___default.a,
        width: 24,
        height: 24,
        minProgress: 0.05
      }
    };
  },


  computed: {
    name: function name() {
      if (this.multiple) {
        return this.inputOfFile + '[]';
      }
      return this.inputOfFile;
    }
  },

  methods: {
    __dispatch: function __dispatch(name, res, data) {
      this.$emit && this.$emit(name, res, data);
    },
    __find: function __find(str) {
      var dq = document.querySelector('#vciu-modal-' + this.formID);
      return dq.querySelector(str);
    },
    change: function change(e) {
      var _this = this;

      var fileVal = document.querySelector('#g-core-upload-input-' + this.formID).value.replace(/C:\\fakepath\\/i, "");
      var fileExt = fileVal.substring(fileVal.lastIndexOf(".") + 1);
      var extensionsArr = this.extensions.split(',');
      if (extensionsArr.length > 1) {
        var reg = new RegExp('^[' + extensionsArr.join('|') + ']+$', 'i');
        if (!reg.test(fileExt)) {
          return this.__dispatch('errorhandle', 'TYPE ERROR');
        }
      }
      if (e.target.files[0].size > this.maxFileSize) {
        var formatSize;
        if (parseInt(this.maxFileSize / 1024 / 1024) > 0) {
          formatSize = (this.maxFileSize / 1024 / 1024).toFixed(2) + 'MB';
        } else if (parseInt(this.maxFileSize / 1024) > 0) {
          formatSize = (this.maxFileSize / 1024).toFixed(2) + 'kB';
        } else {
          formatSize = options.maxFileSize.toFixed(2) + 'Byte';
        }
        console.warn('FILE IS TOO LARGER MAX FILE IS ' + formatSize);
        return this.__dispatch('errorhandle', 'FILE IS TOO LARGER MAX FILE IS ' + formatSize);
      }

      this.files = e.target.files;
      if (this.crop || this.resize) {
        this.__showImage();
        return;
      }
      this.__dispatch('imagechanged', this.files.length > 1 ? this.files : this.files[0]);
      if (this.compress && this.files[0]['type'] !== 'image/png' && this.files[0]['type'] !== 'image/gif') {
        __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.compress(this.files[0], 100 - this.compress, function (code) {
          _this.tryAjaxUpload('', true, code);
        });
      } else {
        this.tryAjaxUpload();
      }
    },
    __showImage: function __showImage() {
      this.hasImage = true;
      this.__readFiles();
    },
    __readFiles: function __readFiles() {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var src = e.target.result;
        overflowVal = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        self.__initImage(src);
      };
      reader.readAsDataURL(this.files[0]);
    },
    __initImage: function __initImage(src) {
      var pic = new Image();
      var self = this;
      pic.src = src;
      var cropBox = this.$refs.cropBox;
      pic.onload = function () {
        self.image.minProgress = self.minWidth / pic.naturalWidth;
        __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.init(src, function (src) {
          self.imgChangeRatio = cropBox.setImage(src, pic.naturalWidth, pic.naturalHeight);
        });
      };
    },
    resizeImage: function resizeImage(progress) {
      var cropBox = this.$refs.cropBox;
      cropBox.resizeImage(progress);
    },
    doRotate: function doRotate(e) {
      var self = this;
      var cropBox = this.$refs.cropBox;
      var targetImage = cropBox.getCropImage();
      this.data.comprose = 100 - this.compress;
      return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.rotate(targetImage, 1, function (src) {
        self.__initImage(src);
      });
    },
    doReverseRotate: function doReverseRotate(e) {
      var self = this;
      var cropBox = this.$refs.cropBox;
      var targetImage = cropBox.getCropImage();
      this.data.comprose = 100 - this.compress;
      return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.rotate(targetImage, -1, function (src) {
        self.__initImage(src);
      });
    },
    doCrop: function doCrop(e) {
      var _this2 = this;

      this.__setData('crop');
      var cropBox = this.$refs.cropBox;
      var upload = this.__setUpload(e.target);
      if (this.crop === 'local') {
        var targetImage = cropBox.getCropImage();
        this.data.comprose = 100 - this.compress;
        return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.crop(targetImage, this.data, function (code) {
          upload(code);
          _this2.__dispatch('imagechanged', code);
        });
      }
      upload();
    },
    doResize: function doResize(e) {
      var _this3 = this;

      this.__setData('resize');
      var cropBox = this.$refs.cropBox;
      var upload = this.__setUpload(e.target);
      if (this.resize === 'local') {
        var targetImage = cropBox.getCropImage();
        this.data.comprose = 100 - this.compress;
        return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.resize(targetImage, this.data, function (code) {
          upload(code);
          _this3.__dispatch('imagechanged', code);
        });
      }
      upload();
    },
    __setData: function __setData(type) {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) !== 'object') {
        this.data = {};
      }
      this.data["request"] = type;
      var cropBox = this.$refs.cropBox;
      var newCSSObj = cropBox.getCropData();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newCSSObj)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;

          this.data[k] = newCSSObj[k];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.maxWidth) {
        this.data['maxWidth'] = this.maxWidth;
      }
      if (this.maxHeight) {
        this.data['maxHeight'] = this.maxHeight;
      }
      if (this.minWidth) {
        this.data['minWidth'] = this.minWidth;
      }
    },
    __setUpload: function __setUpload(btn) {
      var _this4 = this;

      btn.value = btn.value + '...';
      btn.disabled = true;
      var upload = function upload(code) {
        _this4.tryAjaxUpload(function () {
          btn.value = btn.value.replace('...', '');
          btn.disabled = false;
        }, code ? true : false, code);
      };
      return upload;
    },
    cancel: function cancel() {
      this.hasImage = false;
      document.body.style.overflow = overflowVal;
      this.files = '';
      var cropBox = this.$refs.cropBox;
      cropBox.setOriginalSrc(null);
      document.querySelector('#g-core-upload-input-' + this.formID).value = '';
    },
    tryAjaxUpload: function tryAjaxUpload(callback, isBinary, base64Code) {
      var self = this;
      this.__dispatch('imageuploading', this.files[0]);
      var done = function done(res) {
        if (typeof callback === 'function') {
          callback();
        }
        self.uploading = false;
        self.cancel();
        self.__dispatch('imageuploaded', res, self.data);
      };
      var errorUpload = function errorUpload(err) {
        self.__dispatch('errorhandle', err);
      };
      if (!this.isXhr) {
        if (this.crop) {
          this.hasImage = false;
        }
        return typeof callback === 'function' && callback();
      }
      var data = void 0;
      if (isBinary) {
        data = {
          type: this.files[0]['type'],
          filename: encodeURI(this.files[0]['name']),
          filed: this.inputOfFile,
          base64Code: base64Code
        };
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) === 'object') {
          data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.data, data);
        }
      } else {
        data = new FormData();
        for (var i = 0; i < this.files.length; i++) {
          data.append(this.name, this.files[i]);
        }
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) === 'object') {
          for (var k in this.data) {
            if (this.data[k] !== undefined) {
              data.append(k, this.data[k]);
            }
          }
        }
      }
      __WEBPACK_IMPORTED_MODULE_4_core_image_xhr___default()('POST', this.url, this.headers, data, done, errorUpload, isBinary, this.credentials);
    }
  }

});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'DotLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '60px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        backgroundColor: this.color,
        height: parseFloat(this.size) / 2 + 'px',
        width: parseFloat(this.size) / 2 + 'px',
        borderRadius: this.radius
      };
    },
    spinnerBasicStyle: function spinnerBasicStyle() {
      return {
        height: this.size,
        width: this.size,
        position: 'relative'
      };
    }
  }

});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'SyncLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-syncStretchDelay',
        animationDuration: '0.6s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'ease-in-out',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.07s'
      },
      spinnerDelay2: {
        animationDelay: '0.14s'
      },
      spinnerDelay3: {
        animationDelay: '0.21s'
      }
    };
  }
});

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(60);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(119);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alertbar'
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



var inc = 0;
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: {
      type: String,
      default: function _default() {
        return 'editor-' + ++inc;
      }
    },
    value: {
      type: String
    },
    id: {
      type: String,
      default: function _default() {
        return 'editor-' + inc;
      }
    },
    types: {
      type: String,
      default: function _default() {
        return 'classic';
      }
    },
    config: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    instance: function instance() {
      return CKEDITOR.instances[this.id];
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.value !== this.instance.getData()) {
      this.instance.setData(this.value);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (typeof CKEDITOR === 'undefined') {
      console.log('CKEDITOR is missing (http://ckeditor.com/)');
    } else {
      var config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.config, { extraPlugins: 'divarea' });
      if (this.types === 'inline') {
        CKEDITOR.inline(this.id, config);
      } else {
        CKEDITOR.replace(this.id, config);
      }
      this.instance.on('change', function () {
        var html = _this.instance.getData();
        if (html !== _this.value) {
          _this.$emit('input', html);
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    if (this.instance) {
      setTimeout(function () {
        _this2.instance.focusManager.blur(true);
        _this2.instance.removeAllListeners();
        _this2.instance.destroy();
        _this2.instance = null;
      });
    }
  }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'doctorArrayInput',
  props: {
    dataset: Array,
    description: String
  },
  data: function data() {
    return {
      editIndex: -1
    };
  },

  methods: {
    addData: function addData() {
      if (this.editIndex >= 0) return;

      this.dataset.push('');
      this.editIndex = this.dataset.length - 1;

      var focusDelay = 100;
      var refs = this.$refs;
      setTimeout(function () {
        refs.editData[0].focus();
      }, focusDelay);
    },
    saveData: function saveData(index, $event) {
      if (this.dataset[index].length <= 1) {
        this.dataset.splice(index, 1);
      }
      this.$emit('update:dataset', this.dataset);
      this.editIndex = -1;
    },
    editData: function editData(index) {
      this.editIndex = index;

      var focusDelay = 300;
      var refs = this.$refs;
      setTimeout(function () {
        refs.editData[0].focus();
      }, focusDelay);
    },
    removeData: function removeData(index, event) {
      this.dataset.splice(index, 1);
      this.$emit('update:dataset', this.dataset);
      this.editIndex = -1;
    }
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'doctorSingleInput',
  props: {
    dataset: String,
    description: String
  },
  data: function data() {
    return {
      editIndex: false,
      currentDataset: this.dataset,
      prevDataset: this.dataset
    };
  },

  methods: {
    validEmail: function validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    hideInput: function hideInput() {
      if (this.validEmail(this.currentDataset)) {
        this.$emit('update:dataset', this.currentDataset);
      } else {
        this.currentDataset = this.prevDataset;
      }
      this.dataset = this.prevDataset;
      this.editIndex = false;
    },
    saveData: function saveData(index, $event) {
      this.$emit('update:dataset', this.currentDataset);
      this.editIndex = false;
    },
    editData: function editData() {
      this.editIndex = true;

      var focusDelay = 300;
      var refs = this.$refs;
      setTimeout(function () {
        refs.editData.focus();
      }, focusDelay);
    }
  }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    placeholder: {
      type: String,
      default: 'Drag your file(s) here to begin<br> or click to browse'
    },
    uploadFieldName: {
      type: String,
      default: 'image'
    }
  },
  data: function data() {
    return {
      uploadedFile: null
    };
  },

  computed: {
    isInitial: function isInitial() {
      return this.uploadedFile === null;
    }
  },
  methods: {
    fileChange: function fileChange(event) {
      if (event.target.files.length > 0) {
        this.$emit('fileChange', event.target.files[0]);
      }
    }
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'error-message-box',
  props: {
    message: {
      type: String
    }
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    jq: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a,
    BsInput: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"]
  },
  props: {
    valueRemarks: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    var MODE_NORMAL = 0;
    var MODE_EDIT = 1;
    var MODE_NEW = 2;
    return {
      MODE_NORMAL: MODE_NORMAL,
      MODE_EDIT: MODE_EDIT,
      MODE_NEW: MODE_NEW,
      name: null,
      remarkText: null,
      remarkObj: null,
      mode: MODE_NORMAL,
      remarkList: this.valueRemarks
    };
  },

  computed: {
    enableEditMode: function enableEditMode() {
      return this.mode === this.MODE_NORMAL && this.remarkObj !== null;
    }
  },
  methods: {
    remarkClick: function remarkClick(remarkObj) {
      if (this.mode === this.MODE_NORMAL) {
        this.name = remarkObj.name;
        this.remarkText = remarkObj.text;
        this.remarkObj = remarkObj;
      }
    },
    closeEditor: function closeEditor() {
      this.$emit('closeEditor');
    },
    saveRemarks: function saveRemarks() {
      if (this.mode === this.MODE_EDIT) {
        this.remarkObj.name = this.name;
        this.remarkObj.text = this.remarkText;
      } else if (this.mode === this.MODE_NEW) {
        this.remarkList.push({ name: this.name, text: this.remarkText });
        this.remarkObj = null;
        this.name = null;
        this.remarkText = null;
      }
      this.mode = this.MODE_NORMAL;
    },
    gotoEditMode: function gotoEditMode() {
      this.mode = this.MODE_EDIT;
    },
    deleteRemark: function deleteRemark() {
      var _this = this;

      this.remarkList = this.remarkList.filter(function (r) {
        return r.name !== _this.remarkObj.name;
      });
    },
    cancelMode: function cancelMode() {
      this.mode = this.MODE_NORMAL;
      this.remarkObj = null;
      this.name = null;
      this.remarkText = null;
    },
    gotoNewMode: function gotoNewMode() {
      this.mode = this.MODE_NEW;
      this.remarkObj = null;
      this.name = null;
      this.remarkText = null;
    },
    saveEditor: function saveEditor() {
      this.$emit('comment-updated', this.remarkList);
      this.$emit('submitRemark');
      this.$emit('closeEditor');
    }
  },
  watch: {
    values: function values(v, o) {
      this.remarkList = v;
    },

    valueRemarks: function valueRemarks(newVal, oldVal) {
      this.remarkList = newVal;
    }
  },
  mounted: function mounted() {},
  created: function created() {}
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StepBar',
  props: {
    currentStep: Number,
    maxStep: Number
  },
  methods: {
    stepClick: function stepClick(s) {
      this.$emit('step_clicked', s);
    }
  },
  computed: {
    steps: function steps() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(this.maxStep).keys()));
    },
    gridClass: function gridClass() {
      var colSize = 12;
      var gridClass = 'col-' + parseInt(colSize / this.maxStep);
      return gridClass;
    }
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    jq: __WEBPACK_IMPORTED_MODULE_1_jquery___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  props: {
    clinic_id: Number,
    doctor_id: Number,
    booking_per_slot: Number,
    number_options: Array
  },
  data: function data() {
    var minNumber = 1;
    var maxNumber = 5;
    return {
      booking: 4,
      numberOptions: this.generateNumber(minNumber, maxNumber).map(function (v) {
        return v.toString();
      })
    };
  },

  methods: {
    generateNumber: function generateNumber(start, end) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: end - start }, function (v, k) {
        return k + start;
      });
    }
  },
  watch: {
    booking: function booking(v, old) {
      if (v) {
        this.$emit('bookingPerSlotChanged', this.clinic_id, parseInt(v));
      }
    }
  },
  created: function created() {
    if (this.booking_per_slot) {
      this.booking = this.booking_per_slot;
    }

    if (this.number_options) {
      this.numberOptions = this.number_options;
    }
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_timepicker__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_timepicker__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_1_vue2_timepicker___default.a
  },
  props: {
    schedules: Array,
    clinic_id: Number,
    doctor_id: Number,
    booking_per_slot: Number,
    time_slots: Number,
    advance_week_option: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      days: [{
        name: this.$t('message.schedules.monday'),
        week_day: 'mon',
        selected: false,
        timetable: [],
        showAdvance: false,
        week_1_enable: 1,
        week_2_enable: 1,
        week_3_enable: 1,
        week_4_enable: 1,
        week_5_enable: 1,
        week_last_enable: 1
      }, {
        name: this.$t('message.schedules.tuesday'),
        week_day: 'tue',
        selected: false,
        timetable: [],
        showAdvance: false,
        week_1_enable: 1,
        week_2_enable: 1,
        week_3_enable: 1,
        week_4_enable: 1,
        week_5_enable: 1,
        week_last_enable: 1
      }, {
        name: this.$t('message.schedules.wednesday'),
        week_day: 'wed',
        selected: false,
        timetable: [],
        showAdvance: false,
        week_1_enable: 1,
        week_2_enable: 1,
        week_3_enable: 1,
        week_4_enable: 1,
        week_5_enable: 1,
        week_last_enable: 1
      }, {
        name: this.$t('message.schedules.thursday'),
        week_day: 'thu',
        selected: false,
        timetable: [],
        showAdvance: false,
        week_1_enable: 1,
        week_2_enable: 1,
        week_3_enable: 1,
        week_4_enable: 1,
        week_5_enable: 1,
        week_last_enable: 1
      }, {
        name: this.$t('message.schedules.friday'),
        week_day: 'fri',
        selected: false,
        timetable: [],
        showAdvance: false,
        week_1_enable: 1,
        week_2_enable: 1,
        week_3_enable: 1,
        week_4_enable: 1,
        week_5_enable: 1,
        week_last_enable: 1
      }, {
        name: this.$t('message.schedules.saturday'),
        week_day: 'sat',
        selected: false,
        timetable: [],
        showAdvance: false,
        week_1_enable: 1,
        week_2_enable: 1,
        week_3_enable: 1,
        week_4_enable: 1,
        week_5_enable: 1,
        week_last_enable: 1
      }, {
        name: this.$t('message.schedules.sunday'),
        week_day: 'sun',
        selected: false,
        timetable: [],
        showAdvance: false,
        week_1_enable: 1,
        week_2_enable: 1,
        week_3_enable: 1,
        week_4_enable: 1,
        week_5_enable: 1,
        week_last_enable: 1
      }]
    };
  },

  methods: {
    addDefaultTimetable: function addDefaultTimetable(day) {
      if (day.selected) {
        if (day.timetable.length === 0) {
          day.timetable.push({
            from_time: {
              HH: '08',
              mm: '00'
            },
            to_time: {
              HH: '17',
              mm: '00'
            }
          });
        }
      } else {
        day.timetable = [];
      }
    },
    addMoreTimetable: function addMoreTimetable(day) {
      var overHour = 25;
      var workHour = 10;
      var offsetNextHour = 1;
      var offsetNextThreeHour = 4;
      var prevTime = day.timetable[day.timetable.length - 1];
      var nextHour = +prevTime.to_time.HH + offsetNextHour;
      if (nextHour === overHour) nextHour = 0;
      nextHour = nextHour >= workHour ? nextHour + '' : '0' + nextHour;

      var endHour = +prevTime.to_time.HH + offsetNextThreeHour;
      if (endHour === overHour) endHour = 0;
      endHour = endHour >= workHour ? endHour + '' : '0' + endHour;
      day.timetable.push({
        from_time: {
          HH: nextHour,
          mm: '00'
        },
        to_time: {
          HH: endHour,
          mm: '00'
        }
      });
    },
    removeTimetable: function removeTimetable(timetable, index) {
      timetable.splice(index, 1);
    },
    _tranformSchedule: function _tranformSchedule() {
      var self = this;
      var schedule = [];
      var defaultSlot = 30;
      var defaultBooking = 4;
      this.days.forEach(function (d) {
        if (d.selected) {
          d.timetable.forEach(function (t) {
            var newSchedule = {
              doctor_id: self.doctor_id,
              clinic_id: self.clinic_id,
              week_day: d.week_day,
              time_from: t.from_time.HH + ':' + t.from_time.mm,
              time_to: t.to_time.HH + ':' + t.to_time.mm,
              time_slots: self.time_slots || defaultSlot,
              booking_per_slot: self.booking_per_slot || defaultBooking,
              week_1_enable: d.week_1_enable,
              week_2_enable: d.week_2_enable,
              week_3_enable: d.week_3_enable,
              week_4_enable: d.week_4_enable,
              week_5_enable: d.week_5_enable,
              week_last_enable: d.week_last_enable
            };
            if (t.id) newSchedule.id = t.id;
            schedule.push(newSchedule);
          });
        }
      });
      return schedule;
    },
    _convertTimeForPicker: function _convertTimeForPicker(t) {
      var hms = t.split(':');
      return {
        HH: hms[0],
        mm: hms[1]
      };
    },
    emitScheduleChangedEvent: function emitScheduleChangedEvent() {
      this.$emit('scheduleChanged', this.clinic_id, this._tranformSchedule());
    }
  },
  watch: {
    days: {
      handler: function handler(v, o) {
        this.emitScheduleChangedEvent();
      },

      deep: true
    },
    booking_per_slot: {
      handler: function handler(v, o) {
        this.emitScheduleChangedEvent();
      },

      deep: true
    },
    time_slots: {
      handler: function handler(v, o) {
        this.emitScheduleChangedEvent();
      },

      deep: true
    }
  },
  created: function created() {
    var self = this;
    this.schedules.forEach(function (s) {
      var d = self.days.find(function (_d) {
        return _d.week_day === s.week_day;
      });
      d.showAdvance = s.week_1_enable === 0 || s.week_2_enable === 0 || s.week_3_enable === 0 || s.week_4_enable === 0 || s.week_5_enable === 0 || s.week_last_enable === 0;
      d.selected = true;
      d.week_1_enable = s.week_1_enable;
      d.week_2_enable = s.week_2_enable;
      d.week_3_enable = s.week_3_enable;
      d.week_4_enable = s.week_4_enable;
      d.week_5_enable = s.week_5_enable;
      d.week_last_enable = s.week_last_enable;
      d.timetable.push({
        id: s.id,
        from_time: self._convertTimeForPicker(s.time_from),
        to_time: self._convertTimeForPicker(s.time_to)
      });
    });
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    start_time: {
      type: String,
      default: '9:00'
    },
    time_slots: {
      type: Number,
      default: 30
    },
    booking_per_slot: {
      type: Number,
      default: 4
    }
  },
  computed: {
    previews: function previews() {
      var _this = this;

      var time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.start_time, 'HH:mm');
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(4).keys())).map(function (n) {
        var timeString = time.format('HH:mm');
        time = time.add(_this.time_slots, 'minutes');
        return { time: timeString, booking: _this.booking_per_slot };
      });
    },
    previewIcons: function previewIcons() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(this.booking_per_slot).keys()));
    }
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    jq: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
  },
  props: {
    clinic_id: Number,
    doctor_id: Number,
    time_slots: Number,
    slot_options: Array
  },
  data: function data() {
    return {
      slots: 30,
      slotOptions: [10, 15, 20, 30, 60].map(function (time) {
        return time.toString();
      })
    };
  },

  watch: {
    slots: function slots(v, old) {
      if (v) {
        this.$emit('timeSlotsChanged', this.clinic_id, parseInt(v));
      }
    }
  },
  created: function created() {
    if (this.time_slots) {
      this.slots = this.time_slots;
    }

    if (this.slot_options) {
      this.slotOptions = this.slot_options;
    }
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
  props: {
    chartData: Object
  },
  data: function data() {
    return {
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'transparent',
              zeroLineColor: 'transparent'
            },
            ticks: {
              fontSize: 2,
              fontColor: 'transparent'
            }
          }],
          yAxes: [{
            ticks: {
              min: 0,
              beginAtZero: true,
              callback: function callback(value, index, values) {
                if (Math.floor(value) === value) {
                  return value;
                }
                return '';
              }
            }
          }]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 1,
            hitRadius: 4,
            hoverRadius: 4
          }
        }
      }
    };
  },

  methods: {
    refreshRenderChart: function refreshRenderChart() {
      this.renderChart(this.chartData, this.options);
    }
  },
  mounted: function mounted() {
    this.refreshRenderChart();
  }
}));

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
  props: {
    chartData: Object
  },
  data: function data() {
    return {
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'transparent',
              zeroLineColor: 'transparent'
            },
            ticks: {
              fontSize: 2,
              fontColor: 'transparent'
            }
          }],
          yAxes: [{
            ticks: {
              min: 0,
              beginAtZero: true,
              callback: function callback(value, index, values) {
                if (Math.floor(value) === value) {
                  return value;
                }
                return '';
              }
            }
          }]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 1,
            hitRadius: 4,
            hoverRadius: 4
          }
        }
      }
    };
  },

  methods: {
    refreshRenderChart: function refreshRenderChart() {
      this.renderChart(this.chartData, this.options);
    }
  },
  mounted: function mounted() {
    this.refreshRenderChart();
  }
}));

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aside'
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer'
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Navbar__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_2__Navbar___default.a,
    dropdown: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["dropdown"]
  },
  computed: {
    userName: function userName() {
      if (this.$guser.isClinic(this.$route)) {
        return this.$guser.user.name;
      }
      if (this.$guser.isDoctor()) {
        return this.$guser.user.doctor.firstname + ' ' + this.$guser.user.doctor.lastname;
      }
      return 'admin';
    }
  },
  methods: {
    click: function click() {},
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    signout: function signout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$guser.signout();

              case 2:
                _this.$router.push('/auth/login');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changeLang: function changeLang(lang) {
      this.$ls.set('lang', lang);
      this.$i18n.locale = lang;
    }
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbar',
  created: function created() {
    this._navbar = true;
  },

  computed: {
    displayNavbar: function displayNavbar() {
      if (this.$route.query.app === null || this.$route.query.app === undefined) {
        return true;
      } else if (parseInt(this.$route.query.app) === 1) {
        return false;
      }
      return true;
    }
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweet_modal_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(19);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  components: {
    SweetModal: __WEBPACK_IMPORTED_MODULE_2_sweet_modal_vue__["a" /* SweetModal */]
  },
  data: function data() {
    return {
      clinic: {},
      clinicUrl: this.$guser.user.clinic ? this.$APP_CONFIG.api.domain + '/clinic/' + this.$guser.user.clinic.slug : '',
      doctorUrl: this.$guser.user.doctor ? this.$APP_CONFIG.api.domain + '/doctor/' + this.$guser.user.doctor.slug : '',
      currentPending: 0
    };
  },
  firebase: function firebase() {
    if (this.$guser.isClinic()) {
      return {
        notifications: {
          source: this.$rtdb.ref('notifications/' + this.$guser.user.clinic.id),
          asObject: true
        }
      };
    } else {
      return {};
    }
  },

  computed: {
    showPending: function showPending() {
      return this.notifications != null && this.notifications.pendingAppointmentNumber != null && this.notifications.pendingAppointmentNumber > 0;
    },
    pendingSize: function pendingSize() {
      if (this.notifications != null && this.notifications.pendingAppointmentNumber != null) {
        if (this.notifications.pendingAppointmentNumber > this.currentPending) {
          this.player.play();
        }
        this.currentPending = this.notifications.pendingAppointmentNumber;
        return this.notifications.pendingAppointmentNumber;
      } else {
        return 0;
      }
    }
  },
  methods: {
    handleClick: function handleClick(e) {},
    handleMenuClick: function handleMenuClick(e) {
      if (this.$ismobile()) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
      }
    },
    signout: function signout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$guser.signout();

              case 2:
                _this.$router.push('/auth/login');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkFeature: function checkFeature(name) {
      if (!this.$guser.isPremiumAccount()) {
        this.$refs.lockModal.open();
        return false;
      }
      return true;
    },
    gotoPlanPage: function gotoPlanPage() {
      this.$refs.lockModal.close();
      if (this.$guser.isClinic()) {
        __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].push({ 'path': '/package', query: { 'type': 'clinic' } });
      } else if (this.$guser.isDoctor()) {
        __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].push({ 'path': '/package', query: { 'type': 'doctor' } });
      }
    },
    isActive: function isActive() {
      return this.$guser.user.clinic && this.$guser.user.clinic.active === 1;
    }
  },
  mounted: function mounted() {
    this.player = document.getElementById('player');
  }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_containerComponents_Header__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_containerComponents_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_containerComponents_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_containerComponents_Sidebar__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_containerComponents_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_containerComponents_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_containerComponents_Aside__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_containerComponents_Aside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_containerComponents_Aside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_containerComponents_Footer__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_containerComponents_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_containerComponents_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_containerComponents_Breadcrumb__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_containerComponents_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_containerComponents_Breadcrumb__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_containerComponents_Header___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components_containerComponents_Sidebar___default.a,
    AppAside: __WEBPACK_IMPORTED_MODULE_2__components_containerComponents_Aside___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_3__components_containerComponents_Footer___default.a,
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components_containerComponents_Breadcrumb___default.a
  },
  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_flatpickr_component__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_flatpickr_css__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_flatpickr_css__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BsInput: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
    BsDatepicker: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["datepicker"],
    flatPickr: __WEBPACK_IMPORTED_MODULE_2_vue_flatpickr_component___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  },
  data: function data() {
    return {
      showAddPanel: false,
      editMode: false,
      appointments: [],
      appointment: {},
      q: '',
      paginator: {}
    };
  },

  computed: {
    filtered_appointments: function filtered_appointments() {
      var _this = this;

      var _appointments = this.appointments;
      if (this.q.trim()) {
        _appointments = _appointments.filter(function (a) {
          return a.object.phone.match(new RegExp(_this.q));
        });
      }

      return _appointments.sort(function (a, b) {
        return a.created_at < b.created_at;
      });
    },
    isPendingView: function isPendingView() {
      return this.$route.query.status === 'pending';
    }
  },
  watch: {
    $route: function $route(v, o) {
      this.reloadAppointments();
    }
  },
  methods: {
    addAppointment: function addAppointment() {},
    cancelAddingAppointment: function cancelAddingAppointment() {},
    removeAppointment: function removeAppointment() {},
    reloadAppointments: function reloadAppointments(uri) {
      var _this2 = this;

      var params = { clinic_id: this.$guser.user.clinic.id };
      if (this.$route.query.status === 'pending') {
        params.status = this.$route.query.status;
      }

      this.$http.get(uri || this.$APP_CONFIG.api.appointments(), { params: params, credentials: true }).then(function (res) {
        _this2.appointments = res.body.data;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this2.paginator, {
          from: res.body.from,
          to: res.body.to,
          total: res.body.total,
          per_page: res.body.per_page,
          current_page: res.body.per_page,
          next_page_url: res.body.next_page_url,
          prev_page_url: res.body.prev_page_url
        });
      });
    }
  },
  created: function created() {
    this.reloadAppointments();
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fullcalendar_dist_fullcalendar_min_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fullcalendar_dist_fullcalendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fullcalendar_dist_fullcalendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fullcalendar_scheduler_dist_scheduler_min_css__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fullcalendar_scheduler_dist_scheduler_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_fullcalendar_scheduler_dist_scheduler_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_flatpickr_dist_flatpickr_css__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_flatpickr_dist_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_intl_tel_input_build_css_intlTelInput_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_intl_tel_input_build_css_intlTelInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_intl_tel_input_build_css_intlTelInput_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fullcalendar__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fullcalendar_scheduler__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fullcalendar_scheduler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_fullcalendar_scheduler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_intl_tel_input__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_intl_tel_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_intl_tel_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appointment_mixin__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweet_modal_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_flatpickr_component__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_spinner_src_SyncLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_spinner_src_DotLoader__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_spinner_src_DotLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_spinner_src_DotLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ErrorMessageBox__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ErrorMessageBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_ErrorMessageBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_RemarkEditor__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_RemarkEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_RemarkEditor__);



























/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_13__appointment_mixin__["a" /* default */]],
  components: {
    SweetModal: __WEBPACK_IMPORTED_MODULE_17_sweet_modal_vue__["a" /* SweetModal */],
    BsInput: __WEBPACK_IMPORTED_MODULE_19_vue_strap__["input"],
    flatPickr: __WEBPACK_IMPORTED_MODULE_18_vue_flatpickr_component___default.a,
    buttonGroup: __WEBPACK_IMPORTED_MODULE_19_vue_strap__["buttonGroup"],
    radio: __WEBPACK_IMPORTED_MODULE_19_vue_strap__["radio"],
    SyncLoader: __WEBPACK_IMPORTED_MODULE_20_vue_spinner_src_SyncLoader___default.a,
    DotLoader: __WEBPACK_IMPORTED_MODULE_21_vue_spinner_src_DotLoader___default.a,
    dropdown: __WEBPACK_IMPORTED_MODULE_19_vue_strap__["dropdown"],
    errorBox: __WEBPACK_IMPORTED_MODULE_22__components_ErrorMessageBox___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_16_vue_multiselect___default.a,
    RemarkEditor: __WEBPACK_IMPORTED_MODULE_23__components_RemarkEditor___default.a,
    modal: __WEBPACK_IMPORTED_MODULE_19_vue_strap__["modal"]
  },
  props: {
    mode: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      showModal: false,
      monthView: 'month',
      weekView: 'agendaWeek',
      dayView: 'agendaDay',
      loading: false,
      selected_patient: null,
      patient_list: [],
      patient_type: 'exists',
      radioValue: null,
      resourcesAdded: false,
      filter_date_type: 'all',
      filter_date_range: __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('YYYY-MM-DD') + ' to ' + __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('YYYY-MM-DD'),
      export_date_range: __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('YYYY-MM-DD') + ' to ' + __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('YYYY-MM-DD'),
      viewType: 'daily',
      appointment: { duration: 15 },
      editMode: false,
      calendarLoading: false,
      appointmentLoading: false,
      appointmentLoaded: false,
      appointments: [],
      resources: [],
      events: [],
      specialties: [],
      status_options: ['noshow', 'checkin', 'checkout', 'engaged', 'cancel', 'scheduled', 'rescheduled'].map(function (v) {
        return { label: v, value: v };
      }),
      services: [],
      rawServices: [],
      defaultDate: new Date(),
      filter_by_specialty: null,
      filter_by_doctor: null,
      filter_by_clinic: null,
      filter_by_status: null,
      filter_by_service: null,
      filter_by_hn: null,
      filter_search: null,
      count_search: 0,
      filter_searchs: '',
      filter_by_specialties: [],
      filter_by_doctors: [],
      filter_by_clinics: [],
      filter_by_status_list: [],
      filter_by_services: [],
      filter_by_hns: [],
      display_resources: [],
      display_events: [],
      doctor_options: [],
      clinic_options: [],
      service_options: [],
      locale_options: [{ value: 'en', label: 'English' }, { value: 'th', label: 'ไทย' }],
      initedCalendar: false,
      fpConfig: {
        enableTime: true,
        altInput: true,
        wrap: true,
        time_24hr: true
      },
      dateConfig: {
        enableTime: false,
        altInput: true,
        wrap: true
      },
      fc: null,
      apmFrm: this.getAppointmentFormError(),
      patientLoading: false,
      paginator: {},
      processEventLoading: false,
      doctors: [],
      doctorLoading: false,
      clinicLoading: false,
      hn_options: [],
      hnLoading: false,
      readyRenderCalendar: {},
      hnQuery: null,
      prefix_options: [{ value: 'mrs', label: this.$t('message.appointment.prefix_mrs') }, { value: 'mr', label: this.$t('message.appointment.prefix_mr') }, { value: 'ms', label: this.$t('message.appointment.prefix_ms') }, { value: 'master', label: this.$t('message.appointment.prefix_master') }, { value: 'miss', label: this.$t('message.appointment.prefix_miss') }],
      templates: {
        remark_templates: []
      },
      date: null,
      exportFields: [],
      selectedExportFieldIds: [],
      openedExportFields: false,
      updateReq: {
        start: null,
        end: null,
        appointment_id: null,
        sms_confirmation: true,
        loading: false
      },
      hasCustomSlot: false,
      slot: 10
    };
  },

  computed: {
    existing_patient: function existing_patient() {
      return this.patient_type === 'exists';
    },
    show_calendar_view: function show_calendar_view() {
      return this.viewType === 'monthly' || this.viewType === 'weekly' || this.viewType === 'daily';
    },
    inview_doctors: function inview_doctors() {
      return this.resources.map(function (r) {
        return { label: r.title, value: r.id };
      });
    },
    inview_status: function inview_status() {
      var temp = [];
      return this.appointments.map(function (a) {
        if (!temp.includes(a.object.status)) {
          temp.push(a.object.status);
          return { label: a.object.status, value: a.object.status };
        } else {
          return null;
        }
      }).filter(function (_a) {
        return !!_a;
      });
    },
    display_appointments: function display_appointments() {
      var _this = this;

      var _apps = this.appointments;
      if (this.filter_by_specialty && this.filter_by_specialty.value) {
        _apps = _apps.filter(function (r) {
          var d = r.object.doctor;
          return d && d.specialities[0] && d.specialities[0].name === _this.filter_by_specialty.label;
        });
      }
      if (this.filter_by_doctor && this.filter_by_doctor.value) {
        _apps = _apps.filter(function (r) {
          return r.object.doctor && r.object.doctor.id === _this.filter_by_doctor.value;
        });
      }
      if (this.filter_by_service && this.filter_by_service.value && this.show_calendar_view) {
        _apps = _apps.filter(function (r) {
          return r.object.service_id === _this.filter_by_service.value;
        });
      }
      if (this.hnQuery) {
        _apps = _apps.filter(function (a) {
          return a.object.hn && a.object.hn.search(_this.hnQuery) > -1;
        });
      }
      return _apps;
    }
  },
  methods: {
    changeAppointmentService: function changeAppointmentService(selectedOption, id) {
      var changeService = this.services.find(function (s) {
        return s.value === selectedOption.value;
      });
      this.appointment.duration = changeService.duration;
    },
    getSearch: function getSearch(search, doctor, specialty, status, type, from, to) {
      var _this2 = this;

      var params = {};
      if (doctor) {
        doctor = doctor.value;
      }
      if (specialty) {
        specialty = specialty.value;
      }
      if (type === 'all') {
        params = {
          clinic_id: this.$guser.user.clinic ? this.$guser.user.clinic.id : null,
          doctor_id: doctor,
          search_term: search,
          specialty: specialty,
          start: 'all'
        };
      } else {
        if (!from && !to) {
          var dateSplitRange = 2;
          var dates = this.filter_date_range.split('to');
          if (dates.length === dateSplitRange) {
            from = dates[0].trim();
            to = dates[1].trim();
          }
        }
        if (from && to) {
          params = {
            clinic_id: this.$guser.user.clinic ? this.$guser.user.clinic.id : null,
            doctor_id: doctor,
            search_term: search,
            specialty: specialty,
            start: from,
            end: to
          };
        }
      }
      if (status && status.value) {
        params.status = status.value;
      }
      this.appointmentLoaded = false;
      this.appointmentLoading = true;
      this.$http.get(this.$APP_CONFIG.api.appointments(), {
        params: params,
        credentials: true
      }).then(function (res) {
        _this2.appointmentLoading = false;
        _this2.appointmentLoaded = true;
        _this2.appointments = res.body.data;
        _this2.paginator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
          from: res.body.from,
          to: res.body.to,
          total: res.body.total,
          per_page: res.body.per_page,
          current_page: res.body.current_page,
          next_page_url: res.body.next_page_url,
          prev_page_url: res.body.prev_page_url
        });
      });
    },
    getDoctorsOptions: function getDoctorsOptions(search) {
      var self = this;
      var params = {
        doctor_name: search, clinic_id: self.$guser.user.clinic.id
      };
      if (self.filter_by_specialty && self.filter_by_specialty.value) {
        params.speciality_id = self.filter_by_specialty.value;
      }
      self.doctorLoading = true;
      this.$http.get(self.$APP_CONFIG.api.admin.doctors(), {
        params: params,
        credentials: true
      }).then(function (resp) {
        var doctors = resp.body.data.map(function (d) {
          if (!self.resources.find(function (r) {
            return r.id === d.id;
          })) {
            self.resources.push({
              id: d.id,
              title: '' + (self.$i18n.locale === 'th' ? d.name_th : d.name_en),
              specialty: d.specialities[0] && (self.$i18n.locale === 'th' ? d.specialities[0].name_th : d.specialities[0].name_en) || 'Other',
              order: 999
            });
          }

          return {
            value: d.id,
            label: self.$i18n.locale === 'th' ? d.name_th : d.name_en,
            data: d
          };
        });
        doctors.forEach(function (d) {
          var fd = self.doctor_options.find(function (doctorOption) {
            return doctorOption.value === d.value;
          });
          if (!fd) {
            self.doctor_options.push(d);
          }
        });
        self.doctorLoading = false;
      });
    },
    getClinicsOptions: function getClinicsOptions(search) {},
    getPatients: function getPatients(search) {
      var _this3 = this;

      this.patientLoading = true;
      this.$http.get(this.$APP_CONFIG.api.admin.patient(), { params: { clinic_id: this.$guser.user.clinic.id, search: search } }).then(function (res) {
        _this3.patientLoading = false;
        _this3.patient_list = res.body.data.map(function (p) {
          return { label: _this3.patientDesc(p), value: p.id, data: p };
        });
      });
    },
    patientDesc: function patientDesc(p) {
      return p.firstname + ' ' + p.lastname + ' - ' + p.phone + ' ' + (p.email ? '- ' + p.email : '') + ' ' + (p.hn ? '- HN:' + p.hn : '');
    },
    getHnOptions: function getHnOptions(search) {
      var self = this;
      var params = {
        doctor_name: search, clinic_id: self.$guser.user.clinic.id
      };
      if (self.filter_by_specialty && self.filter_by_specialty.value) {
        params.speciality_id = self.filter_by_specialty.value;
      }
      self.doctorLoading = true;
      this.$http.get(self.$APP_CONFIG.api.admin.doctors(), {
        params: params,
        credentials: true
      }).then(function (resp) {
        var doctors = resp.body.data.map(function (d) {
          if (!self.resources.find(function (r) {
            return r.id === d.id;
          })) {
            self.resources.push({
              id: d.id,
              title: '' + (self.$i18n.locale === 'th' ? d.name_th : d.name_en),
              specialty: d.specialities[0] && (self.$i18n.locale === 'th' ? d.specialities[0].name_th : d.specialities[0].name_en) || 'Other',
              order: 999
            });
          }
          return {
            value: d.id,
            label: self.$i18n.locale === 'th' ? d.name_th : d.name_en,
            data: d
          };
        });
        doctors.forEach(function (d) {
          var fd = self.doctor_options.find(function (doctorOption) {
            return doctorOption.value === d.value;
          });
          if (!fd) {
            self.doctor_options.push(d);
          }
        });

        self.doctorLoading = false;
      });
    },
    openNewAppointmentForm: function openNewAppointmentForm(isStatus) {
      var _this4 = this;

      this.editMode = false;
      this.$refs.patient_type_a.click();
      this.appointment = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({
        id: null,
        firstname: null,
        lastname: null,
        phone: '',
        duration: 15,
        service_id: null,
        doctor_id: null,
        comment: null,
        email: null,
        remark: null,
        locale: this.locale_options.find(function (s) {
          return s.value === _this4.$i18n.locale;
        }),
        admin_note: null,
        sms_feedback_to_patient: true
      }, { appointment_time: __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('YYYY-MM-DD 09:00') });
      if (isStatus) {
        this.$refs.modal.open();
      }
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#phone').intlTelInput('setNumber', '');
      this.templates.remark_templates = this.$guser.user.clinic.remark_templates;
    },
    delay: function delay(time) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                  setTimeout(function () {
                    resolve();
                  }, time);
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    switchView: function switchView(v) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this6.viewType = v;
                _context2.next = 3;
                return _this6.delay(1);

              case 3:
                _this6.appointments = [];

                if (!(v === 'monthly' || v === 'weekly' || v === 'daily')) {
                  _context2.next = 12;
                  break;
                }

                if (!_this6.initedCalendar) {
                  _context2.next = 9;
                  break;
                }

                if (v === 'monthly') {
                  _this6.fc.fullCalendar('changeView', _this6.monthView);
                } else if (v === 'weekly') {
                  _this6.fc.fullCalendar('changeView', _this6.weekView, __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('YYYY-MM-DD'));
                } else if (v === 'daily') {
                  _this6.fc.fullCalendar('changeView', _this6.dayView, __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('YYYY-MM-DD'));
                }
                _context2.next = 11;
                break;

              case 9:
                _context2.next = 11;
                return _this6.setupCalendar();

              case 11:
                return _context2.abrupt('return');

              case 12:

                if (v === 'list') {
                  _this6.viewType = 'list';
                  _this6.hnQuery = null;
                  _this6.filter_date_type = 'range';
                  if (!_this6.filter_date_range) {
                    _this6.filter_date_range = __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('YYYY-MM-DD') + ' to ' + __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('YYYY-MM-DD');
                  } else {
                    _this6.loadAppointments(_this6.filter_by_status, _this6.filter_date_type);
                  }
                }

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    switchTime: function switchTime(type) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (type === 'range') {
                  _this7.filter_date_type = 'range';
                } else {
                  _this7.filter_date_type = 'all';
                }
                _context3.next = 3;
                return _this7.loadAppointments(_this7.filter_by_status, _this7.filter_date_type);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    _buildAppointment: function _buildAppointment(ap) {
      if (ap.object.ehr_patient_id) {
        this.$refs.patient_type_b.click();
        this.selected_patient = { label: this.patientDesc(ap.object), value: ap.object.ehr_patient_id, data: ap.object };
        this.patient_list = [this.selected_patient];
      } else {
        this.$refs.patient_type_a.click();
      }
      return {
        id: ap.object.id,
        firstname: ap.object.firstname,
        lastname: ap.object.lastname,
        appointment_time: ap.object.appointment_time,
        duration: ap.object.duration,
        service_id: ap.object.service_id,
        service: this.services.find(function (s) {
          return s.value === ap.object.service_id;
        }),
        doctor_id: ap.object.doctor_id,
        doctor: this.doctor_options.find(function (d) {
          return d.value === ap.object.doctor_id;
        }),
        comment: ap.object.comment,
        remark: ap.object.remark,
        locale: this.locale_options.find(function (s) {
          return s.value === ap.object.locale;
        }),
        admin_note: ap.object.admin_note,
        email: ap.object.email,
        status: ap.object.status,
        ehr_patient_id: ap.object.ehr_patient_id,
        phone: ap.object.phone,
        birthday: ap.object.birthday,
        prefix: ap.object.prefix,
        id_card: ap.object.id_card,
        hn: ap.object.hn,
        sms_feedback_to_patient: ap.object.sms_feedback_to_patient
      };
    },
    removeAppointment: function removeAppointment() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this8.$confirm(_this8.$t('message.appointment.are_you_wath_to_cancel'));

              case 2:
                if (!_context4.sent) {
                  _context4.next = 4;
                  break;
                }

                _this8.$http.delete(_this8.$APP_CONFIG.api.appointment_id(_this8.appointment.id)).then(function (res) {
                  if (res.body) {
                    _this8.$refs.modal.close();
                    _this8.editMode = false;
                    _this8.$toastr.success(_this8.$t('message.appointment.cancel_appointment_success'));
                    if (_this8.show_calendar_view) {
                      _this8.fc.fullCalendar('removeEvents', res.body.id);
                    } else {
                      _this8.appointments = _this8.appointments.filter(function (a) {
                        return a.id !== res.body.id;
                      });
                    }
                  }
                });

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this8);
      }))();
    },
    cancelAppointment: function cancelAppointment(id) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this9.$confirm(_this9.$t('message.appointment.are_you_wath_to_cancel'));

              case 2:
                if (!_context5.sent) {
                  _context5.next = 4;
                  break;
                }

                _this9.$http.put(_this9.$APP_CONFIG.api.admin.appointment_action(id, 'cancel')).then(function (res) {
                  if (res.body) {
                    _this9.$refs.modal.close();
                    _this9.editMode = false;
                    _this9.$toastr.success(_this9.$t('message.appointment.cancel_appointment_success'));
                    if (_this9.show_calendar_view) {
                      _this9.refetchEventsDelay();
                    } else {
                      _this9.loadAppointments(_this9.filter_by_status, _this9.filter_date_type);
                    }
                  }
                });

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },
    editAppointment: function editAppointment(ap) {
      this.editMode = true;
      this.appointment = this._buildAppointment(ap);
      this.$refs.modal.open();
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#phone').intlTelInput('setNumber', ap.object.phone);
    },
    displayAppointmentDate: function displayAppointmentDate(start) {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(start).format('LL');
    },
    displayAppointmentDateTime: function displayAppointmentDateTime(date) {
      if (!date) return '';
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(date).format('LLL');
    },
    displayAppointmentTime: function displayAppointmentTime(start, duration) {
      var minuteUnit = 60;
      var millisUnit = 1000;
      var s = __WEBPACK_IMPORTED_MODULE_14_moment___default()(start);
      duration = +duration || 0;
      var end = __WEBPACK_IMPORTED_MODULE_14_moment___default()(s.valueOf() + duration * minuteUnit * millisUnit);
      var ms = __WEBPACK_IMPORTED_MODULE_14_moment___default()(s);
      var me = __WEBPACK_IMPORTED_MODULE_14_moment___default()(end);
      return ms.format('LT') + ' - ' + me.format('LT');
    },
    closeAppointmentModal: function closeAppointmentModal() {
      this.appointment = {};
      this.clearAppointmentFormError();
      this.$refs.modal.close();
    },
    changeStatus: function changeStatus(id, status) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this10.$confirm(_this10.$t('action_message.are_you_sure'));

              case 2:
                if (!_context6.sent) {
                  _context6.next = 6;
                  break;
                }

                params = {};

                if (status === 'patient_confirm') {
                  params.status = 'scheduled';
                  params.patient_status = 'confirmed';
                } else if (status === 'patient_confirm_3hr') {
                  params.status = 'scheduled';
                  params.patient_status_3hr = 'confirmed';
                } else {
                  params.status = status;
                }
                _this10.$http.put(_this10.$APP_CONFIG.api.admin.appointment_id(id), params).then(function (res) {
                  if (res.body.id) {
                    _this10.loading = false;
                    _this10.$toastr.success(_this10.$t('action_message.save_success'));
                    _this10.$refs.modal.close();
                    _this10.appointment = {};
                    if (_this10.show_calendar_view) _this10.refetchEventsDelay();
                    _this10.loadAppointments(_this10.filter_by_status, _this10.filter_date_type);
                  }
                });

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10);
      }))();
    },
    getDropdownType: function getDropdownType(appointmentStatus) {
      if (appointmentStatus === 'scheduled') {
        return 'success';
      } else if (appointmentStatus === 'checkin') {
        return 'success';
      } else if (appointmentStatus === 'pending') {
        return 'warning';
      } else if (appointmentStatus === 'cancel') {
        return '';
      }

      return '';
    },
    extractAppointment: function extractAppointment() {
      var _a = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({
        clinic_id: this.$guser.user.clinic.id,
        seen_doctor: 0,
        has_medical_record: 0
      }, this.appointment, {
        phone: __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#phone').intlTelInput('getNumber'),
        sms_remark: this.appointment.remark
      });

      if (this.appointment.appointment_time) {
        var mtime = __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.appointment.appointment_time).format('YYYYMMDDHHmm');
        _a.appointment_time = mtime;
      }

      if (this.appointment.service) {
        _a.service_id = this.appointment.service.value;
        delete _a.service;
      }

      if (this.appointment.doctor) {
        _a.doctor_id = this.appointment.doctor.value;
        delete _a.doctor;
      }

      if (this.appointment.locale) {
        _a.locale = this.appointment.locale.value;
      }

      if (this.appointment.prefix) {
        _a.prefix = this.appointment.prefix.value;
      }

      return _a;
    },
    cancelUpdateAppointmentTime: function cancelUpdateAppointmentTime() {
      if (!this.updateReq.loading) {
        this.updateReq.revertFunc();
      }
    },
    updateAppointmentTime: function updateAppointmentTime(obj) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var res, ev, ap;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this11.updateReq.loading = true;

                _this11.$refs.smsConfirmModalForCalendar.close();
                _context7.next = 4;
                return _this11.$http.put(_this11.$APP_CONFIG.api.admin.appointment_id(obj.appointment_id), {
                  start: obj.start,
                  end: obj.end,
                  sms_confirmation_to_patient: obj.sms_confirmation
                });

              case 4:
                res = _context7.sent;


                if (res.body.id) {
                  ev = _this11.events.find(function (ev) {
                    return ev.id === obj.appointment_id;
                  });

                  ev.start = obj.start;
                  ev.end = obj.end;

                  ap = _this11.appointments.find(function (a) {
                    return a.id === obj.appointment_id;
                  });

                  ap.object.appointment_time = __WEBPACK_IMPORTED_MODULE_14_moment___default()(obj.start).format('YYYY-MM-DD HH:mm:ss');
                  _this11.$toastr.success(_this11.$t('action_message.save_success'));
                } else {
                  _this11.$toastr.warning(_this11.$t('action_message.save_not_success'));
                }
                _this11.updateReq.loading = false;
                return _context7.abrupt('return', res);

              case 8:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this11);
      }))();
    },
    confirmAppointmentFormChange: function confirmAppointmentFormChange(req) {
      this.appointment.sms_confirmation_to_patient = req.sms_confirmation;
      this.addOrUpdateAppointment();

      this.$refs.smsConfirmModalForFormChange.close();
      this.$refs.modal.close();
    },
    saveAppointment: function saveAppointment() {
      if (this.appointment.id) {
        this.$refs.smsConfirmModalForFormChange.open();
      } else {
        this.addOrUpdateAppointment();
      }
    },
    addOrUpdateAppointment: function addOrUpdateAppointment() {
      var _this12 = this;

      if (this.appointment.status === 'cancel ') {
        this.cancelAppointment(this.appointment.id);
        return;
      }

      var _a = this.extractAppointment();

      this.clearAppointmentFormError();

      var defaultError = this.getAppointmentFormDefaultError();
      var invalid = false;
      if (!_a.firstname) {
        this.apmFrm.firstnameError = defaultError.firstnameError;
        invalid = true;
      }

      if (!_a.lastname) {
        this.apmFrm.lastnameError = defaultError.lastnameError;
        invalid = true;
      }

      if (!_a.doctor_id) {
        this.apmFrm.doctorIdError = defaultError.doctorIdError;
        invalid = true;
      }

      if (invalid) {
        return;
      }

      if (this.appointment.id) {
        this.loading = true;
        this.$http.put(this.$APP_CONFIG.api.admin.appointment_id(_a.id), _a).then(function (res) {
          if (res.body.id) {
            _this12.loading = false;
            _this12.$toastr.success(_this12.$t('action_message.save_success'));
            _this12.$refs.modal.close();
            _this12.appointment = {};
            if (_this12.fc && _this12.show_calendar_view) _this12.refetchEventsDelay();
            _this12.loadAppointments(_this12.filter_by_status, _this12.filter_date_type);
          }
        }, function (error) {
          _this12.loading = false;
          _this12.showAppointmentFormFromError(error.body.error);
        });
      } else {
        this.loading = true;
        this.$http.post(this.$APP_CONFIG.api.admin.appointment(), _a).then(function (res) {
          _this12.loading = false;
          if (res.body.id) {
            _this12.$toastr.success(_this12.$t('action_message.save_success'));
            _this12.$refs.modal.close();
            _this12.appointment = {};
            _this12.selected_patient = null;
            _this12.patient_list = [];
            if (_this12.fc && _this12.show_calendar_view) {
              _this12.refetchEventsDelay();
            } else {
              _this12.loadAppointments(_this12.filter_by_status, _this12.filter_date_type);
            }
          }
        }, function (error) {
          _this12.loading = false;
          _this12.showAppointmentFormFromError(error.body.error);
        });
      }
    },
    filterEvent: function filterEvent() {
      var _this13 = this;

      if (!this.show_calendar_view) {
        this.loadAppointments(this.filter_by_status, this.filter_date_type);
        return this.events;
      }
      var _resources = this.resources.slice();
      var _events = this.events.slice();

      if (this.filter_by_specialty && this.filter_by_specialty.value) {
        _resources = _resources.filter(function (r) {
          return r.specialty === _this13.filter_by_specialty.label || r.status === 'background';
        });
      }
      if (this.filter_by_doctor && this.filter_by_doctor.value) {
        _resources = _resources.filter(function (r) {
          return r.id === _this13.filter_by_doctor.value || r.status === 'background';
        });
      }
      if (this.filter_by_status && this.filter_by_status.value) {
        _events = _events.filter(function (r) {
          return r.status === _this13.filter_by_status.value || r.status === 'background';
        });
      }
      if (this.filter_by_service && this.filter_by_service.value && this.show_calendar_view) {
        _events = _events.filter(function (r) {
          return r.service_id === _this13.filter_by_service.value || r.status === 'background';
        });
      }
      if (this.filter_by_hn && this.filter_by_hn.value && !this.show_calendar_view) {
        _events = _events.filter(function (r) {
          return r.service_id === _this13.filter_by_hn.value || r.status === 'background';
        });
      }

      if (this.fc) {
        this.resources.forEach(function (r) {
          _this13.fc.fullCalendar('removeResource', r.id);
        });

        this.fc.fullCalendar('removeEvents');

        var scResouces = [];
        var scOthResouces = [];
        var scOthResouces2 = [];
        var resourceSize = 10;
        var count = 0;
        _resources.forEach(function (rs) {
          var ev = _events.find(function (_e) {
            return rs.id === _e.resourceId && (_e.type === 'appointment' || rs.is_today === 1);
          });
          if (ev && count < resourceSize) {
            rs.order = count;
            scResouces.push(rs);
            count++;
          } else {
            scOthResouces.push(rs);
          }
        });

        scOthResouces.forEach(function (rs) {
          var ev = _events.find(function (_e) {
            return rs.id === _e.resourceId && _e.status === 'background';
          });
          if (ev && count < resourceSize) {
            rs.order = count;
            scResouces.push(rs);
            count++;
          } else {
            scOthResouces2.push(rs);
          }
        });

        scResouces.forEach(function (_r) {
          _this13.fc.fullCalendar('addResource', _r);
        });

        scOthResouces2.forEach(function (_r) {
          if (count < resourceSize) {
            _r.order = count;
            _this13.fc.fullCalendar('addResource', _r);
            count++;
          }
        });
      }
      return _events;
    },
    refreshAppointmentList: function refreshAppointmentList(url, pageNum) {
      var _this14 = this;

      if (url) {
        this.appointmentLoaded = false;
        this.appointmentLoading = true;
        var params = {
          clinic_id: this.$guser.user.clinic.id,
          doctor_id: this.filter_by_doctor ? this.filter_by_doctor.value : null,
          status: this.filter_by_status ? this.filter_by_status.value : null,
          page: pageNum,
          start: 'all'
        };

        var from = null;
        var to = null;
        var dateSplitRange = 2;
        var dates = this.filter_date_range.split('to');

        if (this.filter_date_type === 'all') {
          params.start = 'all';
        } else {
          if (dates.length === dateSplitRange) {
            from = dates[0].trim();
            to = dates[1].trim();
          }
          if (from && to) {
            params.start = from;
            params.end = to;
          }
        }

        this.$http.get(this.$APP_CONFIG.api.appointments(), {
          params: params,
          credentials: true
        }).then(function (res) {
          _this14.appointmentLoading = false;
          _this14.appointmentLoaded = true;
          _this14.appointments = res.body.data;
          _this14.paginator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
            from: res.body.from,
            to: res.body.to,
            total: res.body.total,
            per_page: res.body.per_page,
            current_page: res.body.current_page,
            next_page_url: res.body.next_page_url,
            prev_page_url: res.body.prev_page_url
          });
        });
      }
    },
    loadAppointments: function loadAppointments(status, type, from, to) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var params, dateSplitRange, dates, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                params = {};

                params.doctor_id = _this15.$guser.user.doctor ? _this15.$guser.user.doctor.id : null;
                params.clinic_id = _this15.$guser.user.clinic ? _this15.$guser.user.clinic.id : null;

                if (_this15.filter_by_doctor) {
                  params.doctor_id = _this15.filter_by_doctor.value;
                }
                if (_this15.filter_by_clinic) {
                  params.clinic_id = _this15.filter_by_clinic.value;
                }

                if (type === 'all') {
                  params.start = 'all';
                } else {
                  if (!from && !to) {
                    dateSplitRange = 2;
                    dates = _this15.filter_date_range.split('to');

                    if (dates.length === dateSplitRange) {
                      from = dates[0].trim();
                      to = dates[1].trim();
                    }
                  }

                  if (from && to) {
                    params.start = from;
                    params.end = to;
                  }
                }

                if (status && status.value) {
                  params.status = status.value;
                }

                _this15.appointmentLoaded = false;
                _this15.appointmentLoading = true;

                _context8.next = 11;
                return _this15.$http.get(_this15.$APP_CONFIG.api.appointments(), {
                  params: params,
                  credentials: true
                });

              case 11:
                res = _context8.sent;

                _this15.appointmentLoading = false;
                _this15.appointmentLoaded = true;
                _this15.appointments = res.body.data;
                _this15.paginator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
                  from: res.body.from,
                  to: res.body.to,
                  total: res.body.total,
                  per_page: res.body.per_page,
                  current_page: res.body.current_page,
                  next_page_url: res.body.next_page_url,
                  prev_page_url: res.body.prev_page_url
                });

              case 16:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this15);
      }))();
    },
    openExportCriteria: function openExportCriteria() {
      this.$refs.exportCriteriaModel.open();
    },
    loadExportFields: function loadExportFields() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this16.$http.get(_this16.$APP_CONFIG.api.appointmentsExportFields(), { credentials: true });

              case 2:
                res = _context9.sent;

                _this16.exportFields = res.body;

                _this16.exportFields.forEach(function (f, index) {
                  if (f.default) {
                    _this16.selectedExportFieldIds.push(f.id);
                  }
                });

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this16);
      }))();
    },
    exportCurrentApponitments: function exportCurrentApponitments() {
      var dateSplitRange = 2;
      var dates = this.export_date_range.split(' to ');
      if (dates.length === dateSplitRange) {
        var from = dates[0].trim();
        var to = dates[1].trim();
        this.exportApponitments(this.filter_by_status, from, to);
      } else {
        this.exportApponitments(this.filter_by_status);
      }
      this.$refs.exportCriteriaModel.close();
    },
    exportApponitments: function exportApponitments(status, from, to) {
      var params = {};
      if (!from && !to) {
        var dateSplitRange = 2;
        var dates = this.export_date_range.split(' to ');
        if (dates.length === dateSplitRange) {
          from = dates[0].trim();
          to = dates[1].trim();
        }
      }

      if (from && to) {
        params = {
          clinic_id: this.$guser.user.clinic.id,
          start: from,
          end: to
        };
      }

      if (status && status.value) {
        params.status = status.value;
      }

      if (this.filter_by_doctor) {
        params.doctor_id = this.filter_by_doctor.value;
      }

      var exportUrl = this.$APP_CONFIG.api.appointmentsExport() + '?';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          exportUrl += '&' + key + '=' + params[key];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.openedExportFields) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selectedExportFieldIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var id = _step2.value;

            exportUrl += '&fields[]=' + id;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      if (this.hasCustomSlot) {
        exportUrl += '&slot=' + this.slot;
      }

      window.open(exportUrl, '_blank');
    },
    setupFilter: function setupFilter() {
      if (this.$route.query.status === 'pending' || this.$route.query.status === 'scheduled' || this.$route.query.status === 'cancel') {
        this.filter_by_specialties = [];
        this.filter_by_doctors = [];
        this.filter_by_services = [];

        this.filter_by_status = {
          value: this.$route.query.status,
          label: this.$route.query.status
        };

        this.filter_by_status_list = [this.filter_by_status];

        this.viewType = 'list';
        this.filter_date_type = 'all';
      } else {
        this.filter_by_status_list = [];
      }

      switch (this.$route.query.viewType) {
        case 'daily':
          this.viewType = 'daily';
          break;
        case 'monthly':
          this.viewType = 'monthly';
          break;
        case 'list':
          this.viewType = 'list';
          break;
        default:
          this.viewType = 'list';
      }
    },
    clearAppointmentFormError: function clearAppointmentFormError() {
      this.apmFrm = this.getAppointmentFormError();
    },
    getAppointmentFormError: function getAppointmentFormError() {
      return {
        firstnameError: null,
        lastnameError: null,
        phoneError: null,
        emailError: null,
        doctorIdError: null
      };
    },
    getAppointmentFormDefaultError: function getAppointmentFormDefaultError() {
      return {
        firstnameError: this.$t('message.appointment.firstname_require'),
        lastnameError: this.$t('message.appointment.lastname_require'),
        phoneError: this.$t('message.appointment.phone_require'),
        emailError: this.$t('message.appointment.email_require'),
        doctorIdError: this.$t('message.appointment.doctor_require')
      };
    },
    showAppointmentFormFromError: function showAppointmentFormFromError(error) {
      if (error) {
        this.apmFrm.firstnameError = this.getMessageFromError(error.firstname);
        this.apmFrm.lastnameError = this.getMessageFromError(error.lastname);
        this.apmFrm.phoneError = this.getMessageFromError(error.phone);
        this.apmFrm.doctorIdError = this.getMessageFromError(error.doctor_id);
      }
    },
    getMessageFromError: function getMessageFromError(errorObj) {
      var message = null;
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ');
      } else {
        message = errorObj;
      }
      return message;
    },
    viewAppointmentDetail: function viewAppointmentDetail(id) {
      var _this17 = this;

      this.$refs.modal.close();
      setTimeout(function () {
        return _this17.$router.push({ path: '/appointments/' + id });
      }, 300);
    },
    setupCalendar: function setupCalendar() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this18.calendarLoading = true;
                _context10.next = 3;
                return _this18.renderCalendar();

              case 3:
                _this18.filter_date_type = 'all';
                _this18.calendarLoading = false;
                _this18.initedCalendar = true;

              case 6:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this18);
      }))();
    },
    loadInitData: function loadInitData() {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var appmStat, spct, srvList, dtList, srvOpt, d;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this19.$http.get(_this19.$APP_CONFIG.api.admin.appointment_status(), { credentials: true });

              case 2:
                appmStat = _context11.sent;

                if (appmStat) {
                  _this19.status_options = appmStat.body.map(function (v) {
                    return { label: v, value: v };
                  });
                }
                _context11.next = 6;
                return _this19.$http.get(_this19.$APP_CONFIG.api.specialties());

              case 6:
                spct = _context11.sent;

                if (spct) {
                  _this19.specialties = spct.body.map(function (r) {
                    return { label: r.name, value: r.id };
                  });
                }

                if (!(_this19.$guser.isClinic() || _this19.$guser.isClinicMulti())) {
                  _context11.next = 23;
                  break;
                }

                _context11.next = 11;
                return _this19.$http.get(_this19.$APP_CONFIG.api.admin.clinicme(_this19.$route, _this19.$guser));

              case 11:
                srvList = _context11.sent;

                if (srvList) {
                  _this19.rawServices = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, srvList.body.data.services);
                  _this19.services = srvList.body.data.services.map(function (s) {
                    return { label: s[_this19.$i18n.locale].name, value: s.id, duration: s.duration };
                  });
                }

                _context11.next = 15;
                return _this19.$http.get(_this19.$APP_CONFIG.api.admin.doctors(), { params: { clinic_id: _this19.$guser.user.clinic.id, disable_pagination: 0 } });

              case 15:
                dtList = _context11.sent;

                if (dtList) {
                  if (!_this19.doctor_options) {
                    _this19.doctor_options = [];
                  }
                  dtList.body.data.forEach(function (d, index) {
                    if (index) {
                      _this19.doctor_options.push({
                        label: _this19.$i18n.locale === 'th' ? d.name_th : d.name_en,
                        value: d.id,
                        data: d
                      });
                    }

                    if (!_this19.resources.find(function (r) {
                      return r.id === d.id;
                    })) {
                      _this19.resources.push({
                        id: d.id,
                        title: '' + (_this19.$i18n.locale === 'th' ? d.name_th : d.name_en),
                        specialty: d.specialities[0] && (_this19.$i18n.locale === 'th' ? d.specialities[0].name_th : d.specialities[0].name_en) || 'Other',
                        order: 999
                      });
                    }
                  });
                }
                _context11.next = 19;
                return _this19.$http.get(_this19.$APP_CONFIG.api.admin.clinicme_services(_this19.$route, _this19.$guser));

              case 19:
                srvOpt = _context11.sent;

                if (srvOpt) {
                  _this19.service_options = srvOpt.body.data.map(function (service) {
                    return { label: service[_this19.$i18n.locale].name, value: service.id };
                  });
                }

                _context11.next = 24;
                break;

              case 23:
                if (_this19.$guser.isDoctor()) {
                  d = _this19.$guser.user.doctor;

                  _this19.resources.push({
                    id: d.id,
                    title: d.prefix + ' ' + d.firstname + ' ' + d.lastname,
                    specialty: d.specialities[0].name || 'Other',
                    order: 999
                  });
                }

              case 24:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this19);
      }))();
    },
    renderCalendar: function renderCalendar() {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                self = _this20;
                return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                  if (_this20.fc) {
                    resolve('done');
                  } else {
                    _this20.fc = __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#scheduler');

                    _this20.fc.fullCalendar({
                      locale: _this20.$i18n.locale,
                      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                      defaultView: _this20.dayView,
                      defaultDate: self.defaultDate,
                      resourceGroupField: 'specialty',
                      resourceOrder: 'order',
                      editable: true,
                      slotLabelFormat: 'HH:mm',
                      titleFormat: 'ddd MMM D, YYYY',
                      allDaySlot: false,
                      height: 600,
                      slotDuration: '00:10:00',
                      scrollTime: '08:00:00',
                      eventLimit: false,
                      lazyFetching: false,
                      customButtons: {
                        addAppointmentBtn: {
                          text: _this20.$t('message.appointment.add_appointment'),
                          click: function click() {
                            self.$refs.modal.open();
                          }
                        },
                        selectDate: {
                          text: '...',
                          click: function click() {
                            self.$refs.dateModal.open();
                          }
                        }
                      },
                      header: {
                        left: 'prev, today',
                        center: 'title, selectDate',
                        right: 'next'
                      },
                      slotEventOverlap: false,
                      resourceLabelText: _this20.$t('message.appointment.doctor_list'),
                      resources: [],
                      events: function events(start, end, timezone, callback) {
                        var _this21 = this;

                        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12() {
                          var events;
                          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                            while (1) {
                              switch (_context12.prev = _context12.next) {
                                case 0:
                                  events = [];

                                  if (!(_this21.startEndTemp === undefined || _this21.startEndTemp !== start.format() + end.format())) {
                                    _context12.next = 5;
                                    break;
                                  }

                                  _context12.next = 4;
                                  return self.processEventCalendar(start, end, timezone, callback, null);

                                case 4:
                                  events = _context12.sent;

                                case 5:
                                  _this21.startEndTemp = start.format() + end.format();
                                  callback(events);

                                case 7:
                                case 'end':
                                  return _context12.stop();
                              }
                            }
                          }, _callee12, _this21);
                        }))();
                      },
                      eventDrop: function eventDrop(event, delta, revertFunc, jsEvent, ui, view) {
                        self.updateReq.start = __WEBPACK_IMPORTED_MODULE_14_moment___default()(event.start).format('YYYYMMDDHHmm');
                        self.updateReq.end = __WEBPACK_IMPORTED_MODULE_14_moment___default()(event.end || event.start).format('YYYYMMDDHHmm');
                        self.updateReq.appointment_id = event.id;
                        self.updateReq.revertFunc = revertFunc;
                        self.$refs.smsConfirmModalForCalendar.open();
                      },
                      eventResize: function eventResize(event, jsEvent, ui, view) {
                        var start = __WEBPACK_IMPORTED_MODULE_14_moment___default()(event.start).format('YYYYMMDDHHmm');
                        var end = __WEBPACK_IMPORTED_MODULE_14_moment___default()(event.end || event.start).format('YYYYMMDDHHmm');

                        self.$http.put(self.$APP_CONFIG.api.admin.appointment_id(event.id), { start: start, end: end }).then(function (res) {
                          if (res.body.id) {
                            var ev = self.events.find(function (ev) {
                              return ev.id === event.id;
                            });
                            ev.start = event.start;
                            ev.end = event.end;
                            self.$toastr.success(self.$t('action_message.save_success'));
                          } else {
                            self.$toastr.warning(self.$t('action_message.save_not_success'));
                          }
                        });
                      },
                      eventClick: function eventClick(event, jsEvent, view) {
                        var _this22 = this;

                        var ap = self.appointments.find(function (a) {
                          return a.id === event.id;
                        });
                        if (ap) {
                          self.editMode = true;
                          self.appointment = self._buildAppointment(ap);

                          if (self.$guser.isDoctor()) {
                            self.appointment.status = 'cancel';
                          }
                          self.$refs.modal.open();
                          __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#phone').intlTelInput('setNumber', ap.object.phone);
                        } else {
                          this.$refs.patient_type_a.click();
                          self.editMode = false;
                          var _doctor = self.doctor_options.find(function (d) {
                            return d.value === +event.resourceId;
                          });
                          self.appointment = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({
                            id: null,
                            firstname: null,
                            lastname: null,
                            phone: '',
                            duration: event.time_slots,
                            service_id: null,
                            doctor_id: null,
                            doctor: _doctor,
                            comment: null,
                            remark: null,
                            locale: this.locale_options.find(function (s) {
                              return s.value === _this22.$i18n.locale;
                            }),
                            admin_note: null,
                            email: null,
                            ehr_patient_id: null,
                            birthday: null,
                            prefix: null,
                            id_card: null,
                            hn: null,
                            sms_feedback_to_patient: true
                          }, { appointment_time: __WEBPACK_IMPORTED_MODULE_14_moment___default()(event.start, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm') });
                          self.$refs.modal.open();
                          __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#phone').intlTelInput('setNumber', '');
                        }
                      },
                      dayClick: function dayClick(date, jsEvent, view, resource) {
                        if (self.$guser.isDoctor()) {
                          return;
                        }

                        var f = date.format('HH') === '00' ? 'YYYY-MM-DD 09:mm' : 'YYYY-MM-DD HH:mm';

                        var _doctor = null;
                        if (resource) {
                          _doctor = self.doctor_options.find(function (d) {
                            return d.value === +resource.id;
                          });
                        }

                        if (self.filter_by_doctors.length > 0) {
                          _doctor = {
                            data: self.filter_by_doctors[0].data,
                            label: self.filter_by_doctors[0].data.name,
                            value: self.filter_by_doctors[0].data.id
                          };
                        }
                        self.editMode = false;
                        self.appointment = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({
                          id: null,
                          firstname: null,
                          lastname: null,
                          phone: '',
                          duration: 15,
                          service_id: null,
                          doctor_id: null,
                          doctor: _doctor,
                          comment: null,
                          remark: null,
                          locale: self.locale_options.find(function (s) {
                            return s.value === self.$i18n.locale;
                          }),
                          admin_note: null,
                          email: null,
                          ehr_patient_id: null,
                          birthday: null,
                          prefix: null,
                          id_card: null,
                          hn: null,
                          sms_feedback_to_patient: true
                        }, { appointment_time: date.format(f) });
                        self.$refs.modal.open();
                        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#phone').intlTelInput('setNumber', '');
                      },
                      eventRender: function eventRender(event, element) {
                        __WEBPACK_IMPORTED_MODULE_15_jquery___default()(element).find('.fc-content').addClass('text_white');
                        var ap = self.appointments.find(function (a) {
                          return a.id === event.id;
                        });
                        if (ap && ap.object && ap.object.admin_note) {
                          __WEBPACK_IMPORTED_MODULE_15_jquery___default()('<span> - ' + ap.object.admin_note + '</span>').appendTo(__WEBPACK_IMPORTED_MODULE_15_jquery___default()(element).find('.fc-content'));
                        }
                      },
                      viewRender: function viewRender() {
                        resolve('done');
                      }
                    });
                  }
                }));

              case 2:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this20);
      }))();
    },
    getAppointmentParams: function getAppointmentParams(start, end) {
      var appointmentParams = {
        clinic_id: this.$guser.user.clinic ? this.$guser.user.clinic.id : null,
        doctor_id: this.$guser.user.doctor ? this.$guser.user.doctor.id : null,
        start: start.format('YYYY-MM-DD'),
        end: end.subtract(1, 'days').format('YYYY-MM-DD')
      };

      if (this.filter_by_doctor && this.filter_by_doctor.value) {
        appointmentParams.doctor_id = this.filter_by_doctor.value;
      }
      if (this.filter_by_specialty && this.filter_by_specialty.value) {
        appointmentParams.speciality_id = this.filter_by_specialty.value;
      }
      if (this.filter_by_status && this.filter_by_status.value) {
        appointmentParams.status = this.filter_by_status.value;
      }
      if (this.filter_by_service && this.filter_by_service.value && this.show_calendar_view) {
        appointmentParams.service_id = this.filter_by_service.value;
      }
      return appointmentParams;
    },
    refetchEventsDelay: function refetchEventsDelay() {
      if (this.fc) {
        this.fc.fullCalendar('refetchEvents');
      }
    },
    processEventCalendar: function processEventCalendar(start, end, timezone, callback, renderedCallback) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var startApDate, endApDate, res, dtParams, dtListRes, filteredEvent;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this23.processEventLoading = true;
                startApDate = start.format('YYYY-MM-DD');
                endApDate = end.format('YYYY-MM-DD');

                _this23.appointment.appointment_time = startApDate;
                _context14.next = 6;
                return _this23.$http.get(_this23.$APP_CONFIG.api.appointment(), {
                  params: _this23.getAppointmentParams(start, end),
                  credentials: true
                });

              case 6:
                res = _context14.sent;


                _this23.appointments = res.body;
                _this23.events = [];
                if (!(_this23.viewType === 'daily' || _this23.viewType === 'weekly' || _this23.viewType === 'monthly')) {
                  _context14.next = 19;
                  break;
                }

                dtParams = {
                  clinic_id: _this23.$guser.user.clinic ? _this23.$guser.user.clinic.id : null,
                  doctor_id: _this23.$guser.user.doctor ? _this23.$guser.user.doctor.id : null
                };

                dtParams.start = startApDate;
                dtParams.end = endApDate;
                if (_this23.filter_by_doctor && _this23.filter_by_doctor.value) {
                  dtParams.doctor_id = _this23.filter_by_doctor.value;
                }
                if (_this23.filter_by_specialty && _this23.filter_by_specialty.value) {
                  dtParams.speciality_id = _this23.filter_by_specialty.value;
                }
                _context14.next = 17;
                return _this23.$http.get(_this23.$APP_CONFIG.api.admin.doctors(), { params: dtParams });

              case 17:
                dtListRes = _context14.sent;

                if (dtListRes && dtListRes.body && dtListRes.body.data) {
                  dtListRes.body.data.forEach(function (doctorData) {
                    if (doctorData.available_schedules) {
                      doctorData.available_schedules.forEach(function (sc) {
                        var startDt = null;
                        var endDt = null;
                        for (var weekDay = 0; weekDay < 7; weekDay++) {
                          var weekDate = start.weekday(weekDay);
                          var dayWStr = weekDate.locale('en').format('ddd').toLowerCase();
                          if (dayWStr === sc.week_day) {
                            startDt = __WEBPACK_IMPORTED_MODULE_14_moment___default()(weekDate.format('YYYYMMDD') + ' ' + sc.time_from, 'YYYYMMDD HH:mm:ss');
                            endDt = __WEBPACK_IMPORTED_MODULE_14_moment___default()(weekDate.format('YYYYMMDD') + ' ' + sc.time_to, 'YYYYMMDD HH:mm:ss');
                            break;
                          }
                        }

                        if (startDt !== null && endDt !== null) {
                          _this23.events.push({
                            id: sc.doctor_id + '' + startDt + '_' + endDt,
                            resourceId: sc.doctor_id,
                            title: null,
                            start: startDt.format('YYYY-MM-DDTHH:mm:ss'),
                            end: endDt.format('YYYY-MM-DDTHH:mm:ss'),
                            service_id: null,
                            hn: null,
                            status: 'background',
                            time_slots: sc.time_slots,
                            color: '#00FF00',
                            rendering: 'background'
                          });
                        }
                      });
                    }

                    if (doctorData.timeoffs) {
                      doctorData.timeoffs.forEach(function (tf) {
                        var startSpl = tf.start_time.split(' ');
                        var endSpl = tf.end_time.split(' ');
                        var startDt = startSpl.join('T');
                        var endDt = endSpl.join('T');

                        if (_this23.viewType === 'monthly') {
                          startDt = startSpl[0];
                          endDt = __WEBPACK_IMPORTED_MODULE_14_moment___default()(endSpl[0]).add(1, 'days').format('YYYY-MM-DD');
                        }

                        _this23.events.push({
                          id: tf.doctor_id + '' + startDt + '_' + endDt,
                          resourceId: tf.doctor_id,
                          title: null,
                          start: startDt,
                          end: endDt,
                          service_id: null,
                          hn: null,
                          status: 'background',
                          color: '#FF0000',
                          rendering: 'background',
                          overlap: true
                        });
                      });
                    }

                    var fd = _this23.doctor_options.find(function (doctorOption) {
                      return doctorOption.value === +doctorData.id;
                    });
                    if (!fd) {
                      _this23.doctor_options.push({
                        value: doctorData.id,
                        label: _this23.$i18n.locale === 'th' ? doctorData.name_th : doctorData.name_en,
                        data: doctorData
                      });
                    }
                  });
                }

              case 19:

                _this23.appointments.forEach(function (a) {
                  var d = a.object.doctor;
                  if (d) {
                    _this23.events.push({
                      id: a.id,
                      resourceId: d.id,
                      title: a.object.firstname + ' ' + a.object.lastname,
                      start: a.start.split(' ').join('T'),
                      end: a.end.split(' ').join('T'),
                      service_id: a.object.service_id,
                      hn: a.object.hn,
                      patient_status: a.object.patient_status,
                      status: a.object.status,
                      color: a.color,
                      type: 'appointment'
                    });
                  }

                  if (a.object.hn) {
                    var fHn = _this23.hn_options.find(function (ao) {
                      return ao.value === a.object.hn;
                    });
                    if (!fHn) {
                      _this23.hn_options.push({
                        value: a.object.hn,
                        label: a.object.hn,
                        data: a.object
                      });
                    }
                  }
                });

                _this23.resources.forEach(function (r) {
                  _this23.fc.fullCalendar('addResource', r);
                });
                filteredEvent = _this23.filterEvent();

                _this23.processEventLoading = false;

                __WEBPACK_IMPORTED_MODULE_15_jquery___default()('.fc-event').remove();

                return _context14.abrupt('return', filteredEvent);

              case 25:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this23);
      }))();
    },
    processStartup: function processStartup() {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee15() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (_this24.$guser.user.clinic && _this24.$guser.user.clinic.remark_templates === null) {
                  _this24.$guser.user.clinic.remark_templates = _this24.remarkTemplates;
                  _this24.templates.remark_templates = _this24.$guser.user.clinic.remark_templates;
                }

                _this24.loadExportFields();

                _this24.setupFilter();
                _context15.next = 5;
                return _this24.loadInitData();

              case 5:
                if (!(_this24.show_calendar_view && !_this24.initedCalendar)) {
                  _context15.next = 9;
                  break;
                }

                _this24.setupCalendar();
                _context15.next = 15;
                break;

              case 9:
                if (_this24.show_calendar_view) {
                  _context15.next = 14;
                  break;
                }

                _context15.next = 12;
                return _this24.loadAppointments(_this24.filter_by_status, _this24.filter_date_type);

              case 12:
                _context15.next = 15;
                break;

              case 14:
                if (_this24.show_calendar_view && _this24.initedCalendar) {
                  _this24.refetchEventsDelay();
                }

              case 15:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this24);
      }))();
    },
    appendRemark: function appendRemark(content) {
      var newContent = '';
      if (this.appointment.remark) {
        newContent = this.appointment.remark + content;
      } else {
        newContent = content;
      }

      this.appointment = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(this.appointment, {
        remark: newContent
      });
    },
    openRemarkEditor: function openRemarkEditor() {
      this.$refs.modal.close();
      this.$refs.remarkModal.open();
    },
    closeRemarkModal: function closeRemarkModal() {
      this.$refs.remarkModal.close();
      this.$refs.modal.open();
    },
    updateComment: function updateComment($event) {
      this.templates.remark_templates = $event;
    },
    updateRemarks: function updateRemarks() {
      var _this25 = this;

      var updatedClinic = {
        remark_templates: this.templates.remark_templates ? this.templates.remark_templates : []
      };
      this.$http.put(this.$APP_CONFIG.api.admin.clinicme(), updatedClinic, { headers: { 'content-type': 'application/json' } }).then(function (res) {
        if (res.body.status === 'success') {
          _this25.$guser.user.clinic.remark_templates = res.body.data.remark_templates;
        }
      });
    },
    gotoDate: function gotoDate() {
      if (this.date) {
        this.fc.fullCalendar('gotoDate', this.date);
        this.date = null;
        this.$refs.dateModal.close();
      } else {
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('input.flatpickr-input').focus();
      }
    }
  },
  watch: {
    filter_by_specialties: function filter_by_specialties(v, old) {
      if (v && v.length > 0) {
        var data = v[v.length - 1];
        if (v.length > 1) {
          this.filter_by_specialties = [v[v.length - 1]];
        }
        this.filter_by_specialty = data;
      } else {
        this.filter_by_specialty = null;
      }
    },
    filter_by_clinics: function filter_by_clinics(v, old) {
      if (v && v.length > 0) {
        var data = v[v.length - 1];
        if (v.length > 1) {
          this.filter_by_clinics = [v[v.length - 1]];
        }
        this.filter_by_clinic = data;
      } else {
        this.filter_by_clinic = null;
      }
    },
    filter_by_doctors: function filter_by_doctors(v, old) {
      if (v && v.length > 0) {
        var data = v[v.length - 1];
        if (v.length > 1) {
          this.filter_by_doctors = [v[v.length - 1]];
        }
        this.filter_by_doctor = data;
      } else {
        this.filter_by_doctor = null;
      }
    },
    filter_by_status_list: function filter_by_status_list(v, old) {
      if (v && v.length > 0) {
        var data = v[v.length - 1];
        if (v.length > 1) {
          this.filter_by_status_list = [v[v.length - 1]];
        }
        this.filter_by_status = data;
      } else {
        this.filter_by_status = null;
      }
    },
    filter_by_services: function filter_by_services(v, old) {
      if (v && v.length > 0) {
        var data = v[v.length - 1];
        if (v.length > 1) {
          this.filter_by_services = [v[v.length - 1]];
        }
        this.filter_by_service = data;
      } else {
        this.filter_by_service = null;
      }
    },
    filter_by_hns: function filter_by_hns(v, old) {
      if (v && v.length > 0) {
        var data = v[v.length - 1];
        if (v.length > 1) {
          this.filter_by_hns = [v[v.length - 1]];
        }
        this.filter_by_hn = data;
      } else {
        this.filter_by_hn = null;
      }
    },
    filter_searchs: function filter_searchs(v, old) {
      var _this26 = this;

      var valueTimeOut = 500;
      if (v && v.length > 0) {
        this.count_search++;
        this.filter_search = v;
        this.appointments = [];

        this.viewType = 'list';
        this.filter_date_type = 'all';

        setTimeout(function () {
          _this26.count_search--;if (_this26.count_search === 0) {
            _this26.getSearch(v, _this26.filter_by_doctor, _this26.filter_by_specialty, _this26.filter_by_status, _this26.filter_date_type);
          }
        }, valueTimeOut);
      } else {
        this.filter_search = null;
        this.appointments = [];
        setTimeout(function () {
          _this26.loadAppointments(_this26.filter_by_status, _this26.filter_date_type);
        }, valueTimeOut);
      }
    },
    filter_by_specialty: function filter_by_specialty(v, old) {
      if (v !== old && v !== null) {
        this.filter_by_doctors = [];
        if (this.filter_by_doctor && this.filter_by_doctor.data && this.filter_by_doctor.data.specialities && this.filter_by_doctor.data.specialities[0] !== v.value) {
          this.filter_by_doctor = null;
        }
      }

      this.filterEvent();
      this.refetchEventsDelay();
    },
    filter_by_doctor: function filter_by_doctor(v, old) {
      if (!v && this.viewType === 'weekly') {
        this.switchView('daily');
      } else if (v && this.viewType === 'daily') {
        this.switchView('weekly');
      } else {
        console.log('fetch');
        this.filterEvent();
        this.refetchEventsDelay();
      }
    },
    filter_by_status: function filter_by_status(v, old) {
      this.filterEvent();
      this.refetchEventsDelay();
    },
    filter_by_service: function filter_by_service(v, old) {
      this.filterEvent();
      this.refetchEventsDelay();
    },
    filter_by_hn: function filter_by_hn(v, old) {
      this.filterEvent();
      this.refetchEventsDelay();
    },
    filter_date_range: function filter_date_range(v, old) {
      var dateSplitRange = 2;
      var dates = v.split('to');
      if (dates.length === dateSplitRange) {
        var from = dates[0].trim();
        var to = dates[1].trim();
        this.loadAppointments(this.filter_by_status, this.filter_date_type, from, to);
      }
    },
    selected_patient: function selected_patient(v, old) {
      if (!v) return;
      var p = this.patient_list.find(function (_p) {
        return _p.value === +v.value;
      });
      if (p) {
        this.appointment = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(this.appointment, {
          firstname: p.data.firstname,
          lastname: p.data.lastname,
          email: p.data.email,
          ehr_patient_id: p.value,
          birthday: p.data.birthday,
          prefix: p.data.prefix ? this.prefix_options.find(function (d) {
            return d.value === p.data.prefix;
          }) : null,
          hn: p.data.hn,
          id_card: p.data.id_card,
          seen_doctor: 1,
          has_medical_record: 1
        });

        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#phone').intlTelInput('setNumber', p.data.phone);
      }
    },
    patient_type: function patient_type(v, old) {
      if (v === 'noexists') {
        this.selected_patient = null;
      }
    },
    $route: function $route(v, old) {
      this.processStartup();
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#phone').intlTelInput({ nationalMode: true, initialCountry: 'th', utilsScript: '/static/utils.js' });
    this.processStartup();
    this.openNewAppointmentForm(false);
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intl_tel_input_build_css_intlTelInput_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intl_tel_input_build_css_intlTelInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_intl_tel_input_build_css_intlTelInput_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_intl_tel_input__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_intl_tel_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_intl_tel_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appointment_mixin__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_flatpickr_component__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_SyncLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_spinner_src_DotLoader__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_spinner_src_DotLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_spinner_src_DotLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ErrorMessageBox__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ErrorMessageBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_ErrorMessageBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_RemarkEditor__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_RemarkEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_RemarkEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweet_modal_vue__ = __webpack_require__(9);




















/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__appointment_mixin__["a" /* default */]],
  components: {
    flatPickr: __WEBPACK_IMPORTED_MODULE_8_vue_flatpickr_component___default.a,
    BsInput: __WEBPACK_IMPORTED_MODULE_10_vue_strap__["input"],
    BsDropdown: __WEBPACK_IMPORTED_MODULE_10_vue_strap__["dropdown"],
    Multiselect: __WEBPACK_IMPORTED_MODULE_9_vue_multiselect___default.a,
    SyncLoader: __WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_SyncLoader___default.a,
    DotLoader: __WEBPACK_IMPORTED_MODULE_12_vue_spinner_src_DotLoader___default.a,
    ErrorBox: __WEBPACK_IMPORTED_MODULE_13__components_ErrorMessageBox___default.a,
    RemarkEditor: __WEBPACK_IMPORTED_MODULE_14__components_RemarkEditor___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_15_sweet_modal_vue__["a" /* SweetModal */]
  },
  data: function data() {
    var defaultFrmError = {
      firstnameError: null,
      lastnameError: null,
      phoneError: null,
      emailError: null,
      doctorIdError: null
    };

    var defaultMessageFrmError = {
      firstnameError: this.$t('message.appointment.firstname_require'),
      lastnameError: this.$t('message.appointment.lastname_require'),
      phoneError: this.$t('message.appointment.phone_require'),
      emailError: this.$t('message.appointment.email_require'),
      doctorIdError: this.$t('message.appointment.doctor_require')
    };
    return {
      defaultMessageFrmError: defaultMessageFrmError,
      loading: false,
      dataLoaded: false,
      appointment: {
        appointment_time: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        duration: 15
      },
      fpConfig: {
        enableTime: true,
        altInput: true,
        wrap: true,
        time_24hr: true
      },
      fpConfigBirthday: {
        enableTime: false,
        altInput: true,
        wrap: true
      },
      doctor_options: [],
      service_options: [],
      prefix_options: [{ value: 'mrs', label: this.$t('message.appointment.prefix_mrs') }, { value: 'mr', label: this.$t('message.appointment.prefix_mr') }, { value: 'ms', label: this.$t('message.appointment.prefix_ms') }, { value: 'master', label: this.$t('message.appointment.prefix_master') }, { value: 'miss', label: this.$t('message.appointment.prefix_miss') }],
      apmFrm: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, defaultFrmError),
      selected_patient: null,
      patient_list: [],
      patientLoading: false,
      locale_options: [{ value: 'en', label: 'English' }, { value: 'th', label: 'ไทย' }],
      patient_type: 'noexists',
      templates: {
        remark_templates: []
      }
    };
  },

  computed: {
    isExistingPatient: function isExistingPatient() {
      return this.patient_type === 'exists';
    },
    isCancelAppointment: function isCancelAppointment() {
      return this.appointment.status === 'cancel';
    },
    dropdownStatus: function dropdownStatus() {
      if (this.appointment.status === 'scheduled') {
        return 'success';
      } else if (this.appointment.status === 'checkin') {
        return 'success';
      } else if (this.appointment.status === 'pending') {
        return 'warning';
      } else if (this.appointment.status === 'cancel') {
        return '';
      }
      return '';
    }
  },
  watch: {
    selected_patient: function selected_patient(v, old) {
      if (!v) return;
      var p = this.patient_list.find(function (_p) {
        return _p.value === +v.value;
      });
      if (p) {
        this.appointment = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.appointment, {
          firstname: p.data.firstname,
          lastname: p.data.lastname,
          email: p.data.email,
          ehr_patient_id: p.value,
          id_card: p.data.id_card,
          prefix: p.data.prefix ? p.data.prefix.value ? p.data.prefix : this.prefix_options.find(function (d) {
            return d.value === p.data.prefix;
          }) : null,
          hn: p.data.hn,
          birthday: p.data.birthday
        });

        __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#phone').intlTelInput('setNumber', p.data.phone);
      }
    },
    patient_type: function patient_type(v, old) {
      if (v === 'noexists') {
        this.selected_patient = null;
      }
    }
  },
  methods: {
    back: function back() {
      this.$router.go(-1);
    },
    getPatients: function getPatients(search) {
      var _this = this;

      this.patientLoading = true;
      this.$http.get(this.$APP_CONFIG.api.admin.patient(), { params: { clinic_id: this.$guser.user.clinic.id, search: search } }).then(function (res) {
        _this.patientLoading = false;
        _this.patient_list = res.body.data.map(function (p) {
          return { label: _this.patientDesc(p), value: p.id, data: p };
        });
      });
    },
    patientDesc: function patientDesc(p) {
      return p.firstname + ' ' + p.lastname + ' - ' + p.phone + ' - ' + (p.email || '');
    },
    cancelAppointment: function cancelAppointment() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$confirm(_this2.$t('message.appointment.are_you_wath_to_cancel'));

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                _this2.$http.put(_this2.$APP_CONFIG.api.admin.appointment_action(_this2.appointment.id, 'cancel')).then(function (res) {
                  if (res.body) {
                    _this2.$toastr.success(_this2.$t('message.appointment.cancel_appointment_success'));
                    _this2.back();
                  }
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    saveAppointment: function saveAppointment() {
      var _this3 = this;

      if (this.appointment.status === 'cancel ') {
        this.cancelAppointment(this.appointment.id);
        return;
      }

      var editedApm = this.extractAppointment();

      this.apmFrm = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.defaultFrmError);

      var defaultError = this.defaultMessageFrmError;
      var invalid = false;
      if (!editedApm.firstname) {
        this.apmFrm.firstnameError = defaultError.firstnameError;
        invalid = true;
      }

      if (!editedApm.lastname) {
        this.apmFrm.lastnameError = defaultError.lastnameError;
        invalid = true;
      }

      if (!editedApm.phone) {
        this.apmFrm.phoneError = defaultError.phoneError;
        invalid = true;
      }

      if (!editedApm.email) {
        this.apmFrm.emailError = defaultError.emailError;
        invalid = true;
      }

      if (!editedApm.doctor_id) {
        this.apmFrm.doctorIdError = defaultError.doctorIdError;
        invalid = true;
      }

      if (invalid) {
        return;
      }

      this.loading = true;
      this.$http.put(this.$APP_CONFIG.api.admin.appointment_id(editedApm.id), editedApm).then(function (res) {
        if (res.body.id) {
          _this3.loading = false;
          _this3.$toastr.success(_this3.$t('action_message.save_success'));
          _this3.back();
        }
      }, function (error) {
        _this3.loading = false;
        _this3.showAppointmentFormFromError(error.body.error);
      });
    },
    changeStatus: function changeStatus(status) {
      this.appointment.status = status;
    },
    loadData: function loadData() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var doctors, srvOpt, appointmentsRes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this4.$route.params.id) {
                  _context2.next = 15;
                  break;
                }

                _this4.dataLoaded = false;
                _context2.next = 4;
                return _this4.$http.get(_this4.$APP_CONFIG.api.admin.doctors(), { params: { clinic_id: _this4.$guser.user.clinic.id, disable_pagination: 1 } });

              case 4:
                doctors = _context2.sent;

                if (doctors) {
                  doctors.body.data.forEach(function (d) {
                    _this4.doctor_options.push({
                      label: _this4.$i18n.locale === 'th' ? d.name_th : d.name_en,
                      value: d.id
                    });
                  });
                }

                _context2.next = 8;
                return _this4.$http.get(_this4.$APP_CONFIG.api.admin.clinicme_services());

              case 8:
                srvOpt = _context2.sent;

                if (srvOpt) {
                  _this4.service_options = srvOpt.body.data.map(function (service) {
                    return { label: service[_this4.$i18n.locale].name, value: service.id };
                  });
                }

                _context2.next = 12;
                return _this4.$http.get(_this4.$APP_CONFIG.api.appointment_id(_this4.$route.params.id), { credentials: true });

              case 12:
                appointmentsRes = _context2.sent;

                if (appointmentsRes.body) {
                  _this4.appointment = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, appointmentsRes.body, {
                    doctor: _this4.doctor_options.find(function (d) {
                      return d.value === appointmentsRes.body.doctor_id;
                    }),
                    service: _this4.service_options.find(function (d) {
                      return d.value === appointmentsRes.body.service_id;
                    }),
                    prefix: _this4.prefix_options.find(function (d) {
                      return d.value === appointmentsRes.body.prefix;
                    }),
                    locale: _this4.locale_options.find(function (d) {
                      return d.value === appointmentsRes.body.locale;
                    })
                  });
                }

                _this4.dataLoaded = true;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    extractAppointment: function extractAppointment() {
      var _a = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
        clinic_id: this.$guser.user.clinic.id
      }, this.appointment, {
        phone: __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#phone').intlTelInput('getNumber'),
        sms_remark: this.appointment.remark
      });

      if (this.appointment.service) {
        _a.service_id = this.appointment.service.value;
      }
      delete _a.service;

      if (this.appointment.doctor) {
        _a.doctor_id = this.appointment.doctor.value;
      }
      delete _a.doctor;
      delete _a.clinic;

      if (this.appointment.appointment_time) {
        var mtime = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.appointment.appointment_time).format('YYYYMMDDHHmm');
        _a.appointment_time = mtime;
      }

      if (this.appointment.prefix) {
        _a.prefix = this.appointment.prefix.value;
      }

      if (this.appointment.locale) {
        _a.locale = this.appointment.locale.value;
      }

      return _a;
    },
    showAppointmentFormFromError: function showAppointmentFormFromError(error) {
      if (error) {
        this.apmFrm.firstnameError = this.getMessageFromError(error.firstname);
        this.apmFrm.lastnameError = this.getMessageFromError(error.lastname);
        this.apmFrm.phoneError = this.getMessageFromError(error.phone);
        this.apmFrm.doctorIdError = this.getMessageFromError(error.doctor_id);
      }
    },
    getMessageFromError: function getMessageFromError(errorObj) {
      var message = null;
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ');
      } else {
        message = errorObj;
      }
      return message;
    },
    appendRemark: function appendRemark(content) {
      var newContent = '';
      if (this.appointment.remark) {
        newContent = this.appointment.remark + content;
      } else {
        newContent = content;
      }

      this.appointment = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.appointment, {
        remark: newContent
      });
    },
    openRemarkEditor: function openRemarkEditor() {
      this.$refs.remarkModal.open();
    },
    closeRemarkModal: function closeRemarkModal() {
      this.$refs.remarkModal.close();
    },
    updateRemarks: function updateRemarks() {
      var _this5 = this;

      var updatedClinic = {
        remark_templates: this.templates.remark_templates ? this.templates.remark_templates : []
      };

      this.$http.put(this.$APP_CONFIG.api.admin.clinicme(), updatedClinic, { headers: { 'content-type': 'application/json' } }).then(function (res) {
        if (res.body.status === 'success') {
          _this5.$guser.user.clinic.remark_templates = res.body.data.remark_templates;
        }
      });
    }
  },
  created: function created() {
    if (this.$guser.user.clinic.remark_templates === null) {
      this.$guser.user.clinic.remark_templates = this.remarkTemplates;
    }
    this.templates.remark_templates = this.$guser.user.clinic.remark_templates;

    this.loadData();
  },
  mounted: function mounted() {
    var _this6 = this;

    var setupPhone = function setupPhone() {
      if (_this6.dataLoaded) {
        __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#phone').intlTelInput({ nationalMode: true, initialCountry: 'th', utilsScript: '/static/utils.js' });
        __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#phone').intlTelInput('setNumber', _this6.appointment.phone);
      } else {
        setTimeout(setupPhone, 500);
      }
    };

    var setupPatient = function setupPatient() {
      if (_this6.dataLoaded) {
        if (_this6.appointment.ehr_patient_id) {
          _this6.$refs.patient_type_b.click();
          _this6.selected_patient = { label: _this6.patientDesc(_this6.appointment), value: _this6.appointment.ehr_patient_id, data: _this6.appointment };
          _this6.patient_list = [_this6.selected_patient];
        } else {
          _this6.$refs.patient_type_a.click();
        }
      } else {
        setTimeout(setupPatient, 500);
      }
    };

    setupPhone();
    setupPatient();
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AlertBar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AlertBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AlertBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_core_image_upload__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_core_image_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_core_image_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Ckeditor__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Ckeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Ckeditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_SyncLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ErrorMessageBox__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ErrorMessageBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ErrorMessageBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DropZone__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DropZone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_DropZone__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: String
  },
  components: {
    BsInput: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["input"],
    BsDatepicker: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["datepicker"],
    VueCoreImageUpload: __WEBPACK_IMPORTED_MODULE_3_vue_core_image_upload___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
    Ckeditor: __WEBPACK_IMPORTED_MODULE_5__components_Ckeditor___default.a,
    SyncLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_SyncLoader___default.a,
    Alertbar: __WEBPACK_IMPORTED_MODULE_1__components_AlertBar___default.a,
    ErrorBox: __WEBPACK_IMPORTED_MODULE_7__components_ErrorMessageBox___default.a,
    DropZone: __WEBPACK_IMPORTED_MODULE_8__components_DropZone___default.a
  },
  data: function data() {
    var defaultArticle = {
      title: null,
      content: '',
      status: 'unpublished',
      featured_image: null
    };

    var formCleanError = {
      title: null,
      content: null
    };

    var formDefaultError = {
      title: this.$t('message.article.title_require'),
      content: this.$t('message.article.content_require')
    };

    var featuredPlaceholderImage = '/static/img/default_image.png';

    return {
      loading: false,
      q: '',
      _searchQ: null,
      showAddPanel: false,
      editMode: false,
      articles: [],
      defaultArticle: defaultArticle,
      article: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultArticle),
      doctor_list: [{ label: 'doctor1', value: 200 }],
      clinic: {},
      awsConfig: {},
      uploadImageUri: '',
      owner_by_doctor: false,
      alreadyInitCk: false,
      selected_doctor: null,
      paginator: {},
      formDefaultError: formDefaultError,
      formCleanError: formCleanError,
      frmError: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, formCleanError),
      ckeditorConfig: {
        toolbar: [{ name: 'basicstyles', items: ['Bold', 'Italic'] }, { name: 'paragraph', items: ['BulletedList'] }, { name: 'styles', items: ['Format'] }]
      },
      featuredImagePlaceholder: '<i class="fa fa-cloud-upload" aria-hidden="true"> ' + this.$t('message.article.select_featured_image') + '</i>',
      featured_placeholder_image: featuredPlaceholderImage,
      featured_image_preview: featuredPlaceholderImage
    };
  },

  computed: {
    filtered_articles: function filtered_articles() {
      return this.articles.sort(function (a, b) {
        return a.created_at < b.created_at;
      });
    },
    isFeaturedImage: function isFeaturedImage() {
      return this.article.featured_image;
    }
  },
  watch: {
    q: function q(v, old) {
      var _this = this;

      var delayTime = 500;
      clearTimeout(this._searchQ);
      this._searchQ = setTimeout(function () {
        _this.$http.get(_this.$APP_CONFIG.api.admin.articles(), { params: {
            search: v,
            clinic_id: _this.$guser.user.clinic.id
          } }).then(function (res) {
          _this.articles = res.body.data;

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.paginator, {
            from: res.body.from,
            to: res.body.to,
            total: res.body.total,
            per_page: res.body.per_page,
            current_page: res.body.per_page,
            next_page_url: res.body.next_page_url,
            prev_page_url: res.body.prev_page_url
          });
        });
      }, delayTime);
    },
    owner_by_doctor: function owner_by_doctor(v, old) {
      if (!v) {
        this.article.doctor_id = null;
        this.selected_doctor = null;
      }
    },
    'article.featured_image': function articleFeatured_image(v, o) {
      this.featured_image_preview = v || this.featured_placeholder_image;
    }
  },
  methods: {
    reloadArticle: function reloadArticle(uri) {
      var _this2 = this;

      this.$http.get(uri || this.$APP_CONFIG.api.admin.articles(), { params: {
          clinic_id: this.$route.query.ref_clinic_id
        } }).then(function (res) {
        _this2.articles = res.body.data;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this2.paginator, {
          from: res.body.from,
          to: res.body.to,
          total: res.body.total,
          per_page: res.body.per_page,
          current_page: res.body.per_page,
          next_page_url: res.body.next_page_url,
          prev_page_url: res.body.prev_page_url
        });
      });
    },
    enterCreateAritcle: function enterCreateAritcle() {
      this.showAddPanel = true;
      this.selected_doctor = null;
      this.editMode = false;
      this.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultArticle);
      this.featured_image_preview = this.featured_placeholder_image;
      this.clearFormError();
    },
    editArticle: function editArticle(a) {
      this.editMode = true;
      this.showAddPanel = true;
      this.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, a);
      this.featured_image_preview = a.featured_image || this.featured_placeholder_image;
      this.clearFormError();
    },
    featuredImageFileChange: function featuredImageFileChange(file) {
      var _this3 = this;

      var imageData = {
        key: 'images/' + new Date().getTime() + '-' + file.name,
        AWSAccessKeyId: this.awsConfig.AWS_ACCESS_KEY,
        acl: 'public-read',
        policy: this.awsConfig.AWS_S3_POLICY.policy,
        signature: this.awsConfig.AWS_S3_POLICY.signature,
        'Content-Type': file.type !== '' ? file.type : 'application/octet-stream',
        filename: file.name,
        file: file,
        success_action_status: '201'
      };

      var data = new FormData();
      for (var field in imageData) {
        data.append(field, imageData[field]);
      }

      this.$http.post(this.uploadImageUri, data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (res) {
        _this3.article.featured_image = 'https://' + _this3.awsConfig.AWS_CLOUNDFRONT_DOMAIN + '/' + imageData.key;
        _this3.featured_image_preview = _this3.article.featured_image;
      }).catch(function (reason) {
        _this3.article.featured_image = 'https://' + _this3.awsConfig.AWS_CLOUNDFRONT_DOMAIN + '/' + imageData.key;
        _this3.featured_image_preview = _this3.article.featured_image;
      });
    },
    removeFeatureImage: function removeFeatureImage() {
      this.article.featured_image = null;
      this.featured_image_preview = this.featured_placeholder_image;
    },
    enterListView: function enterListView() {
      this.showAddPanel = false;
      this.editMode = false;
      this.reloadArticle();
    },
    removeArticle: function removeArticle() {
      var _this4 = this;

      this.$http.delete(this.$APP_CONFIG.api.admin.articles_id(this.article.id)).then(function (res) {
        if (res.body) {
          _this4.enterListView();
          _this4.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.defaultArticle);
        }
      });
    },
    addArticle: function addArticle() {
      var _this5 = this;

      if (this.editMode) {
        this._updataArticle();
      } else {
        console.log(this.clinic);
        if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
          this.article.clinic_id = this.clinic.id;
        }
        if (this.$guser.isDoctor()) {
          this.article.doctor_id = this.$guser.user.doctor.id;
        }
        this.loading = true;
        this.clearFormError();
        this.$http.post(this.$APP_CONFIG.api.admin.articles(), this.article).then(function (res) {
          _this5.loading = false;

          if (res.body.id) {
            _this5.enterListView();
            _this5.$toastr.success(_this5.$t('message.article.create_success'));
            _this5.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this5.defaultArticle);
          }
        }, function (error) {
          _this5.loading = false;
          if (error.body.error) {
            _this5.showFormFromError(error.body.error);
          }
        });
      }
    },
    _updataArticle: function _updataArticle() {
      var _this6 = this;

      if (this.selected_doctor) this.article.doctor_id = this.selected_doctor.value;
      this.loading = true;

      this.clearFormError();

      this.$http.put(this.$APP_CONFIG.api.admin.articles_id(this.article.id), this.article).then(function (res) {
        _this6.loading = false;
        if (res.body.id) {
          _this6.$toastr.success(_this6.$t('message.article.update_success'));
          _this6.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this6.defaultArticle);
          _this6.enterListView();
        }
      }, function (error) {
        _this6.loading = false;
        if (error.body.error) {
          _this6.showFormFromError(error.body.error);
        }
      });
    },
    clearFormError: function clearFormError() {
      this.frmError = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.formCleanError);
    },
    showFormFromError: function showFormFromError(error) {
      if (error) {
        this.frmError.title = this.getMessageFromError(error.title);
        this.frmError.content = this.getMessageFromError(error.content);
      }
    },
    getMessageFromError: function getMessageFromError(errorObj) {
      var message = null;
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ');
      } else {
        message = errorObj;
      }
      return message;
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.reloadArticle();

    if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
      this.$http.get(this.$APP_CONFIG.api.admin.clinicme(this.$route, this.$guser)).then(function (res) {
        _this7.clinic = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.body.data);
        console.log(_this7.clinic);
        if (_this7.clinic) {
          _this7.$http.get(_this7.$APP_CONFIG.api.admin.doctors_clinic(_this7.clinic.id)).then(function (res) {
            _this7.doctor_list = res.body.data.map(function (doctor) {
              return {
                value: doctor.id,
                label: _this7.$i18n && _this7.$i18n.locale === 'th' ? doctor.name_th : doctor.name_en
              };
            });

            if (_this7.article.doctor_id) {
              _this7.selected_doctor = _this7.doctor_list.find(function (d) {
                return _this7.article.doctor_id === d.value;
              });
            }
          });
        }
      });
    }

    this.$http.get(this.$APP_CONFIG.api.config()).then(function (res) {
      _this7.awsConfig = res.body;

      _this7.uploadImageUri = 'https://s3-' + _this7.awsConfig.AWS_S3_REGION + '.amazonaws.com/' + _this7.awsConfig.AWS_S3_BUCKET_NAME + '/';
    });
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_SyncLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(19);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SyncLoader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_SyncLoader___default.a,
    dropdown: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["dropdown"]
  },
  data: function data() {
    return {
      username: null,
      password: null,
      userChecking: false,
      errorMessage: null,
      error: {
        email: false,
        password: false
      },
      loading: false
    };
  },

  methods: {
    login: function login(data) {
      var _this = this;

      this.loading = true;
      this.errorMessage = null;
      this.$http.post(this.$APP_CONFIG.api.login(), {
        email: this.username,
        password: this.password
      }, {
        withCredentials: true
      }).then(function (res) {
        var success = 200;
        if (res.status === success) {
          _this.redirect();
        }
      }).catch(function (error) {
        if (error.body.message instanceof Object) {
          var errorMsg = '';
          for (var k in error.body.message) {
            errorMsg += error.body.message[k].join(', ');
          }
          _this.errorMessage = errorMsg;
        } else {
          _this.errorMessage = error.body.message;
        }

        _this.error.email = error.body.message && error.body.message.email;
        _this.error.password = error.body.message && error.body.message.password;

        _this.loading = false;
      });
    },
    redirect: function redirect() {
      var path = this.$guser.redirectPath || '/';
      this.$guser.redirectPath = null;

      if (path === '/auth/login' || path === '/') {
        this.$router.replace({ path: '/' });
      } else {
        this.$router.replace({ path: path });
      }
    },
    changeLang: function changeLang(lang) {
      this.$ls.set('lang', lang);
      this.$i18n.locale = lang;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_2__router__["a" /* UserStore */].signedIn()) {
      var path = __WEBPACK_IMPORTED_MODULE_2__router__["a" /* UserStore */].store.user.redirectPath || '/';
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* UserStore */].store.user.redirectPath = null;
      if (path === '/auth/login' || path === '/') {
        next({ path: '/' });
      } else {
        next({ path: path });
      }
    } else {
      next();
    }
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_flatpickr_component__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_SyncLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweet_modal_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FlatPickr: __WEBPACK_IMPORTED_MODULE_2_vue_flatpickr_component___default.a,
    SyncLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_SyncLoader___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_4_sweet_modal_vue__["a" /* SweetModal */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  },
  props: {},
  data: function data() {
    return {
      services: [],
      broadcastTypes: [{
        name: 'appointment_date',
        detail: 'เลือกตามวันที่นัดหมาย'
      }, {
        name: 'all_patients',
        detail: 'เลือกคนไข้ทั้งหมด'
      }, {
        name: 'last_visit',
        detail: 'เลือกตาม Last visit'
      }],
      req: {
        type: '',
        date: null,
        content: null,
        date_from: null,
        start: null,
        end: null,
        service_id: null
      },
      selectedServiceId: 0,
      selectedMonth: '',
      selectedYear: '',
      selectedDoctor: {
        id: 0,
        name: 'แพทย์ทั้งหมด'
      },
      doctors: [],
      numberOfMessage: 0,
      errorMessage: null,
      loading: {
        checking: false,
        sending: false
      }
    };
  },

  computed: {
    isAbleToSend: function isAbleToSend() {
      if (this.req.type === 'all_patients' && this.numberOfMessage > 0 && this.req.content && this.req.content.length > 0) {
        return true;
      } else if (this.req.type === 'appointment_date' && this.numberOfMessage > 0 && this.req.date && this.req.content && this.req.content.length > 0) {
        return true;
      } else if (this.req.type === 'last_visit' && this.numberOfMessage > 0 && this.selectedMonth > 0 && this.selectedYear > 0 && this.req.content && this.req.content.length > 0) {
        return true;
      }
      return false;
    },
    creditUsage: function creditUsage() {
      var content = this.req.content ? this.req.content : ' ';
      return this.numberOfMessage * Math.ceil(content.length / 67);
    },
    years: function years() {
      var years = [];
      var date = __WEBPACK_IMPORTED_MODULE_6_moment___default()();
      for (var i = 0; i < 10; i++) {
        years.push(date.format('YYYY'));
        date.subtract(1, 'year');
      }
      return years;
    },
    months: function months() {
      return [{ name: 'มกราคม', number: '01' }, { name: 'กุมภาพันธ์', number: '02' }, { name: 'มีนาคม', number: '03' }, { name: 'เมษายน', number: '04' }, { name: 'พฤษภาคม', number: '05' }, { name: 'มิถุนายน', number: '06' }, { name: 'กรกฎาคม', number: '07' }, { name: 'สิงหาคม', number: '08' }, { name: 'กันยายน', number: '09' }, { name: 'ตุลาคม', number: '10' }, { name: 'พฤศจิกายน', number: '11' }, { name: 'ธันวาคม', number: '12' }];
    }
  },
  watch: {
    'req.date': function reqDate(date) {
      this.checkNumberOfMessage(date);
    },
    'selectedDoctor': function selectedDoctor(doctor) {
      this.req.doctor_id = doctor && doctor.id !== 0 ? doctor.id : undefined;
      if (this.req.date) {
        this.checkNumberOfMessage(this.req.date);
      }
    },
    'req.type': function reqType(type) {
      if (type === 'all_patients') {
        this.checkNumberOfMessage(this.req.date);
      } else if (type === 'last_visit') {
        this.numberOfMessage = 0;
        this.selectedServiceId = 0;
      }
    },
    'selectedMonth': function selectedMonth(_selectedMonth) {
      if (this.selectedYear && _selectedMonth) {
        this.req = this.sanitizeReq(this.req);
        this.checkNumberOfMessage(this.req.date);
      }
    },
    'selectedYear': function selectedYear(_selectedYear) {
      if (_selectedYear && this.selectedMonth) {
        this.req = this.sanitizeReq(this.req);
        this.checkNumberOfMessage(this.req.date);
      }
    },
    'selectedServiceId': function selectedServiceId(_selectedServiceId) {
      if (this.selectedYear && this.selectedMonth && _selectedServiceId) {
        this.req = this.sanitizeReq(this.req);
        this.checkNumberOfMessage(this.req.date);
      }
    }
  },
  methods: {
    checkNumberOfMessage: function checkNumberOfMessage(date) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading.checking = true;
                _context.next = 4;
                return _this.$http.get(_this.$APP_CONFIG.api.admin.broadcast_check(), { params: {
                    type: _this.req.type,
                    date: date,
                    start: _this.req.start,
                    end: _this.req.end,
                    doctor_id: _this.req.doctor_id,
                    service_id: _this.req.service_id,
                    clinic_id: _this.$route.query.ref_clinic_id ? _this.$route.query.ref_clinic_id : _this.$guser.user.clinic.id
                  } });

              case 4:
                res = _context.sent;

                _this.numberOfMessage = res.body.numberOfMessage;
                _this.loading.checking = false;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this.loading.checking = false;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    sendMessage: function sendMessage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.req = _this2.sanitizeReq(_this2.req);

                _this2.loading.sending = true;
                _context2.next = 5;
                return _this2.$http.post(_this2.$APP_CONFIG.api.admin.broadcast(), {
                  type: _this2.req.type,
                  date: _this2.req.date,
                  start: _this2.req.start,
                  end: _this2.req.end,
                  doctor_id: _this2.req.doctor_id,
                  content: _this2.req.content,
                  service_id: _this2.req.service_id,
                  clinic_id: _this2.$route.query.ref_clinic_id ? _this2.$route.query.ref_clinic_id : _this2.$guser.user.clinic.id
                });

              case 5:
                _this2.loading.sending = false;
                _this2.$refs.success.open();
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this2.loading.sending = false;
                _this2.errorMessage = _context2.t0.body.error;
                _this2.$refs.fail.open();

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    getDoctors: function getDoctors() {
      var _this3 = this;

      var self = this;
      var params = {
        clinic_id: this.$guser.user.clinic.id
      };

      this.$http.get(self.$APP_CONFIG.api.admin.doctors(), {
        params: params,
        credentials: true
      }).then(function (resp) {
        _this3.doctors = resp.body.data;
        _this3.doctors.unshift({
          id: 0,
          name: 'เลือกแพทย์ทั้งหมด'
        });
      });
    },
    getServices: function getServices() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.$http.get(_this4.$APP_CONFIG.api.admin.clinicme_services(_this4.$route, _this4.$guser));

              case 2:
                _this4.services = _context3.sent.body.data;

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    sanitizeReq: function sanitizeReq(req) {
      if (req.type === 'last_visit') {
        req.start = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedYear + '-' + this.selectedMonth + '-01').format('YYYY-MM-DD');
        req.end = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.selectedYear + '-' + this.selectedMonth + '-01').endOf('month').format('YYYY-MM-DD');
        req.service_id = parseInt(this.selectedServiceId) === 0 ? null : parseInt(this.selectedServiceId);
        req.date = null;
      }
      return req;
    }
  },
  created: function created() {
    this.getDoctors();
    this.getServices();
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AlertBar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AlertBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AlertBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweet_modal_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DoctorArrayInput__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DoctorArrayInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_DoctorArrayInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DoctorSingleInput__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DoctorSingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_DoctorSingleInput__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Alertbar: __WEBPACK_IMPORTED_MODULE_3__components_AlertBar___default.a,
    SyncLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_7_sweet_modal_vue__["a" /* SweetModal */],
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker___default.a,
    BsInput: __WEBPACK_IMPORTED_MODULE_6_vue_strap__["input"],
    DoctorArrayInput: __WEBPACK_IMPORTED_MODULE_8__components_DoctorArrayInput___default.a,
    DoctorSingleInput: __WEBPACK_IMPORTED_MODULE_9__components_DoctorSingleInput___default.a
  },
  data: function data() {
    var clinicDefault = {
      sms_credit: 0,
      second_reminder_time_p: {
        HH: '08',
        mm: '00'
      },
      first_reminder_time_p: {
        HH: '08',
        mm: '00'
      }
    };
    return {
      clinic: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, clinicDefault),
      loading: true,
      loaded: false
    };
  },

  methods: {
    loadSetting: function loadSetting() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$http.get(_this.$APP_CONFIG.api.admin.clinicme(_this.$route, _this.$guser), { credentials: true });

              case 2:
                response = _context.sent;

                if (response) {
                  _this.processClinic(response.body.data);
                }
                _this.loading = false;
                _this.loaded = true;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    processClinic: function processClinic(data) {
      this.clinic = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.clinic, data);
      if (this.clinic.first_reminder_time) {
        var timeSplit = this.clinic.first_reminder_time.split(':');
        if (timeSplit.length > 1) {
          this.clinic = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.clinic, {
            first_reminder_time_p: {
              HH: timeSplit[0],
              mm: timeSplit[1]
            }
          });
        }
      }

      if (!this.clinic.emails || this.clinic.emails.length === 0) {
        this.clinic = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.clinic, {
          emails: []
        });
      }
    },
    save: function save() {
      var _this2 = this;

      this.loading = true;
      var updatedClinic = {
        sms_confirmation: this.clinic.sms_confirmation ? 1 : 0,
        email_confirmation: this.clinic.sms_confirmation ? 1 : 0,
        forward_to_clinic_email: this.clinic.forward_to_clinic_email ? 1 : 0,
        clinic_email: this.clinic.clinic_email,
        emails: this.clinic.emails,
        sms_active: this.clinic.sms_active ? 1 : 0,
        first_sms_reminder: this.clinic.first_sms_reminder ? 1 : 0,
        first_email_reminder: this.clinic.first_sms_reminder ? 1 : 0,
        second_sms_reminder: this.clinic.second_sms_reminder ? 1 : 0,
        second_email_reminder: this.clinic.second_sms_reminder ? 1 : 0,
        auto_match_ehr_patient: this.clinic.auto_match_ehr_patient ? 1 : 0,
        first_reminder_time: this.clinic.first_reminder_time_p.HH + ':' + this.clinic.first_reminder_time_p.mm + ',',
        instant_booking: this.clinic.instant_booking,
        appointment_active: this.clinic.appointment_active,
        instant_booking_sms_confirmation: this.clinic.instant_booking_sms_confirmation
      };

      this.$http.put(this.$APP_CONFIG.api.admin.clinicme(this.$route, this.$guser), updatedClinic, { headers: { 'content-type': 'application/json' } }).then(function (res) {
        _this2.loading = false;
        if (res.body.status === 'success') {
          _this2.processClinic(res.body.data);
          _this2.$refs.modal.open();
        }
      });
    }
  },
  created: function created() {
    this.loadSetting();
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ErrorMessageBox__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ErrorMessageBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ErrorMessageBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_SyncLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_flatpickr_dist_l10n_th_js__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_flatpickr_dist_l10n_th_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_flatpickr_dist_l10n_th_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);













/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: {
      type: String,
      default: null
    },
    doctor_id: {
      type: String,
      default: null
    }
  },
  components: {
    BsInput: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["input"],
    ErrorBox: __WEBPACK_IMPORTED_MODULE_4__components_ErrorMessageBox___default.a,
    SyncLoader: __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_SyncLoader___default.a,
    FlatPickr: __WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_8_vue_multiselect___default.a
  },
  data: function data() {
    var defaultleave = {
      doctor: null,
      clinic_id: this.$guser.isClinic() || this.$guser.isClinicMulti() ? this.$guser.user.clinic.id : null,
      doctor_id: this.$guser.isDoctor() ? this.$guser.user.doctor.id : null,
      start_time: null,
      end_time: null,
      description: '',
      all_day: false
    };

    var formDefaultError = {
      doctor_id: this.$t('message.leave.doctor_require'),
      start_time: this.$t('message.leave.time_require'),
      end_time: this.$t('message.leave.time_require'),
      invalid_time: this.$t('message.leave.time_invalid')
    };

    var formCleanError = {
      doctor_id: null,
      start_time: null,
      end_time: null,
      invalid_time: null
    };

    return {
      defaultleave: defaultleave,
      formDefaultError: formDefaultError,
      formCleanError: formCleanError,
      loading: false,
      preLoaded: false,
      frmError: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, formCleanError),
      leave: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, defaultleave),
      selectedDateTime: {
        start_date: null,
        start_time: '0000-00-00 00:00',
        end_date: null,
        end_time: '0000-00-00 00:00'
      },
      doctor_options: [],
      fpConfig: {
        defaultHour: 8,
        defaultMinute: 0,
        altFormat: 'j M Y',
        altInput: true,
        enableTime: false,
        dateFormat: 'Y-m-d H:i',
        locale: this.$i18n.locale === 'th' ? __WEBPACK_IMPORTED_MODULE_7_flatpickr_dist_l10n_th_js___default.a.th : null
      },
      fpTimeConfig: {
        defaultHour: 8,
        defaultMinute: 0,
        altFormat: 'H:i',
        altInput: true,
        enableTime: true,
        time_24hr: true,
        noCalendar: true,
        dateFormat: 'Y-m-d H:i',
        locale: this.$i18n.locale === 'th' ? __WEBPACK_IMPORTED_MODULE_7_flatpickr_dist_l10n_th_js___default.a.th : null
      }
    };
  },

  computed: {
    isEditMode: function isEditMode() {
      return this.id !== null;
    }
  },
  methods: {
    back: function back() {
      this.$router.go(-1);
    },
    cancelLeave: function cancelLeave() {
      this.$router.go(-1);
    },
    removeLeave: function removeLeave(leave) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$confirm(_this.$t('action_message.are_you_sure'));

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                _this.$http.delete(_this.$APP_CONFIG.api.admin.timeoffs() + '/' + _this.id, {
                  credentials: true,
                  headers: { 'content-type': 'application/json' }
                }).then(function (res) {
                  _this.refreshLeave();
                  _this.back();
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addLeave: function addLeave() {
      var _this2 = this;

      if (this.isEditMode) {
        this.updateLeave();
      } else {
        this.clearFormError();

        if (this.leave.all_day) {
          this.leave.start_time = this.selectedDateTime.start_date;
          this.leave.end_time = this.selectedDateTime.end_date;
        } else {
          this.leave.start_time = this.selectedDateTime.start_date.substr(0, 10) + ' ' + this.selectedDateTime.start_time.substr(this.selectedDateTime.start_time.length - 5, 5);
          this.leave.end_time = this.selectedDateTime.end_date.substr(0, 10) + ' ' + this.selectedDateTime.end_time.substr(this.selectedDateTime.start_time.length - 5, 5);
        }

        var leave = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.leave);

        if (!this.checkValidForm()) {
          return;
        }
        if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
          leave.doctor_id = leave.doctor.value;
        } else {
          leave.doctor_id = this.$guser.user.doctor.id;
        }

        this.processTime();
        delete leave.doctor;
        this.$http.post(this.$APP_CONFIG.api.admin.timeoffs(), leave, {
          credentials: true,
          headers: { 'content-type': 'application/json' }
        }).then(function (res) {
          if (res.body.id) {
            _this2.refreshLeave();
            _this2.back();
          }
        }, function (error) {
          if (error.body.error) {
            _this2.showFormFromError(error.body.error);
          }
        });
      }
    },
    updateLeave: function updateLeave() {
      var _this3 = this;

      this.clearFormError();

      if (this.leave.all_day) {
        this.leave.start_time = this.selectedDateTime.start_date;
        this.leave.end_time = this.selectedDateTime.end_date;
      } else {
        this.leave.start_time = this.selectedDateTime.start_date.substr(0, 10) + ' ' + this.selectedDateTime.start_time.substr(this.selectedDateTime.start_time.length - 5, 5);
        this.leave.end_time = this.selectedDateTime.end_date.substr(0, 10) + ' ' + this.selectedDateTime.end_time.substr(this.selectedDateTime.start_time.length - 5, 5);
      }

      var leave = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.leave);
      if (!this.checkValidForm()) {
        return;
      }

      if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
        leave.doctor_id = leave.doctor.value;
      } else {
        leave.doctor_id = this.$guser.user.doctor.id;
      }
      this.processTime();
      delete leave.updated_at;
      delete leave.created_at;
      delete leave.doctor;

      this.$http.put(this.$APP_CONFIG.api.admin.timeoffs() + '/' + this.id, this.leave, {
        credentials: true,
        headers: { 'content-type': 'application/json' }
      }).then(function (res) {
        if (res.body.id) {
          _this3.refreshLeave();
          _this3.back();
        }
      }, function (error) {
        if (error.body.error) {
          _this3.showFormFromError(error.body.error);
        }
      });
    },
    refreshLeave: function refreshLeave() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, self, res, doctorId, leaveInfo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.$guser.isDoctor() && !_this4.id)) {
                  _context2.next = 3;
                  break;
                }

                _this4.preLoaded = true;
                return _context2.abrupt('return');

              case 3:
                params = { ref_clinic_id: _this4.$route.query.ref_clinic_id };

                if (_this4.$guser.isClinic() || _this4.$guser.isClinicMulti()) {
                  params.clinic_id = _this4.$guser.user.clinic.id;
                  params.doctor_id = _this4.doctor_id;
                } else {
                  params.doctor_id = _this4.$guser.user.doctor.id;
                }

                self = _this4;
                _context2.next = 8;
                return _this4.$http.get(_this4.$APP_CONFIG.api.admin.timeoffs(), {
                  params: params,
                  credentials: true
                });

              case 8:
                res = _context2.sent;


                if (res) {
                  if (res.body) {
                    doctorId = null;

                    if (_this4.$guser.isClinic() || _this4.$guser.isClinicMulti()) {
                      doctorId = +self.doctor_id;
                    } else {
                      doctorId = +self.$guser.user.doctor.id;
                    }
                    leaveInfo = res.body.find(function (_l) {
                      return _l.id === +self.id && _l.doctor_id === doctorId;
                    });

                    if (leaveInfo) {
                      self.leave = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, leaveInfo, {
                        doctor: self.doctor_options.find(function (_d) {
                          return _d.value === doctorId;
                        })
                      });

                      _this4.selectedDateTime.start_time = leaveInfo.start_time.substr(0, leaveInfo.start_time.length - 3);
                      _this4.selectedDateTime.start_date = leaveInfo.start_time.substr(0, leaveInfo.start_time.length - 3);
                      _this4.selectedDateTime.end_time = leaveInfo.end_time.substr(0, leaveInfo.end_time.length - 3);
                      _this4.selectedDateTime.end_date = leaveInfo.end_time.substr(0, leaveInfo.end_time.length - 3);
                    }
                    _this4.preLoaded = true;
                  }
                }

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    processTime: function processTime() {
      var spltTime = null;
      if (this.leave.start_time) {
        spltTime = this.leave.start_time.split(':');
        if (spltTime.length > 2) {
          this.leave.start_time = spltTime[0] + ':' + spltTime[1];
        }
      }
      if (this.leave.end_time) {
        spltTime = this.leave.end_time.split(':');
        if (spltTime.length > 2) {
          this.leave.end_time = spltTime[0] + ':' + spltTime[1];
        }
      }
    },
    clearFormError: function clearFormError() {
      this.frmError = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.formCleanError);
    },
    showFormFromError: function showFormFromError(error) {
      if (error) {
        this.frmError.doctor_id = this.getMessageFromError(error.doctor_id);
        this.frmError.start_time = this.getMessageFromError(error.start_time);
        this.frmError.end_time = this.getMessageFromError(error.end_time);
      }
    },
    getMessageFromError: function getMessageFromError(errorObj) {
      var message = null;
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ');
      } else {
        message = errorObj;
      }
      return message;
    },
    checkValidForm: function checkValidForm() {
      var defaultFrmError = this.formDefaultError;
      if (this.$guser.isClinic() && !this.leave.doctor) {
        this.frmError.doctor_id = defaultFrmError.doctor_id;
        return false;
      }

      if (!this.selectedDateTime.start_date && this.leave.all_day) {
        this.frmError.start_time = defaultFrmError.start_time;
        return false;
      }

      if ((!this.selectedDateTime.start_time || !this.selectedDateTime.start_date) && !this.leave.all_day) {
        this.frmError.start_time = defaultFrmError.start_time;
        return false;
      }

      if (!this.selectedDateTime.end_date && this.leave.all_day) {
        this.frmError.end_time = defaultFrmError.end_time;
        return false;
      }

      if ((!this.selectedDateTime.end_time || !this.selectedDateTime.end_date) && !this.leave.all_day) {
        this.frmError.end_time = defaultFrmError.end_time;
        return false;
      }

      if (__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.leave.end_time).diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.leave.start_time), 'minutes') <= 0) {
        this.frmError.end_time = defaultFrmError.invalid_time;
        return false;
      }
      return true;
    },
    loadDoctors: function loadDoctors() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var params, dtList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  disable_pagination: 1
                };

                if (_this5.$guser.isClinic() || _this5.$guser.isClinicMulti()) {
                  params.clinic_id = _this5.$guser.user.clinic.id;
                } else {
                  params.doctor_id = _this5.$guser.user.doctor.id;
                }
                _context3.next = 4;
                return _this5.$http.get(_this5.$APP_CONFIG.api.admin.doctors(), { params: params });

              case 4:
                dtList = _context3.sent;

                if (dtList) {
                  _this5.doctor_options = [];
                  dtList.body.data.forEach(function (d) {
                    _this5.doctor_options.push({
                      label: _this5.$i18n.locale === 'th' ? d.name_th : d.name_en,
                      value: d.id
                    });
                  });
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    initData: function initData() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this6.$guser.isClinic() || _this6.$guser.isClinicMulti())) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return _this6.loadDoctors();

              case 3:
                _context4.next = 5;
                return _this6.refreshLeave();

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    }
  },
  created: function created() {
    this.initData();
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fullcalendar__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fullcalendar_scheduler__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fullcalendar_scheduler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fullcalendar_scheduler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fullcalendar_dist_fullcalendar_min_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fullcalendar_dist_fullcalendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fullcalendar_dist_fullcalendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fullcalendar_scheduler_dist_scheduler_min_css__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fullcalendar_scheduler_dist_scheduler_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fullcalendar_scheduler_dist_scheduler_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_SyncLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_strap__);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SyncLoader: __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_SyncLoader___default.a,
    BsInput: __WEBPACK_IMPORTED_MODULE_9_vue_strap__["input"]
  },
  data: function data() {
    return {
      limitContentLength: 80,
      loading: false,
      loaded: false,
      leaveList: { data: [] },
      doctorSearchQ: null,
      showCalendar: false,
      fc: null,
      createdCalendar: false,
      calendarResources: [],
      calendarEvents: []
    };
  },

  computed: {
    displayLeaveList: function displayLeaveList() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.leaveList, {
        data: this.leaveList.data.filter(function (leave) {
          return !_this.doctorSearchQ || (leave.doctor.firstname + ' ' + leave.doctor.lastname).search(_this.doctorSearchQ) > -1;
        })
      });
    }
  },
  methods: {
    openDoctor: function openDoctor(id) {
      if (id) this.$router.push({ path: '/doctor/step1/' + id, query: { action: 'edit', ref_clinic_id: this.$route.query.ref_clinic_id } });
    },
    getDoctorName: function getDoctorName(data) {
      if (data && data.doctor) {
        return '' + data.doctor.prefix + data.doctor.firstname + ' ' + data.doctor.lastname;
      }
      return '';
    },
    getDoctorSpecialty: function getDoctorSpecialty(data) {
      return '';
    },
    toggleMoreContent: function toggleMoreContent(data) {
      data.showMoreContent = !data.showMoreContent;
    },
    viewContent: function viewContent(content, isTruncate) {
      if (isTruncate) {
        return this.$options.filters.truncate(content, this.limitContentLength);
      }
      return content;
    },
    loadLeaveList: function loadLeaveList(url) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.$guser.isClinic() || _this2.$guser.isDoctor() || _this2.$guser.isClinicMulti())) {
                  _context.next = 11;
                  break;
                }

                _this2.loading = true;
                _this2.loaded = false;
                params = { ref_clinic_id: _this2.$route.query.ref_clinic_id };

                if (_this2.$guser.isClinic() || _this2.$guser.isClinicMulti()) {
                  params.clinic_id = _this2.$guser.user.clinic.id;
                } else if (_this2.$guser.isDoctor()) {
                  params.doctor_id = _this2.$guser.user.doctor.id;
                }
                _context.next = 7;
                return _this2.$http.get(url || _this2.$APP_CONFIG.api.admin.timeoffs(), {
                  params: params,
                  credentials: true
                });

              case 7:
                res = _context.sent;


                _this2.loading = false;
                _this2.loaded = true;
                _this2.leaveList = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                  data: res.body.map(function (d) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, d, {
                      showMoreContent: false,
                      moreContentEnable: d && d.description && d.description.length > _this2.limitContentLength
                    });
                  })
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    newLeave: function newLeave() {
      if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
        this.$router.push({
          path: '/clinic/leave/add',
          query: {
            ref_clinic_id: this.$route.query.ref_clinic_id
          }
        });
      } else {
        this.$router.push({ path: '/doctor/leave/add' });
      }
    },
    editLeave: function editLeave(leave) {
      if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
        this.$router.push({ path: '/clinic/leave/' + leave.doctor_id + '/' + leave.id, query: { ref_clinic_id: this.$route.query.ref_clinic_id } });
      } else {
        this.$router.push({ path: '/doctor/leave/' + leave.id });
      }
    },
    setupCalendar: function setupCalendar() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this3;

                _this3.fc = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#leaveCalendar');

                _this3.fc.fullCalendar({
                  locale: _this3.$i18n.locale,
                  schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                  defaultView: _this3.dayView,
                  defaultDate: new Date(),
                  editable: true,
                  slotLabelFormat: 'HH:mm',
                  titleFormat: 'ddd MMM D, YYYY',
                  allDaySlot: false,
                  header: {
                    left: 'prev, today',
                    center: 'title',
                    right: 'next'
                  },
                  slotEventOverlap: false,
                  resourceLabelText: _this3.$t('message.appointment.doctor_list'),
                  resources: _this3.calendarResources,
                  events: function events(start, end, timezone, callback) {
                    self.processEventCalendar(start, end, timezone, callback);
                  },
                  eventDrop: function eventDrop(event, delta, revertFunc, jsEvent, ui, view) {
                    self.processEventDrop(event, delta, revertFunc, jsEvent, ui, view);
                  },
                  eventResize: function eventResize(event, jsEvent, ui, view) {
                    self.processEventResize(event, jsEvent, ui, view);
                  },
                  eventClick: function eventClick(event, jsEvent, view) {
                    self.processEventClick(event, jsEvent, view);
                  },
                  dayClick: function dayClick(date, jsEvent, view, resource) {
                    self.processDayClick(date, jsEvent, view, resource);
                  },
                  eventRender: function eventRender(event, element) {
                    self.processEventRender(event, element);
                  }
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    processEventCalendar: function processEventCalendar(start, end, timezone, callback) {
      var _this4 = this;

      var events = [];
      this.displayLeaveList.data.forEach(function (leave) {
        events.push({
          id: leave.id,
          resourceId: leave.doctor_id,
          title: leave.doctor.firstname + ' ' + leave.doctor.lastname,
          start: leave.start_time.split(' ').join('T'),
          end: leave.end_time.split(' ').join('T'),
          color: '#FF0000',
          data: leave
        });

        if (!_this4.calendarResources.find(function (cr) {
          return cr.id === leave.doctor_id;
        })) {
          var r = {
            id: leave.doctor_id,
            title: leave.doctor.firstname + ' ' + leave.doctor.lastname,
            data: leave.doctor
          };
          _this4.calendarResources.push(r);
          _this4.fc.fullCalendar('addResource', r);
        }
      });
      this.calendarEvents = events;
      callback(events);
    },
    processEventDrop: function processEventDrop(event, delta, revertFunc, jsEvent, ui, view) {},
    processEventResize: function processEventResize(event, jsEvent, ui, view) {},
    processEventClick: function processEventClick(event, jsEvent, view) {
      if (event.data) this.editLeave(event.data);
    },
    processDayClick: function processDayClick(date, jsEvent, view, resource) {},
    processEventRender: function processEventRender(event, element) {},
    refetchEvents: function refetchEvents() {
      if (this.fc) {
        this.fc.fullCalendar('refetchEvents');
      }
    },
    showListView: function showListView() {
      this.$router.push({ path: '/clinic/leave' });
    },
    showCalendarView: function showCalendarView() {
      this.$router.push({
        path: '/clinic/leave',
        query: {
          view_type: 'calendar',
          ref_clinic_id: this.$route.query.ref_clinic_id
        }
      });
    }
  },
  watch: {
    $route: function $route(v, old) {
      this.showCalendar = v.query && v.query.view_type === 'calendar';
    },
    showCalendar: function showCalendar(v, o) {
      if (v && !this.createdCalendar) {
        this.setupCalendar();
      } else if (v) {
        this.refetchEvents();
      }
    },
    displayLeaveList: function displayLeaveList(v, o) {
      if (this.showCalendar) {
        this.refetchEvents();
      }
    }
  },
  created: function created() {
    this.showCalendar = this.$route.query && this.$route.query.view_type === 'calendar';
    this.loadLeaveList();
  },
  mounted: function mounted() {
    if (this.showCalendar && !this.createdCalendar) {
      this.setupCalendar();
    }
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AlertBar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AlertBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AlertBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);







__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__["load"])({
  key: 'AIzaSyDQfPboNp8M8hdPiafwxu5xBo-StuWDpXI',
  v: '3.28',
  libraries: ['places'] });

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BsInput: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["input"],
    GoogleMap: __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__["Map"],
    GmapMarker: __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__["Marker"],
    GmapAutocomplete: __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__["Autocomplete"],
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a,
    Alertbar: __WEBPACK_IMPORTED_MODULE_0__components_AlertBar___default.a
  },
  props: {
    clinic: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      selectedProvince: null,
      selectedDistrict: null,
      selectedInsurance: null,
      refProvinces: [],
      refDistricts: [],
      allInsurances: [],
      allProvinces: [] };
  },

  methods: {
    updatePlace: function updatePlace(pos) {
      this.clinic.lat = pos.geometry.location.lat();
      this.clinic.long = pos.geometry.location.lng();
    },
    setPosition: function setPosition(pos) {
      this.clinic.lat = pos.latLng.lat();
      this.clinic.long = pos.latLng.lng();
    },
    saveAndContinue: function saveAndContinue() {
      this.clinic.province_id = this.selectedProvince.value;
      this.clinic.district_id = this.selectedDistrict.value;
      this.$emit('update:clinic', this.clinic);

      this.$emit('finishStep', {
        th: { b_addr: this.clinic.th.b_addr },
        en: { b_addr: this.clinic.en.b_addr },
        website: this.clinic.website,
        facebook: this.clinic.facebook,
        clinic_email: this.clinic.clinic_email,
        province_id: this.selectedProvince.value,
        district_id: this.selectedDistrict.value,
        lat: this.clinic.lat,
        long: this.clinic.long,
        insurances: this.selectedInsurance.map(function (obj) {
          return obj.id;
        })
      });
    },
    cancelChange: function cancelChange() {
      this.$emit('cancelChange');
    }
  },
  computed: {
    mapCenter: function mapCenter() {
      return { lat: +this.clinic.lat, lng: +this.clinic.long };
    },
    markPosition: function markPosition() {
      return { lat: +this.clinic.lat, lng: +this.clinic.long };
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get(this.$APP_CONFIG.api.provinces(), { credentials: true }).then(function (res) {
      _this.allProvinces = res.body;
      _this.refProvinces = res.body.map(function (p) {
        return { value: p.id, label: p.name };
      });

      if (_this.clinic.province_id) {
        _this.selectedProvince = _this.refProvinces.find(function (r) {
          return r.value === _this.clinic.province_id;
        });
        setTimeout(function () {
          if (_this.clinic.district_id) {
            _this.selectedDistrict = _this.refDistricts.find(function (d) {
              return d.value === _this.clinic.district_id;
            });
          }
        }, 0);
      }
    });

    this.$http.get(this.$APP_CONFIG.api.insurance(), { credentials: true }).then(function (res) {
      _this.allInsurances = res.body;
      _this.selectedInsurance = _this.clinic.insurances;
    });
  },

  watch: {
    selectedProvince: function selectedProvince(newValue, old) {
      var _province = this.allProvinces.find(function (p) {
        return p.id === newValue.value;
      });
      this.refDistricts = _province.districts.map(function (d) {
        return { value: d.id, label: d.name };
      });
    }
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StepBar__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_StepBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_clinic_steps_General__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_clinic_steps_General___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_clinic_steps_General__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_clinic_steps_Address__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_clinic_steps_Address___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_clinic_steps_Address__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_clinic_steps_Schedules__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_clinic_steps_Schedules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_clinic_steps_Schedules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_clinic_steps_Services__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_clinic_steps_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_clinic_steps_Services__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_clinic_steps_Doctors__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_clinic_steps_Doctors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_clinic_steps_Doctors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweet_modal_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(19);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SweetModal: __WEBPACK_IMPORTED_MODULE_7_sweet_modal_vue__["a" /* SweetModal */],
    StepBar: __WEBPACK_IMPORTED_MODULE_1__components_StepBar___default.a,
    'step1': __WEBPACK_IMPORTED_MODULE_2__pages_clinic_steps_General___default.a,
    'step2': __WEBPACK_IMPORTED_MODULE_3__pages_clinic_steps_Address___default.a,
    'step3': __WEBPACK_IMPORTED_MODULE_4__pages_clinic_steps_Schedules___default.a,
    'step4': __WEBPACK_IMPORTED_MODULE_5__pages_clinic_steps_Services___default.a,
    'step5': __WEBPACK_IMPORTED_MODULE_6__pages_clinic_steps_Doctors___default.a
  },
  data: function data() {
    return {
      currentStep: 'step1',
      stepOrder: ['step1', 'step2', 'step3', 'step4', 'step5'],
      lastStep: 'step5',
      clinic: {
        en: {},
        th: {},
        images: [],
        schedules: []
      },
      clinicReady: false
    };
  },

  methods: {
    gotoStep: function gotoStep(s) {
      __WEBPACK_IMPORTED_MODULE_8__router__["b" /* default */].push({ path: '/clinic/steps/step' + (s + 1) });
    },
    cancelChange: function cancelChange() {
      this._prevStep();
    },
    finishStep: function finishStep(clinicDataChanged) {
      var _this = this;

      if (clinicDataChanged) {
        this.$http.put(this.$APP_CONFIG.api.admin.clinicme(), clinicDataChanged, {
          credentials: true,
          headers: { 'content-type': 'application/json' }
        }).then(function (res) {
          if (res.body.status === 'success') {
            _this.$toastr.success('Update Successful');
            _this._nextStep();
          }
        });
      } else {
        if (this.currentStep === this.lastStep) {
          var gotoNextStepTimeout = 1500;
          this.$refs.modal.open();
          setTimeout(function () {
            _this.$refs.modal.close();
            _this._nextStep();
          }, gotoNextStepTimeout);
        } else {
          this._nextStep();
        }
      }
    },
    _nextStep: function _nextStep() {
      var i = this.stepOrder.indexOf(this.currentStep) + 1;
      if (i < this.stepOrder.length) {
        this.$router.replace('/clinic/steps/' + this.stepOrder[i]);
      } else if (i === this.stepOrder.length) {
        this.$router.replace('/clinic/general');
      }
    },
    _prevStep: function _prevStep() {
      var i = this.stepOrder.indexOf(this.currentStep) - 1;
      if (i >= 0) {
        this.$router.replace('/clinic/steps/' + this.stepOrder[i]);
      } else {
        this.$router.replace('/clinic/steps/' + this.stepOrder[0]);
      }
    }
  },
  computed: {
    currentStepNumber: function currentStepNumber() {
      return +this.currentStep.slice(this.currentStep.length - 1);
    }
  },
  created: function created() {
    var self = this;

    var _step = this.$route.params.step || 'step1';
    this.currentStep = _step.toLowerCase();

    this.$http.get(this.$APP_CONFIG.api.admin.clinicme(), { credentials: true }).then(function (res) {
      self.clinic = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.clinic, res.body.data);

      if (!self.clinic.th.video_links) {
        self.clinic.th.video_links = [];
      }
      if (!self.clinic.en.video_links) {
        self.clinic.en.video_links = [];
      }
      self.clinicReady = true;
    }, function (errorResponse) {
      console.error(errorResponse);
    });
  },

  watch: {
    '$route': function $route(to, from) {
      var _step = this.$route.params.step || 'step1';
      this.currentStep = _step.toLowerCase();
    }
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AlertBar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AlertBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AlertBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ErrorMessageBox__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ErrorMessageBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ErrorMessageBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweet_modal_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__xkeshi_vue_qrcode__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__xkeshi_vue_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__xkeshi_vue_qrcode__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BsInput: __WEBPACK_IMPORTED_MODULE_4_vue_strap__["input"],
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a,
    alertbar: __WEBPACK_IMPORTED_MODULE_3__components_AlertBar___default.a,
    errorBox: __WEBPACK_IMPORTED_MODULE_7__components_ErrorMessageBox___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_8_sweet_modal_vue__["a" /* SweetModal */],
    VueQrcode: __WEBPACK_IMPORTED_MODULE_9__xkeshi_vue_qrcode___default.a
  },
  props: {
    clinic: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    var defaultDoctor = {
      th: {
        prefix: ''
      },
      en: {},
      gender: 'm',
      isStep: true
    };

    return {
      _searchQ: null,
      q: '',
      showAddPanel: false,
      editMode: false,
      defaultDoctor: defaultDoctor,
      doctor: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, defaultDoctor),
      doctors: [],
      selected_specialities: null,
      selected_sub_specialities: [],
      specialities: [],
      sub_specialities: [],
      paginator: {},
      frmError: this.getFormError(),
      selected_doctor_filter: null,
      selected_specialty_filter: null,
      selected_subspecialty_filter: null,
      selected_specialty_filters: [],
      selected_subspecialty_filters: [],
      selected_doctor_filters: [],
      doctor_filters: [],
      specialty_filters: [],
      subspecialty_filters: [],
      doctorSearching: false,
      doctorQrUrl: ''
    };
  },

  computed: {
    select_specialties_options: function select_specialties_options() {
      return this.specialities.map(function (s) {
        return { label: s.name, value: s.id };
      });
    },
    doctor_list: function doctor_list() {
      return this.doctors.sort(function (a, b) {
        return a.created_at < b.created_at;
      });
    }
  },
  methods: {
    enterCreateMode: function enterCreateMode() {
      this.showAddPanel = true;
      this.editMode = false;
      this.doctor = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.doctor, this.defaultDoctor);
    },
    editDoctor: function editDoctor(d) {
      __WEBPACK_IMPORTED_MODULE_6__router__["b" /* default */].push({
        path: '/doctor/step1/' + d.id,
        query: {
          action: 'edit',
          ref_clinic_id: this.$route.query.ref_clinic_id
        }
      });
    },
    showQRCode: function showQRCode(d) {
      this.doctorQrUrl = this.$APP_CONFIG.api.domain + '/doctor/d-' + d.id;
      this.$refs.qrCodeModal.open();
    },
    downloadDoctorQr: function downloadDoctorQr() {
      this.$refs.doctorQrLink.href = document.getElementById('doctorQrCanvas').toDataURL();
      this.$refs.doctorQrLink.download = 'qr-code';
      this.$refs.doctorQrLink.click();
    },
    saveAndContinue: function saveAndContinue() {
      this.$emit('finishStep');
    },
    cancelChange: function cancelChange() {
      this.$emit('cancelChange');
    },
    refreshDoctorList: function refreshDoctorList(url) {
      var _this = this;

      var newParams = { clinic_id: this.clinic.id };

      if (this.q) {
        newParams.doctor_name = this.q;
      }
      if (this.selected_specialty_filter) {
        newParams.speciality_id = this.selected_specialty_filter.value;
      }
      if (this.selected_subspecialty_filter) {
        newParams.subspeciality_id = this.selected_subspecialty_filter.value;
      }

      this.$http.get(url || this.$APP_CONFIG.api.admin.doctors(), { params: newParams }).then(function (res) {
        _this.doctors = res.body.data || [];

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(_this.paginator, {
          from: res.body.from,
          to: res.body.to,
          total: res.body.total,
          per_page: res.body.per_page,
          current_page: res.body.per_page,
          next_page_url: res.body.next_page_url,
          prev_page_url: res.body.prev_page_url
        });
      }, function (errorResponse) {
        console.error(errorResponse);
      });
    },
    display_sub_specialities: function display_sub_specialities(doctor) {
      var self = this;
      return doctor.subspecialities.map(function (s) {
        return self.$i18n.locale === 'th' ? s.name_th : s.name_en;
      }).join(', ');
    },
    addDoctor: function addDoctor() {
      var _this2 = this;

      if (this.editMode) {
        this._updataDoctor();
      } else {
        if (!this.checkInvalidForm()) {
          return;
        }

        this.clearFormError();

        this.$http.post(this.$APP_CONFIG.api.admin.doctors(), {
          th: this.doctor.th,
          en: this.doctor.en,
          specialities: [+this.selected_specialities.value],
          subspecialities: this.selected_sub_specialities.map(function (s) {
            return +s.value;
          }),
          gender: this.doctor.gender,
          clinics: [this.clinic.id]
        }, {
          headers: { 'content-type': 'application/json' }
        }).then(function (res) {
          if (res.body.status === 'success') {
            if (res.body.data.id) {
              _this2.editDoctor(res.body.data);
            }

            _this2.doctor = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this2.defaultDoctor);

            _this2.showAddPanel = false;

            _this2.refreshDoctorList();
          }
        }, function (error) {
          if (error.body.error) {
            _this2.showFormFromError(error.body.error);
          }
        });
      }
    },
    _updataDoctor: function _updataDoctor() {
      var _this3 = this;

      if (!this.checkInvalidForm()) {
        return;
      }

      this.clearFormError();

      this.$http.put(this.$APP_CONFIG.api.admin.doctors_id(this.doctor.id), {
        th: this.doctor.th,
        en: this.doctor.en,
        specialities: [+this.selected_specialities.value],
        subspecialities: this.selected_sub_specialities.map(function (s) {
          return +s.value;
        })
      }, {
        headers: { 'content-type': 'application/json' }
      }).then(function (res) {
        if (res.body.status === 'success') {
          _this3.doctor = _this3.defaultDoctor;

          _this3.showAddPanel = false;

          _this3.refreshDoctorList();
        }
      }, function (error) {
        if (error.body.error) {
          _this3.showFormFromError(error.body.error);
        }
      });
    },
    removeDoctor: function removeDoctor() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.$confirm('Are you sure ?');

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                _this4.$http.delete(_this4.$APP_CONFIG.api.admin.doctors_id(_this4.doctor.id), {
                  headers: { 'content-type': 'application/json' }
                }).then(function (res) {
                  _this4.doctor = _this4.defaultDoctor;

                  _this4.showAddPanel = false;
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    cancelAddingDoctor: function cancelAddingDoctor() {
      this.showAddPanel = false;
      this.editMode = false;
      this.doctor = this.defaultDoctor;
    },
    checkInvalidForm: function checkInvalidForm() {
      var defaultFrmError = this.getFormDefaultError();
      if (!this.selected_specialities) {
        this.frmError.specialities = defaultFrmError.specialities;
        return false;
      }
      return true;
    },
    clearFormError: function clearFormError() {
      this.frmError = this.getFormError();
    },
    getFormError: function getFormError() {
      return {
        'th.prefix': null,
        'th.firstname': null,
        'th.lastname': null,
        'en.prefix': null,
        'en.firstname': null,
        'en.lastname': null,
        specialities: null
      };
    },
    getFormDefaultError: function getFormDefaultError() {
      return {
        'th.prefix': this.$t('message.doctors.prefix_required'),
        'th.firstname': this.$t('message.doctors.firstname_required'),
        'th.lastname': this.$t('message.doctors.lastname_required'),
        'en.prefix': this.$t('message.doctors.prefix_required'),
        'en.firstname': this.$t('message.doctors.firstname_required'),
        'en.lastname': this.$t('message.doctors.lastname_required'),
        specialities: this.$t('message.doctors.specialty_required')
      };
    },
    showFormFromError: function showFormFromError(error) {
      if (error) {
        this.frmError['th.prefix'] = this.getMessageFromError(error['th.prefix']);
        this.frmError['th.firstname'] = this.getMessageFromError(error['th.firstname']);
        this.frmError['th.lastname'] = this.getMessageFromError(error['th.lastname']);
        this.frmError['en.prefix'] = this.getMessageFromError(error['en.prefix']);
        this.frmError['en.firstname'] = this.getMessageFromError(error['en.firstname']);
        this.frmError['en.lastname'] = this.getMessageFromError(error['en.lastname']);
        this.frmError.specialities = this.getMessageFromError(error.specialities);
      }
    },
    getMessageFromError: function getMessageFromError(errorObj) {
      var message = null;
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ');
      } else {
        message = errorObj;
      }
      return message;
    },
    loadData: function loadData() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var spct;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.$http.get(_this5.$APP_CONFIG.api.specialties());

              case 2:
                spct = _context2.sent;

                if (spct) {
                  _this5.specialities = spct.body;
                  _this5.specialty_filters = spct.body.map(function (r) {
                    return { label: r.name, value: r.id };
                  });
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    loadSubspecialty: function loadSubspecialty(specialtyId) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var sbspct;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (specialtyId) {
                  _context3.next = 5;
                  break;
                }

                _this6.subspecialty_filters = [];
                _this6.selected_subspecialty_filters = [];
                _this6.selected_subspecialty_filter = null;
                return _context3.abrupt('return');

              case 5:
                _context3.next = 7;
                return _this6.$http.get(_this6.$APP_CONFIG.api.sub_specialities(specialtyId));

              case 7:
                sbspct = _context3.sent;

                if (sbspct) {
                  _this6.subspecialty_filters = sbspct.body.map(function (r) {
                    return { label: r.name, value: r.id };
                  });
                }

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    getDoctorsOptions: function getDoctorsOptions(search) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this7.doctorSearching = true;
                _context4.next = 3;
                return _this7.$http.get(_this7.$APP_CONFIG.api.admin.doctors(), {
                  params: {
                    doctor_name: search, clinic_id: _this7.clinic.id
                  },
                  credentials: true
                });

              case 3:
                resp = _context4.sent;


                _this7.doctorSearching = false;
                if (resp) {
                  _this7.doctor_filters = resp.body.data.map(function (r) {
                    return {
                      value: r.id,
                      label: _this7.$i18n.locale === 'th' ? r.name_th : r.name_en
                    };
                  });
                }

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    }
  },
  watch: {
    q: function q(v, old) {
      var _this8 = this;

      var debounchTime = 500;
      clearTimeout(this._searchQ);
      this._searchQ = setTimeout(function () {
        _this8.refreshDoctorList();
      }, debounchTime);
    },
    selected_specialities: function selected_specialities(newValue) {
      var _this9 = this;

      var spid = +newValue.value;
      this.$http.get(this.$APP_CONFIG.api.sub_specialities(spid)).then(function (res) {
        _this9.sub_specialities = res.body.map(function (s) {
          return { value: s.id, label: s.name };
        });
      });
    },
    selected_doctor_filters: function selected_doctor_filters(v, old) {
      if (v && v.length > 0) {
        var data = v[v.length - 1];
        if (v.length > 1) {
          this.selected_doctor_filters = [v[v.length - 1]];
        }
        this.selected_doctor_filter = data;
      } else {
        this.selected_doctor_filter = null;
      }
    },
    selected_specialty_filters: function selected_specialty_filters(v, old) {
      var searchId = null;
      if (v && v.length > 0) {
        var data = v[v.length - 1];
        if (v.length > 1) {
          this.selected_specialty_filters = [v[v.length - 1]];
        }
        this.selected_specialty_filter = data;
        searchId = data.value;
      } else {
        this.selected_specialty_filter = null;
      }

      this.loadSubspecialty(searchId);
    },
    selected_subspecialty_filters: function selected_subspecialty_filters(v, old) {
      if (v && v.length > 0) {
        var data = v[v.length - 1];
        if (v.length > 1) {
          this.selected_subspecialty_filters = [v[v.length - 1]];
        }
        this.selected_subspecialty_filter = data;
      } else {
        this.selected_subspecialty_filter = null;
      }
    },
    selected_doctor_filter: function selected_doctor_filter(v, old) {
      this.refreshDoctorList();
    },
    selected_specialty_filter: function selected_specialty_filter(v, old) {
      this.refreshDoctorList();
    },
    selected_subspecialty_filter: function selected_subspecialty_filter(v, old) {
      this.refreshDoctorList();
    }
  },
  created: function created() {
    this.loadData();

    this.refreshDoctorList();

    this.isStepPrcess = typeof this.$route.params.step !== 'undefined';
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AlertBar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AlertBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AlertBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepBar__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_StepBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_core_image_upload__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_core_image_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_core_image_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Ckeditor__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Ckeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Ckeditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DropZone__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DropZone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_DropZone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweet_modal_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DoctorArrayInput__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DoctorArrayInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_DoctorArrayInput__);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VDropdown: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["dropdown"],
    Step: __WEBPACK_IMPORTED_MODULE_4__components_StepBar___default.a,
    Alertbar: __WEBPACK_IMPORTED_MODULE_3__components_AlertBar___default.a,
    VueCoreImageUpload: __WEBPACK_IMPORTED_MODULE_6_vue_core_image_upload___default.a,
    Ckeditor: __WEBPACK_IMPORTED_MODULE_7__components_Ckeditor___default.a,
    DropZone: __WEBPACK_IMPORTED_MODULE_8__components_DropZone___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_9_sweet_modal_vue__["a" /* SweetModal */],
    DoctorArrayInput: __WEBPACK_IMPORTED_MODULE_10__components_DoctorArrayInput___default.a
  },
  props: {
    clinic: {
      type: Object,
      default: {
        en: {
          video_links: []
        },
        th: {
          video_links: []
        },
        images: []
      },
      required: true
    }
  },
  data: function data() {
    return {
      profile_image_src: '/static/img/no_profile_image.png',
      ckeditorConfig: {
        toolbar: [{ name: 'basicstyles', items: ['Bold', 'Italic'] }, { name: 'paragraph', items: ['BulletedList'] }, { name: 'styles', items: ['Format'] }],
        readOnly: !this.$guser.isPremiumAccount()
      },
      profileImagePlaceholder: '<i class="fa fa-cloud-upload" aria-hidden="true"> ' + this.$t('message.clinic_info.clinic_picture_ph') + '</i>'
    };
  },

  computed: {
    isProfileImage: function isProfileImage() {
      return self.profile_image_src !== null;
    }
  },
  methods: {
    saveAndContinue: function saveAndContinue() {
      this.$emit('update:clinic', this.clinic);

      this.$emit('finishStep', {
        th: {
          clinic_name: this.clinic.th.clinic_name,
          info: this.clinic.th.info,
          detail: this.clinic.th.detail,
          video_links: this.clinic.th.video_links ? this.clinic.th.video_links : []
        },
        en: {
          clinic_name: this.clinic.en.clinic_name,
          info: this.clinic.en.info,
          detail: this.clinic.en.detail,
          video_links: this.clinic.en.video_links ? this.clinic.en.video_links : []
        }
      });
    },
    cancelChange: function cancelChange() {
      this.$emit('cancelChange');
    },
    removeImageFromAlblum: function removeImageFromAlblum(imgId) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _self;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!imgId) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return _this.$confirm(_this.$t('action_message.are_you_sure'));

              case 3:
                if (!_context.sent) {
                  _context.next = 6;
                  break;
                }

                _self = _this;

                _this.$http.delete(_this.$APP_CONFIG.api.admin.upload_clinicme_alblum_id(imgId), { credentials: true }).then(function (res) {
                  _self.refreshDoctor();
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    imageAlblumUploaded: function imageAlblumUploaded() {
      this.refreshDoctor();
    },
    refreshDoctor: function refreshDoctor() {
      var _this2 = this;

      var self = this;
      this.$http.get(this.$APP_CONFIG.api.admin.clinicme(), { credentials: true }).then(function (res) {
        var clinic = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.clinic, res.body.data);

        if (!_this2.clinic.th.video_links) {
          _this2.clinic.th.video_links = [];
        }
        if (!_this2.clinic.en.video_links) {
          _this2.clinic.en.video_links = [];
        }
        self.doctor_profile_th = res.body.data.th;
        self.doctor_profile_en = res.body.data.en;

        if (clinic.images && clinic.images.length > 0) {
          var activeUri = clinic.images.find(function (img) {
            return img.is_active;
          });
          self.profile_image_src = activeUri.file_thumb || '';
        }
        _this2.$emit('update:clinic', clinic);
      }, function (errorResponse) {
        console.error(errorResponse);
      });
    },
    profileImageFileChange: function profileImageFileChange(file) {
      var _this3 = this;

      this.$loadFile(file, function (result) {
        _this3.$refs.croppieRef.bind({
          url: result
        });
        _this3.$refs['crop-modal'].open();
      });
    },
    cancelCrop: function cancelCrop() {
      this.$refs['crop-modal'].close();
    },
    confirmCrop: function confirmCrop() {
      var _this4 = this;

      this.$refs['crop-modal'].close();
      var options = {
        format: 'jpeg'
      };
      this.$refs.croppieRef.result(options, function (output) {
        var formData = new FormData();
        formData.append('image', _this4.$processB64ToBlob(output));
        _this4.$http.post(_this4.$APP_CONFIG.api.admin.upload_clinicme_image(), formData).then(function (res) {
          _this4.$refs['crop-profile-image'].src = res.body.data;
        });
      });
    }
  },
  mounted: function mounted() {
    if (this.clinic.images && this.clinic.images.length > 0) {
      var activeUri = this.clinic.images.find(function (img) {
        return img.is_active;
      });
      this.profile_image_src = activeUri.file_thumb || '';
    }
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AlertBar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AlertBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AlertBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WorkingSchedule__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WorkingSchedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_WorkingSchedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WorkingTimeSlot__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WorkingTimeSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_WorkingTimeSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WorkingBookingPerSlot__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WorkingBookingPerSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_WorkingBookingPerSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweet_modal_vue__ = __webpack_require__(9);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    WorkingSchedule: __WEBPACK_IMPORTED_MODULE_2__components_WorkingSchedule___default.a,
    WorkingTimeSlot: __WEBPACK_IMPORTED_MODULE_3__components_WorkingTimeSlot___default.a,
    WorkingBookingPerSlot: __WEBPACK_IMPORTED_MODULE_4__components_WorkingBookingPerSlot___default.a,
    Alertbar: __WEBPACK_IMPORTED_MODULE_1__components_AlertBar___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_5_sweet_modal_vue__["a" /* SweetModal */]
  },
  props: {
    clinic: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      slotData: {
        booking_per_slot: this.clinic.schedules.length > 0 ? this.clinic.schedules[0].booking_per_slot : 4,
        time_slots: this.clinic.schedules.length > 0 ? this.clinic.schedules[0].time_slots : 30
      }
    };
  },

  computed: {
    isActive: function isActive() {
      return this.$guser.user.clinic && this.$guser.user.clinic.active === 1;
    }
  },
  methods: {
    saveAndContinue: function saveAndContinue() {
      this.$emit('update:clinic', this.clinic);

      this.$emit('finishStep', {
        schedules: this.clinic.schedules,
        appointment_active: this.clinic.appointment_active,
        instant_booking: this.clinic.instant_booking
      });
    },
    cancelChange: function cancelChange() {
      this.$emit('cancelChange');
    },
    updateSchedules: function updateSchedules(clinicId, schedules) {
      this.clinic.schedules = schedules;
    },
    updateTimeSlots: function updateTimeSlots(clinicId, timeSlots) {
      this.slotData.time_slots = timeSlots;
    },
    updateBookingPerSlot: function updateBookingPerSlot(clinicId, booking) {
      this.slotData.booking_per_slot = booking;
    },
    checkFeature: function checkFeature(name) {
      if (!this.$guser.isPremiumAccount()) {
        this.$refs.lockModal.open();
        return false;
      }
      return true;
    },
    gotoPlanPage: function gotoPlanPage() {
      this.$refs.lockModal.close();
      if (this.$guser.isClinic()) {
        __WEBPACK_IMPORTED_MODULE_0__router__["b" /* default */].push({ 'path': '/package', query: { 'type': 'clinic' } });
      } else if (this.$guser.isDoctor()) {
        __WEBPACK_IMPORTED_MODULE_0__router__["b" /* default */].push({ 'path': '/package', query: { 'type': 'doctor' } });
      }
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ErrorMessageBox__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ErrorMessageBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ErrorMessageBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    clinic: {
      type: Object,
      default: {}
    }
  },
  components: {
    BsInput: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["input"],
    ErrorBox: __WEBPACK_IMPORTED_MODULE_4__components_ErrorMessageBox___default.a,
    Draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a
  },
  data: function data() {
    var defaultService = {
      th: {},
      en: {},
      price: null,
      duration: null
    };

    var formDefaultError = {
      'th.name': this.$t('message.services.service_name_require'),
      'en.name': this.$t('message.services.service_name_require'),
      duration: this.$t('message.services.service_duration_require'),
      price: this.$t('message.services.service_price_require')
    };

    var formCleanError = {
      'th.name': null,
      'en.name': null,
      duration: null,
      price: null
    };

    return {
      isModifiedOrder: false,
      services: [],
      defaultService: defaultService,
      formDefaultError: formDefaultError,
      formCleanError: formCleanError,
      frmError: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, formCleanError),
      service: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, defaultService),
      showAddPanel: false,
      editMode: false,
      priceOption: 'price_default'
    };
  },

  watch: {
    priceOption: function priceOption(newOption, oldOption) {
      if (newOption === 'price_default') {
        this.service.is_price_range = 0;
        this.service.is_price_from = 0;
      } else if (newOption === 'price_range') {
        this.service.is_price_range = 1;
        this.service.is_price_from = 0;
      } else if (newOption === 'price_from') {
        this.service.is_price_range = 0;
        this.service.is_price_from = 1;
      }
    }
  },
  methods: {
    saveAndContinue: function saveAndContinue() {
      var _this = this;

      if (this.isModifiedOrder) {
        this.services.forEach(function (service) {
          return _this._updateServiceWithOrder(service);
        });
      }

      this.$emit('update:clinic', this.clinic);

      this.$emit('finishStep');
    },
    cancelChange: function cancelChange() {
      this.$emit('cancelChange');
    },
    editService: function editService(service) {
      this.service = service;
      this.showAddPanel = true;
      this.editMode = true;

      if (!this.service.is_price_range && !this.service.is_price_from) {
        this.priceOption = 'price_default';
      } else if (this.service.is_price_range) {
        this.priceOption = 'price_range';
      } else if (this.service.is_price_from) {
        this.priceOption = 'price_from';
      }
    },
    cancelAddingService: function cancelAddingService() {
      this.service = this.defaultService;
      this.showAddPanel = false;
    },
    removeService: function removeService(s) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$confirm(_this2.$t('action_message.are_you_sure'));

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                _this2.$http.delete(_this2.$APP_CONFIG.api.admin.clinicme_services_id(_this2.service.id, _this2.$route, _this2.$guser), {
                  credentials: true,
                  headers: { 'content-type': 'application/json' }
                }).then(function (res) {
                  _this2.service = _this2.defaultService;

                  _this2.showAddPanel = false;

                  _this2.refreshService();
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    addService: function addService() {
      var _this3 = this;

      if (this.editMode) {
        this._updateService();
      } else {
        this.clearFormError();
        this.$http.post(this.$APP_CONFIG.api.admin.clinicme_services(this.$route, this.$guser), this.service, {
          credentials: true,
          headers: { 'content-type': 'application/json' }
        }).then(function (res) {
          if (res.body.id) {
            _this3.service = _this3.defaultService;

            _this3.showAddPanel = false;

            _this3.refreshService();
          }
        }, function (error) {
          if (error.body.error) {
            _this3.showFormFromError(error.body.error);
          }
        });
      }
    },
    _updateService: function _updateService() {
      var _this4 = this;

      delete this.service.updated_at;
      delete this.service.created_at;
      delete this.service.order;
      delete this.service.d_price;
      delete this.service.clinic_id;

      this.clearFormError();

      this.$http.put(this.$APP_CONFIG.api.admin.clinic_services_id(this.service.id), this.service, {
        credentials: true,
        headers: { 'content-type': 'application/json' }
      }).then(function (res) {
        if (res.body.id) {
          _this4.service = _this4.defaultService;

          _this4.showAddPanel = false;

          _this4.refreshService();
        }
      }, function (error) {
        if (error.body.error) {
          _this4.showFormFromError(error.body.error);
        }
      });
    },
    _updateServiceWithOrder: function _updateServiceWithOrder(service) {
      delete service.updated_at;
      delete service.created_at;
      delete service.clinic_id;
      this.$http.put(this.$APP_CONFIG.api.admin.clinic_services_id(service.id), service, {
        credentials: true,
        headers: { 'content-type': 'application/json' }
      }).then(function (res) {});
    },
    refreshService: function refreshService() {
      var self = this;

      var reqUrl = this.$APP_CONFIG.api.admin.clinicme_services();
      if (this.$route.query.ref_clinic_id) {
        reqUrl = this.$APP_CONFIG.api.admin.domain() + '/clinics/' + this.$route.query.ref_clinic_id + '/services';
      }

      this.$http.get(reqUrl, { credentials: true }).then(function (res) {
        if (res.body.data) {
          self.services = res.body.data.sort(function (obj1, obj2) {
            return obj1.order - obj2.order;
          });
        }
      }, function (errorResponse) {
        console.error(errorResponse);
      });
    },
    clearFormError: function clearFormError() {
      this.frmError = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.formCleanError);
    },
    showFormFromError: function showFormFromError(error) {
      if (error) {
        this.frmError['th.name'] = this.getMessageFromError(error['th.name']);
        this.frmError['en.name'] = this.getMessageFromError(error['en.name']);
        this.frmError.duration = this.getMessageFromError(error.duration);
        this.frmError.price = this.getMessageFromError(error.price);
      }
    },
    getMessageFromError: function getMessageFromError(errorObj) {
      var _message = null;
      if (errorObj && Array.isArray(errorObj)) {
        _message = errorObj.join(' ');
      } else {
        _message = errorObj;
      }
      return _message;
    },
    onServiceDraggableEnd: function onServiceDraggableEnd(evt) {
      this.isModifiedOrder = true;
      for (var index in this.services) {
        this.services[index].order = +index;
      }
    }
  },
  created: function created() {
    this.refreshService();
  }
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_clinic_steps_General__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_clinic_steps_General___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_clinic_steps_General__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_clinic_steps_Address__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_clinic_steps_Address___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_clinic_steps_Address__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_clinic_steps_Schedules__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_clinic_steps_Schedules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_clinic_steps_Schedules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_clinic_steps_Services__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_clinic_steps_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_clinic_steps_Services__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_clinic_steps_Doctors__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_clinic_steps_Doctors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_clinic_steps_Doctors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweet_modal_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_SyncLoader__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SweetModal: __WEBPACK_IMPORTED_MODULE_6_sweet_modal_vue__["a" /* SweetModal */],
    SyncLoader: __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_SyncLoader___default.a,
    'general': __WEBPACK_IMPORTED_MODULE_1__pages_clinic_steps_General___default.a,
    'clinic_address': __WEBPACK_IMPORTED_MODULE_2__pages_clinic_steps_Address___default.a,
    'schedules': __WEBPACK_IMPORTED_MODULE_3__pages_clinic_steps_Schedules___default.a,
    'services': __WEBPACK_IMPORTED_MODULE_4__pages_clinic_steps_Services___default.a,
    'doctors': __WEBPACK_IMPORTED_MODULE_5__pages_clinic_steps_Doctors___default.a
  },
  data: function data() {
    return {
      loading: false,
      clinic: {
        en: {
          video_links: []
        },
        th: {
          video_links: []
        },
        images: [],
        schedules: []
      },
      clinicReady: false,
      page: 'general'
    };
  },

  methods: {
    cancelChange: function cancelChange() {},
    finishStep: function finishStep(clinicDataChanged) {
      var _this = this;

      if (clinicDataChanged) {
        this.loading = true;
        this.$http.put(this.$APP_CONFIG.api.admin.clinicme(this.$route, this.$guser), clinicDataChanged, {
          headers: { 'content-type': 'application/json' }
        }).then(function (res) {
          _this.loading = false;
          if (res.body.status === 'success') {
            _this.clinic = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.clinic, res.body.data);

            if (!_this.clinic.th.video_links) {
              _this.clinic.th.video_links = [];
            }
            if (!_this.clinic.en.video_links) {
              _this.clinic.en.video_links = [];
            }
            _this.$refs.modal.open();
          }
        });
      } else {
        this.loading = false;
        this.$refs.modal.open();
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.get(this.$APP_CONFIG.api.admin.clinicme(this.$route, this.$guser), { credentials: true }).then(function (res) {
      _this2.clinic = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.clinic, res.body.data);

      if (!_this2.clinic.th.video_links) {
        _this2.clinic.th.video_links = [];
      }
      if (!_this2.clinic.en.video_links) {
        _this2.clinic.en.video_links = [];
      }
      _this2.clinicReady = true;
    }, function (errorResponse) {
      console.error(errorResponse);
    });
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'buttons'
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cards'
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarExample__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarExample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_BarExample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_LineExample__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_LineExample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_LineExample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_DoughnutExample__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_DoughnutExample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__charts_DoughnutExample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_RadarExample__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_RadarExample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__charts_RadarExample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__charts_PieExample__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__charts_PieExample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__charts_PieExample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__charts_PolarAreaExample__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__charts_PolarAreaExample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__charts_PolarAreaExample__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'charts',
  components: {
    BarExample: __WEBPACK_IMPORTED_MODULE_0__charts_BarExample___default.a,
    LineExample: __WEBPACK_IMPORTED_MODULE_1__charts_LineExample___default.a,
    DoughnutExample: __WEBPACK_IMPORTED_MODULE_2__charts_DoughnutExample___default.a,
    RadarExample: __WEBPACK_IMPORTED_MODULE_3__charts_RadarExample___default.a,
    PieExample: __WEBPACK_IMPORTED_MODULE_4__charts_PieExample___default.a,
    PolarAreaExample: __WEBPACK_IMPORTED_MODULE_5__charts_PolarAreaExample___default.a
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_strap__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fomrs',
  components: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["dropdown"]
  },
  methods: {
    click: function click() {}
  }
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_strap__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modals',
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["modal"]
  },
  data: function data() {
    return {
      myModal: false,
      largeModal: false,
      smallModal: false,
      primaryModal: false,
      successModal: false,
      warningModal: false,
      dangerModal: false,
      infoModal: false
    };
  }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'social-buttons'
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'switches'
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tables'
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'widgets',
  data: function data() {
    return {
      msg: 'Widgets'
    };
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      datasets: [{
        label: 'GitHub Commits',
        backgroundColor: '#f87979',
        data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
      }]
    });
  }
}));

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Doughnut"].extend({
  mounted: function mounted() {
    this.renderChart({
      labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
      datasets: [{
        backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
        data: [40, 20, 80, 10]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
}));

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [{
        label: 'Data One',
        backgroundColor: '#f87979',
        data: [40, 39, 10, 40, 39, 80, 40]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
}));

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
  mounted: function mounted() {
    this.renderChart({
      labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
      datasets: [{
        backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
        data: [40, 20, 80, 10]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
}));

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["PolarArea"].extend({
  mounted: function mounted() {
    this.renderChart({
      labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
      datasets: [{
        label: 'My First dataset',
        backgroundColor: 'rgba(179,181,198,0.2)',
        pointBackgroundColor: 'rgba(179,181,198,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(179,181,198,1)',
        data: [65, 59, 90, 81, 56, 55, 40]
      }, {
        label: 'My Second dataset',
        backgroundColor: 'rgba(255,99,132,0.2)',
        pointBackgroundColor: 'rgba(255,99,132,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(255,99,132,1)',
        data: [28, 48, 40, 19, 96, 27, 100]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
}));

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Radar"].extend({
  mounted: function mounted() {
    this.renderChart({
      labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
      datasets: [{
        label: 'My First dataset',
        backgroundColor: 'rgba(179,181,198,0.2)',
        borderColor: 'rgba(179,181,198,1)',
        pointBackgroundColor: 'rgba(179,181,198,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(179,181,198,1)',
        data: [65, 59, 90, 81, 56, 55, 40]
      }, {
        label: 'My Second dataset',
        backgroundColor: 'rgba(255,99,132,0.2)',
        borderColor: 'rgba(255,99,132,1)',
        pointBackgroundColor: 'rgba(255,99,132,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(255,99,132,1)',
        data: [28, 48, 40, 19, 96, 27, 100]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
}));

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'font-awesome'
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'simple-line-icons'
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: this.$guser.user,
      clinics: this.$guser.user.clinics ? this.$guser.user.clinics : null,
      error: null
    };
  },

  methods: {
    setData: function setData(err, data) {
      if (err) {
        this.error = err.toString();
      } else {
        this.clinics = data;
      }
    }
  }
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chart_LineChart__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chart_LineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_chart_LineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_DotLoader__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_DotLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_DotLoader__);







var backgroundColor = '#20a8d8';
var borderColor = 'rgba(255,255,255,.55)';

__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('th');

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DashboardLineChart: __WEBPACK_IMPORTED_MODULE_1__components_chart_LineChart___default.a,
    DotLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_DotLoader___default.a
  },
  data: function data() {
    return {
      loading: false,
      appointments: {},
      stats: {},
      notifications: [],
      appointmentStatChartData: {
        count: 0,
        labels: [],
        datasets: [{
          label: '',
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          data: []
        }]
      },
      viewStatChartData: {
        count: 0,
        labels: [],
        datasets: [{
          label: '',
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          data: []
        }]
      }
    };
  },

  computed: {
    notificationShow: function notificationShow() {
      return this.notifications.length > 0;
    }
  },
  methods: {
    actionProcess: function actionProcess(type) {
      if (type === 'appointment') {
        this.gotoAppointmentsView();
      }
    },
    gotoAppointmentsView: function gotoAppointmentsView() {
      this.$router.push({ path: '/appointments', query: { status: 'pending' } });
    }
  },
  created: function created() {
    var _this = this;

    var self = this;

    self.notifications = [];
    this.$http.get(this.$APP_CONFIG.api.appointments(), {
      params: {
        clinic_id: this.$guser.user.clinic.id,
        start: 'all',
        status: 'pending'
      },
      credentials: true
    }).then(function (res) {
      self.appointments = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.body);
      if (self.appointments.total) {
        self.notifications.push({
          id: 1,
          type: 'appointment',
          message: '' + _this.$t('message.dashboard.notification_appointment_first') + self.appointments.total + _this.$t('message.dashboard.notification_appointment_last'),
          action: _this.$t('message.dashboard.notification_action')
        });
      }
    });

    if (this.$guser.isClinic()) {
      this.loading = true;
      this.$http.get(this.$APP_CONFIG.api.admin.clinic_stats(this.$guser.user.clinic.id)).then(function (res) {
        self.stats = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.stats, res.body);

        if (self.stats.appointmentStat) {
          self.appointmentStatChartData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
            count: 0,
            labels: [],
            datasets: [{
              label: '',
              backgroundColor: backgroundColor,
              borderColor: borderColor,
              data: []
            }]
          });
          var appStatByDate = {};
          var viewStatByDate = {};

          var days = __WEBPACK_IMPORTED_MODULE_2_moment___default()().daysInMonth();
          var n = 0;
          for (n = days; n >= 0; n--) {
            var _key = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract({ days: n }).format('YYYY-MM-DD');
            appStatByDate[_key] = {
              count: 0,
              date: _key
            };
            viewStatByDate[_key] = {
              count: 0,
              date: _key
            };
          }

          self.stats.appointmentStat.forEach(function (data) {
            if (data.count && data.date) {
              appStatByDate[data.date] = {
                count: data.count,
                date: data.date
              };
            }
          });

          var key = null;
          for (key in appStatByDate) {
            var dataDateObj = appStatByDate[key];
            if (dataDateObj.count >= 0 && dataDateObj.date) {
              self.appointmentStatChartData.datasets[0].data.push(dataDateObj.count);
              self.appointmentStatChartData.labels.push(dataDateObj.date);
              self.appointmentStatChartData.count += dataDateObj.count;
            }
          }

          self.viewStatChartData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
            count: 0,
            labels: [],
            datasets: [{
              label: '',
              backgroundColor: backgroundColor,
              borderColor: borderColor,
              data: []
            }]
          });
          self.stats.viewStat.forEach(function (data) {
            if (data.count && data.date) {
              viewStatByDate[data.date] = {
                count: data.count,
                date: data.date
              };
            }
          });

          for (key in viewStatByDate) {
            var _dataDateObj = viewStatByDate[key];
            if (_dataDateObj.count >= 0 && _dataDateObj.date) {
              self.viewStatChartData.datasets[0].data.push(_dataDateObj.count);
              self.viewStatChartData.labels.push(_dataDateObj.date);
              self.viewStatChartData.count += _dataDateObj.count;
            }
          }
        }

        self.loading = false;
      });
    }
    this.notifications = [];
  }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AlertBar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AlertBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AlertBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweet_modal_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DoctorArrayInput__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DoctorArrayInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_DoctorArrayInput__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Alertbar: __WEBPACK_IMPORTED_MODULE_3__components_AlertBar___default.a,
    SyncLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_7_sweet_modal_vue__["a" /* SweetModal */],
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker___default.a,
    BsInput: __WEBPACK_IMPORTED_MODULE_6_vue_strap__["input"],
    DoctorArrayInput: __WEBPACK_IMPORTED_MODULE_8__components_DoctorArrayInput___default.a
  },
  data: function data() {
    var doctorDefault = {
      show_review: 0
    };
    return {
      clinic: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, doctorDefault),
      loading: true,
      loaded: false
    };
  },

  methods: {
    loadSetting: function loadSetting() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$http.get(_this.$APP_CONFIG.api.admin.doctorme(), { credentials: true });

              case 2:
                response = _context.sent;

                if (response) {
                  _this.processDoctor(response.body.data);
                }
                _this.loading = false;
                _this.loaded = true;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    processDoctor: function processDoctor(data) {
      this.doctor = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.doctor, data);
    },
    save: function save() {
      var _this2 = this;

      this.loading = true;
      var updatedDoctor = {
        show_review: this.doctor.show_review ? 1 : 0
      };

      this.$http.put(this.$APP_CONFIG.api.admin.doctorme(), updatedDoctor, { headers: { 'content-type': 'application/json' } }).then(function (res) {
        _this2.loading = false;
        if (res.body.status === 'success') {
          _this2.processDoctor(res.body.data);
          _this2.$refs.modal.open();
        }
      });
    }
  },
  created: function created() {
    this.loadSetting();
  }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepBar__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_StepBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DoctorArrayInput__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DoctorArrayInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_DoctorArrayInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixin__ = __webpack_require__(59);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DoctorEditStep4',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixin__["a" /* default */]],
  components: {
    Step: __WEBPACK_IMPORTED_MODULE_4__components_StepBar___default.a,
    DoctorArrayInput: __WEBPACK_IMPORTED_MODULE_5__components_DoctorArrayInput___default.a
  },
  data: function data() {
    return {
      doctor: {
        license_number: '',
        th: {
          educations: [],
          certifications: [],
          professional_memberships: []
        },
        en: {
          educations: [],
          certifications: [],
          professional_memberships: []
        }
      }
    };
  },

  methods: {
    back: function back() {
      __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].go(-1);
    },
    saveAndContinue: function saveAndContinue() {
      var _this = this;

      var routeData = { path: this.next_uri(4), query: { action: this.$route.query.action } };
      this.$http.put(this.doctor_uri, {
        th: this.doctor.th,
        en: this.doctor.en,
        license_number: this.doctor.license_number
      }, {
        credentials: true,
        headers: { 'content-type': 'application/json' }
      }).then(function (res) {
        if (res.body.status === 'success') {
          _this.$toastr.success(_this.$t('action_message.save_success'));
          __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].push(routeData);
        }
      });
    },
    deleteDoctor: function deleteDoctor() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$confirm(_this2.$t('action_message.are_you_sure'));

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                _this2.$http.delete(_this2.$APP_CONFIG.api.admin.doctors(_this2.doctor_key)).then(function (res) {
                  if (res.body) {
                    __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].push({ path: '/clinic/doctors' });
                  }
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  created: function created() {
    var self = this;
    this.$http.get(this.doctor_uri).then(function (res) {
      var _doctor = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.body.data);

      var fields = ['educations', 'certifications', 'professional_memberships'];
      fields.forEach(function (field) {
        if (_doctor.th[field]) {
          _doctor.th[field].forEach(function (v) {
            self.doctor.th[field].push(v);
          });
        }

        if (_doctor.en[field]) {
          _doctor.en[field].forEach(function (v) {
            self.doctor.en[field].push(v);
          });
        }

        self.doctor.license_number = _doctor.license_number;
      });
    }, function (errorResponse) {
      console.error(errorResponse);
    });
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StepBar__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StepBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixin__ = __webpack_require__(59);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DoctorEditStep1',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixin__["a" /* default */]],
  components: {
    BsInput: __WEBPACK_IMPORTED_MODULE_4_vue_strap__["input"],
    Step: __WEBPACK_IMPORTED_MODULE_3__components_StepBar___default.a,
    Dropzone: __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a
  },
  data: function data() {
    return {
      doctor: {
        en: {
          custom_text: null
        },
        th: {
          custom_text: null
        }
      },
      selected_specialities: null,
      selected_sub_specialities: [],
      specialities: [],
      sub_specialities: [],
      institutes: [],
      selected_institute: null,
      clinics: [],
      selected_clinics: [],
      selected_clinic: null,
      clinicLoading: false
    };
  },

  computed: {
    select_specialties_options: function select_specialties_options() {
      return this.specialities.map(function (s) {
        return { label: s.name, value: s.id };
      });
    },
    _selected_specialties: function _selected_specialties() {
      try {
        var self = this;
        return this.doctor.specialities.map(function (s) {
          if (self.$i18n.locale === 'en') {
            return { label: s.name_en, value: s.id };
          }
          return { label: s.name_th, value: s.id };
        });
      } catch (e) {
        return null;
      }
    },
    select_institutes_options: function select_institutes_options() {
      return this.institutes.map(function (s) {
        return { label: s.name, value: s.id };
      });
    }
  },
  watch: {
    selected_specialities: function selected_specialities(newValue) {
      var spid = +newValue.value;
      var self = this;
      this.$http.get(this.$APP_CONFIG.api.sub_specialities(spid)).then(function (res) {
        self.sub_specialities = res.body.map(function (s) {
          return { value: s.id, label: s.name };
        });
      });
    }
  },
  methods: {
    back: function back() {
      __WEBPACK_IMPORTED_MODULE_7__router__["b" /* default */].go(-1);
    },
    selectSpeciality: function selectSpeciality(values) {
      var self = this;

      this.doctor.specialities = values.map(function (v) {
        var s = self.specialities.find(function (_s) {
          return +_s.id === +v.value;
        });
        return {
          id: s.id,
          name_th: s.translations.find(function (t) {
            return t.locale === 'th';
          }).name,
          name_en: s.translations.find(function (t) {
            return t.locale === 'en';
          }).name
        };
      });
    },
    saveAndContinue: function saveAndContinue() {
      var _this = this;

      var data = {
        en: {
          custom_text: this.doctor.en.custom_text
        },
        th: {
          custom_text: this.doctor.th.custom_text
        }
      };
      if (this.selected_specialities) {
        data.specialities = [+this.selected_specialities.value];
      }

      if (this.selected_sub_specialities) {
        data.subspecialities = this.selected_sub_specialities.map(function (s) {
          return +s.value;
        });
      }

      if (this.selected_institute) {
        data.institutes = [+this.selected_institute.value];
      }

      if (this.selected_clinics) {
        data.clinics = this.selected_clinics.map(function (c) {
          return +c.value;
        });
      }

      var routeData = { path: this.next_uri(2), query: { action: this.$route.query.action } };
      this.$http.put(this.doctor_uri, data, {
        credentials: true,
        headers: { 'content-type': 'application/json' }
      }).then(function (res) {
        if (res.body.status === 'success') {
          _this.$toastr.success(_this.$t('action_message.save_success'));
          __WEBPACK_IMPORTED_MODULE_7__router__["b" /* default */].push(routeData);
        }
      });
    },
    getClinicsOptions: function getClinicsOptions(search) {
      var self = this;
      self.clinicLoading = true;
      this.$http.get(this.$APP_CONFIG.api.clinics(), {
        params: {
          clinic_name: search
        },
        credentials: true
      }).then(function (resp) {
        self.clinics = resp.body.data.map(function (c) {
          return {
            value: c.id,
            label: c.clinic_name
          };
        });
        self.clinicLoading = false;
      });
    },
    deleteDoctor: function deleteDoctor() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$confirm(_this2.$t('action_message.are_you_sure'));

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                _this2.$http.delete(_this2.$APP_CONFIG.api.admin.doctors_id(_this2.doctor.id)).then(function (res) {
                  if (res.body) {
                    __WEBPACK_IMPORTED_MODULE_7__router__["b" /* default */].push({ path: '/clinic/doctors' });
                  }
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  created: function created() {
    var _this3 = this;

    var self = this;

    this.$http.get(this.$APP_CONFIG.api.specialties(), { credentials: true }).then(function (res) {
      self.specialities = res.body;
    });

    this.$http.get(this.$APP_CONFIG.api.institutes(), { credentials: true }).then(function (res) {
      self.institutes = res.body;
    });

    this.$http.get(this.doctor_uri, { credentials: true }).then(function (res) {
      self.doctor = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.doctor, res.body.data);

      if (self.doctor.specialities.length > 0) {
        var s = self.doctor.specialities[0];
        if (self.$i18n.locale === 'en') {
          self.selected_specialities = { value: s.id, label: s.name_en };
        } else {
          self.selected_specialities = { value: s.id, label: s.name_th };
        }
      }

      self.selected_sub_specialities = _this3.doctor.subspecialities.map(function (s) {
        if (self.$i18n.locale === 'en') {
          return { value: s.id, label: s.name_en };
        } else {
          return { value: s.id, label: s.name_th };
        }
      });

      if (self.doctor.institutes.length > 0) {
        var ins = self.doctor.institutes[0];
        if (self.$i18n.locale === 'en') {
          self.selected_institute = { value: ins.id, label: ins.name_en };
        } else {
          self.selected_institute = { value: ins.id, label: ins.name_th };
        }
      }

      self.selected_clinics = _this3.doctor.clinics.map(function (c) {
        return { value: c.id, label: c.name_th };
      });
    }, function (errorResponse) {
      console.error(errorResponse);
    });
  }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepBar__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_StepBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_core_image_upload__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_core_image_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_core_image_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Ckeditor__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Ckeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Ckeditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DropZone__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DropZone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_DropZone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweet_modal_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AlertBar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AlertBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_AlertBar__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DoctorEditStep1',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixin__["a" /* default */]],
  components: {
    VDropdown: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["dropdown"],
    Step: __WEBPACK_IMPORTED_MODULE_4__components_StepBar___default.a,
    VueCoreImageUpload: __WEBPACK_IMPORTED_MODULE_6_vue_core_image_upload___default.a,
    Ckeditor: __WEBPACK_IMPORTED_MODULE_8__components_Ckeditor___default.a,
    DropZone: __WEBPACK_IMPORTED_MODULE_9__components_DropZone___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_10_sweet_modal_vue__["a" /* SweetModal */],
    Alertbar: __WEBPACK_IMPORTED_MODULE_11__components_AlertBar___default.a
  },
  data: function data() {
    return {
      doctor: {},
      doctor_profile_th: {},
      doctor_profile_en: {},
      profile_image_src: '/static/img/no_profile_image.png',
      profile_upload_url: '',
      profile_upload_album: '',
      ckeditorConfig: {
        toolbar: [{ name: 'basicstyles', items: ['Bold', 'Italic'] }, { name: 'paragraph', items: ['BulletedList'] }, { name: 'styles', items: ['Format'] }]
      },
      profileImagePlaceholder: '<i class="fa fa-cloud-upload" aria-hidden="true"> ' + this.$t('message.doctor_general.select_image') + '</i>'
    };
  },

  computed: {
    isProfileImage: function isProfileImage() {
      return self.profile_image_src !== null;
    }
  },
  methods: {
    saveAndContinue: function saveAndContinue() {
      var _this = this;

      var routeData = { path: this.next_uri(1), query: { action: this.$route.query.action } };
      this.$http.put(this.doctor_uri, {
        th: this.doctor_profile_th,
        en: this.doctor_profile_en,
        gender: this.doctor.gender
      }, {
        credentials: true,
        headers: { 'content-type': 'application/json' }
      }).then(function (res) {
        if (res.body.status === 'success') {
          _this.$toastr.success(_this.$t('action_message.save_success'));
          __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].push(routeData);
        }
      });
    },
    removeImageFromAlblum: function removeImageFromAlblum(imgId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!imgId) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return _this2.$confirm(_this2.$t('action_message.are_you_sure'));

              case 3:
                if (!_context.sent) {
                  _context.next = 6;
                  break;
                }

                self = _this2;

                _this2.$http.delete(_this2.profile_upload_album + '/' + imgId, { credentials: true }).then(function (res) {
                  self.doctor.images.find(function (img) {
                    return img.id === imgId;
                  });
                  _this2.refreshDoctor();
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    imageAlblumUploaded: function imageAlblumUploaded() {
      this.refreshDoctor();
    },
    refreshDoctor: function refreshDoctor() {
      var _this3 = this;

      this.$http.get(this.doctor_uri).then(function (res) {
        _this3.doctor = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.body.data);
        _this3.doctor_profile_th = res.body.data.th;
        _this3.doctor_profile_en = res.body.data.en;

        if (_this3.doctor.images && _this3.doctor.images.length > 0) {
          var activeUri = _this3.doctor.images.find(function (img) {
            return img.is_active;
          });
          _this3.profile_image_src = activeUri.file_thumb || '';
        }
      }, function (errorResponse) {
        console.error(errorResponse);
      });
    },
    deleteDoctor: function deleteDoctor() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.$confirm(_this4.$t('action_message.are_you_sure'));

              case 2:
                if (!_context2.sent) {
                  _context2.next = 4;
                  break;
                }

                _this4.$http.delete(_this4.$APP_CONFIG.api.admin.doctors_id(_this4.doctor.id)).then(function (res) {
                  if (res.body && _this4.$guser.isClinicMulti()) {
                    __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].push({ path: '/clinic/doctors', query: { ref_clinic_id: _this4.$route.query.ref_clinic_id } });
                  } else if (res.body) {
                    __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].push({ path: '/clinic/doctors' });
                  }
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    profileImageFileChange: function profileImageFileChange(file) {
      var _this5 = this;

      this.$loadFile(file, function (result) {
        _this5.$refs.croppieRef.bind({
          url: result
        });
        _this5.$refs['crop-modal'].open();
      });
    },
    cancelCrop: function cancelCrop() {
      this.$refs['crop-modal'].close();
    },
    confirmCrop: function confirmCrop() {
      var _this6 = this;

      this.$refs['crop-modal'].close();
      var options = {
        format: 'jpeg'
      };
      this.$refs.croppieRef.result(options, function (output) {
        var formData = new FormData();
        formData.append('image', _this6.$processB64ToBlob(output));
        _this6.$http.post(_this6.profile_upload_url, formData).then(function (res) {
          _this6.$refs['crop-profile-image'].src = res.body.data;
        });
      });
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.$http.get(this.doctor_uri).then(function (res) {
      _this7.doctor = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.body.data);
      _this7.doctor_profile_th = res.body.data.th;
      _this7.doctor_profile_en = res.body.data.en;
      _this7.profile_upload_url = _this7.$APP_CONFIG.api.admin.upload_doctorme_image(_this7.doctor.id);
      _this7.profile_upload_album = _this7.$APP_CONFIG.api.admin.upload_doctorme_alblum(_this7.doctor.id);

      if (_this7.doctor.images && _this7.doctor.images.length > 0) {
        var activeUri = _this7.doctor.images.find(function (img) {
          return img.is_active;
        });
        _this7.profile_image_src = activeUri.file_thumb || '';
      }
    });
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepBar__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_StepBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DoctorArrayInput__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DoctorArrayInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_DoctorArrayInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Ckeditor__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Ckeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Ckeditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweet_modal_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixin__ = __webpack_require__(59);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DoctorEditStep5',
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixin__["a" /* default */]],
  components: {
    Step: __WEBPACK_IMPORTED_MODULE_4__components_StepBar___default.a,
    DoctorArrayInput: __WEBPACK_IMPORTED_MODULE_5__components_DoctorArrayInput___default.a,
    Ckeditor: __WEBPACK_IMPORTED_MODULE_7__components_Ckeditor___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_8_sweet_modal_vue__["a" /* SweetModal */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a
  },
  data: function data() {
    return {
      doctor: {
        th: {
          info: '',
          video_links: []
        },
        en: {
          info: ''
        }
      },
      selected_languages: [],
      language_list: [],
      contentEng: '',
      contentThai: '',
      ckeditorConfig: {
        readOnly: !this.$guser.isActive(),
        toolbar: [{ name: 'basicstyles', items: ['Bold', 'Italic'] }, { name: 'paragraph', items: ['BulletedList'] }, { name: 'styles', items: ['Format'] }]
      },
      editMode: false
    };
  },

  computed: {
    isActive: function isActive() {
      return this.$guser.user.clinic && this.$guser.user.clinic.active === 1;
    }
  },
  methods: {
    back: function back() {
      __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].go(-1);
    },
    saveAndContinue: function saveAndContinue() {
      var self = this;

      var routeData = { path: this.next_uri(0), query: { action: this.$route.query.action } };

      self.doctor.en.video_links = self.doctor.th.video_links;
      this.$http.put(this.doctor_uri, {
        languages: this.selected_languages.map(function (l) {
          return l.value;
        }),
        en: self.doctor.en,
        th: self.doctor.th
      }).then(function (res) {
        if (res.body.status === 'success') {
          var backToMainDelay = 2000;
          self.$refs.modal.open();
          if (self.$guser.isClinic()) {
            setTimeout(function () {
              self.$refs.modal.close();
              __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].push({ path: '/clinic/doctors' });
            }, backToMainDelay);
          } else {
            setTimeout(function () {
              self.$refs.modal.close();
              __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].push(routeData);
            }, backToMainDelay);
          }
        }
      });
    },
    deleteDoctor: function deleteDoctor() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$confirm(_this.$t('action_message.are_you_sure'));

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                _this.$http.delete(_this.$APP_CONFIG.api.admin.doctors_id(_this.doctor.id)).then(function (res) {
                  if (res.body) {
                    __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].push({ path: '/clinic/doctors' });
                  }
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkFeature: function checkFeature(name) {
      if (!this.$guser.isActive()) {
        this.$refs.infoLockModal.open();
        return false;
      }
      return true;
    },
    gotoPlanPage: function gotoPlanPage() {
      this.$refs.infoLockModal.close();
      __WEBPACK_IMPORTED_MODULE_3__router__["b" /* default */].push({ 'path': '/package' });
    }
  },
  mounted: function mounted() {
    this.editMode = this.$route.query.action === 'edit';

    var self = this;

    this.$http.get(this.$APP_CONFIG.api.languages()).then(function (res) {
      self.language_list = res.body.map(function (l) {
        return {
          value: l.id,
          label: l.lang_name_en
        };
      });
    });

    this.$http.get(this.doctor_uri).then(function (res) {
      self.doctor = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.body.data);
      if (self.doctor.th && !self.doctor.th.video_links) {
        self.doctor.th.video_links = [];
      }

      self.selected_languages = self.doctor.languages.map(function (l) {
        return { value: l.id, label: l.name_en };
      });
    }, function (errorResponse) {
      console.error(errorResponse);
    });
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepBar__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_StepBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WorkingSchedule__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WorkingSchedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_WorkingSchedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WorkingTimeSlot__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WorkingTimeSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_WorkingTimeSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_WorkingBookingPerSlot__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_WorkingBookingPerSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_WorkingBookingPerSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_WorkingSlotPreview__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_WorkingSlotPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_WorkingSlotPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweet_modal_vue__ = __webpack_require__(9);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DoctorEditStep3',
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixin__["a" /* default */]],
  components: {
    Step: __WEBPACK_IMPORTED_MODULE_4__components_StepBar___default.a,
    WorkingSchedule: __WEBPACK_IMPORTED_MODULE_6__components_WorkingSchedule___default.a,
    WorkingTimeSlot: __WEBPACK_IMPORTED_MODULE_7__components_WorkingTimeSlot___default.a,
    WorkingBookingPerSlot: __WEBPACK_IMPORTED_MODULE_8__components_WorkingBookingPerSlot___default.a,
    WorkingSlotPreview: __WEBPACK_IMPORTED_MODULE_9__components_WorkingSlotPreview___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_11_sweet_modal_vue__["a" /* SweetModal */]
  },
  data: function data() {
    return {
      doctor: {},

      schedules_by_clinics: {},
      slotData: {},
      currentClinic: null
    };
  },

  computed: {
    isActive: function isActive() {
      return this.$guser.user.clinic && this.$guser.user.clinic.active === 1;
    }
  },
  methods: {
    back: function back() {
      __WEBPACK_IMPORTED_MODULE_5__router__["b" /* default */].go(-1);
    },
    saveAndContinue: function saveAndContinue() {
      var _this = this;

      var routeData = { path: this.next_uri(3), query: { action: this.$route.query.action } };
      this.$http.put(this.doctor_uri, {
        appointment_active: this.doctor.appointment_active,
        schedules: this.doctor.schedules
      }, {
        credentials: true,
        headers: { 'content-type': 'application/json' }
      }).then(function (res) {
        if (res.body.status === 'success') {
          _this.$toastr.success(_this.$t('action_message.save_success'));
          __WEBPACK_IMPORTED_MODULE_5__router__["b" /* default */].push(routeData);
        }
      });
    },
    updateSchedules: function updateSchedules(clinicId, schedule) {
      this.doctor.schedules = this.doctor.schedules.filter(function (s) {
        return !(s.clinic_id === clinicId);
      });

      this.doctor.schedules = this.doctor.schedules.concat(schedule);
    },
    updateTimeSlots: function updateTimeSlots(clinicId, timeSlots) {
      this.slotData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.slotData, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, clinicId, {
        time_slots: timeSlots,
        booking_per_slot: this.slotData[clinicId].booking_per_slot
      }));
    },
    updateBookingPerSlot: function updateBookingPerSlot(clinicId, booking) {
      this.slotData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.slotData, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, clinicId, {
        booking_per_slot: booking,
        time_slots: this.slotData[clinicId].time_slots
      }));
    },
    deleteDoctor: function deleteDoctor() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$confirm(_this2.$t('action_message.are_you_sure'));

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                _this2.$http.delete(_this2.$APP_CONFIG.api.admin.doctors_id(_this2.doctor.id)).then(function (res) {
                  if (res.body) {
                    __WEBPACK_IMPORTED_MODULE_5__router__["b" /* default */].push({ path: '/clinic/doctors' });
                  }
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    shouldView: function shouldView(clinicId) {
      return !this.$guser.isClinic() || this.$guser.isClinic() && clinicId === this.currentClinic;
    },
    checkFeature: function checkFeature(name) {
      if (!this.$guser.isPremiumAccount()) {
        this.$refs.lockModal.open();
        return false;
      }
      return true;
    },
    gotoPlanPage: function gotoPlanPage() {
      this.$refs.lockModal.close();
      if (this.$guser.isClinic()) {
        __WEBPACK_IMPORTED_MODULE_5__router__["b" /* default */].push({ 'path': '/package', query: { 'type': 'clinic' } });
      } else if (this.$guser.isDoctor()) {
        __WEBPACK_IMPORTED_MODULE_5__router__["b" /* default */].push({ 'path': '/package', query: { 'type': 'doctor' } });
      }
    }
  },
  created: function created() {
    var self = this;

    if (this.$guser.isClinic()) {
      this.$http.get(this.$APP_CONFIG.api.admin.clinicme(), { credentials: true }).then(function (res) {
        self.currentClinic = res.body.data.id;
      }, function (errorResponse) {
        console.error(errorResponse);
      });
    }

    this.$http.get(this.doctor_uri).then(function (res) {
      self.doctor = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, res.body.data);

      self.doctor.clinics.forEach(function (c) {
        self.schedules_by_clinics[c.id] = [];
        self.slotData[c.id] = { time_slots: 30, booking_per_slot: 4 };
      });

      self.doctor.schedules.forEach(function (s) {
        self.schedules_by_clinics[s.clinic_id] = self.schedules_by_clinics[s.clinic_id] || [];
        self.schedules_by_clinics[s.clinic_id].push(s);
        if (self.schedules_by_clinics[s.clinic_id].length > 0) {
          self.slotData[s.clinic_id] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
            time_slots: self.schedules_by_clinics[s.clinic_id][0].time_slots,
            booking_per_slot: self.schedules_by_clinics[s.clinic_id][0].booking_per_slot
          });
        }
      });
    }, function (errorResponse) {
      console.error(errorResponse);
    });
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SyncLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SyncLoader___default.a
  },
  data: function data() {
    return {
      limitContentLength: 80,
      reviews: {},
      loading: false,
      loaded: false,
      ratingKeys: [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(Array(5).keys()))
    };
  },

  methods: {
    openAppointmentDetail: function openAppointmentDetail(id) {
      if (id) this.$router.push({ path: '/appointments/' + id });
    },
    openPatient: function openPatient(id) {
      if (id) this.$router.push({ path: '/patient/' + id });
    },
    openDoctor: function openDoctor(id) {
      if (id) this.$router.push({ path: '/doctor/step1/' + id, query: { action: 'edit' } });
    },
    getDoctorName: function getDoctorName(review) {
      if (review && review.doctor) {
        return review.doctor.firstname + ' ' + review.doctor.lastname;
      }
      return '';
    },
    getDoctorSpecialty: function getDoctorSpecialty(review) {
      return '';
    },
    toggleMoreContent: function toggleMoreContent(review) {
      review.showMoreContent = !review.showMoreContent;
    },
    viewContent: function viewContent(content, isTruncate) {
      if (isTruncate) {
        return this.$options.filters.truncate(content, this.limitContentLength);
      }
      return content;
    },
    loadReviews: function loadReviews(url) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, reviewResp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _this.loaded = false;
                params = {};

                if (_this.$guser.isClinic() || _this.$guser.isClinicMulti()) {
                  params.clinic_id = _this.$guser.user.clinic.id;
                } else if (_this.$guser.isDoctor()) {
                  params.doctor_id = _this.$guser.user.doctor.id;
                }
                _context.next = 6;
                return _this.$http.get(url || _this.$APP_CONFIG.api.admin.reviews(_this.$route, _this.$guser), {
                  params: params,
                  credentials: true
                });

              case 6:
                reviewResp = _context.sent;


                _this.loading = false;
                _this.loaded = true;
                _this.reviews = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
                  from: reviewResp.body.from,
                  to: reviewResp.body.to,
                  total: reviewResp.body.total,
                  per_page: reviewResp.body.per_page,
                  current_page: reviewResp.body.per_page,
                  next_page_url: reviewResp.body.next_page_url,
                  prev_page_url: reviewResp.body.prev_page_url,
                  data: reviewResp.body.data.map(function (rv) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, rv, {
                      showMoreContent: false,
                      moreContentEnable: rv.content && rv.content.length > _this.limitContentLength
                    });
                  })
                });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {
    this.loadReviews();
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Page404'
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Page500'
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Register'
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StepBar__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_StepBar__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Step: __WEBPACK_IMPORTED_MODULE_0__components_StepBar___default.a
  },
  data: function data() {
    return {
      doctor: {},
      plans: [{
        id: 1,
        name: 'Basic Plan (subscription)',
        detail: '499 (per month) x 3 months',
        duration: '3 เดือน',
        price: 1497
      }, {
        id: 2,
        name: 'Advance Plan (subscription)',
        detail: '฿399 (per month) x 12 months',
        duration: '1 ปี',
        price: 4788
      }, {
        id: 3,
        name: 'Pro Plan (subscription)',
        detail: '฿299 (per month) x 36 months',
        duration: '3 ปี',
        price: 10764
      }]
    };
  },
  created: function created() {
    var _this = this;

    this.$http.get(this.$APP_CONFIG.api.admin.doctorme(), { credentials: true }).then(function (res) {
      _this.doctor = res.body.data;
    });
  }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  computed: {
    addAppParams: function addAppParams() {
      if (this.$route.query.app !== null && this.$route.query.app !== undefined) {
        return '&app=' + this.$route.query.app;
      }
      return '';
    }
  },
  data: function data() {
    return {
      selectedPriceList: [],

      doctorPriceList: [{
        name: '3 เดือน',
        image: '/static/img/plans/plan_1.png',
        link: '/package/payment/step1?plan_id=1',
        price: '฿499',
        priceDetail: '<strong>฿1,497 ต่อ 3 เดือน</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [{ name: 'มีเลขาส่วนตัวดูแลระบบ', checked: true }, { name: 'แสดงผลการค้นหาในระบบ', checked: true }, { name: 'นัดหมายออนไลน์ได้', checked: true }, { name: 'มีระบบแจ้งเตือนทาง SMS', checked: true }, { name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true }, { name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true }, { name: '<strong>ระยะเวลาสมาชิก 3 เดือน</strong>', checked: true }]
      }, {
        name: '1 ปี',
        image: '/static/img/plans/plan_2.png',
        link: '/package/payment/step1?plan_id=2',
        price: '฿399',
        priceDetail: '<strong>฿4,788 ต่อ 12 เดือน</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [{ name: 'มีเลขาส่วนตัวดูแลระบบ', checked: true }, { name: 'แสดงผลการค้นหาในระบบ', checked: true }, { name: 'นัดหมายออนไลน์ได้', checked: true }, { name: 'มีระบบแจ้งเตือนทาง SMS', checked: true }, { name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true }, { name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true }, { name: '<strong>ระยะเวลาสมาชิก 12 เดือน</strong>', checked: true }]
      }, {
        name: '3 ปี',
        image: '/static/img/plans/plan_3.png',
        link: '/package/payment/step1?plan_id=3',
        price: '฿299',
        priceDetail: '<strong>฿10,764 ต่อ 36 เดือน</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [{ name: 'มีเลขาส่วนตัวดูแลระบบ', checked: true }, { name: 'แสดงผลการค้นหาในระบบ', checked: true }, { name: 'นัดหมายออนไลน์ได้', checked: true }, { name: 'มีระบบแจ้งเตือนทาง SMS', checked: true }, { name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true }, { name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true }, { name: '<strong>ระยะเวลาสมาชิก 36 เดือน</strong>', checked: true }]
      }],

      clinicPriceList: [{
        name: '3 เดือน',
        image: '/static/img/plans/plan_1.png',
        link: '/package/payment/direct?plan_id=1&type=clinic',
        price: '฿1,500',
        priceDetail: '<strong>฿4,500 ต่อ 3 เดือน</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [{ name: 'แสดงผลการค้นหาในระบบ', checked: true }, { name: 'นัดหมายออนไลน์ได้', checked: true }, { name: 'มีระบบแจ้งเตือนทาง SMS', checked: true }, { name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true }, { name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true }, { name: '<strong>ระยะเวลาสมาชิก 3 เดือน</strong>', checked: true }]
      }, {
        name: '1 ปี',
        image: '/static/img/plans/plan_2.png',
        link: '/package/payment/direct?plan_id=2&type=clinic',
        price: '฿1,333',
        priceDetail: '<strong>฿16,000 ต่อ 1 ปี</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [{ name: 'แสดงผลการค้นหาในระบบ', checked: true }, { name: 'นัดหมายออนไลน์ได้', checked: true }, { name: 'มีระบบแจ้งเตือนทาง SMS', checked: true }, { name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true }, { name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true }, { name: '<strong>ระยะเวลาสมาชิก 12 เดือน</strong>', checked: true }]
      }, {
        name: '3 ปี',
        image: '/static/img/plans/plan_3.png',
        link: '/package/payment/direct?plan_id=3&type=clinic',
        price: '฿1,250',
        priceDetail: '<strong>฿45,000 ต่อ 3 ปี</strong>',
        subPrice: 'per month',
        icon: 'fa-paper-plane',
        features: [{ name: 'แสดงผลการค้นหาในระบบ', checked: true }, { name: 'นัดหมายออนไลน์ได้', checked: true }, { name: 'มีระบบแจ้งเตือนทาง SMS', checked: true }, { name: 'สามารถใส่วันหยุดแพทย์ได้', checked: true }, { name: 'เก็บความคิดเห็นจากคนไข้ได้', checked: true }, { name: '<strong>ระยะเวลาสมาชิก 36 เดือน</strong>', checked: true }]
      }]
    };
  },
  mounted: function mounted() {
    if (this.$route.query.type === 'doctor') {
      this.selectedPriceList = this.doctorPriceList;
    } else if (this.$route.query.type === 'clinic') {
      this.selectedPriceList = this.clinicPriceList;
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      selectedPlan: {},
      doctorPlans: [{
        id: 1,
        name: 'Basic Plan (subscription)',
        detail: '499 (per month) x 3 months',
        duration: '3 เดือน',
        price: 1497
      }, {
        id: 2,
        name: 'Advance Plan (subscription)',
        detail: '฿399 (per month) x 12 months',
        duration: '1 ปี',
        price: 4788
      }, {
        id: 3,
        name: 'Pro Plan (subscription)',
        detail: '฿299 (per month) x 36 months',
        duration: '3 ปี',
        price: 10764
      }],
      clinicPlans: [{
        id: 1,
        name: 'Basic Plan (subscription)',
        detail: '1,500 (per month) x 3 months',
        duration: '3 เดือน',
        price: 4500
      }, {
        id: 2,
        name: 'Advance Plan (subscription)',
        detail: '1,333 (per month) x 12 months',
        duration: '1 ปี',
        price: 16000
      }, {
        id: 3,
        name: 'Pro Plan (subscription)',
        detail: '฿1,250 (per month) x 36 months',
        duration: '3 ปี',
        price: 45000
      }]
    };
  },
  mounted: function mounted() {
    if (this.$route.query.type === 'doctor' && this.$route.query.plan_id !== undefined) {
      this.selectedPlan = this.doctorPlans[parseInt(this.$route.query.plan_id) - 1];
    } else if (this.$route.query.type === 'clinic' && this.$route.query.plan_id !== undefined) {
      this.selectedPlan = this.clinicPlans[parseInt(this.$route.query.plan_id) - 1];
    }
  }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StepBar__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_StepBar__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Step: __WEBPACK_IMPORTED_MODULE_0__components_StepBar___default.a
  },
  data: function data() {
    return {
      selectedPlan: {},
      plans: [{
        id: 1,
        name: 'Basic Plan (subscription)',
        detail: '499 (per month) x 3 months',
        duration: '3 เดือน',
        price: 1497
      }, {
        id: 2,
        name: 'Advance Plan (subscription)',
        detail: '฿399 (per month) x 12 months',
        duration: '1 ปี',
        price: 4788
      }, {
        id: 3,
        name: 'Pro Plan (subscription)',
        detail: '฿299 (per month) x 36 months',
        duration: '3 ปี',
        price: 10764
      }]
    };
  },
  mounted: function mounted() {
    if (this.$route.query.plan_id && this.$route.query.plan_id > 0 && this.$route.query.plan_id <= 3) {
      this.selectedPlan = this.plans[parseInt(this.$route.query.plan_id) - 1];
    } else {
      this.selectedPlan = this.plans[0];
    }
  },

  computed: {
    step2Link: function step2Link() {
      return '/package/payment/step2?plan_id=' + this.selectedPlan.id;
    },
    addAppParams: function addAppParams() {
      if (this.$route.query.app !== null && this.$route.query.app !== undefined) {
        return '&app=' + this.$route.query.app;
      }
      return '';
    },
    creditCardFee: function creditCardFee() {
      if (typeof this.selectedPlan.price === 'undefined') {
        return 0;
      }
      return parseInt(this.selectedPlan.price * 0.038);
    }
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StepBar__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_StepBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweet_modal_vue__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Step: __WEBPACK_IMPORTED_MODULE_2__components_StepBar___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_4_sweet_modal_vue__["a" /* SweetModal */]
  },
  data: function data() {
    return {
      isLoading: false,
      creditCardDetail: {},
      err: {},
      selectedPlan: {},
      plans: [{
        id: 1,
        name: 'Basic Plan (subscription)',
        detail: '499 (per month) x 3 months',
        duration: '3 เดือน',
        price: 1497
      }, {
        id: 2,
        name: 'Advance Plan (subscription)',
        detail: '฿399 (per month) x 12 months',
        duration: '1 ปี',
        price: 4788
      }, {
        id: 3,
        name: 'Pro Plan (subscription)',
        detail: '฿299 (per month) x 36 months',
        duration: '3 ปี',
        price: 10764
      }]
    };
  },

  computed: {
    backLink: function backLink() {
      return '/package/payment/step1?plan_id=' + this.selectedPlan.id;
    },
    nextLink: function nextLink() {
      return '/package/payment/step3?plan_id=' + this.selectedPlan.id;
    },
    addAppParams: function addAppParams() {
      if (this.$route.query.app !== null && this.$route.query.app !== undefined) {
        return '&app=' + this.$route.query.app;
      }
      return '';
    },
    years: function years() {
      var time = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      var years = [];
      for (var i = 0; i < 20; i++) {
        years.push(time.year());
        time.add(1, 'y');
      }
      return years;
    },
    creditCardFee: function creditCardFee() {
      if (typeof this.selectedPlan.price === 'undefined') {
        return 0;
      }
      return parseInt(this.selectedPlan.price * 0.038);
    }
  },
  mounted: function mounted() {
    if (this.$route.query.plan_id && this.$route.query.plan_id > 0 && this.$route.query.plan_id <= 3) {
      this.selectedPlan = this.plans[parseInt(this.$route.query.plan_id) - 1];
    } else {
      this.selectedPlan = this.plans[0];
    }
    this.creditCardDetail = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$ls.get('creditCardDetail'));
  },

  methods: {
    gotoPage: function gotoPage(step) {
      this.$router.push({ path: '/package/payment/step' + (step + 1) + '?plan_id=' + this.selectedPlan.id });
    },
    submitAndNext: function submitAndNext() {
      var _this = this;

      this.validate().then(function (result) {
        _this.isLoading = true;
        return _this.$http.post(_this.$APP_CONFIG.api.admin.payment_token(), _this.creditCardDetail);
      }).then(function (resp) {
        _this.$ls.set('paymentToken', resp.body.id, 60 * 60 * 1000);
        _this.$ls.set('creditCardDetail', _this.creditCardDetail, 5 * 60 * 1000);
        _this.$router.push({ path: '/package/payment/step3?plan_id=' + _this.selectedPlan.id + _this.addAppParams });
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
        _this.$refs.errorModal.open();
      });
    },
    closeModal: function closeModal() {
      this.$refs.errorModal.close();
    },
    validate: function validate() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$validator.validateAll().then(function (result) {
          if (result) {
            resolve(result);
          } else {
            reject(new Error('Not validated'));
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StepBar__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StepBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_StepBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweet_modal_vue__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Step: __WEBPACK_IMPORTED_MODULE_1__components_StepBar___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_2_sweet_modal_vue__["a" /* SweetModal */]
  },
  computed: {
    backLink: function backLink() {
      return '/package/payment/step2?plan_id=' + this.selectedPlan.id;
    },
    addAppParams: function addAppParams() {
      if (this.$route.query.app !== null && this.$route.query.app !== undefined) {
        return '&app=' + this.$route.query.app;
      }
      return '';
    },
    creditCardFee: function creditCardFee() {
      if (typeof this.selectedPlan.price === 'undefined') {
        return 0;
      }
      return parseInt(this.selectedPlan.price * 0.038);
    }
  },
  data: function data() {
    return {
      isLoading: false,
      creditCardDetail: {},
      selectedPlan: {},
      paymentToken: '',
      plans: [{
        id: 1,
        name: 'Basic Plan (subscription)',
        detail: '499 (per month) x 3 months',
        duration: '3 เดือน',
        price: 1497
      }, {
        id: 2,
        name: 'Advance Plan (subscription)',
        detail: '฿399 (per month) x 12 months',
        duration: '1 ปี',
        price: 4788
      }, {
        id: 3,
        name: 'Pro Plan (subscription)',
        detail: '฿299 (per month) x 36 months',
        duration: '3 ปี',
        price: 10764
      }]
    };
  },

  methods: {
    closeDoneModal: function closeDoneModal() {
      this.$refs.doneModal.close();
    },
    closeErrorModal: function closeErrorModal() {
      this.$refs.errorModal.close();
    },
    goToSuccessPage: function goToSuccessPage() {
      window.location.href = '/package/me?callbackPayment=success' + this.addAppParams;
    },
    gotoPage: function gotoPage(step) {
      this.$router.push({ path: '/package/payment/step' + (step + 1) + '?plan_id=' + this.selectedPlan.id + this.addAppParams });
    },
    confirm: function confirm() {
      var _this = this;

      this.isLoading = true;
      this.$http.post(this.$APP_CONFIG.api.admin.subscription(), {
        plan_id: this.selectedPlan.id,
        token_id: this.paymentToken,
        amount: parseInt(this.selectedPlan.price + this.creditCardFee)
      }).then(function (result) {
        _this.$refs.doneModal.open();
      }).catch(function (error) {
        console.log(error);
        _this.isLoading = false;
        _this.$refs.errorModal.open();
      });
    }
  },
  mounted: function mounted() {
    if (this.$route.query.plan_id && this.$route.query.plan_id > 0 && this.$route.query.plan_id <= 3) {
      this.selectedPlan = this.plans[parseInt(this.$route.query.plan_id) - 1];
    } else {
      this.selectedPlan = this.plans[0];
    }

    this.creditCardDetail = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$ls.get('creditCardDetail'));
    this.paymentToken = this.$ls.get('paymentToken');

    if (typeof this.creditCardDetail.name === 'undefined' || this.paymentToken.length <= 1) {
      this.$router.push({ path: '/package/payment/step2?plan_id=' + this.selectedPlan.id });
    }
  }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_flatpickr_component__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_SyncLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ErrorMessageBox__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ErrorMessageBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ErrorMessageBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweet_modal_vue__ = __webpack_require__(9);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BsInput: __WEBPACK_IMPORTED_MODULE_4_vue_strap__["input"],
    flatPickr: __WEBPACK_IMPORTED_MODULE_5_vue_flatpickr_component___default.a,
    SyncLoader: __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_SyncLoader___default.a,
    ErrorBox: __WEBPACK_IMPORTED_MODULE_9__components_ErrorMessageBox___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_10_sweet_modal_vue__["a" /* SweetModal */]
  },
  props: {
    id: String
  },
  data: function data() {
    var defaultPatient = {
      birthday: '',
      gender: 'm'
    };

    return {
      export_csv: this.$APP_CONFIG.api.domain + '/admin/api/v1/ehr_patient/export_csv',
      intl_phone: '',
      loading: false,
      searchLoading: false,
      editMode: false,
      showAddPanel: false,
      _searchQ: null,
      q: '',
      patients: [],
      defaultPatient: defaultPatient,
      patient: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, defaultPatient),
      paginator: {},
      frmError: this.getFormError(),
      sweetErrorMsg: '',
      openEditMode: false,
      prefix_options: [{ value: 'mrs', label: this.$t('message.patient.prefix_mrs') }, { value: 'mr', label: this.$t('message.patient.prefix_mr') }, { value: 'ms', label: this.$t('message.patient.prefix_ms') }, { value: 'master', label: this.$t('message.patient.prefix_master') }, { value: 'miss', label: this.$t('message.patient.prefix_miss') }]
    };
  },

  watch: {
    q: function q(v, old) {
      var _this = this;

      var debounchDelay = 500;
      clearTimeout(this._searchQ);
      this._searchQ = setTimeout(function () {
        _this.searchLoading = true;
        _this.$http.get(_this.$APP_CONFIG.api.admin.patient(), { params: {
            search: v,
            clinic_id: _this.$guser.user.clinic.id
          } }).then(function (res) {
          _this.patients = res.body.data;

          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(_this.paginator, {
            from: res.body.from,
            to: res.body.to,
            total: res.body.total,
            per_page: res.body.per_page,
            current_page: res.body.per_page,
            next_page_url: res.body.next_page_url,
            prev_page_url: res.body.prev_page_url
          });
          _this.searchLoading = false;
        }).catch(function () {
          _this.searchLoading = false;
        });
      }, debounchDelay);
    }
  },
  computed: {
    filtered_patients: function filtered_patients() {
      return this.patients.sort(function (a, b) {
        return a.created_at < b.created_at;
      });
    }
  },
  methods: {
    reloadPatient: function reloadPatient(uri) {
      var _this2 = this;

      this.$http.get(uri || this.$APP_CONFIG.api.admin.patient(), { params: {
          clinic_id: this.$guser.user.clinic.id,
          search: this.q
        } }).then(function (res) {
        _this2.patients = res.body.data;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(_this2.paginator, {
          from: res.body.from,
          to: res.body.to,
          total: res.body.total,
          per_page: res.body.per_page,
          current_page: res.body.per_page,
          next_page_url: res.body.next_page_url,
          prev_page_url: res.body.prev_page_url
        });

        if (!_this2.openEditMode && _this2.id) {
          _this2.openEditMode = true;
          var p = _this2.patients.find(function (pt) {
            return pt.id === +_this2.id;
          });
          if (p) {
            _this2.editPatient(_this2.id);
          }
        }
      });
    },
    editPatient: function editPatient(patient) {
      this.patient = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, patient, {
        prefix: this.prefix_options.find(function (d) {
          return d.value === patient.prefix;
        })
      });

      __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#phone').intlTelInput('setNumber', this.patient.phone);
      this.editMode = true;
      this.showAddPanel = true;
    },
    _updatePatient: function _updatePatient() {
      var _this3 = this;

      this.loading = true;

      var patient = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.patient, {
        prefix: this.patient.prefix ? this.patient.prefix.value : null,
        clinic_id: this.$guser.user.clinic.id
      });

      this.$http.put(this.$APP_CONFIG.api.admin.patient_id(patient.id), patient, { credentials: true }).then(function (res) {
        _this3.reloadPatient();
        _this3.enterListView();
        _this3.patient = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this3.defaultPatient);
        _this3.loading = false;
        __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#phone').intlTelInput('setNumber', '');
      }).catch(function (res) {
        _this3.loading = false;
        if (typeof res.body.error === 'string') {
          _this3.sweetErrorMsg = 'เบอร์โทรศัพท์, email หรือ เลขที่บัตรประชาชน นี้ได้ถูกใช้แล้วไม่สามารถสร้างซ้ำกันได้';
          _this3.$refs.errorModal.open();
        } else {
          var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(res.body.error)[0];
          _this3.sweetErrorMsg = res.body.error[key][0];
          _this3.$refs.errorModal.open();
        }
        if (res.body.error) {
          _this3.showFormFromError(res.body.error);
        }
      });
    },
    addPatient: function addPatient() {
      var _this4 = this;

      this.patient.phone = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#phone').intlTelInput('getNumber');
      if (this.editMode) {
        this._updatePatient();
      } else {
        this.loading = true;
        var patient = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.patient, {
          prefix: this.patient.prefix ? this.patient.prefix.value : null,
          clinic_id: this.$guser.user.clinic.id
        });

        this.$http.post(this.$APP_CONFIG.api.admin.patient(), patient, { credentials: true }).then(function (res) {
          _this4.loading = false;

          if (res.body.id) {
            _this4.reloadPatient();
            _this4.enterListView();
            _this4.patients.push(res.body);

            _this4.patient = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this4.defaultPatient);
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#phone').intlTelInput('setNumber', '');
            _this4.$toastr.success('Create new patient successful!');
          }
        }).catch(function (res) {
          _this4.loading = false;
          if (typeof res.body.error === 'string') {
            _this4.sweetErrorMsg = 'เบอร์โทรศัพท์, email หรือ เลขที่บัตรประชาชน นี้ได้ถูกใช้แล้วไม่สามารถสร้างซ้ำกันได้';
            _this4.$refs.errorModal.open();
          } else {
            var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(res.body.error)[0];
            _this4.sweetErrorMsg = res.body.error[key][0];
            _this4.$refs.errorModal.open();
          }
          if (res.body.error) {
            _this4.showFormFromError(res.body.error);
          }
        });
      }
    },
    enterCreateForm: function enterCreateForm() {
      this.showAddPanel = !this.showAddPanel;
      this.editMode = false;
      this.patient = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.defaultPatient);
    },
    enterListView: function enterListView() {
      this.showAddPanel = false;
      this.editMode = false;
    },
    removePatient: function removePatient() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this5.$confirm('Are you sure');

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                _this5.$http.delete(_this5.$APP_CONFIG.api.admin.patient_id(_this5.patient.id), { credentials: true }).then(function (res) {
                  _this5.enterListView();
                  var i = _this5.patients.findIndex(function (p) {
                    return p.id === _this5.patient.id;
                  });
                  if (i !== -1) {
                    _this5.patients.splice(i, 1);
                  }

                  _this5.patient = _this5.defaultPatient;
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    clearFormError: function clearFormError() {
      this.frmError = this.getFormError();
    },
    getFormError: function getFormError() {
      return {
        firstnameError: null,
        lastnameError: null,
        phoneError: null,
        birthdayError: null
      };
    },
    getFormDefaultError: function getFormDefaultError() {
      return {
        firstnameError: 'The firstname field is required.',
        lastnameError: 'The lastname field is required.',
        phoneError: 'The phone field is required.',
        birthdayError: 'The birthday field is required.'
      };
    },
    showFormFromError: function showFormFromError(error) {
      if (error) {
        this.frmError.firstnameError = this.getMessageFromError(error.firstname);
        this.frmError.lastnameError = this.getMessageFromError(error.lastname);
        this.frmError.phoneError = this.getMessageFromError(error.phone);
        this.frmError.birthdayError = this.getMessageFromError(error.birthday);
      }
    },
    getMessageFromError: function getMessageFromError(errorObj) {
      var message = null;
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ');
      } else {
        message = errorObj;
      }
      return message;
    }
  },
  created: function created() {
    this.reloadPatient();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#phone').intlTelInput({ nationalMode: true, initialCountry: 'th', utilsScript: '/static/utils.js' });
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chart_LineChart__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chart_LineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_chart_LineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chart_BarChart__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chart_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_chart_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_SyncLoader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_SyncLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_SyncLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_DotLoader__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_DotLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_DotLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_strap__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_strap__);













var backgroundColor = '#20a8d8';
var borderColor = 'rgba(255,255,255,.55)';

var backgroundMColor = '#85ace7';
var backgroundFColor = '#e258a7';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ReportLineChart: __WEBPACK_IMPORTED_MODULE_3__components_chart_LineChart___default.a,
    ReportBarChart: __WEBPACK_IMPORTED_MODULE_4__components_chart_BarChart___default.a,
    SyncLoader: __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_SyncLoader___default.a,
    tabs: __WEBPACK_IMPORTED_MODULE_9_vue_strap__["tabs"],
    tab: __WEBPACK_IMPORTED_MODULE_9_vue_strap__["tab"],
    Multiselect: __WEBPACK_IMPORTED_MODULE_8_vue_multiselect___default.a,
    DotLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_DotLoader___default.a
  },
  data: function data() {
    var dateFilterOptions = [{ label: this.$t('message.report.today'), value: 'today' }, { label: this.$t('message.report.week'), value: 'week' }, { label: this.$t('message.report.month'), value: 'month' }, { label: this.$t('message.report.year'), value: 'year' }];
    return {
      loading: false,
      activeTab: 0,
      dateFilterOptions: dateFilterOptions,
      selectedDateFilter: dateFilterOptions[0],
      stats: {
        demographicStat: {
          female: 0,
          male: 0
        },
        articleStat: [],
        doctorStat: [],
        appointmentStatusStat: [{ status: 'pending', count: 0 }, { status: 'checkin', count: 0 }, { status: 'cancel', count: 0 }, { status: 'scheduled', count: 0 }]
      },
      orderedDoctorStat: [],
      appointmentStatChartData: {
        count: 0,
        labels: [],
        datasets: [{
          label: '',
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          data: []
        }]
      },
      viewStatChartData: {
        count: 0,
        labels: [],
        datasets: [{
          label: '',
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          data: []
        }]
      },
      genderStatChartData: {
        maleCount: 0,
        femaleCount: 0,
        labels: [],
        datasets: [{
          label: '',
          backgroundColor: backgroundMColor,
          borderColor: borderColor,
          data: []
        }, {
          label: '',
          backgroundColor: backgroundFColor,
          borderColor: borderColor,
          data: []
        }]
      }
    };
  },

  computed: {
    malePercent: function malePercent() {
      var total = this.stats.demographicStat.male + this.stats.demographicStat.female;
      var percent = 0;
      if (total > 0) {
        percent = this.stats.demographicStat.male / total * 100.0;
      }
      return percent;
    },
    femalePercent: function femalePercent() {
      var total = this.stats.demographicStat.male + this.stats.demographicStat.female;
      var percent = 0;
      if (total > 0) {
        percent = this.stats.demographicStat.female / total * 100.0;
      }
      return percent;
    }
  },
  watch: {
    selectedDateFilter: function selectedDateFilter(v, o) {
      this.loadStats();
    }
  },
  methods: {
    getDoctorName: function getDoctorName(doctor) {
      if (doctor) {
        return '' + doctor.prefix + doctor.firstname + ' ' + doctor.lastname;
      }
      return '';
    },
    getAppointmentStatusCount: function getAppointmentStatusCount(status) {
      var item = this.stats.appointmentStatusStat.find(function (it) {
        return it.status === status;
      });
      if (item) {
        return item.count;
      }
      return 0;
    },
    openPath: function openPath(id) {
      if (id) if (id) window.open('' + this.$APP_CONFIG.api.domain + id, '_blank');
    },
    getParams: function getParams() {
      var params = {};
      if (this.selectedDateFilter.value === 'today') {
        params = {
          start: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-MM-DD'),
          end: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-MM-DD')
        };
      } else if (this.selectedDateFilter.value === 'week') {
        params = {
          start: __WEBPACK_IMPORTED_MODULE_7_moment___default()().weekday(0).format('YYYY-MM-DD'),
          end: __WEBPACK_IMPORTED_MODULE_7_moment___default()().weekday(6).format('YYYY-MM-DD')
        };
      } else if (this.selectedDateFilter.value === 'month') {
        params = {
          start: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-MM-1'),
          end: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-MM-') + __WEBPACK_IMPORTED_MODULE_7_moment___default()().daysInMonth()
        };
      } else if (this.selectedDateFilter.value === 'year') {
        params = {
          start: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-01-1'),
          end: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-12-31')
        };
      }
      return params;
    },
    loadStats: function loadStats() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var self, url, params, res, appStatByDate, viewStatByDate, days, n, _key, key, dataDateObj, _dataDateObj;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;

                self.loading = true;
                url = '';
                params = _this.getParams();

                if (_this.$guser.isClinicMulti()) {
                  url = _this.$APP_CONFIG.api.admin.clinic_stats(_this.$guser.user.clinic.id);
                } else if (_this.$guser.isClinic()) {
                  url = _this.$APP_CONFIG.api.admin.clinic_stats(_this.$guser.user.clinic.id);
                } else {
                  url = _this.$APP_CONFIG.api.admin.doctor_stats(_this.$guser.user.doctor.id);
                }
                _context.next = 7;
                return _this.$http.get(url, { params: params });

              case 7:
                res = _context.sent;


                if (res) {
                  self.stats = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, self.stats, res.body);

                  if (self.stats.appointmentStat) {
                    self.appointmentStatChartData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
                      count: 0,
                      labels: [],
                      datasets: [{
                        label: '',
                        backgroundColor: backgroundColor,
                        borderColor: borderColor,
                        data: []
                      }]
                    });
                    appStatByDate = {};
                    viewStatByDate = {};
                    days = __WEBPACK_IMPORTED_MODULE_7_moment___default()().daysInMonth();
                    n = 0;

                    for (n = 0; n < days; n++) {
                      _key = __WEBPACK_IMPORTED_MODULE_7_moment___default()(__WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-MM') + '-' + (n + 1), 'YYYY-MM-DD').format('YYYY-MM-DD');

                      appStatByDate[_key] = {
                        count: 0,
                        date: _key
                      };
                      viewStatByDate[_key] = {
                        count: 0,
                        date: _key
                      };
                    }

                    self.stats.appointmentStat.forEach(function (data) {
                      if (data.count && data.date) {
                        appStatByDate[data.date] = {
                          count: data.count,
                          date: data.date
                        };
                      }
                    });

                    key = null;

                    for (key in appStatByDate) {
                      dataDateObj = appStatByDate[key];

                      if (dataDateObj.count >= 0 && dataDateObj.date) {
                        self.appointmentStatChartData.datasets[0].data.push(dataDateObj.count);
                        self.appointmentStatChartData.labels.push(dataDateObj.date);
                        self.appointmentStatChartData.count += dataDateObj.count;
                      }
                    }

                    self.viewStatChartData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
                      count: 0,
                      labels: [],
                      datasets: [{
                        label: '',
                        backgroundColor: backgroundColor,
                        borderColor: borderColor,
                        data: []
                      }]
                    });
                    self.stats.viewStat.forEach(function (data) {
                      if (data.count && data.date) {
                        viewStatByDate[data.date] = {
                          count: data.count,
                          date: data.date
                        };
                      }
                    });

                    for (key in viewStatByDate) {
                      _dataDateObj = viewStatByDate[key];

                      if (_dataDateObj.count >= 0 && _dataDateObj.date) {
                        self.viewStatChartData.datasets[0].data.push(_dataDateObj.count);
                        self.viewStatChartData.labels.push(_dataDateObj.date);
                        self.viewStatChartData.count += _dataDateObj.count;
                      }
                    }
                  }

                  if (_this.stats.doctorAppointment) {
                    _this.orderedDoctorStat = _this.stats.doctorAppointment.sort(function (a, b) {
                      return b.appointment_count - a.appointment_count;
                    }).splice(0, 20);
                  }
                }

                self.loading = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {
    this.loadStats();
  }
});

/***/ }),
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 263,
	"./af.js": 263,
	"./ar": 270,
	"./ar-dz": 264,
	"./ar-dz.js": 264,
	"./ar-kw": 265,
	"./ar-kw.js": 265,
	"./ar-ly": 266,
	"./ar-ly.js": 266,
	"./ar-ma": 267,
	"./ar-ma.js": 267,
	"./ar-sa": 268,
	"./ar-sa.js": 268,
	"./ar-tn": 269,
	"./ar-tn.js": 269,
	"./ar.js": 270,
	"./az": 271,
	"./az.js": 271,
	"./be": 272,
	"./be.js": 272,
	"./bg": 273,
	"./bg.js": 273,
	"./bm": 274,
	"./bm.js": 274,
	"./bn": 275,
	"./bn.js": 275,
	"./bo": 276,
	"./bo.js": 276,
	"./br": 277,
	"./br.js": 277,
	"./bs": 278,
	"./bs.js": 278,
	"./ca": 279,
	"./ca.js": 279,
	"./cs": 280,
	"./cs.js": 280,
	"./cv": 281,
	"./cv.js": 281,
	"./cy": 282,
	"./cy.js": 282,
	"./da": 283,
	"./da.js": 283,
	"./de": 286,
	"./de-at": 284,
	"./de-at.js": 284,
	"./de-ch": 285,
	"./de-ch.js": 285,
	"./de.js": 286,
	"./dv": 287,
	"./dv.js": 287,
	"./el": 288,
	"./el.js": 288,
	"./en-au": 289,
	"./en-au.js": 289,
	"./en-ca": 290,
	"./en-ca.js": 290,
	"./en-gb": 291,
	"./en-gb.js": 291,
	"./en-ie": 292,
	"./en-ie.js": 292,
	"./en-il": 293,
	"./en-il.js": 293,
	"./en-nz": 294,
	"./en-nz.js": 294,
	"./eo": 295,
	"./eo.js": 295,
	"./es": 298,
	"./es-do": 296,
	"./es-do.js": 296,
	"./es-us": 297,
	"./es-us.js": 297,
	"./es.js": 298,
	"./et": 299,
	"./et.js": 299,
	"./eu": 300,
	"./eu.js": 300,
	"./fa": 301,
	"./fa.js": 301,
	"./fi": 302,
	"./fi.js": 302,
	"./fo": 303,
	"./fo.js": 303,
	"./fr": 306,
	"./fr-ca": 304,
	"./fr-ca.js": 304,
	"./fr-ch": 305,
	"./fr-ch.js": 305,
	"./fr.js": 306,
	"./fy": 307,
	"./fy.js": 307,
	"./gd": 308,
	"./gd.js": 308,
	"./gl": 309,
	"./gl.js": 309,
	"./gom-latn": 310,
	"./gom-latn.js": 310,
	"./gu": 311,
	"./gu.js": 311,
	"./he": 312,
	"./he.js": 312,
	"./hi": 313,
	"./hi.js": 313,
	"./hr": 314,
	"./hr.js": 314,
	"./hu": 315,
	"./hu.js": 315,
	"./hy-am": 316,
	"./hy-am.js": 316,
	"./id": 317,
	"./id.js": 317,
	"./is": 318,
	"./is.js": 318,
	"./it": 319,
	"./it.js": 319,
	"./ja": 320,
	"./ja.js": 320,
	"./jv": 321,
	"./jv.js": 321,
	"./ka": 322,
	"./ka.js": 322,
	"./kk": 323,
	"./kk.js": 323,
	"./km": 324,
	"./km.js": 324,
	"./kn": 325,
	"./kn.js": 325,
	"./ko": 326,
	"./ko.js": 326,
	"./ky": 327,
	"./ky.js": 327,
	"./lb": 328,
	"./lb.js": 328,
	"./lo": 329,
	"./lo.js": 329,
	"./lt": 330,
	"./lt.js": 330,
	"./lv": 331,
	"./lv.js": 331,
	"./me": 332,
	"./me.js": 332,
	"./mi": 333,
	"./mi.js": 333,
	"./mk": 334,
	"./mk.js": 334,
	"./ml": 335,
	"./ml.js": 335,
	"./mn": 336,
	"./mn.js": 336,
	"./mr": 337,
	"./mr.js": 337,
	"./ms": 339,
	"./ms-my": 338,
	"./ms-my.js": 338,
	"./ms.js": 339,
	"./mt": 340,
	"./mt.js": 340,
	"./my": 341,
	"./my.js": 341,
	"./nb": 342,
	"./nb.js": 342,
	"./ne": 343,
	"./ne.js": 343,
	"./nl": 345,
	"./nl-be": 344,
	"./nl-be.js": 344,
	"./nl.js": 345,
	"./nn": 346,
	"./nn.js": 346,
	"./pa-in": 347,
	"./pa-in.js": 347,
	"./pl": 348,
	"./pl.js": 348,
	"./pt": 350,
	"./pt-br": 349,
	"./pt-br.js": 349,
	"./pt.js": 350,
	"./ro": 351,
	"./ro.js": 351,
	"./ru": 352,
	"./ru.js": 352,
	"./sd": 353,
	"./sd.js": 353,
	"./se": 354,
	"./se.js": 354,
	"./si": 355,
	"./si.js": 355,
	"./sk": 356,
	"./sk.js": 356,
	"./sl": 357,
	"./sl.js": 357,
	"./sq": 358,
	"./sq.js": 358,
	"./sr": 360,
	"./sr-cyrl": 359,
	"./sr-cyrl.js": 359,
	"./sr.js": 360,
	"./ss": 361,
	"./ss.js": 361,
	"./sv": 362,
	"./sv.js": 362,
	"./sw": 363,
	"./sw.js": 363,
	"./ta": 364,
	"./ta.js": 364,
	"./te": 365,
	"./te.js": 365,
	"./tet": 366,
	"./tet.js": 366,
	"./tg": 367,
	"./tg.js": 367,
	"./th": 368,
	"./th.js": 368,
	"./tl-ph": 369,
	"./tl-ph.js": 369,
	"./tlh": 370,
	"./tlh.js": 370,
	"./tr": 371,
	"./tr.js": 371,
	"./tzl": 372,
	"./tzl.js": 372,
	"./tzm": 374,
	"./tzm-latn": 373,
	"./tzm-latn.js": 373,
	"./tzm.js": 374,
	"./ug-cn": 375,
	"./ug-cn.js": 375,
	"./uk": 376,
	"./uk.js": 376,
	"./ur": 377,
	"./ur.js": 377,
	"./uz": 379,
	"./uz-latn": 378,
	"./uz-latn.js": 378,
	"./uz.js": 379,
	"./vi": 380,
	"./vi.js": 380,
	"./x-pseudo": 381,
	"./x-pseudo.js": 381,
	"./yo": 382,
	"./yo.js": 382,
	"./zh-cn": 383,
	"./zh-cn.js": 383,
	"./zh-hk": 384,
	"./zh-hk.js": 384,
	"./zh-tw": 385,
	"./zh-tw.js": 385
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 886;

/***/ }),
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.6.3","/Users/praponc/zeekdoc/zeekdoc-webapp"]],"_from":"vue-chartjs@2.6.3","_id":"vue-chartjs@2.6.3","_inBundle":false,"_integrity":"sha1-75T06RmhGEW/1y3W1UP4bWAuoyQ=","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.6.3","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.6.3","saveSpec":null,"fetchSpec":"2.6.3"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.6.3.tgz","_spec":"2.6.3","_where":"/Users/praponc/zeekdoc/zeekdoc-webapp","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash":"^4.17.4"},"description":"vue.js wrapper for chart.js","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.24.1","babel-loader":"^7.0.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.5.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.3.3","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.0.4","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.3.3","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.5.0","vue":"^2.3.3"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.6.3"}

/***/ }),
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(712)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1018),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(702)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1010),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(513),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1013),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(992),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1035),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(995),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1021),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(743)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1053),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(729)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1040),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(687)
  __webpack_require__(686)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(991),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(714)
  __webpack_require__(713)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1020),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(735)
  __webpack_require__(734)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1044),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(726)
  __webpack_require__(725)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1036),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(684)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(989),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(706)
  __webpack_require__(705)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1012),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(730)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1041),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(746)
  __webpack_require__(745)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1055),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(723)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1031),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(744)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1054),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(699)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1006),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(999),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(988),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(986),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1051),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1019),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(997),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d3c26ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1033),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1015),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1030),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(547),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(548),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(549),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(550),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(551),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(552),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1039),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1002),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(707)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1014),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(737)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1046),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(747)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1056),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(990),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(711)
  __webpack_require__(710)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1017),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(719)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1026),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(740)
  __webpack_require__(739)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1048),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(676)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(979),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(701)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1009),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1007),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(982),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1032),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(748)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1057),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(722)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1028),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(727)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1037),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(717)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1024),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1023),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(715)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1022),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(697)
  __webpack_require__(696)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1004),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(732)
  __webpack_require__(731)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1042),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(977),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(728)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1038),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(675)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(978),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06c75dfd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(993),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(981),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1001),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(742)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1050),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1029),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(998),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(983),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_open),
      expression: "is_open"
    }],
    class: _vm.overlay_classes,
    on: {
      "click": _vm._onOverlayClick
    }
  }, [_c('div', {
    class: _vm.modal_classes
  }, [_c('div', {
    staticClass: "sweet-box-actions"
  }, [_vm._t("box-action"), _vm._v(" "), (!_vm.hideCloseButton) ? _c('div', {
    staticClass: "sweet-action-close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
      "fill": "#292c34"
    }
  })])]) : _vm._e()], 2), _vm._v(" "), (_vm.has_title || _vm.has_tabs) ? _c('div', {
    staticClass: "sweet-title"
  }, [(_vm.has_tabs && !_vm.has_title) ? [_c('ul', {
    staticClass: "sweet-modal-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: _vm._getClassesForTab(tab)
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm._changeTab(tab)
        }
      }
    }, [_c('div', {
      staticClass: "sweet-modal-valign"
    }, [(tab.icon) ? _c('span', {
      staticClass: "sweet-modal-tab-icon",
      domProps: {
        "innerHTML": _vm._s(tab.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sweet-modal-tab-title"
    }, [_vm._v(_vm._s(tab.title))])])])])
  }))] : _vm._e(), _vm._v(" "), (_vm.has_title) ? [(_vm.title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("title")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.has_title && _vm.has_tabs) ? _c('ul', {
    staticClass: "sweet-modal-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: _vm._getClassesForTab(tab)
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm._changeTab(tab)
        }
      }
    }, [_c('div', {
      staticClass: "sweet-modal-valign"
    }, [(tab.icon) ? _c('span', {
      staticClass: "sweet-modal-tab-icon",
      domProps: {
        "innerHTML": _vm._s(tab.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sweet-modal-tab-title"
    }, [_vm._v(_vm._s(tab.title))])])])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "sweet-content"
  }, [(_vm.icon == 'error') ? _c('div', {
    ref: "icon_error",
    staticClass: "sweet-modal-icon sweet-modal-error"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.icon == 'warning') ? _c('div', {
    ref: "icon_warning",
    staticClass: "sweet-modal-icon sweet-modal-warning"
  }, [_c('span', {
    staticClass: "sweet-modal-body"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-dot"
  })]) : _vm._e(), _vm._v(" "), (_vm.icon == 'info') ? _c('div', {
    ref: "icon_info",
    staticClass: "sweet-modal-icon sweet-modal-info"
  }) : _vm._e(), _vm._v(" "), (_vm.icon == 'success') ? _c('div', {
    ref: "icon_success",
    staticClass: "sweet-modal-icon sweet-modal-success"
  }, [_c('span', {
    staticClass: "sweet-modal-line sweet-modal-tip"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-line sweet-modal-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "sweet-modal-placeholder"
  }), _vm._v(" "), _c('div', {
    staticClass: "sweet-modal-fix"
  })]) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
    staticClass: "sweet-content-content"
  }, [_vm._t("default")], 2) : _vm._e()]), _vm._v(" "), (_vm.$slots.button) ? _c('div', {
    staticClass: "sweet-buttons"
  }, [_vm._t("button")], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sweet-modal-x-mark"
  }, [_c('span', {
    staticClass: "sweet-modal-line sweet-modal-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-line sweet-modal-right"
  })])
}]}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-aside"
  }, [_c('div', {
    staticClass: "g-crop-image-box"
  }, [_c('div', {
    staticClass: "g-crop-image-principal",
    on: {
      "touchstart": _vm.drag,
      "mousedown": _vm.drag
    }
  }, [_c('div', {
    staticClass: "image-wrap",
    style: ({
      width: _vm.width + 'px',
      height: _vm.height + 'px',
      left: _vm.left + 'px',
      top: _vm.top + 'px',
      backgroundImage: 'url(' + _vm.src + ')',
      cursor: _vm.isResize ? 'default' : 'move'
    })
  }, [_c('img', {
    ref: "crop-image",
    staticStyle: {
      "width": "0",
      "height": "0"
    },
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), (!_vm.isResize) ? _c('div', {
    staticClass: "image-mask"
  }, [_c('div', {
    staticClass: "mask top",
    style: ({
      top: 0,
      height: _vm.cropCSS.top + 'px',
      left: 0,
      width: '100%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask bottom",
    style: ({
      bottom: 0,
      top: (_vm.cropCSS.top + _vm.cropCSS.height) + 'px',
      left: 0,
      width: '100%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask left",
    style: ({
      top: _vm.cropCSS.top + 'px',
      height: _vm.cropCSS.height + 'px',
      left: 0,
      width: _vm.cropCSS.left + 'px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask right",
    style: ({
      top: _vm.cropCSS.top + 'px',
      height: _vm.cropCSS.height + 'px',
      left: (_vm.cropCSS.left + _vm.cropCSS.width) + 'px',
      right: 0
    })
  })]) : _vm._e(), _vm._v(" "), (!_vm.isResize) ? _c('div', {
    staticClass: "crop-box",
    style: ({
      top: _vm.cropCSS.top + 'px',
      left: _vm.cropCSS.left + 'px',
      height: _vm.cropCSS.height + 'px',
      width: _vm.cropCSS.width + 'px'
    })
  }, [_c('div', {
    staticClass: "reference-line v"
  }), _vm._v(" "), _c('div', {
    staticClass: "reference-line h"
  }), _vm._v(" "), _c('a', {
    staticClass: "g-resize",
    on: {
      "touchstart": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.resize($event)
      },
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.resize($event)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.resize) ? _c('resize-bar', {
    ref: "resizeBar",
    on: {
      "resize": _vm.resizeImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isRotate) ? _c('rotate-bar', {
    on: {
      "rotate": _vm.rotateImage
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [(_vm.$route.query.action === 'edit') ? _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_edit')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_new')))]), _vm._v(" "), _c('step', {
    attrs: {
      "currentStep": 3,
      "maxStep": 5
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.personal_info')))]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.experience')))]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.schedules')))]), _vm._v(" "), _c('div', {
    slot: "4"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.education')))]), _vm._v(" "), _c('div', {
    slot: "5"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.other_info')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_schedules.schedule')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group online-appointment",
    class: {
      'disable': !_vm.$guser.isPremiumAccount()
    },
    on: {
      "click": function($event) {
        _vm.checkFeature()
      }
    }
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.appointment_active),
      expression: "doctor.appointment_active"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.$guser.isPremiumAccount()
    },
    domProps: {
      "checked": Array.isArray(_vm.doctor.appointment_active) ? _vm._i(_vm.doctor.appointment_active, null) > -1 : (_vm.doctor.appointment_active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.doctor.appointment_active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.doctor.appointment_active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.doctor.appointment_active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.doctor.appointment_active = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    staticClass: "switch-name",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_schedules.online_appointment_on')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])])]), _vm._v(" "), _vm._l((_vm.doctor.clinics), function(clinic) {
    return _c('div', {
      key: clinic.id,
      staticClass: "row"
    }, [(_vm.shouldView(clinic.id)) ? _c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      attrs: {
        "for": "name"
      }
    }, [_vm._v(_vm._s(_vm.$t('message.doctor_schedules.select_time_slot_for')) + " "), _c('b', [_vm._v(_vm._s((_vm.$i18n.locale === 'th') ? clinic.name_th : clinic.name_en))])])]), _vm._v(" "), _c('working-schedule', {
      attrs: {
        "schedules": _vm.schedules_by_clinics[clinic.id],
        "doctor_id": _vm.doctor.id,
        "clinic_id": clinic.id,
        "booking_per_slot": _vm.slotData[clinic.id].booking_per_slot,
        "time_slots": _vm.slotData[clinic.id].time_slots,
        "advance_week_option": true
      },
      on: {
        "scheduleChanged": _vm.updateSchedules
      }
    }), _vm._v(" "), _c('working-time-slot', {
      attrs: {
        "time_slots": _vm.slotData[clinic.id].time_slots,
        "clinic_id": clinic.id,
        "doctor_id": _vm.doctor.id
      },
      on: {
        "timeSlotsChanged": _vm.updateTimeSlots
      }
    }), _vm._v(" "), _c('working-booking-per-slot', {
      attrs: {
        "booking_per_slot": _vm.slotData[clinic.id].booking_per_slot,
        "clinic_id": clinic.id,
        "doctor_id": _vm.doctor.id
      },
      on: {
        "bookingPerSlotChanged": _vm.updateBookingPerSlot
      }
    }), _vm._v(" "), _c('working-slot-preview', {
      attrs: {
        "booking_per_slot": _vm.slotData[clinic.id].booking_per_slot,
        "time_slots": _vm.slotData[clinic.id].time_slots
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), (_vm.$route.query.action === 'edit') ? _c('button', {
    staticClass: "btn btn-delete btn-right btn-lg",
    on: {
      "click": _vm.deleteDoctor
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])], 2), _vm._v(" "), _c('sweet-modal', {
    ref: "lockModal",
    attrs: {
      "icon": "info",
      "title": "ฟังชั้นนี้ถูกปิดการใช้งานอยู่",
      "overlay-theme": "dark"
    }
  }, [_c('p', [_vm._v("ฟังชั้นนี้ถูกปิดการใช้งานอยู่ ต้องการปลดล๊อกกรุณากดปุ่ม unlock ด้านล่าง")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.gotoPlanPage()
      }
    }
  }, [(!_vm.isActive) ? _c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" Unlock")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bs-wizard",
    staticStyle: {
      "border-bottom": "0"
    }
  }, _vm._l((_vm.steps), function(step) {
    return _c('div', {
      key: step,
      staticClass: "bs-wizard-step col",
      class: [_vm.currentStep > (step + 1) ? 'complete' : '', _vm.currentStep == (step + 1) ? 'active' : '', _vm.currentStep < (step + 1) ? 'disabled' : ''],
      on: {
        "click": function($event) {
          _vm.stepClick(step)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "slot-wrapper"
    }, [_vm._t(step + 1)], 2), _vm._v(" "), _c('a', {
      staticClass: "bs-wizard-dot"
    }, [_c('strong', [_vm._v(_vm._s(step + 1))])])])
  }))
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar"
  })])
}]}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('h1', {
    staticClass: "float-left display-3 mr-4"
  }, [_vm._v("500")]), _vm._v(" "), _c('h4', {
    staticClass: "pt-3"
  }, [_vm._v("Houston, we have a problem!")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("The page you are looking for is temporarily unavailable.")])]), _vm._v(" "), _c('div', {
    staticClass: "input-prepend input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "prependedInput",
      "size": "16",
      "type": "text",
      "placeholder": "What are you looking for?"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Search")])])])])])])])
}]}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "time-picker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayTime),
      expression: "displayTime"
    }],
    staticClass: "display-time",
    attrs: {
      "id": _vm.id,
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.displayTime)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDropdown($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayTime = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.hideClearButton) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDropdown && _vm.showClearBtn),
      expression: "!showDropdown && showClearBtn"
    }],
    staticClass: "clear-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clearTime($event)
      }
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticClass: "time-picker-overlay",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDropdown($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdown),
      expression: "showDropdown"
    }],
    staticClass: "dropdown"
  }, [_c('div', {
    staticClass: "select-list"
  }, [_c('ul', {
    staticClass: "hours"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.hourType)
    }
  }), _vm._v(" "), _vm._l((_vm.hours), function(hr) {
    return _c('li', {
      class: {
        active: _vm.hour === hr
      },
      domProps: {
        "textContent": _vm._s(hr)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select('hour', hr)
        }
      }
    })
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "minutes"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.minuteType)
    }
  }), _vm._v(" "), _vm._l((_vm.minutes), function(m) {
    return _c('li', {
      class: {
        active: _vm.minute === m
      },
      domProps: {
        "textContent": _vm._s(m)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select('minute', m)
        }
      }
    })
  })], 2), _vm._v(" "), (_vm.secondType) ? _c('ul', {
    staticClass: "seconds"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.secondType)
    }
  }), _vm._v(" "), _vm._l((_vm.seconds), function(s) {
    return _c('li', {
      class: {
        active: _vm.second === s
      },
      domProps: {
        "textContent": _vm._s(s)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select('second', s)
        }
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.apmType) ? _c('ul', {
    staticClass: "apms"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.apmType)
    }
  }), _vm._v(" "), _vm._l((_vm.apms), function(a) {
    return _c('li', {
      class: {
        active: _vm.apm === a
      },
      domProps: {
        "textContent": _vm._s(a)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select('apm', a)
        }
      }
    })
  })], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "booking"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.schedules.booking_number_per_time_slot')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "booking-options",
    attrs: {
      "id": "booking",
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "placeholder": "",
      "options": _vm.numberOptions,
      "allow-empty": false
    },
    model: {
      value: (_vm.booking),
      callback: function($$v) {
        _vm.booking = $$v
      },
      expression: "booking"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "bookingHelpInline"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.schedules.booking_number_per_time_slot_e_g')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])])
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-core-image-upload-btn"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasImage),
      expression: "!hasImage"
    }],
    staticClass: "g-core-image-upload-form",
    staticStyle: {
      "display": "block",
      "cursor": "pointer",
      "position": "absolute",
      "left": "0px",
      "top": "0px",
      "width": "1242px",
      "height": "61px",
      "opacity": "0",
      "margin": "0px",
      "padding": "0px",
      "overflow": "hidden"
    },
    attrs: {
      "method": "post",
      "enctype": "multipart/form-data",
      "action": "/api2/common_user/cropHeadUrl"
    }
  }, [_c('input', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "disabled": _vm.uploading,
      "id": 'g-core-upload-input-' + _vm.formID,
      "name": _vm.name,
      "multiple": _vm.multiple,
      "type": "file",
      "accept": _vm.inputAccept
    },
    on: {
      "change": _vm.change
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasImage),
      expression: "hasImage"
    }],
    staticClass: "g-core-image-corp-container",
    attrs: {
      "id": 'vciu-modal-' + _vm.formID
    }
  }, [_c('crop', {
    ref: "cropBox",
    attrs: {
      "is-resize": _vm.resize && !_vm.crop,
      "ratio": _vm.cropRatio,
      "is-rotate": _vm.rotate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-aside"
  }, [_c('p', {
    staticClass: "btn-groups rotate-groups",
    staticStyle: {
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn btn-rotate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doRotate
    }
  }, [_vm._v("↺")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-reverserotate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doReverseRotate
    }
  }, [_vm._v("↻")])]), _vm._v(" "), (_vm.crop) ? _c('p', {
    staticClass: "btn-groups"
  }, [_c('button', {
    staticClass: "btn btn-upload",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doCrop
    }
  }, [_vm._v(_vm._s(_vm.cropBtn.ok))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cropBtn.cancel))])]) : _vm._e(), _vm._v(" "), (_vm.resize && !_vm.crop) ? _c('p', {
    staticClass: "btn-groups"
  }, [_c('button', {
    staticClass: "btn btn-upload",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doResize
    }
  }, [_vm._v(_vm._s(_vm.ResizeBtn.ok))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.ResizeBtn.cancel))])]) : _vm._e()])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card-columns cols-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('line-example')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('bar-example')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('doughnut-example')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('radar-example')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('pie-example')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('polar-area-example')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Line Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Bar Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Doughnut Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Radar Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Pie Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Polar Area Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
}]}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-left"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.remarks.title_remark_editor')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "disabled": _vm.mode === _vm.MODE_EDIT || _vm.mode === _vm.MODE_NEW
    }
  }, _vm._l((_vm.remarkList), function(rt) {
    return _c('option', {
      key: rt.name,
      on: {
        "click": function($event) {
          _vm.remarkClick(rt)
        }
      }
    }, [_vm._v(_vm._s(rt.name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('bs-input', {
    attrs: {
      "placeholder": _vm.$t('message.remarks.name'),
      "disabled": _vm.mode === _vm.MODE_NORMAL
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.$t('message.remarks.remark'),
      "disabled": _vm.mode === _vm.MODE_NORMAL
    },
    model: {
      value: (_vm.remarkText),
      callback: function($$v) {
        _vm.remarkText = $$v
      },
      expression: "remarkText"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-left"
  }, [_c('button', {
    staticClass: "btn btn-close btn-lg btn-space",
    on: {
      "click": _vm.closeEditor
    }
  }, [_vm._v(_vm._s(this.$t('action_message.close')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg btn-space",
    on: {
      "click": _vm.saveEditor
    }
  }, [_vm._v(_vm._s(this.$t('action_message.save')))]), _vm._v(" "), (_vm.mode === _vm.MODE_EDIT || _vm.mode === _vm.MODE_NEW) ? _c('button', {
    staticClass: "btn btn-cancel btn-lg float-right btn-space",
    on: {
      "click": _vm.cancelMode
    }
  }, [_vm._v(_vm._s(this.$t('action_message.cancel')))]) : _vm._e(), _vm._v(" "), (_vm.mode === _vm.MODE_EDIT || _vm.mode === _vm.MODE_NEW) ? _c('button', {
    staticClass: "btn btn-store btn-lg float-right btn-space",
    on: {
      "click": _vm.saveRemarks
    }
  }, [_vm._v(_vm._s(this.$t('action_message.ok')))]) : _vm._e(), _vm._v(" "), (_vm.mode === _vm.MODE_NORMAL && _vm.remarkObj !== null) ? _c('button', {
    staticClass: "btn btn-delete btn-lg float-right btn-space",
    on: {
      "click": _vm.deleteRemark
    }
  }, [_vm._v(_vm._s(this.$t('action_message.remove')))]) : _vm._e(), _vm._v(" "), (_vm.enableEditMode) ? _c('button', {
    staticClass: "btn btn-store btn-lg float-right btn-space",
    on: {
      "click": _vm.gotoEditMode
    }
  }, [_vm._v(_vm._s(this.$t('action_message.edit')))]) : _vm._e(), _vm._v(" "), (_vm.mode === _vm.MODE_NORMAL) ? _c('button', {
    staticClass: "btn btn-store btn-lg float-right btn-space",
    on: {
      "click": _vm.gotoNewMode
    }
  }, [_vm._v(_vm._s(this.$t('action_message.add')))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-primary text-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('footer', [_vm._v("Someone famous in\n              "), _c('cite', {
    attrs: {
      "title": "Source Title"
    }
  }, [_vm._v("Source Title")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-success text-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('footer', [_vm._v("Someone famous in\n              "), _c('cite', {
    attrs: {
      "title": "Source Title"
    }
  }, [_vm._v("Source Title")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-info text-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('footer', [_vm._v("Someone famous in\n              "), _c('cite', {
    attrs: {
      "title": "Source Title"
    }
  }, [_vm._v("Source Title")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-warning text-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('footer', [_vm._v("Someone famous in\n              "), _c('cite', {
    attrs: {
      "title": "Source Title"
    }
  }, [_vm._v("Source Title")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-danger text-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('footer', [_vm._v("Someone famous in\n              "), _c('cite', {
    attrs: {
      "title": "Source Title"
    }
  }, [_vm._v("Source Title")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-primary text-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('footer', [_vm._v("Someone famous in\n              "), _c('cite', {
    attrs: {
      "title": "Source Title"
    }
  }, [_vm._v("Source Title")])])])], 1)])])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card title\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("Card footer")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("Card with icon\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card with switch\n          "), _c('label', {
    staticClass: "switch switch-sm switch-text switch-info float-right mb-0"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card with label\n          "), _c('span', {
    staticClass: "badge badge-success float-right"
  }, [_vm._v("Success")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card with label\n          "), _c('span', {
    staticClass: "badge badge-pill badge-danger float-right"
  }, [_vm._v("42")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-outline-primary"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card outline\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-outline-secondary"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card outline\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-outline-success"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card outline\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-outline-info"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card outline\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-outline-warning"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card outline\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-outline-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card outline\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-accent-primary"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card with accent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-accent-secondary"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card with accent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-accent-success"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card with accent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-accent-info"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card with accent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-accent-warning"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card with accent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-accent-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card with accent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-primary"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card title\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-success"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card title\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-info"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card title\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-warning"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card title\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Card title\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n        ")])])])])
}]}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [(!_vm.userChecking) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-12 col-sm-10 col-lg-6"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4 login"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-wrap"
  }, [_c('sync-loader', {
    attrs: {
      "size": "15px",
      "color": "#20a8d8"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('message.login.title')))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted text-center title"
  }, [_vm._v(_vm._s(_vm.$t('message.login.header')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.error.email
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('message.login.user_placeholder')
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-4"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.error.password
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('message.login.password_placeholder')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v("Error: " + _vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block px-4",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.login.submit')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center forgot"
  }, [_c('button', {
    staticClass: "btn btn-link px-0",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.login.forgot_password')))])])])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "card card-inverse card-primary py-5 d-md-down-none",
    staticStyle: {
      "width": "44%"
    }
  }, [_c('div', {
    staticClass: "card-block text-center"
  }, [_c('div', [_c('h2', [_vm._v("Sign up")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary active mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.fetchProfile()
      }
    }
  }, [_vm._v("Register Now!")])])])]) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo3_color.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
}]}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [(_vm.$route.query.action === 'edit') ? _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_edit')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_new')))]), _vm._v(" "), _c('step', {
    attrs: {
      "currentStep": 4,
      "maxStep": 5
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.personal_info')))]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.experience')))]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.schedules')))]), _vm._v(" "), _c('div', {
    slot: "4"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.education')))]), _vm._v(" "), _c('div', {
    slot: "5"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.other_info')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.education')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_education.education_info')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "step-subheader"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_education.education_info_th')))])])]), _vm._v(" "), _c('doctor-array-input', {
    attrs: {
      "dataset": _vm.doctor.th.educations,
      "description": _vm.$t('message.doctor_education.education_info_th')
    },
    on: {
      "update:dataset": [function($event) {
        _vm.doctor.th.educations = $event
      }, function (v) { return _vm.doctor.th.educations = v; }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "step-subheader"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_education.education_info_en')))])])]), _vm._v(" "), _c('doctor-array-input', {
    attrs: {
      "dataset": _vm.doctor.en.educations,
      "description": _vm.$t('message.doctor_education.education_info_en')
    },
    on: {
      "update:dataset": [function($event) {
        _vm.doctor.en.educations = $event
      }, function (v) { return _vm.doctor.en.educations = v; }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_education.certifications')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "step-subheader"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_education.certifications_th')))])])]), _vm._v(" "), _c('doctor-array-input', {
    attrs: {
      "dataset": _vm.doctor.th.certifications,
      "description": _vm.$t('message.doctor_education.certifications_th')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "step-subheader"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_education.certifications_en')))])])]), _vm._v(" "), _c('doctor-array-input', {
    attrs: {
      "dataset": _vm.doctor.en.certifications,
      "description": _vm.$t('message.doctor_education.certifications_en')
    },
    on: {
      "update:dataset": function($event) {
        _vm.doctor.en.certifications = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_education.license_number')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.license_number),
      expression: "doctor.license_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('message.doctor_education.license_number')
    },
    domProps: {
      "value": (_vm.doctor.license_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor.license_number = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_education.professional_memberships')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "step-subheader"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_education.professional_memberships_th')))])])]), _vm._v(" "), _c('doctor-array-input', {
    attrs: {
      "dataset": _vm.doctor.th.professional_memberships,
      "description": _vm.$t('message.doctor_education.professional_memberships_th')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "step-subheader"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_education.professional_memberships_en')))])])]), _vm._v(" "), _c('doctor-array-input', {
    attrs: {
      "dataset": _vm.doctor.en.professional_memberships,
      "description": _vm.$t('message.doctor_education.professional_memberships_en')
    },
    on: {
      "update:dataset": function($event) {
        _vm.doctor.en.professional_memberships = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), (_vm.$route.query.action === 'edit') ? _c('button', {
    staticClass: "btn btn-delete btn-right btn-lg",
    on: {
      "click": _vm.deleteDoctor
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [(_vm.isPendingView) ? _c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.pending_view')))]) : _c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.appointment_view')))]), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "appointments-wrapper"
  }, [_c('bs-input', {
    attrs: {
      "placeholder": _vm.$t('message.appointment.search_appointment')
    },
    model: {
      value: (_vm.q),
      callback: function($$v) {
        _vm.q = $$v
      },
      expression: "q"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.show')))]), _vm._v(" " + _vm._s(_vm.paginator.from) + " - " + _vm._s(_vm.paginator.to) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.from')))]), _vm._v(" " + _vm._s(_vm.paginator.total) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.rows')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.prev_page_url && _vm.reloadAppointments(_vm.paginator.prev_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.prev')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.next_page_url && _vm.reloadAppointments(_vm.paginator.next_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.next')))])]), _vm._v(" "), (_vm.filtered_appointments.length > 0) ? _c('div', [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.filtered_appointments), function(app, index) {
    return _c('div', {
      key: index,
      staticClass: "appointment-container"
    }, [_c('div', {
      staticClass: "card appointment-content"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('span', {
      staticClass: "app-date"
    }, [_vm._v(_vm._s(app.start))]), _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v(_vm._s(app.object.status))])]), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('h6', {
      staticClass: "app-name"
    }, [_vm._v(_vm._s(app.object.firstname) + " " + _vm._s(app.object.lastname))]), _vm._v(" "), _c('div', {
      staticClass: "app-phone"
    }, [_vm._v(_vm._s(app.object.phone))]), _vm._v(" "), _c('div', {
      staticClass: "app-doctor"
    }, [_vm._v(_vm._s(app.title))])])])])
  }))], 1) : _c('h6', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.appointment.no_appointment')) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.showAddPanel) ? _c('div', {
    staticClass: "appointment-form"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.appointment.add_appointment')))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "fp"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.appointment.appointment_date')))])]), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "id": "fp",
      "config": {
        enableTime: true,
        altInput: true,
        wrap: true,
        time_24hr: true
      }
    },
    model: {
      value: (_vm.appointment.appointment_time),
      callback: function($$v) {
        _vm.appointment.appointment_time = $$v
      },
      expression: "appointment.appointment_time"
    }
  }), _c('br'), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.appointment.firstname'),
      "placeholder": _vm.$t('message.appointment.firstname')
    },
    model: {
      value: (_vm.appointment.firstname),
      callback: function($$v) {
        _vm.appointment.firstname = $$v
      },
      expression: "appointment.firstname"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.appointment.lastname'),
      "placeholder": _vm.$t('message.appointment.lastname')
    },
    model: {
      value: (_vm.appointment.lastname),
      callback: function($$v) {
        _vm.appointment.lastname = $$v
      },
      expression: "appointment.lastname"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.appointment.phone'),
      "placeholder": _vm.$t('message.appointment.phone')
    },
    model: {
      value: (_vm.appointment.phone),
      callback: function($$v) {
        _vm.appointment.phone = $$v
      },
      expression: "appointment.phone"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.appointment.email'),
      "placeholder": _vm.$t('message.appointment.email')
    },
    model: {
      value: (_vm.appointment.email),
      callback: function($$v) {
        _vm.appointment.email = $$v
      },
      expression: "appointment.email"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.duration')))]), _vm._v(" "), _c('bs-input', {
    staticClass: "input-min",
    attrs: {
      "type": "Number",
      "min": "1",
      "max": "59",
      "placeholder": _vm.$t('message.appointment.duration')
    },
    model: {
      value: (_vm.appointment.duration),
      callback: function($$v) {
        _vm.appointment.duration = $$v
      },
      expression: "appointment.duration"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.appointment.duration_unit')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.service')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "service",
      "placeholder": _vm.$t('message.appointment.service_placeholder'),
      "options": [{
        label: 'service',
        value: '1'
      }],
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.service),
      callback: function($$v) {
        _vm.appointment.service = $$v
      },
      expression: "appointment.service"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.doctor')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "doctor",
      "placeholder": _vm.$t('message.appointment.doctor'),
      "options": [{
        label: 'doctor1',
        value: '1'
      }],
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.doctor),
      callback: function($$v) {
        _vm.appointment.doctor = $$v
      },
      expression: "appointment.doctor"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "label": _vm.$t('message.appointment.addition'),
      "placeholder": _vm.$t('message.appointment.addition')
    },
    model: {
      value: (_vm.appointment.comment),
      callback: function($$v) {
        _vm.appointment.comment = $$v
      },
      expression: "appointment.comment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": _vm.cancelAddingAppointment
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": _vm.addAppointment
    }
  }, [_vm._v(_vm._s(_vm.editMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.add')))]), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-action",
    on: {
      "click": _vm.removeAppointment
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])]), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))])])]) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "breadcrumb-item"
    }, [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-rotate-bar"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.rotateLeft
    }
  }, [_c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "viewBox": "0 0 481.95 481.95"
    }
  }, [_c('path', {
    attrs: {
      "d": "M281.7,243.8V138.2c75.9,13.5,135.4,78.6,135.4,159.8s-59.6,146.3-135.4,159.8V512\n        c105.7-13.5,189.6-102.9,189.6-214s-84-200.5-189.6-214V0L159.8,121.9L281.7,243.8z M94.8,270.9c2.7-24.4,13.5-46.1,27.1-67.7\n        L84,165.2C59.6,197.8,46.1,233,40.6,270.9H94.8z M159.8,430.7l-37.9,37.9c32.5,24.4,67.7,37.9,105.7,43.3v-54.2\n        C203.2,455.1,181.5,444.3,159.8,430.7z M94.8,325.1H40.6c2.7,37.9,19,73.1,43.3,105.7l37.9-37.9\n        C108.4,371.1,97.5,349.5,94.8,325.1z",
      "fill": "#27ae60"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.rotateRight
    }
  }, [_c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "viewBox": "0 0 481.95 481.95"
    }
  }, [_c('path', {
    attrs: {
      "d": "M331.5,114.75L216.75,0v79.05C117.3,91.8,38.25,175.95,38.25,280.5s79.05,188.7,178.5,201.45v-51    C145.35,418.2,89.25,357,89.25,280.5s56.1-137.7,127.5-150.45v99.45L331.5,114.75z M443.7,255    c-5.101-35.7-17.851-68.85-40.8-99.45l-35.7,35.7c12.75,20.4,22.95,40.8,25.5,63.75H443.7z M267.75,430.95v51    c35.7-5.101,68.85-17.851,99.45-40.8l-35.7-35.7C311.1,418.2,290.7,428.4,267.75,430.95z M367.2,369.75l35.7,35.7    c22.949-30.601,38.25-63.75,40.8-99.45h-51C390.15,328.95,379.95,349.35,367.2,369.75z",
      "fill": "#27ae60"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-resize-bar"
  }, [_c('div', {
    staticClass: "g-resize-highlight",
    style: ({
      width: _vm.left + '%',
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "circle-btn",
    style: ({
      left: _vm.left + '%',
    }),
    on: {
      "touchstart": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.drag($event)
      },
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.drag($event)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto header"
  }, [_c('dropdown', {
    staticClass: "nav-item nav-profile",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-user fa-lg"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v(_vm._s(_vm.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    slot: "dropdown-menu"
  }, [(_vm.$guser.isClinicMulti()) ? _c('div', {
    staticClass: "dropdown-header text-center"
  }, [_c('strong', [_vm._v("Clinics")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.$guser.user.clinics), function(clinic, index) {
    return (_vm.$guser.isClinicMulti()) ? _c('a', {
      key: index,
      staticClass: "dropdown-item",
      attrs: {
        "href": '/clinic/general?ref_clinic_id=' + clinic.id
      }
    }, [_c('i', {
      staticClass: "fa fa-hospital-o"
    }), _vm._v(" " + _vm._s(clinic.clinic_name) + "\n        ")]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-header text-center"
  }, [_c('strong', [_vm._v("Others")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.$guser.isClinicMulti()) ? _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/clinic_multi'
    }
  }, [_c('i', {
    staticClass: "fa fa-hospital-o"
  }), _vm._v(" หน้าแรก\n        ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": '/package/me'
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.my_subcription')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.signout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.sign_out')))])], 2)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ckeditor"
  }, [_c('textarea', {
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "types": _vm.types,
      "config": _vm.config
    },
    domProps: {
      "value": _vm.value
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Social Media Button")]), _vm._v(" "), _c('small', [_vm._v("Usage ex.")]), _c('code', {
    staticStyle: {
      "text-transform": "lowercase"
    }
  }, [_vm._v("<button class=\"btn btn-facebook\"><span>Facebook</span></button>")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    staticClass: "btn-setting",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-settings"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-minimize",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "",
      "aria-expanded": "false",
      "aria-controls": "collapseExample"
    }
  }, [_c('i', {
    staticClass: "icon-arrow-up"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h6', [_vm._v("Size Small "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-sm")])])]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-sm btn-facebook",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-twitter",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-linkedin",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-flickr",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-tumblr",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-xing",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-github",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-html5",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-openid",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-stack-overflow",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-css3",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-youtube",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-dribbble",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-google-plus",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-instagram",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-pinterest",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-vk",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-yahoo",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-behance",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-dropbox",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-reddit",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-spotify",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-vine",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-foursquare",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-vimeo",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vimeo")])])]), _vm._v(" "), _c('h6', [_vm._v("Size Normal")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-facebook",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-twitter",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-linkedin",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flickr",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-tumblr",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xing",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-github",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-html5",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-openid",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-stack-overflow",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-css3",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-youtube",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dribbble",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-google-plus",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-instagram",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-pinterest",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-vk",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-yahoo",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-behance",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dropbox",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-reddit",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-spotify",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-vine",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-foursquare",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-vimeo",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vimeo")])])]), _vm._v(" "), _c('h6', [_vm._v("Size Large "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-lg")])])]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-lg btn-facebook",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-twitter",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-linkedin",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-flickr",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-tumblr",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-xing",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-github",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-html5",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-openid",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-stack-overflow",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-css3",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-youtube",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-dribbble",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-google-plus",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-instagram",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-pinterest",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-vk",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-yahoo",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-behance",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-dropbox",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-reddit",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-spotify",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-vine",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-foursquare",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-vimeo",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vimeo")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Social Media Button")]), _vm._v(" "), _c('small', [_vm._v("Only icons. Usage ex.")]), _vm._v(" "), _c('code', {
    staticStyle: {
      "text-transform": "lowercase"
    }
  }, [_vm._v("<button class=\"btn btn-facebook icon\"><span>Facebook</span></button>")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    staticClass: "btn-setting",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-settings"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-minimize",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "",
      "aria-expanded": "false",
      "aria-controls": "collapseExample"
    }
  }, [_c('i', {
    staticClass: "icon-arrow-up"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h6', [_vm._v("Size Small "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-sm")])])]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-sm btn-facebook icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-twitter icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-linkedin icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-flickr icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-tumblr icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-xing icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-github icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-html5 icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-openid icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-stack-overflow icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-css3 icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-youtube icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-dribbble icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-google-plus icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-instagram icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-pinterest icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-vk icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-yahoo icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-behance icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-dropbox icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-reddit icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-spotify icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-vine icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-foursquare icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-vimeo icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vimeo")])])]), _vm._v(" "), _c('h6', [_vm._v("Size Normal")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-facebook icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-twitter icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-linkedin icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flickr icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-tumblr icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xing icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-github icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-html5 icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-openid icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-stack-overflow icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-css3 icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-youtube icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dribbble icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-google-plus icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-instagram icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-pinterest icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-vk icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-yahoo icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-behance icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dropbox icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-reddit icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-spotify icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-vine icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-foursquare icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-vimeo icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vimeo")])])]), _vm._v(" "), _c('h6', [_vm._v("Size Large "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-lg")])])]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-lg btn-facebook icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-twitter icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-linkedin icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-flickr icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-tumblr icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-xing icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-github icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-html5 icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-openid icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-stack-overflow icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-css3 icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-youtube icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-dribbble icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-google-plus icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-instagram icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-pinterest icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-vk icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-yahoo icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-behance icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-dropbox icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-reddit icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-spotify icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-vine icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-foursquare icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-vimeo icon",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vimeo")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Social Media Button")]), _vm._v(" "), _c('small', [_vm._v("Only text. Usage ex.")]), _vm._v(" "), _c('code', {
    staticStyle: {
      "text-transform": "lowercase"
    }
  }, [_vm._v("<button class=\"btn btn-facebook text\"><span>Facebook</span></button>")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    staticClass: "btn-setting",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-settings"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-minimize",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "",
      "aria-expanded": "false",
      "aria-controls": "collapseExample"
    }
  }, [_c('i', {
    staticClass: "icon-arrow-up"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h6', [_vm._v("Size Small "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-sm")])])]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-sm btn-facebook text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-twitter text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-linkedin text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-flickr text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-tumblr text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-xing text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-github text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-html5 text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-openid text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-stack-overflow text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-css3 text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-youtube text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-dribbble text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-google-plus text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-instagram text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-pinterest text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-vk text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-yahoo text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-behance text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-dropbox text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-reddit text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-spotify text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-vine text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-foursquare text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-vimeo text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vimeo")])])]), _vm._v(" "), _c('h6', [_vm._v("Size Normal")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-facebook text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-twitter text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-linkedin text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flickr text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-tumblr text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xing text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-github text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-html5 text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-openid text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-stack-overflow text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-css3 text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-youtube text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dribbble text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-google-plus text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-instagram text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-pinterest text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-vk text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-yahoo text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-behance text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dropbox text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-reddit text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-spotify text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-vine text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-foursquare text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-vimeo text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vimeo")])])]), _vm._v(" "), _c('h6', [_vm._v("Size Large "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-lg")])])]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-lg btn-facebook text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-twitter text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-linkedin text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("LinkedIn")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-flickr text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Flickr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-tumblr text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Tumblr")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-xing text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Xing")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-github text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Github")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-html5 text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("HTML5")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-openid text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("OpenID")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-stack-overflow text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("StackOverflow")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-css3 text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("CSS3")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-youtube text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("YouTube")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-dribbble text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dribbble")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-google-plus text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Google+")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-instagram text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Instagram")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-pinterest text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Pinterest")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-vk text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("VK")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-yahoo text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Yahoo")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-behance text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Behance")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-dropbox text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Dropbox")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-reddit text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-spotify text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Spotify")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-vine text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vine")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-foursquare text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Forsquare")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-vimeo text",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Vimeo")])])])])])])])])
}]}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Link")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("With Icons")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v("  Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  }), _vm._v("  Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-magic"
  }), _vm._v("  Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("  Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-rss"
  }), _vm._v("  Danger")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("  Link")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Size Large")]), _vm._v(" "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-lg")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Link")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Size Small")]), _vm._v(" "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-sm")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Link")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Disabled state")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("disabled=\"disabled\"")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Link")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Active state")]), _vm._v(" "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".active")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-primary active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Link")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Block Level Buttons")]), _vm._v(" "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-block")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("With Icons")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v("  Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  }), _vm._v("  Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-magic"
  }), _vm._v("  Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("  Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-rss"
  }), _vm._v("  Danger")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Size Large")]), _vm._v(" "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-lg")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-secondary btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-success btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-info btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-warning btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Size Small")]), _vm._v(" "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-sm")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-secondary btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-success btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-info btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-warning btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Disabled state")]), _vm._v(" "), _c('small', [_vm._v("Add this "), _c('code', [_vm._v("disabled=\"disabled\"")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-info",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-warning",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v("Danger")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Active state")]), _vm._v(" "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".active")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-secondary active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Secondary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-success active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-info active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-warning active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger active",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Block Level Buttons")]), _vm._v(" "), _c('small', [_vm._v("Add this class "), _c('code', [_vm._v(".btn-block")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-outline-secondary btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-primary btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-success btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-info btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-warning btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger btn-lg btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Block level button")])])])])])])
}]}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$guser.isClinic() && _vm.$guser.user.clinic && _vm.$guser.user.clinic.approved !== 1) ? _c('div', {
    staticClass: "card-inverse card-warning alert-top-box card-orange-warning"
  }, [_c('div', {
    staticClass: "card-block alert-container"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle alert-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "card-blockquote alert-text"
  }, [_c('h4', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('message.alert_bar.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.alert_bar.message')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.alert_bar.contact')))])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic() && _vm.$guser.user.clinic && _vm.$guser.user.clinic.approved === 1 && _vm.$guser.user.clinic.sms_active && _vm.$guser.user.clinic.sms_credit < 100) ? _c('div', {
    staticClass: "card-inverse card-warning alert-top-box card-orange-warning"
  }, [_c('div', {
    staticClass: "card-block alert-container"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle alert-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "card-blockquote alert-text"
  }, [_c('h4', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('message.alert_bar_sms_warning.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.alert_bar_sms_warning.message')) + " " + _vm._s(_vm.$guser.user.clinic.sms_credit + ' Credit'))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.alert_bar_sms_warning.contact')))])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor() && _vm.$guser.user.doctor && _vm.$guser.user.doctor.approved !== 1) ? _c('div', {
    staticClass: "card-inverse card-warning alert-top-box card-orange-warning"
  }, [_c('div', {
    staticClass: "card-block alert-container"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle alert-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "card-blockquote alert-text"
  }, [_c('h4', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.$t('message.alert_bar.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.alert_bar.message')) + " " + _vm._s(_vm.$t('message.alert_bar.contact')))])])], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" Simple Line Icons\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-user icons font-2xl d-block mt-4"
  }), _vm._v("icon-user\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-people icons font-2xl d-block mt-4"
  }), _vm._v("icon-people\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-user-female icons font-2xl d-block mt-4"
  }), _vm._v("icon-user-female\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-user-follow icons font-2xl d-block mt-4"
  }), _vm._v("icon-user-follow\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-user-following icons font-2xl d-block mt-4"
  }), _vm._v("icon-user-following\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-user-unfollow icons font-2xl d-block mt-4"
  }), _vm._v("icon-user-unfollow\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-login icons font-2xl d-block mt-4"
  }), _vm._v("icon-login\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-logout icons font-2xl d-block mt-4"
  }), _vm._v("icon-logout\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-emotsmile icons font-2xl d-block mt-4"
  }), _vm._v("icon-emotsmile\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-phone icons font-2xl d-block mt-4"
  }), _vm._v("icon-phone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-call-end icons font-2xl d-block mt-4"
  }), _vm._v("icon-call-end\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-call-in icons font-2xl d-block mt-4"
  }), _vm._v("icon-call-in\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-call-out icons font-2xl d-block mt-4"
  }), _vm._v("icon-call-out\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-map icons font-2xl d-block mt-4"
  }), _vm._v("icon-map\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-location-pin icons font-2xl d-block mt-4"
  }), _vm._v("icon-location-pin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-direction icons font-2xl d-block mt-4"
  }), _vm._v("icon-direction\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-directions icons font-2xl d-block mt-4"
  }), _vm._v("icon-directions\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-compass icons font-2xl d-block mt-4"
  }), _vm._v("icon-compass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-layers icons font-2xl d-block mt-4"
  }), _vm._v("icon-layers\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-menu icons font-2xl d-block mt-4"
  }), _vm._v("icon-menu\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-list icons font-2xl d-block mt-4"
  }), _vm._v("icon-list\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-options-vertical icons font-2xl d-block mt-4"
  }), _vm._v("icon-options-vertical\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-options icons font-2xl d-block mt-4"
  }), _vm._v("icon-options\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-down icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-left icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-right icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-up icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-up-circle icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-up-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-left-circle icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-left-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-right-circle icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-right-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-down-circle icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-down-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-check icons font-2xl d-block mt-4"
  }), _vm._v("icon-check\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-clock icons font-2xl d-block mt-4"
  }), _vm._v("icon-clock\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-plus icons font-2xl d-block mt-4"
  }), _vm._v("icon-plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-close icons font-2xl d-block mt-4"
  }), _vm._v("icon-close\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-trophy icons font-2xl d-block mt-4"
  }), _vm._v("icon-trophy\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-screen-smartphone icons font-2xl d-block mt-4"
  }), _vm._v("icon-screen-smartphone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-screen-desktop icons font-2xl d-block mt-4"
  }), _vm._v("icon-screen-desktop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-plane icons font-2xl d-block mt-4"
  }), _vm._v("icon-plane\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-notebook icons font-2xl d-block mt-4"
  }), _vm._v("icon-notebook\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-mustache icons font-2xl d-block mt-4"
  }), _vm._v("icon-mustache\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-mouse icons font-2xl d-block mt-4"
  }), _vm._v("icon-mouse\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-magnet icons font-2xl d-block mt-4"
  }), _vm._v("icon-magnet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-energy icons font-2xl d-block mt-4"
  }), _vm._v("icon-energy\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-disc icons font-2xl d-block mt-4"
  }), _vm._v("icon-disc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-cursor icons font-2xl d-block mt-4"
  }), _vm._v("icon-cursor\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-cursor-move icons font-2xl d-block mt-4"
  }), _vm._v("icon-cursor-move\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-crop icons font-2xl d-block mt-4"
  }), _vm._v("icon-crop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-chemistry icons font-2xl d-block mt-4"
  }), _vm._v("icon-chemistry\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-speedometer icons font-2xl d-block mt-4"
  }), _vm._v("icon-speedometer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-shield icons font-2xl d-block mt-4"
  }), _vm._v("icon-shield\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-screen-tablet icons font-2xl d-block mt-4"
  }), _vm._v("icon-screen-tablet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-magic-wand icons font-2xl d-block mt-4"
  }), _vm._v("icon-magic-wand\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-hourglass icons font-2xl d-block mt-4"
  }), _vm._v("icon-hourglass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-graduation icons font-2xl d-block mt-4"
  }), _vm._v("icon-graduation\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-ghost icons font-2xl d-block mt-4"
  }), _vm._v("icon-ghost\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-game-controller icons font-2xl d-block mt-4"
  }), _vm._v("icon-game-controller\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-fire icons font-2xl d-block mt-4"
  }), _vm._v("icon-fire\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-eyeglass icons font-2xl d-block mt-4"
  }), _vm._v("icon-eyeglass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-envelope-open icons font-2xl d-block mt-4"
  }), _vm._v("icon-envelope-open\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-envelope-letter icons font-2xl d-block mt-4"
  }), _vm._v("icon-envelope-letter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-bell icons font-2xl d-block mt-4"
  }), _vm._v("icon-bell\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-badge icons font-2xl d-block mt-4"
  }), _vm._v("icon-badge\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-anchor icons font-2xl d-block mt-4"
  }), _vm._v("icon-anchor\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-wallet icons font-2xl d-block mt-4"
  }), _vm._v("icon-wallet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-vector icons font-2xl d-block mt-4"
  }), _vm._v("icon-vector\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-speech icons font-2xl d-block mt-4"
  }), _vm._v("icon-speech\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-puzzle icons font-2xl d-block mt-4"
  }), _vm._v("icon-puzzle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-printer icons font-2xl d-block mt-4"
  }), _vm._v("icon-printer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-present icons font-2xl d-block mt-4"
  }), _vm._v("icon-present\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-playlist icons font-2xl d-block mt-4"
  }), _vm._v("icon-playlist\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-pin icons font-2xl d-block mt-4"
  }), _vm._v("icon-pin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-picture icons font-2xl d-block mt-4"
  }), _vm._v("icon-picture\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-handbag icons font-2xl d-block mt-4"
  }), _vm._v("icon-handbag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-globe-alt icons font-2xl d-block mt-4"
  }), _vm._v("icon-globe-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-globe icons font-2xl d-block mt-4"
  }), _vm._v("icon-globe\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-folder-alt icons font-2xl d-block mt-4"
  }), _vm._v("icon-folder-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-folder icons font-2xl d-block mt-4"
  }), _vm._v("icon-folder\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-film icons font-2xl d-block mt-4"
  }), _vm._v("icon-film\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-feed icons font-2xl d-block mt-4"
  }), _vm._v("icon-feed\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-drop icons font-2xl d-block mt-4"
  }), _vm._v("icon-drop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-drawer icons font-2xl d-block mt-4"
  }), _vm._v("icon-drawer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-docs icons font-2xl d-block mt-4"
  }), _vm._v("icon-docs\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-doc icons font-2xl d-block mt-4"
  }), _vm._v("icon-doc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-diamond icons font-2xl d-block mt-4"
  }), _vm._v("icon-diamond\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-cup icons font-2xl d-block mt-4"
  }), _vm._v("icon-cup\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-calculator icons font-2xl d-block mt-4"
  }), _vm._v("icon-calculator\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-bubbles icons font-2xl d-block mt-4"
  }), _vm._v("icon-bubbles\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-briefcase icons font-2xl d-block mt-4"
  }), _vm._v("icon-briefcase\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-book-open icons font-2xl d-block mt-4"
  }), _vm._v("icon-book-open\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-basket-loaded icons font-2xl d-block mt-4"
  }), _vm._v("icon-basket-loaded\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-basket icons font-2xl d-block mt-4"
  }), _vm._v("icon-basket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-bag icons font-2xl d-block mt-4"
  }), _vm._v("icon-bag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-action-undo icons font-2xl d-block mt-4"
  }), _vm._v("icon-action-undo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-action-redo icons font-2xl d-block mt-4"
  }), _vm._v("icon-action-redo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-wrench icons font-2xl d-block mt-4"
  }), _vm._v("icon-wrench\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-umbrella icons font-2xl d-block mt-4"
  }), _vm._v("icon-umbrella\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-trash icons font-2xl d-block mt-4"
  }), _vm._v("icon-trash\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-tag icons font-2xl d-block mt-4"
  }), _vm._v("icon-tag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-support icons font-2xl d-block mt-4"
  }), _vm._v("icon-support\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-frame icons font-2xl d-block mt-4"
  }), _vm._v("icon-frame\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-size-fullscreen icons font-2xl d-block mt-4"
  }), _vm._v("icon-size-fullscreen\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-size-actual icons font-2xl d-block mt-4"
  }), _vm._v("icon-size-actual\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-shuffle icons font-2xl d-block mt-4"
  }), _vm._v("icon-shuffle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-share-alt icons font-2xl d-block mt-4"
  }), _vm._v("icon-share-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-share icons font-2xl d-block mt-4"
  }), _vm._v("icon-share\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-rocket icons font-2xl d-block mt-4"
  }), _vm._v("icon-rocket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-question icons font-2xl d-block mt-4"
  }), _vm._v("icon-question\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-pie-chart icons font-2xl d-block mt-4"
  }), _vm._v("icon-pie-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-pencil icons font-2xl d-block mt-4"
  }), _vm._v("icon-pencil\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-note icons font-2xl d-block mt-4"
  }), _vm._v("icon-note\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-loop icons font-2xl d-block mt-4"
  }), _vm._v("icon-loop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-home icons font-2xl d-block mt-4"
  }), _vm._v("icon-home\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-grid icons font-2xl d-block mt-4"
  }), _vm._v("icon-grid\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-graph icons font-2xl d-block mt-4"
  }), _vm._v("icon-graph\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-microphone icons font-2xl d-block mt-4"
  }), _vm._v("icon-microphone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-music-tone-alt icons font-2xl d-block mt-4"
  }), _vm._v("icon-music-tone-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-music-tone icons font-2xl d-block mt-4"
  }), _vm._v("icon-music-tone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-earphones-alt icons font-2xl d-block mt-4"
  }), _vm._v("icon-earphones-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-earphones icons font-2xl d-block mt-4"
  }), _vm._v("icon-earphones\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-equalizer icons font-2xl d-block mt-4"
  }), _vm._v("icon-equalizer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-like icons font-2xl d-block mt-4"
  }), _vm._v("icon-like\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-dislike icons font-2xl d-block mt-4"
  }), _vm._v("icon-dislike\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-start icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-start\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-rewind icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-rewind\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-play icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-play\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-pause icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-pause\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-forward icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-forward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-end icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-end\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-volume-1 icons font-2xl d-block mt-4"
  }), _vm._v("icon-volume-1\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-volume-2 icons font-2xl d-block mt-4"
  }), _vm._v("icon-volume-2\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-volume-off icons font-2xl d-block mt-4"
  }), _vm._v("icon-volume-off\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-calendar icons font-2xl d-block mt-4"
  }), _vm._v("icon-calendar\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-bulb icons font-2xl d-block mt-4"
  }), _vm._v("icon-bulb\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-chart icons font-2xl d-block mt-4"
  }), _vm._v("icon-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-ban icons font-2xl d-block mt-4"
  }), _vm._v("icon-ban\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-bubble icons font-2xl d-block mt-4"
  }), _vm._v("icon-bubble\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-camrecorder icons font-2xl d-block mt-4"
  }), _vm._v("icon-camrecorder\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-camera icons font-2xl d-block mt-4"
  }), _vm._v("icon-camera\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-cloud-download icons font-2xl d-block mt-4"
  }), _vm._v("icon-cloud-download\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-cloud-upload icons font-2xl d-block mt-4"
  }), _vm._v("icon-cloud-upload\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-envelope icons font-2xl d-block mt-4"
  }), _vm._v("icon-envelope\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-eye icons font-2xl d-block mt-4"
  }), _vm._v("icon-eye\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-flag icons font-2xl d-block mt-4"
  }), _vm._v("icon-flag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-heart icons font-2xl d-block mt-4"
  }), _vm._v("icon-heart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-info icons font-2xl d-block mt-4"
  }), _vm._v("icon-info\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-key icons font-2xl d-block mt-4"
  }), _vm._v("icon-key\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-link icons font-2xl d-block mt-4"
  }), _vm._v("icon-link\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-lock icons font-2xl d-block mt-4"
  }), _vm._v("icon-lock\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-lock-open icons font-2xl d-block mt-4"
  }), _vm._v("icon-lock-open\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-magnifier icons font-2xl d-block mt-4"
  }), _vm._v("icon-magnifier\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-magnifier-add icons font-2xl d-block mt-4"
  }), _vm._v("icon-magnifier-add\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-magnifier-remove icons font-2xl d-block mt-4"
  }), _vm._v("icon-magnifier-remove\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-paper-clip icons font-2xl d-block mt-4"
  }), _vm._v("icon-paper-clip\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-paper-plane icons font-2xl d-block mt-4"
  }), _vm._v("icon-paper-plane\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-power icons font-2xl d-block mt-4"
  }), _vm._v("icon-power\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-refresh icons font-2xl d-block mt-4"
  }), _vm._v("icon-refresh\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-reload icons font-2xl d-block mt-4"
  }), _vm._v("icon-reload\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-settings icons font-2xl d-block mt-4"
  }), _vm._v("icon-settings\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-star icons font-2xl d-block mt-4"
  }), _vm._v("icon-star\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-symbol-female icons font-2xl d-block mt-4"
  }), _vm._v("icon-symbol-female\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-symbol-male icons font-2xl d-block mt-4"
  }), _vm._v("icon-symbol-male\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-target icons font-2xl d-block mt-4"
  }), _vm._v("icon-target\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-credit-card icons font-2xl d-block mt-4"
  }), _vm._v("icon-credit-card\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-paypal icons font-2xl d-block mt-4"
  }), _vm._v("icon-paypal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-tumblr icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-tumblr\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-twitter icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-twitter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-facebook icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-facebook\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-instagram icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-instagram\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-linkedin icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-linkedin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-pinterest icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-pinterest\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-github icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-github\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-gplus icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-gplus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-reddit icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-reddit\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-skype icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-skype\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-dribbble icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-dribbble\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-behance icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-behance\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-foursqare icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-foursqare\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-soundcloud icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-soundcloud\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-spotify icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-spotify\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-stumbleupon icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-stumbleupon\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-youtube icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-youtube\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-dropbox icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-dropbox\n        ")])])])])])
}]}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.days), function(day) {
    return _c('div', {
      key: day.name,
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "dayselector"
    }, [_c('div', {
      staticClass: "dayselector-checkbox"
    }, [_c('div', {
      staticClass: "squaredThree"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (day.selected),
        expression: "day.selected"
      }],
      attrs: {
        "type": "checkbox",
        "value": "None",
        "id": day.name + _vm.clinic_id
      },
      domProps: {
        "checked": Array.isArray(day.selected) ? _vm._i(day.selected, "None") > -1 : (day.selected)
      },
      on: {
        "click": function($event) {
          _vm.addDefaultTimetable(day)
        },
        "__c": function($event) {
          var $$a = day.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "None",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (day.selected = $$a.concat($$v))
            } else {
              $$i > -1 && (day.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            day.selected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": day.name + _vm.clinic_id
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "dayselector-detail"
    }, [_c('span', [_vm._v(_vm._s(day.name))]), _vm._v(" "), (day.selected) ? _c('div', _vm._l((day.timetable), function(t, index) {
      return _c('div', {
        key: index,
        staticClass: "dayselector-detail-item"
      }, [_c('form', {
        staticClass: "form-inline"
      }, [_c('vue-timepicker', {
        attrs: {
          "minute-interval": 30
        },
        model: {
          value: (t.from_time),
          callback: function($$v) {
            t.from_time = $$v
          },
          expression: "t.from_time"
        }
      }), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.$t('message.schedules.to')))]), _vm._v(" "), _c('vue-timepicker', {
        attrs: {
          "minute-interval": 30
        },
        model: {
          value: (t.to_time),
          callback: function($$v) {
            t.to_time = $$v
          },
          expression: "t.to_time"
        }
      }), _vm._v(" "), (index > 0) ? _c('span', {
        staticClass: "text-danger",
        on: {
          "click": function($event) {
            _vm.removeTimetable(day.timetable, index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()], 1)])
    })) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(day.selected) ? _c('div', {
      staticClass: "col-12 dayselector-addtime"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.addMoreTimetable(day)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle fa-lg fa-fw text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.schedules.add_time_slot')))])])]) : _vm._e(), _vm._v(" "), (_vm.advance_week_option && day.selected) ? _c('div', {
      staticClass: "col-12 dayselector-options"
    }, [_c('a', {
      on: {
        "click": function($event) {
          day.showAdvance = !day.showAdvance
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-times-o fa-lg fa-fw text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s((day.showAdvance) ? _vm.$t('message.schedules.hide') : _vm.$t('message.schedules.show')) + " " + _vm._s(_vm.$t('message.schedules.options')))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (day.selected && day.showAdvance),
        expression: "day.selected && day.showAdvance"
      }],
      staticClass: "dayselector-advance-group animated fadeIn"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('message.schedules.week')))])]), _vm._v(" "), _c('div', {
      staticClass: "dayselector-advance-group-week"
    }, [_c('div', {
      staticClass: "squaredThree"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (day.week_1_enable),
        expression: "day.week_1_enable"
      }],
      attrs: {
        "type": "checkbox",
        "value": "None",
        "id": (_vm.clinic_id + "-" + (day.name) + "-week_enable_1")
      },
      domProps: {
        "checked": Array.isArray(day.week_1_enable) ? _vm._i(day.week_1_enable, "None") > -1 : (day.week_1_enable)
      },
      on: {
        "__c": function($event) {
          var $$a = day.week_1_enable,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "None",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (day.week_1_enable = $$a.concat($$v))
            } else {
              $$i > -1 && (day.week_1_enable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            day.week_1_enable = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": (_vm.clinic_id + "-" + (day.name) + "-week_enable_1")
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "dayselector-advance-group-label"
    }, [_vm._v("1")]), _vm._v(" "), _c('div', {
      staticClass: "squaredThree"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (day.week_2_enable),
        expression: "day.week_2_enable"
      }],
      attrs: {
        "type": "checkbox",
        "value": "None",
        "id": (_vm.clinic_id + "-" + (day.name) + "-week_enable_2")
      },
      domProps: {
        "checked": Array.isArray(day.week_2_enable) ? _vm._i(day.week_2_enable, "None") > -1 : (day.week_2_enable)
      },
      on: {
        "__c": function($event) {
          var $$a = day.week_2_enable,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "None",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (day.week_2_enable = $$a.concat($$v))
            } else {
              $$i > -1 && (day.week_2_enable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            day.week_2_enable = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": (_vm.clinic_id + "-" + (day.name) + "-week_enable_2")
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "dayselector-advance-group-label"
    }, [_vm._v("2")]), _vm._v(" "), _c('div', {
      staticClass: "squaredThree"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (day.week_3_enable),
        expression: "day.week_3_enable"
      }],
      attrs: {
        "type": "checkbox",
        "value": "None",
        "id": (_vm.clinic_id + "-" + (day.name) + "-week_enable_3")
      },
      domProps: {
        "checked": Array.isArray(day.week_3_enable) ? _vm._i(day.week_3_enable, "None") > -1 : (day.week_3_enable)
      },
      on: {
        "__c": function($event) {
          var $$a = day.week_3_enable,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "None",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (day.week_3_enable = $$a.concat($$v))
            } else {
              $$i > -1 && (day.week_3_enable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            day.week_3_enable = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": (_vm.clinic_id + "-" + (day.name) + "-week_enable_3")
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "dayselector-advance-group-label"
    }, [_vm._v("3")]), _vm._v(" "), _c('div', {
      staticClass: "squaredThree"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (day.week_4_enable),
        expression: "day.week_4_enable"
      }],
      attrs: {
        "type": "checkbox",
        "value": "None",
        "id": (_vm.clinic_id + "-" + (day.name) + "-week_enable_4")
      },
      domProps: {
        "checked": Array.isArray(day.week_4_enable) ? _vm._i(day.week_4_enable, "None") > -1 : (day.week_4_enable)
      },
      on: {
        "__c": function($event) {
          var $$a = day.week_4_enable,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "None",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (day.week_4_enable = $$a.concat($$v))
            } else {
              $$i > -1 && (day.week_4_enable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            day.week_4_enable = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": (_vm.clinic_id + "-" + (day.name) + "-week_enable_4")
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "dayselector-advance-group-label"
    }, [_vm._v("4")]), _vm._v(" "), _c('div', {
      staticClass: "squaredThree"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (day.week_5_enable),
        expression: "day.week_5_enable"
      }],
      attrs: {
        "type": "checkbox",
        "value": "None",
        "id": (_vm.clinic_id + "-" + (day.name) + "-week_enable_5")
      },
      domProps: {
        "checked": Array.isArray(day.week_5_enable) ? _vm._i(day.week_5_enable, "None") > -1 : (day.week_5_enable)
      },
      on: {
        "__c": function($event) {
          var $$a = day.week_5_enable,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "None",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (day.week_5_enable = $$a.concat($$v))
            } else {
              $$i > -1 && (day.week_5_enable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            day.week_5_enable = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": (_vm.clinic_id + "-" + (day.name) + "-week_enable_5")
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "dayselector-advance-group-label"
    }, [_vm._v("5")]), _vm._v(" "), _c('div', {
      staticClass: "squaredThree"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (day.week_last_enable),
        expression: "day.week_last_enable"
      }],
      attrs: {
        "type": "checkbox",
        "value": "None",
        "id": (_vm.clinic_id + "-" + (day.name) + "-week_enable_last")
      },
      domProps: {
        "checked": Array.isArray(day.week_last_enable) ? _vm._i(day.week_last_enable, "None") > -1 : (day.week_last_enable)
      },
      on: {
        "__c": function($event) {
          var $$a = day.week_last_enable,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "None",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (day.week_last_enable = $$a.concat($$v))
            } else {
              $$i > -1 && (day.week_last_enable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            day.week_last_enable = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": (_vm.clinic_id + "-" + (day.name) + "-week_enable_last")
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "dayselector-advance-group-label"
    }, [_vm._v(_vm._s(_vm.$t('message.schedules.last_week')))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "form-divider"
    })])
  }))
},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patient-wrapper"
  }, [_c('div', {
    staticClass: "row animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.patient.title')))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "href": _vm.export_csv,
      "target": "_blank"
    }
  }, [_vm._v("Export csv")]), _vm._v(" "), (!_vm.showAddPanel) ? _c('button', {
    staticClass: "add-service btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.enterCreateForm()
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('action_message.add')))]) : _vm._e(), _vm._v(" "), (_vm.showAddPanel) ? _c('button', {
    staticClass: "add-service btn btn-info",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddPanel = !_vm.showAddPanel
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.list')))]) : _vm._e()]), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "patient-list-wrapper"
  }, [_c('bs-input', {
    attrs: {
      "placeholder": _vm.$t('message.patient.search_by')
    },
    model: {
      value: (_vm.q),
      callback: function($$v) {
        _vm.q = $$v
      },
      expression: "q"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('message.patient.patient_list')))]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.show')))]), _vm._v(" " + _vm._s(_vm.paginator.from) + " - " + _vm._s(_vm.paginator.to) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.from')))]), _vm._v(" " + _vm._s(_vm.paginator.total) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.rows')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.prev_page_url && _vm.reloadPatient(_vm.paginator.prev_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.prev')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.next_page_url && _vm.reloadPatient(_vm.paginator.next_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.next')))])]), _vm._v(" "), _c('div', {
    staticClass: "patient-container-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchLoading),
      expression: "searchLoading"
    }],
    staticClass: "loading-wrap"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px",
      "color": "#20a8d8"
    }
  })], 1), _vm._v(" "), (_vm.patients.length > 0) ? _c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.filtered_patients), function(p, index) {
    return _c('div', {
      key: p,
      staticClass: "patients-container",
      on: {
        "click": function($event) {
          _vm.editPatient(p)
        }
      }
    }, [_c('div', {
      staticClass: "btn"
    }, [(p.gender === 'm') ? _c('i', {
      staticClass: "fa fa-male fa-lg",
      staticStyle: {
        "color": "darkblue"
      }
    }) : _vm._e(), _vm._v(" "), (p.gender === 'f') ? _c('i', {
      staticClass: "fa fa-female fa-lg",
      staticStyle: {
        "color": "deeppink"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "patients-content"
    }, [_c('h6', [_vm._v(_vm._s(p.firstname) + " " + _vm._s(p.lastname) + " " + _vm._s(p.hn ? ' - ' + p.hn : ''))])]), _vm._v(" "), _c('div', {
      staticClass: "patients-actions"
    }, [_c('i', {
      staticClass: "fa fa-chevron-right",
      on: {
        "click": function($event) {
          _vm.editPatient(p)
        }
      }
    })])])
  })) : _c('h6', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.patient.no_patient')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddPanel),
      expression: "showAddPanel"
    }],
    staticClass: "service-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.patient.required_info')))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(this.$t('message.patient.prefix')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "prefix",
      "placeholder": this.$t('message.patient.prefix_placeholder'),
      "options": _vm.prefix_options,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.patient.prefix),
      callback: function($$v) {
        _vm.patient.prefix = $$v
      },
      expression: "patient.prefix"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "required": "",
      "label": _vm.$t('message.patient.firstname'),
      "placeholder": _vm.$t('message.patient.firstname')
    },
    model: {
      value: (_vm.patient.firstname),
      callback: function($$v) {
        _vm.patient.firstname = $$v
      },
      expression: "patient.firstname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.firstnameError
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "required": "",
      "label": _vm.$t('message.patient.lastname'),
      "placeholder": _vm.$t('message.patient.lastname')
    },
    model: {
      value: (_vm.patient.lastname),
      callback: function($$v) {
        _vm.patient.lastname = $$v
      },
      expression: "patient.lastname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.lastnameError
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.patient.gender')))]), _vm._v(" "), _c('div', {
    staticClass: "gender-select"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient.gender),
      expression: "patient.gender"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio1",
      "value": "m"
    },
    domProps: {
      "checked": _vm._q(_vm.patient.gender, "m")
    },
    on: {
      "__c": function($event) {
        _vm.patient.gender = "m"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-male fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.patient.male')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient.gender),
      expression: "patient.gender"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio2",
      "value": "f"
    },
    domProps: {
      "checked": _vm._q(_vm.patient.gender, "f")
    },
    on: {
      "__c": function($event) {
        _vm.patient.gender = "f"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-female fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.patient.female')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('message.patient.phone_no')))]), _c('br'), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "phone"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.phoneError
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.patient.hn'),
      "placeholder": _vm.$t('message.patient.hn')
    },
    model: {
      value: (_vm.patient.hn),
      callback: function($$v) {
        _vm.patient.hn = $$v
      },
      expression: "patient.hn"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.patient.contact')))]), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.patient.email'),
      "type": "email",
      "placeholder": _vm.$t('message.patient.email')
    },
    model: {
      value: (_vm.patient.email),
      callback: function($$v) {
        _vm.patient.email = $$v
      },
      expression: "patient.email"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.patient.address'),
      "placeholder": _vm.$t('message.patient.address')
    },
    model: {
      value: (_vm.patient.b_address),
      callback: function($$v) {
        _vm.patient.b_address = $$v
      },
      expression: "patient.b_address"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.patient.personal_info')))]), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.patient.id_card'),
      "placeholder": _vm.$t('message.patient.id_card')
    },
    model: {
      value: (_vm.patient.id_card),
      callback: function($$v) {
        _vm.patient.id_card = $$v
      },
      expression: "patient.id_card"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t('message.patient.birthdate')))]), _c('br'), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "id": "fp",
      "config": {
        enableTime: false,
        altInput: true,
        wrap: true,
        defaultDate: new Date('1986-01-01')
      }
    },
    model: {
      value: (_vm.patient.birthday),
      callback: function($$v) {
        _vm.patient.birthday = $$v
      },
      expression: "patient.birthday"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.birthdayError
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.patient.allergy'),
      "placeholder": _vm.$t('message.patient.allergy')
    },
    model: {
      value: (_vm.patient.allergy),
      callback: function($$v) {
        _vm.patient.allergy = $$v
      },
      expression: "patient.allergy"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.patient.diseases'),
      "placeholder": _vm.$t('message.patient.diseases')
    },
    model: {
      value: (_vm.patient.diseases),
      callback: function($$v) {
        _vm.patient.diseases = $$v
      },
      expression: "patient.diseases"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.patient.relative_info')))]), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.patient.relative_name'),
      "placeholder": _vm.$t('message.patient.relative_name')
    },
    model: {
      value: (_vm.patient.relative_name),
      callback: function($$v) {
        _vm.patient.relative_name = $$v
      },
      expression: "patient.relative_name"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.patient.relative_relation'),
      "placeholder": _vm.$t('message.patient.relative_relation')
    },
    model: {
      value: (_vm.patient.relative_relation),
      callback: function($$v) {
        _vm.patient.relative_relation = $$v
      },
      expression: "patient.relative_relation"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.patient.relative_phone'),
      "placeholder": _vm.$t('message.patient.relative_phone')
    },
    model: {
      value: (_vm.patient.relative_phone),
      callback: function($$v) {
        _vm.patient.relative_phone = $$v
      },
      expression: "patient.relative_phone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": _vm.enterListView
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": _vm.addPatient
    }
  }, [_vm._v(_vm._s(_vm.editMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.add')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-patient-action",
    on: {
      "click": _vm.removePatient
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])], 1)])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "errorModal",
    attrs: {
      "icon": "error",
      "title": "Error",
      "overlay-theme": "dark"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.sweetErrorMsg) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-sync v-sync1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-sync v-sync2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-sync v-sync3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  })])
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [(_vm.clinicReady) ? _c('div', {
    staticClass: "component-wrapper"
  }, [_c(_vm.$route.params.page, {
    tag: "component",
    attrs: {
      "clinic": _vm.clinic
    },
    on: {
      "update:clinic": function($event) {
        _vm.clinic = $event
      },
      "finishStep": _vm.finishStep,
      "cancelChange": _vm.cancelChange
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm",
    slot: "loader"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "icon": "success"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('h1', {
    staticClass: "float-left display-3 mr-4"
  }, [_vm._v("404")]), _vm._v(" "), _c('h4', {
    staticClass: "pt-3"
  }, [_vm._v("Oops! You're lost.")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("The page you are looking for was not found.")])]), _vm._v(" "), _c('div', {
    staticClass: "input-prepend input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "prependedInput",
      "size": "16",
      "type": "text",
      "placeholder": "What are you looking for?"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Search")])])])])])])])
}]}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.title')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_name')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "clinic-name-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_name_th')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.th.clinic_name),
      expression: "clinic.th.clinic_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "clinic-name-th",
      "placeholder": _vm.$t('message.clinic_info.clinic_name_th')
    },
    domProps: {
      "value": (_vm.clinic.th.clinic_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clinic.th.clinic_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "clinic-name-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_name_en')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.en.clinic_name),
      expression: "clinic.en.clinic_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "clinic-name-en",
      "placeholder": _vm.$t('message.clinic_info.clinic_name_en')
    },
    domProps: {
      "value": (_vm.clinic.en.clinic_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clinic.en.clinic_name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_detail')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "clinic-detail-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_detail_th')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.th.detail),
      expression: "clinic.th.detail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "clinic-detail-th",
      "placeholder": _vm.$t('message.clinic_info.clinic_detail_th')
    },
    domProps: {
      "value": (_vm.clinic.th.detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clinic.th.detail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "clinic-detail-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_detail_en')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.en.detail),
      expression: "clinic.en.detail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "clinic-detail-en",
      "placeholder": _vm.$t('message.clinic_info.clinic_detail_en')
    },
    domProps: {
      "value": (_vm.clinic.en.detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clinic.en.detail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_logo')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('drop-zone', {
    staticClass: "crop-profile-image-dropzone",
    class: {
      'profile-image-active': _vm.isProfileImage
    },
    attrs: {
      "placeholder": _vm.profileImagePlaceholder
    },
    on: {
      "fileChange": _vm.profileImageFileChange
    }
  }), _vm._v(" "), _c('img', {
    ref: "crop-profile-image",
    staticClass: "crop-profile-image",
    attrs: {
      "src": _vm.profile_image_src
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_albums')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    attrs: {
      "id": "alblum-wrapper"
    }
  }, [_vm._l((_vm.clinic.images), function(img) {
    return (!img.is_active) ? _c('div', {
      key: img.id,
      staticClass: "image-in-alblum-wrapper"
    }, [_c('i', {
      staticClass: "fa fa-2x fa-times remove-image-from-alblum",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.removeImageFromAlblum(img.id)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "image-in-alblum",
      attrs: {
        "src": img.file_thumb
      }
    })]) : _vm._e()
  }), _vm._v(" "), _c('vue-core-image-upload', {
    class: ['btn', 'btn-primary', 'btn-upload-image'],
    attrs: {
      "crop": false,
      "max-file-size": 5242880,
      "input-of-file": "image",
      "url": _vm.$APP_CONFIG.api.admin.upload_clinicme_alblum()
    },
    on: {
      "imageuploaded": _vm.imageAlblumUploaded
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-plus plus-image",
    attrs: {
      "title": "remove image",
      "aria-hidden": "true"
    }
  })])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_info')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-12"
  }, [_c('label', {
    attrs: {
      "for": "bio-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_info_th')))]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "id": "bio-th",
      "config": _vm.ckeditorConfig
    },
    model: {
      value: (_vm.clinic.th.info),
      callback: function($$v) {
        _vm.clinic.th.info = $$v
      },
      expression: "clinic.th.info"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "editor-lock"
  }, [(_vm.ckeditorConfig.readOnly) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-12"
  }, [_c('label', {
    attrs: {
      "for": "bio-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_info_en')))]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "id": "bio-en",
      "config": _vm.ckeditorConfig
    },
    model: {
      value: (_vm.clinic.en.info),
      callback: function($$v) {
        _vm.clinic.en.info = $$v
      },
      expression: "clinic.en.info"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "editor-lock"
  }, [(_vm.ckeditorConfig.readOnly) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.video_links')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-12"
  }, [_c('doctor-array-input', {
    attrs: {
      "dataset": _vm.clinic.th.video_links,
      "description": _vm.$t('message.clinic_info.youtube_link')
    },
    on: {
      "update:dataset": [function($event) {
        _vm.clinic.th.video_links = $event
      }, function (v) { return _vm.clinic.th.video_links = v; }]
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _vm._t("loader")], 2)])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "crop-modal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-croppie', {
    ref: "croppieRef",
    attrs: {
      "enableOrientation": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelCrop($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.confirmCrop($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.ok')))])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.feedback.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(!_vm.$ismobile()) ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.feedback.appointment_no')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.feedback.appointment_date')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.feedback.patient_name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.feedback.doctor_name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.feedback.score')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "34%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.feedback.comment')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.reviews.data), function(review) {
    return _c('tr', {
      key: review.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openAppointmentDetail(review.appointment.id)
        }
      }
    }, [_vm._v(_vm._s(review.appointment.id))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("formatDateTimeFull")(review.appointment.appointment_time)))]), _vm._v(" "), _c('td', [(review.appointment.ehr_patient_id) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openPatient(review.appointment.ehr_patient_id)
        }
      }
    }, [_vm._v(_vm._s(((review.appointment.firstname) + " " + (review.appointment.lastname))))]) : _c('div', [_vm._v(_vm._s(((review.appointment.firstname) + " " + (review.appointment.lastname))))])]), _vm._v(" "), _c('td', [_c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openDoctor(review.appointment.doctor_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.getDoctorName(review)))])]), _vm._v(" "), _c('small', {
      staticClass: "text-one-ellipsis"
    }, [_vm._v(_vm._s(_vm.getDoctorSpecialty(review)))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, _vm._l((_vm.ratingKeys), function(n) {
      return _c('i', {
        key: n,
        staticClass: "text-danger fa",
        class: {
          'fa-heart': n < review.rating, 'fa-heart-o': n >= review.rating
        },
        attrs: {
          "aria-hidden": "true"
        }
      })
    })), _vm._v(" "), _c('td', {
      staticClass: "text-justify"
    }, [_c('span', [_vm._v(_vm._s(_vm.viewContent(review.content, !review.showMoreContent)))]), _vm._v(" "), (review.moreContentEnable) ? _c('a', {
      staticClass: "view-more-btn",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleMoreContent(review)
        }
      }
    }, [_vm._v(_vm._s(review.showMoreContent ? _vm.$t('action_message.close') : _vm.$t('action_message.view_more')))]) : _vm._e()])])
  }), _vm._v(" "), (_vm.loaded && _vm.reviews.data.length === 0) ? _c('tr', [_c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.feedback.no_comment')))])])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('tr', [_c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.show')))]), _vm._v(" " + _vm._s(_vm.reviews.from) + " - " + _vm._s(_vm.reviews.to) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.from')))]), _vm._v(" " + _vm._s(_vm.reviews.total) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.rows')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.reviews.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.reviews.prev_page_url && _vm.loadReviews(_vm.reviews.prev_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.prev')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.reviews.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.reviews.next_page_url && _vm.loadReviews(_vm.reviews.next_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.next')))])])]) : _c('div', [_c('div', {
    staticClass: "feedback-container"
  }, [(_vm.loaded && _vm.reviews.data.length !== 0) ? _c('div', {
    staticClass: "pagination"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.show')))]), _vm._v(" " + _vm._s(_vm.reviews.from) + " - " + _vm._s(_vm.reviews.to) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.from')))]), _vm._v(" " + _vm._s(_vm.reviews.total) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.rows')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.reviews.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.reviews.prev_page_url && _vm.loadReviews(_vm.reviews.prev_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.prev')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.reviews.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.reviews.next_page_url && _vm.loadReviews(_vm.reviews.next_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.next')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.reviews.data), function(review) {
    return _c('div', {
      key: review.id,
      staticClass: "card feedback-content"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('span', {
      staticClass: "col-6 app-id"
    }, [_vm._v(_vm._s(_vm.$t('message.feedback.appointment_no')) + ":\n                      "), _c('strong', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openAppointmentDetail(review.appointment.id)
        }
      }
    }, [_vm._v(_vm._s(review.appointment.id))])])]), _vm._v(" "), _c('span', {
      staticClass: "col-6 app-date text-right"
    }, [_vm._v(_vm._s(_vm._f("formatDateTimeFull")(review.appointment.appointment_time)))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('h6', {
      staticClass: "app-username"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openPatient(review.appointment.ehr_patient_id)
        }
      }
    }, [_vm._v(_vm._s(((review.appointment.firstname) + " " + (review.appointment.lastname))))])]), _vm._v(" "), _c('h5', {
      staticClass: "app-doctor"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openDoctor(review.appointment.doctor_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.getDoctorName(review)))])]), _vm._v(" "), _c('div', {
      staticClass: "app-rate"
    }, _vm._l((_vm.ratingKeys), function(n) {
      return _c('i', {
        key: n,
        staticClass: "text-danger fa",
        class: {
          'fa-heart': n < review.rating, 'fa-heart-o': n >= review.rating
        },
        attrs: {
          "aria-hidden": "true"
        }
      })
    })), _vm._v(" "), _c('span', {
      staticClass: "app-comment"
    }, [_vm._v(_vm._s(_vm.viewContent(review.content, !review.showMoreContent)))]), _vm._v(" "), (review.moreContentEnable) ? _c('a', {
      staticClass: "view-more-btn",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleMoreContent(review)
        }
      }
    }, [_vm._v(_vm._s(review.showMoreContent ? _vm.$t('action_message.close') : _vm.$t('action_message.view_more')))]) : _vm._e()])])
  })], 2), _vm._v(" "), (_vm.loaded && _vm.reviews.data.length === 0) ? _c('h6', {
    staticClass: "text-center alert alert-warning"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.feedback.no_comment')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('message.schedules.example')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.previews), function(preview) {
    return _c('div', {
      key: preview.startTime,
      staticClass: "slot-preview-item col-3"
    }, [_c('div', {
      staticClass: "slot-preview-time-box"
    }, [_vm._v("\n            " + _vm._s(preview.time) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "slot-preview-persons"
    }, _vm._l((_vm.previewIcons), function(bn) {
      return _c('i', {
        key: bn,
        staticClass: "fa fa-male",
        attrs: {
          "aria-hidden": "true"
        }
      })
    })), _vm._v(" "), _c('div', {
      staticClass: "slot-preview-desc"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('message.schedules.booking_number')) + " " + _vm._s(preview.booking) + " " + _vm._s(_vm.$t('message.schedules.booking_unit')))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body clinic-doctor-wrapper"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.doctors.title')))]), _vm._v(" "), (!_vm.showAddPanel) ? _c('button', {
    staticClass: "add-service btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.enterCreateMode($event)
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('action_message.add')))]) : _vm._e(), _vm._v(" "), (_vm.showAddPanel) ? _c('button', {
    staticClass: "add-service btn btn-info",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddPanel = !_vm.showAddPanel
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.list')))]) : _vm._e()]), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "doctor-wrapper"
  }, [(!_vm.isStepPrcess) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [(!_vm.isStepPrcess) ? _c('bs-input', {
    attrs: {
      "placeholder": _vm.$t('message.doctors.search_doctor')
    },
    model: {
      value: (_vm.q),
      callback: function($$v) {
        _vm.q = $$v
      },
      expression: "q"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('multiselect', {
    attrs: {
      "id": "specialty_filter",
      "placeholder": _vm.$t('message.doctors.filter_specialty'),
      "options": _vm.specialty_filters,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_specialty_filters),
      callback: function($$v) {
        _vm.selected_specialty_filters = $$v
      },
      expression: "selected_specialty_filters"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('multiselect', {
    attrs: {
      "id": "subspecialty_filter",
      "placeholder": _vm.$t('message.doctors.filter_subspecialty'),
      "options": _vm.subspecialty_filters,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_subspecialty_filters),
      callback: function($$v) {
        _vm.selected_subspecialty_filters = $$v
      },
      expression: "selected_subspecialty_filters"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isStepPrcess) ? _c('div', {
    staticClass: "pagination"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.show')))]), _vm._v(" " + _vm._s(_vm.paginator.from) + " - " + _vm._s(_vm.paginator.to) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.from')))]), _vm._v(" " + _vm._s(_vm.paginator.total) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.doctors.doctor_unit')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.prev_page_url && _vm.refreshDoctorList(_vm.paginator.prev_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.prev')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.next_page_url && _vm.refreshDoctorList(_vm.paginator.next_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.next')))])]) : _vm._e(), _vm._v(" "), (_vm.doctors.length > 0) ? _c('div', _vm._l((_vm.doctor_list), function(d, index) {
    return _c('div', {
      key: d,
      staticClass: "doctor-container"
    }, [_c('div', {
      staticClass: "doctor-content",
      on: {
        "click": function($event) {
          _vm.editDoctor(d)
        }
      }
    }, [_c('h6', [_vm._v(_vm._s((_vm.$i18n.locale === 'th') ? d.name_th : d.name_en))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(d.specialities[0] && ((_vm.$i18n.locale === 'th') ? d.specialities[0].name_th : d.specialities[0].name_en)) + " : " + _vm._s(_vm.display_sub_specialities(d)))])]), _vm._v(" "), _c('div', {
      staticClass: "doctor-actions"
    }, [_c('a', {
      attrs: {
        "href": _vm.$APP_CONFIG.api.domain + '/doctor/d-' + d.id,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" "), (!_vm.$ismobile()) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('action_message.view')))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "doctor-actions"
    }, [_c('i', {
      staticClass: "fa fa-qrcode",
      on: {
        "click": function($event) {
          _vm.showQRCode(d)
        }
      }
    }), _vm._v(" "), (!_vm.$ismobile()) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('message.doctors.qr_code')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "doctor-actions"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      on: {
        "click": function($event) {
          _vm.editDoctor(d)
        }
      }
    }), _vm._v(" "), (!_vm.$ismobile()) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('action_message.edit')))])]) : _vm._e()])])
  })) : _c('h6', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.doctors.no_doctor')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.showAddPanel) ? _c('div', {
    staticClass: "doctor-form"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctors.name_th')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('bs-input', {
    staticClass: "prefix-name remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.prefix'),
      "placeholder": _vm.$t('message.doctors.prefix')
    },
    model: {
      value: (_vm.doctor.th.prefix),
      callback: function($$v) {
        _vm.doctor.th.prefix = $$v
      },
      expression: "doctor.th.prefix"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['th.prefix']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.firstname'),
      "placeholder": _vm.$t('message.doctors.firstname')
    },
    model: {
      value: (_vm.doctor.th.firstname),
      callback: function($$v) {
        _vm.doctor.th.firstname = $$v
      },
      expression: "doctor.th.firstname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['th.firstname']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  })], 1)]), _vm._v(" "), _c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.lastname'),
      "placeholder": _vm.$t('message.doctors.lastname')
    },
    model: {
      value: (_vm.doctor.th.lastname),
      callback: function($$v) {
        _vm.doctor.th.lastname = $$v
      },
      expression: "doctor.th.lastname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['th.lastname']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.doctors.name_en')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('bs-input', {
    staticClass: "prefix-name remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.prefix'),
      "placeholder": _vm.$t('message.doctors.prefix')
    },
    model: {
      value: (_vm.doctor.en.prefix),
      callback: function($$v) {
        _vm.doctor.en.prefix = $$v
      },
      expression: "doctor.en.prefix"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['en.prefix']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.firstname'),
      "placeholder": _vm.$t('message.doctors.firstname')
    },
    model: {
      value: (_vm.doctor.en.firstname),
      callback: function($$v) {
        _vm.doctor.en.firstname = $$v
      },
      expression: "doctor.en.firstname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['en.firstname']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  })], 1)]), _vm._v(" "), _c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.lastname'),
      "placeholder": _vm.$t('message.doctors.lastname')
    },
    model: {
      value: (_vm.doctor.en.lastname),
      callback: function($$v) {
        _vm.doctor.en.lastname = $$v
      },
      expression: "doctor.en.lastname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['en.lastname']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.doctors.gender')))]), _vm._v(" "), _c('div', {
    staticClass: "gender-select"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.gender),
      expression: "doctor.gender"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio1",
      "value": "m"
    },
    domProps: {
      "checked": _vm._q(_vm.doctor.gender, "m")
    },
    on: {
      "__c": function($event) {
        _vm.doctor.gender = "m"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-male fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.doctors.male')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.gender),
      expression: "doctor.gender"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio2",
      "value": "f"
    },
    domProps: {
      "checked": _vm._q(_vm.doctor.gender, "f")
    },
    on: {
      "__c": function($event) {
        _vm.doctor.gender = "f"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-female fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.doctors.female')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.doctors.specialty')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctors.specialty')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "speciality",
      "placeholder": _vm.$t('message.doctors.specialty_placeholder'),
      "options": _vm.select_specialties_options,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_specialities),
      callback: function($$v) {
        _vm.selected_specialities = $$v
      },
      expression: "selected_specialities"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.specialities
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctors.subspecialty')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "subspeciality",
      "placeholder": _vm.$t('message.doctors.subspecialty_placeholder'),
      "options": _vm.sub_specialities,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_sub_specialities),
      callback: function($$v) {
        _vm.selected_sub_specialities = $$v
      },
      expression: "selected_sub_specialities"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": _vm.cancelAddingDoctor
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": _vm.addDoctor
    }
  }, [_vm._v(_vm._s(_vm.editMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.add')))]), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-doctor-action",
    on: {
      "click": _vm.removeDoctor
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _vm._t("loader")], 2)]) : _vm._e()])]), _vm._v(" "), _c('sweet-modal', {
    ref: "qrCodeModal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-qrcode', {
    attrs: {
      "id": "doctorQrCanvas",
      "value": _vm.doctorQrUrl,
      "options": {
        size: 200
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.downloadDoctorQr
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.download_qr_code')))]), _vm._v(" "), _c('a', {
    ref: "doctorQrLink"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    attrs: {
      "href": _vm.doctorQrUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.doctorQrUrl) + "\n        ")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn setting-container step-container broadcast"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v("Broadcast")]), _vm._v(" "), _c('h6', [_vm._v("broadcast SMS (มี " + _vm._s(_vm.$guser.user.clinic.sms_credit) + " Credits)")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.req.type),
      expression: "req.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "broadcastTypes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.req.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("-- เลือกประเภท --")]), _vm._v(" "), _vm._l((_vm.broadcastTypes), function(t) {
    return _c('option', {
      key: t.name,
      domProps: {
        "value": t.name
      }
    }, [_vm._v("\n                " + _vm._s(t.detail) + "\n              ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.checking && _vm.req.type !== 'appointment_date'),
      expression: "loading.checking && req.type!=='appointment_date'"
    }],
    staticClass: "col-md-5 form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.req.type === 'appointment_date'),
      expression: "req.type==='appointment_date'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-12"
  }, [_c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "selectedDoctor",
      "placeholder": "Optional",
      "options": _vm.doctors,
      "multiple": false,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "name",
      "track-by": "id"
    },
    on: {
      "search-change": _vm.getDoctors
    },
    model: {
      value: (_vm.selectedDoctor),
      callback: function($$v) {
        _vm.selectedDoctor = $$v
      },
      expression: "selectedDoctor"
    }
  })], 1)]), _vm._v(" "), (_vm.req.type === 'appointment_date') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "-- เลือกวันที่นัดหมาย --"
    },
    model: {
      value: (_vm.req.date),
      callback: function($$v) {
        _vm.req.date = $$v
      },
      expression: "req.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.checking),
      expression: "loading.checking"
    }],
    staticClass: "col-md-5 form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.req.type === 'last_visit') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMonth),
      expression: "selectedMonth"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "broadcastTypes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMonth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("-- เดือน --")]), _vm._v(" "), _vm._l((_vm.months), function(m) {
    return _c('option', {
      key: m.number,
      domProps: {
        "value": m.number
      }
    }, [_vm._v("\n                " + _vm._s(m.name) + "\n              ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedYear),
      expression: "selectedYear"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "broadcastTypes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("-- ปี --")]), _vm._v(" "), _vm._l((_vm.years), function(y) {
    return _c('option', {
      key: y,
      domProps: {
        "value": y
      }
    }, [_vm._v("\n                " + _vm._s(y) + "\n              ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedServiceId),
      expression: "selectedServiceId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "service"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedServiceId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("บริการทั้งหมด")]), _vm._v(" "), _vm._l((_vm.services), function(s) {
    return _c('option', {
      key: s.id,
      domProps: {
        "value": s.id
      }
    }, [_vm._v("\n                " + _vm._s(s.th.name) + "\n              ")])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.req.content),
      expression: "req.content"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "placeholder": "ข้อความใน SMS",
      "maxlength": "335"
    },
    domProps: {
      "value": (_vm.req.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.req.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-length"
  }, [_vm._v("ความยาวข้อความ " + _vm._s(_vm.req.content ? _vm.req.content.length : 0) + " / " + _vm._s(67 * 5))])])])]), _vm._v(" "), (_vm.req.type === 'appointment_date') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v("มี " + _vm._s(_vm.numberOfMessage) + " นัดหมาย (ใช้ credit=" + _vm._s(_vm.creditUsage) + ")")]), _vm._v(" "), _c('p', [_vm._v("หมายเหตุ: ทุกๆข้อความยาว 67 ตัวอักษรใช้ 1 credit")])])]) : _vm._e(), _vm._v(" "), (_vm.req.type === 'all_patients') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v("มีคนไข้ " + _vm._s(_vm.numberOfMessage) + " คน (ใช้ credit=" + _vm._s(_vm.creditUsage) + ")")]), _vm._v(" "), _c('p', [_vm._v("หมายเหตุ: ทุกๆข้อความยาว 67 ตัวอักษรใช้ 1 credit")])])]) : _vm._e(), _vm._v(" "), (_vm.req.type === 'last_visit') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v("มีคนไข้ " + _vm._s(_vm.numberOfMessage) + " คน (ใช้ credit=" + _vm._s(_vm.creditUsage) + ")")]), _vm._v(" "), _c('p', [_vm._v("หมายเหตุ: ทุกๆข้อความยาว 67 ตัวอักษรใช้ 1 credit")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-success",
    attrs: {
      "disabled": !_vm.isAbleToSend
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v("Send")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.sending),
      expression: "loading.sending"
    }],
    staticClass: "loader"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])]), _vm._v(" "), _c('sweet-modal', {
    ref: "success",
    attrs: {
      "icon": "success"
    }
  }, [_vm._v("Success!")]), _vm._v(" "), _c('sweet-modal', {
    ref: "fail",
    attrs: {
      "icon": "error"
    }
  }, [_vm._v("Fail: " + _vm._s(_vm.errorMessage))])], 1)
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside-menu px-4"
  }, [_c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-4"
  }, [_c('small', [_c('b', [_vm._v("Option 1")])]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-success switch-sm float-right"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]), _vm._v(" "), _c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-3"
  }, [_c('small', [_c('b', [_vm._v("Option 2")])]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-success switch-sm float-right"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]), _vm._v(" "), _c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-3"
  }, [_c('small', [_c('b', [_vm._v("Option 3")])]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-success switch-sm float-right"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-3"
  }, [_c('small', [_c('b', [_vm._v("Option 4")])]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-success switch-sm float-right"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("System Utilization")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-1 mt-4"
  }, [_c('small', [_c('b', [_vm._v("CPU Usage")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar bg-info",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("348 Processes. 1/4 Cores.")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-1 mt-2"
  }, [_c('small', [_c('b', [_vm._v("Memory Usage")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar bg-warning",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "70",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("11444GB/16384MB")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-1 mt-2"
  }, [_c('small', [_c('b', [_vm._v("SSD 1 Usage")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar bg-danger",
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "95",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("243GB/256GB")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-1 mt-2"
  }, [_c('small', [_c('b', [_vm._v("SSD 2 Usage")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar bg-success",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "10",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("25GB/256GB")])])
}]}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container clinic-multi"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', [_vm._v("สถานประกอบการในเครือ " + _vm._s(_vm.user.clinic_brand.name))]), _vm._v(" "), _c('p', [_vm._v("กรุณาเลือกสาขาที่ต้องการ")])]), _vm._v(" "), _vm._l((_vm.clinics), function(c) {
    return _c('div', {
      key: c.id,
      staticClass: "col-sm-12 col-md-4"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-body text-center"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/clinic/general',
          query: {
            ref_clinic_id: c.id
          }
        }
      }
    }, [_c('img', {
      staticClass: "rounded mx-auto d-block clinic-image",
      attrs: {
        "src": c.active_image
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(c.clinic_name))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(c.b_addr))])], 1)])])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Simple Table\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('th', [_vm._v("Date registered")]), _vm._v(" "), _c('th', [_vm._v("Role")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Samppa Nori")]), _vm._v(" "), _c('td', [_vm._v("2012/01/01")]), _vm._v(" "), _c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Estavan Lykos")]), _vm._v(" "), _c('td', [_vm._v("2012/02/01")]), _vm._v(" "), _c('td', [_vm._v("Staff")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("Banned")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Chetan Mohamed")]), _vm._v(" "), _c('td', [_vm._v("2012/02/01")]), _vm._v(" "), _c('td', [_vm._v("Admin")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-default"
  }, [_vm._v("Inactive")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Derick Maximinus")]), _vm._v(" "), _c('td', [_vm._v("2012/03/01")]), _vm._v(" "), _c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-warning"
  }, [_vm._v("Pending")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Friderik Dávid")]), _vm._v(" "), _c('td', [_vm._v("2012/01/21")]), _vm._v(" "), _c('td', [_vm._v("Staff")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item active"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Striped Table\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('th', [_vm._v("Date registered")]), _vm._v(" "), _c('th', [_vm._v("Role")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Yiorgos Avraamu")]), _vm._v(" "), _c('td', [_vm._v("2012/01/01")]), _vm._v(" "), _c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Avram Tarasios")]), _vm._v(" "), _c('td', [_vm._v("2012/02/01")]), _vm._v(" "), _c('td', [_vm._v("Staff")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("Banned")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Quintin Ed")]), _vm._v(" "), _c('td', [_vm._v("2012/02/01")]), _vm._v(" "), _c('td', [_vm._v("Admin")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-default"
  }, [_vm._v("Inactive")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Enéas Kwadwo")]), _vm._v(" "), _c('td', [_vm._v("2012/03/01")]), _vm._v(" "), _c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-warning"
  }, [_vm._v("Pending")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Agapetus Tadeáš")]), _vm._v(" "), _c('td', [_vm._v("2012/01/21")]), _vm._v(" "), _c('td', [_vm._v("Staff")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item active"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Condensed Table\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('th', [_vm._v("Date registered")]), _vm._v(" "), _c('th', [_vm._v("Role")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Carwyn Fachtna")]), _vm._v(" "), _c('td', [_vm._v("2012/01/01")]), _vm._v(" "), _c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nehemiah Tatius")]), _vm._v(" "), _c('td', [_vm._v("2012/02/01")]), _vm._v(" "), _c('td', [_vm._v("Staff")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("Banned")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ebbe Gemariah")]), _vm._v(" "), _c('td', [_vm._v("2012/02/01")]), _vm._v(" "), _c('td', [_vm._v("Admin")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-default"
  }, [_vm._v("Inactive")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Eustorgios Amulius")]), _vm._v(" "), _c('td', [_vm._v("2012/03/01")]), _vm._v(" "), _c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-warning"
  }, [_vm._v("Pending")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Leopold Gáspár")]), _vm._v(" "), _c('td', [_vm._v("2012/01/21")]), _vm._v(" "), _c('td', [_vm._v("Staff")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item active"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Bordered Table\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('th', [_vm._v("Date registered")]), _vm._v(" "), _c('th', [_vm._v("Role")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Pompeius René")]), _vm._v(" "), _c('td', [_vm._v("2012/01/01")]), _vm._v(" "), _c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Paĉjo Jadon")]), _vm._v(" "), _c('td', [_vm._v("2012/02/01")]), _vm._v(" "), _c('td', [_vm._v("Staff")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("Banned")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Micheal Mercurius")]), _vm._v(" "), _c('td', [_vm._v("2012/02/01")]), _vm._v(" "), _c('td', [_vm._v("Admin")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-default"
  }, [_vm._v("Inactive")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ganesha Dubhghall")]), _vm._v(" "), _c('td', [_vm._v("2012/03/01")]), _vm._v(" "), _c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-warning"
  }, [_vm._v("Pending")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hiroto Šimun")]), _vm._v(" "), _c('td', [_vm._v("2012/01/21")]), _vm._v(" "), _c('td', [_vm._v("Staff")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item active"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Combined All Table\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('th', [_vm._v("Date registered")]), _vm._v(" "), _c('th', [_vm._v("Role")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Vishnu Serghei")]), _vm._v(" "), _c('td', [_vm._v("2012/01/01")]), _vm._v(" "), _c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Zbyněk Phoibos")]), _vm._v(" "), _c('td', [_vm._v("2012/02/01")]), _vm._v(" "), _c('td', [_vm._v("Staff")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("Banned")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Einar Randall")]), _vm._v(" "), _c('td', [_vm._v("2012/02/01")]), _vm._v(" "), _c('td', [_vm._v("Admin")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-default"
  }, [_vm._v("Inactive")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Félix Troels")]), _vm._v(" "), _c('td', [_vm._v("2012/03/01")]), _vm._v(" "), _c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-warning"
  }, [_vm._v("Pending")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Aulus Agmundr")]), _vm._v(" "), _c('td', [_vm._v("2012/01/21")]), _vm._v(" "), _c('td', [_vm._v("Staff")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")])])])])]), _vm._v(" "), _c('nav', [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item active"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])])])])])])])])])
}]}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "slot"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.schedules.select_time_slot_number')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "slot-options",
    attrs: {
      "id": "slot",
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "placeholder": "",
      "options": _vm.slotOptions,
      "allow-empty": false
    },
    model: {
      value: (_vm.slots),
      callback: function($$v) {
        _vm.slots = $$v
      },
      expression: "slots"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "slotHelpInline"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.schedules.time_slot_e_g')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [(_vm.$route.query.action === 'edit') ? _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_edit')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_new')))]), _vm._v(" "), _c('step', {
    attrs: {
      "currentStep": 2,
      "maxStep": 5
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.personal_info')))]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.experience')))]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.schedules')))]), _vm._v(" "), _c('div', {
    slot: "4"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.education')))]), _vm._v(" "), _c('div', {
    slot: "5"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.other_info')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.experience')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_experience.specialty')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("สาขาเฉพาะทาง")]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "speciality",
      "placeholder": _vm.$t('message.doctor_experience.specialty_placeholder'),
      "options": _vm.select_specialties_options,
      "allow-empty": false,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_specialities),
      callback: function($$v) {
        _vm.selected_specialities = $$v
      },
      expression: "selected_specialities"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_experience.subspecialty')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "subspeciality",
      "placeholder": _vm.$t('message.doctor_experience.subspecialty_placeholder'),
      "options": _vm.sub_specialities,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_sub_specialities),
      callback: function($$v) {
        _vm.selected_sub_specialities = $$v
      },
      expression: "selected_sub_specialities"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('bs-input', {
    attrs: {
      "label": _vm.$t('message.doctor_experience.medical_procedure_th'),
      "placeholder": _vm.$t('message.doctor_experience.medical_procedure_placeholder'),
      "maxlength": 120
    },
    model: {
      value: (_vm.doctor.th.custom_text),
      callback: function($$v) {
        _vm.doctor.th.custom_text = $$v
      },
      expression: "doctor.th.custom_text"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('bs-input', {
    attrs: {
      "label": _vm.$t('message.doctor_experience.medical_procedure_en'),
      "placeholder": _vm.$t('message.doctor_experience.medical_procedure_placeholder'),
      "maxlength": 120
    },
    model: {
      value: (_vm.doctor.en.custom_text),
      callback: function($$v) {
        _vm.doctor.en.custom_text = $$v
      },
      expression: "doctor.en.custom_text"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_experience.place')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_experience.clinic_place')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "clinic",
      "placeholder": _vm.$t('message.doctor_experience.clinic_place_placeholder'),
      "options": _vm.clinics,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "disabled": _vm.$guser.isClinic() || _vm.$guser.isClinicMulti(),
      "loading": _vm.clinicLoading,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getClinicsOptions
    },
    model: {
      value: (_vm.selected_clinics),
      callback: function($$v) {
        _vm.selected_clinics = $$v
      },
      expression: "selected_clinics"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_experience.institute_place')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "institute",
      "placeholder": _vm.$t('message.doctor_experience.institute_place_placeholder'),
      "options": _vm.select_institutes_options,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_institute),
      callback: function($$v) {
        _vm.selected_institute = $$v
      },
      expression: "selected_institute"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), (_vm.$route.query.action === 'edit') ? _c('button', {
    staticClass: "btn btn-delete btn-right btn-lg",
    on: {
      "click": _vm.deleteDoctor
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered doctor-single"
  }, [_c('tbody', [_c('tr', [(!_vm.editIndex) ? _c('td', [_c('div', {
    staticClass: "doctor-education-element"
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataset) + " ( Email หลัก )")])])]) : _vm._e(), _vm._v(" "), (!_vm.editIndex) ? _c('td', {
    staticClass: "edit-element"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    on: {
      "click": function($event) {
        _vm.editData()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editIndex) ? _c('td', [_c('div', {
    staticClass: "doctor-education-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentDataset),
      expression: "currentDataset"
    }],
    ref: "editData",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentDataset)
    },
    on: {
      "blur": function($event) {
        _vm.hideInput()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentDataset = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "confirm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.saveData()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.ok')))])])])]) : _vm._e(), _vm._v(" "), (_vm.editIndex) ? _c('td', {
    staticClass: "edit-element"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.myModal = true
      }
    }
  }, [_vm._v("Launch demo modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.largeModal = true
      }
    }
  }, [_vm._v("Launch large modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.smallModal = true
      }
    }
  }, [_vm._v("Launch small modal")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.primaryModal = true
      }
    }
  }, [_vm._v("Launch primary modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.successModal = true
      }
    }
  }, [_vm._v("Launch success modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.warningModal = true
      }
    }
  }, [_vm._v("Launch warning modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dangerModal = true
      }
    }
  }, [_vm._v("Launch danger modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.infoModal = true
      }
    }
  }, [_vm._v("Launch info modal")])])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.myModal = false
      }
    },
    model: {
      value: (_vm.myModal),
      callback: function($$v) {
        _vm.myModal = $$v
      },
      expression: "myModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Modal title",
      "large": "",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.largeModal = false
      }
    },
    model: {
      value: (_vm.largeModal),
      callback: function($$v) {
        _vm.largeModal = $$v
      },
      expression: "largeModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Modal title",
      "small": "",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.smallModal = false
      }
    },
    model: {
      value: (_vm.smallModal),
      callback: function($$v) {
        _vm.smallModal = $$v
      },
      expression: "smallModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    staticClass: "modal-primary",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.primaryModal = false
      }
    },
    model: {
      value: (_vm.primaryModal),
      callback: function($$v) {
        _vm.primaryModal = $$v
      },
      expression: "primaryModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    staticClass: "modal-success",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.successModal = false
      }
    },
    model: {
      value: (_vm.successModal),
      callback: function($$v) {
        _vm.successModal = $$v
      },
      expression: "successModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    staticClass: "modal-warning",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.warningModal = false
      }
    },
    model: {
      value: (_vm.warningModal),
      callback: function($$v) {
        _vm.warningModal = $$v
      },
      expression: "warningModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    staticClass: "modal-danger",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.dangerModal = false
      }
    },
    model: {
      value: (_vm.dangerModal),
      callback: function($$v) {
        _vm.dangerModal = $$v
      },
      expression: "dangerModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    staticClass: "modal-info",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.infoModal = false
      }
    },
    model: {
      value: (_vm.infoModal),
      callback: function($$v) {
        _vm.infoModal = $$v
      },
      expression: "infoModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Bootstrap Modals\n          ")])
}]}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-page-wrapper"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.appointment.title_appointmemt')) + "\n    "), _c('div', {
    staticClass: "views-wrapper d-none d-md-block"
  }, [_c('div', {
    staticClass: "form-group has-feedback has-search event-filt event-filt-input search-input"
  }, [_c('span', {
    staticClass: "fa fa-search form-control-feedback",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_searchs),
      expression: "filter_searchs"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('message.appointment.filter_search')
    },
    domProps: {
      "value": (_vm.filter_searchs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter_searchs = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openNewAppointmentForm(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.appointment.add_appointment')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openExportCriteria
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.appointment.export_appointments')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Basic example"
    }
  }, [(!_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.viewType === 'daily'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('daily')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.daily_view')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq",
    class: {
      'btn-primary': _vm.viewType === 'monthly'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('monthly')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.monthly_view')))]), _vm._v(" "), (_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.viewType === 'weekly'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('weekly')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.weekly_view')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq-right",
    class: {
      'btn-primary': _vm.viewType === 'list'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('list')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.list_view')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "time-wrapper d-none d-md-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "event-wrapper d-none d-md-block"
  }, [_c('div', {
    staticClass: "event-filters"
  }, [_c('div', {
    staticClass: "switch-time-btn event-filt"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_calendar_view),
      expression: "!show_calendar_view"
    }],
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Basic example"
    }
  }, [_c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.filter_date_type === 'all'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchTime('all')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.filter_date_all')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq-right",
    class: {
      'btn-primary': _vm.filter_date_type === 'range'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchTime('range')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.filter_date_range')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filter_date_type === 'range' && !_vm.show_calendar_view),
      expression: "filter_date_type === 'range' && !show_calendar_view"
    }],
    staticClass: "filter-date event-filt"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    class: {
      'inactive': _vm.filter_date_type == 'all'
    },
    attrs: {
      "placeholder": _vm.$t('message.appointment.filter_date_range_placeholder'),
      "config": {
        mode: 'range'
      },
      "id": "filter-date-range"
    },
    model: {
      value: (_vm.filter_date_range),
      callback: function($$v) {
        _vm.filter_date_range = $$v
      },
      expression: "filter_date_range"
    }
  })], 1), _vm._v(" "), (_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_doctor",
      "placeholder": _vm.$t('message.appointment.filter_doctor'),
      "options": _vm.doctor_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "loading": _vm.doctorLoading,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getDoctorsOptions
    },
    model: {
      value: (_vm.filter_by_doctors),
      callback: function($$v) {
        _vm.filter_by_doctors = $$v
      },
      expression: "filter_by_doctors"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_clinic",
      "placeholder": _vm.$t('message.appointment.filter_clinic'),
      "options": _vm.clinic_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "loading": _vm.clinicLoading,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getClinicsOptions
    },
    model: {
      value: (_vm.filter_by_clinics),
      callback: function($$v) {
        _vm.filter_by_clinics = $$v
      },
      expression: "filter_by_clinics"
    }
  }) : _vm._e(), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_status",
      "placeholder": _vm.$t('message.appointment.filter_status'),
      "options": _vm.status_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.filter_by_status_list),
      callback: function($$v) {
        _vm.filter_by_status_list = $$v
      },
      expression: "filter_by_status_list"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu d-sm-block d-md-none"
  }, [_c('div', [_c('div', {
    staticClass: "form-group has-feedback has-search event-filt event-filt-input search-input"
  }, [_c('span', {
    staticClass: "fa fa-search form-control-feedback",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_searchs),
      expression: "filter_searchs"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('message.appointment.filter_search')
    },
    domProps: {
      "value": (_vm.filter_searchs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter_searchs = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openNewAppointmentForm(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.appointment.add_appointment')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-block btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openExportCriteria
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v("\n        " + _vm._s(_vm.$t('message.appointment.export_appointments')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Basic example"
    }
  }, [(!_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.viewType === 'daily'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('daily')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.daily_view')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq",
    class: {
      'btn-primary': _vm.viewType === 'monthly'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('monthly')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.monthly_view')))]), _vm._v(" "), (_vm.filter_by_doctor) ? _c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.viewType === 'weekly'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('weekly')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.weekly_view')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq-right",
    class: {
      'btn-primary': _vm.viewType === 'list'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchView('list')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("\n          " + _vm._s(_vm.$t('message.appointment.list_view')))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "switch-time-btn event-filt"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_calendar_view),
      expression: "!show_calendar_view"
    }],
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Basic example"
    }
  }, [_c('button', {
    staticClass: "btn btn-sq-border btn-sq-left",
    class: {
      'btn-primary': _vm.filter_date_type === 'all'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchTime('all')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.filter_date_all')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sq-border btn-sq-right",
    class: {
      'btn-primary': _vm.filter_date_type === 'range'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.switchTime('range')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.filter_date_range')))])])])]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filter_date_type === 'range' && !_vm.show_calendar_view),
      expression: "filter_date_type === 'range' && !show_calendar_view"
    }],
    staticClass: "filter-date event-filt"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    class: {
      'inactive': _vm.filter_date_type == 'all'
    },
    attrs: {
      "placeholder": _vm.$t('message.appointment.filter_date_range_placeholder'),
      "config": {
        mode: 'range'
      },
      "id": "filter-date-range"
    },
    model: {
      value: (_vm.filter_date_range),
      callback: function($$v) {
        _vm.filter_date_range = $$v
      },
      expression: "filter_date_range"
    }
  })], 1)]), _vm._v(" "), _c('div', [(_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_doctor",
      "placeholder": _vm.$t('message.appointment.filter_doctor'),
      "options": _vm.doctor_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "loading": _vm.doctorLoading,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getDoctorsOptions
    },
    model: {
      value: (_vm.filter_by_doctors),
      callback: function($$v) {
        _vm.filter_by_doctors = $$v
      },
      expression: "filter_by_doctors"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.$guser.isDoctor()) ? _c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_clinic",
      "placeholder": _vm.$t('message.appointment.filter_clinic'),
      "options": _vm.clinic_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "loading": _vm.clinicLoading,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getClinicsOptions
    },
    model: {
      value: (_vm.filter_by_clinics),
      callback: function($$v) {
        _vm.filter_by_clinics = $$v
      },
      expression: "filter_by_clinics"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('multiselect', {
    staticClass: "multi-select-form event-filt",
    attrs: {
      "id": "filter_by_status",
      "placeholder": _vm.$t('message.appointment.filter_status'),
      "options": _vm.status_options,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.filter_by_status_list),
      callback: function($$v) {
        _vm.filter_by_status_list = $$v
      },
      expression: "filter_by_status_list"
    }
  })], 1)]), _vm._v(" "), (_vm.show_calendar_view && _vm.calendarLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-5 col-md-2"
  }, [_c('dot-loader', {
    attrs: {
      "loading": _vm.calendarLoading,
      "size": "60px"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_calendar_view),
      expression: "show_calendar_view"
    }],
    staticClass: "scheduler-box"
  }, [(_vm.processEventLoading && !_vm.calendarLoading) ? _c('div', {
    staticClass: "scheduler-indicator-box"
  }, [_c('div', {
    staticClass: "scheduler-indicator"
  }, [_c('dot-loader', {
    attrs: {
      "size": "60px"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "scheduler"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_calendar_view),
      expression: "!show_calendar_view"
    }]
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.show')))]), _vm._v(" " + _vm._s(_vm.paginator.from) + " - " + _vm._s(_vm.paginator.to) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.from')))]), _vm._v(" " + _vm._s(_vm.paginator.total) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.rows')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.prev_page_url && _vm.refreshAppointmentList(_vm.paginator.prev_page_url, _vm.paginator.current_page - 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.prev')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.next_page_url && _vm.refreshAppointmentList(_vm.paginator.next_page_url, _vm.paginator.current_page + 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.next')))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.order')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.patient')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.doctor_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.latest_reminded_time')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.patient_status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('message.appointment.appointment_status')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.display_appointments), function(app) {
    return _c('tr', {
      key: app
    }, [_c('td', [_vm._v(_vm._s(app.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displayAppointmentDate(app.start)) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.displayAppointmentTime(app.start, app.object.duration)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(app.object.firstname) + " " + _vm._s(app.object.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(app.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displayAppointmentDateTime(app.object.latest_reminded_time)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(app.object.patient_status != 'inactive') ? _c('i', {
      staticClass: "fa fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (app.object.patient_status_3hr != 'inactive') ? _c('i', {
      staticClass: "fa fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (app.object.patient_status == 'inactive') ? _c('i', {
      staticClass: "fa fa-minus text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (app.object.patient_status_3hr == 'inactive') ? _c('i', {
      staticClass: "fa fa-minus text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('dropdown', {
      attrs: {
        "text": app.object.status,
        "type": _vm.getDropdownType(app.object.status),
        "disabled": app.object.status == 'cancel'
      }
    }, [(app.object.status !== 'scheduled') ? _c('li', {
      staticClass: "status-change"
    }, [_c('a', {
      staticClass: "text-success",
      on: {
        "click": function($event) {
          _vm.changeStatus(app.id, 'scheduled')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_scheduled')))])]) : _vm._e(), _vm._v(" "), (app.object.status === 'scheduled' && app.object.patient_status === 'inactive') ? _c('li', {
      staticClass: "status-change"
    }, [_c('a', {
      staticClass: "text-success",
      on: {
        "click": function($event) {
          _vm.changeStatus(app.id, 'patient_confirm')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_patient_confirm')))])]) : _vm._e(), _vm._v(" "), (app.object.status === 'scheduled' && app.object.patient_status_3hr === 'inactive') ? _c('li', {
      staticClass: "status-change"
    }, [_c('a', {
      staticClass: "text-success",
      on: {
        "click": function($event) {
          _vm.changeStatus(app.id, 'patient_confirm_3hr')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_patient_confirm_3hr')))])]) : _vm._e(), _vm._v(" "), (app.object.status !== 'pending' && app.object.status !== 'checkin') ? _c('li', {
      staticClass: "status-change"
    }, [_c('a', {
      staticClass: "text-success",
      on: {
        "click": function($event) {
          _vm.changeStatus(app.id, 'checkin')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_checkin')))])]) : _vm._e(), _vm._v(" "), _c('li', {
      staticClass: "status-change"
    }, [_c('a', {
      staticClass: "text-danger",
      on: {
        "click": function($event) {
          _vm.cancelAppointment(app.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_cancel')))])])])], 1), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "btn btn-sm fa fa-edit",
      on: {
        "click": function($event) {
          _vm.editAppointment(app)
        }
      }
    }, [_c('small', [_vm._v(" " + _vm._s(_vm.$t('action_message.edit')))])])])])
  }), _vm._v(" "), (_vm.display_appointments.length === 0 && _vm.appointmentLoaded && !_vm.appointmentLoading) ? _c('tr', [_c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.appointment.no_appointment_with_filter')))])])]) : _vm._e(), _vm._v(" "), (_vm.appointmentLoading) ? _c('tr', [_c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.appointmentLoading),
      expression: "appointmentLoading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])]) : _vm._e()], 2)])]), _vm._v(" "), _c('sweet-modal', {
    ref: "exportCriteriaModel"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', [_vm._v("เลือกวันที่")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 offset-3"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    attrs: {
      "placeholder": _vm.$t('message.appointment.filter_date_range_placeholder'),
      "config": {
        mode: 'range'
      },
      "id": "export_date_range"
    },
    model: {
      value: (_vm.export_date_range),
      callback: function($$v) {
        _vm.export_date_range = $$v
      },
      expression: "export_date_range"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 custom-field-wrap"
  }, [_c('a', {
    staticClass: "custom-field",
    on: {
      "click": function($event) {
        _vm.openedExportFields = !_vm.openedExportFields
      }
    }
  }, [_vm._v("Custom fields")])]), _vm._v(" "), (_vm.openedExportFields) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form', [_vm._l((_vm.exportFields), function(field) {
    return _c('div', {
      key: field.id,
      staticClass: "form-check form-check-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedExportFieldIds),
        expression: "selectedExportFieldIds"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox",
        "id": "inlineCheckboxs1"
      },
      domProps: {
        "value": field.id,
        "checked": Array.isArray(_vm.selectedExportFieldIds) ? _vm._i(_vm.selectedExportFieldIds, field.id) > -1 : (_vm.selectedExportFieldIds)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedExportFieldIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = field.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.selectedExportFieldIds = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedExportFieldIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedExportFieldIds = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-check-label",
      attrs: {
        "for": "inlineCheckbox1"
      }
    }, [_vm._v(_vm._s(field.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasCustomSlot),
      expression: "hasCustomSlot"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "inlineCheckboxs1"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.hasCustomSlot) ? _vm._i(_vm.hasCustomSlot, true) > -1 : (_vm.hasCustomSlot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.hasCustomSlot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.hasCustomSlot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.hasCustomSlot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hasCustomSlot = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "inlineCheckbox1"
    }
  }, [_vm._v("Fixed Slot เวลา (นาที)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slot),
      expression: "slot"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100px",
      "display": "inline-block"
    },
    attrs: {
      "type": "text",
      "id": "หสนะ",
      "placeholder": "เลือก",
      "disabled": !_vm.hasCustomSlot
    },
    domProps: {
      "value": (_vm.slot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.slot = $event.target.value
      }
    }
  })])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": _vm.exportCurrentApponitments
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.ok')))])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "remarkModal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('remark-editor', {
    attrs: {
      "valueRemarks": _vm.templates.remark_templates
    },
    on: {
      "update:valueRemarks": function($event) {
        _vm.templates.remark_templates = $event
      },
      "closeEditor": _vm.closeRemarkModal,
      "submitRemark": _vm.updateRemarks,
      "comment-updated": function($event) {
        _vm.updateComment($event)
      }
    }
  })], 1), _vm._v(" "), _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.editMode) ? _c('h4', [_vm._v(_vm._s(_vm.$t('message.appointment.title_edit')))]) : _c('h4', [_vm._v(_vm._s(_vm.$t('message.appointment.title_add')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 confirm-btn-group"
  }, [(_vm.appointment.status) ? _c('dropdown', {
    staticClass: "confirm-btn-lg",
    attrs: {
      "text": _vm.appointment.status,
      "type": _vm.getDropdownType(_vm.appointment.status),
      "disabled": _vm.appointment.status == 'cancel'
    }
  }, [(_vm.appointment.status !== 'checkin') ? _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-success",
    on: {
      "click": function($event) {
        _vm.appointment.status = 'scheduled'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_scheduled')))])]) : _vm._e(), _vm._v(" "), (_vm.appointment.status !== 'pending' && _vm.appointment.status !== 'checkin') ? _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-success",
    on: {
      "click": function($event) {
        _vm.appointment.status = 'checkin'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_checkin')))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-danger",
    on: {
      "click": function($event) {
        _vm.appointment.status = 'cancel '
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.status_cancel')))])])]) : _vm._e()], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "id": "fp",
      "config": _vm.fpConfig,
      "required": ""
    },
    model: {
      value: (_vm.appointment.appointment_time),
      callback: function($$v) {
        _vm.appointment.appointment_time = $$v
      },
      expression: "appointment.appointment_time"
    }
  }), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "doctor",
      "placeholder": _vm.$t('message.appointment.doctor_placeholder'),
      "options": _vm.doctor_options,
      "loading": _vm.doctorLoading,
      "allow-empty": true,
      "disabled": _vm.appointment.status === 'cancel',
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getDoctorsOptions
    },
    model: {
      value: (_vm.appointment.doctor),
      callback: function($$v) {
        _vm.appointment.doctor = $$v
      },
      expression: "appointment.doctor"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.doctorIdError
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient_type),
      expression: "patient_type"
    }],
    ref: "patient_type_b",
    attrs: {
      "type": "radio",
      "name": "patient_type",
      "value": "exists",
      "disabled": _vm.appointment.status === 'cancel'
    },
    domProps: {
      "checked": _vm._q(_vm.patient_type, "exists")
    },
    on: {
      "__c": function($event) {
        _vm.patient_type = "exists"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.appointment.old_patient')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient_type),
      expression: "patient_type"
    }],
    ref: "patient_type_a",
    attrs: {
      "type": "radio",
      "name": "patient_type",
      "value": "noexists",
      "disabled": _vm.appointment.status === 'cancel'
    },
    domProps: {
      "checked": _vm._q(_vm.patient_type, "noexists")
    },
    on: {
      "__c": function($event) {
        _vm.patient_type = "noexists"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.appointment.new_patient')) + "\n        ")])])]), _vm._v(" "), (_vm.patient_type == "exists") ? _c('div', [_c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "patient",
      "placeholder": _vm.$t('message.appointment.search_patient_placeholder'),
      "options": _vm.patient_list,
      "allow-empty": true,
      "disabled": _vm.appointment.status === 'cancel',
      "loading": _vm.patientLoading,
      "internal-search": false,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getPatients
    },
    model: {
      value: (_vm.selected_patient),
      callback: function($$v) {
        _vm.selected_patient = $$v
      },
      expression: "selected_patient"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "prefix",
      "placeholder": this.$t('message.appointment.prefix_placeholder'),
      "options": _vm.prefix_options,
      "allow-empty": true,
      "disabled": _vm.appointment.status === 'cancel',
      "readonly": _vm.existing_patient,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.prefix),
      callback: function($$v) {
        _vm.appointment.prefix = $$v
      },
      expression: "appointment.prefix"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "readonly": _vm.existing_patient,
      "placeholder": _vm.$t('message.appointment.firstname_placeholder'),
      "required": "",
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.firstname),
      callback: function($$v) {
        _vm.appointment.firstname = $$v
      },
      expression: "appointment.firstname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.firstnameError
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "readonly": _vm.existing_patient,
      "placeholder": _vm.$t('message.appointment.lastname_placeholder'),
      "required": "",
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.lastname),
      callback: function($$v) {
        _vm.appointment.lastname = $$v
      },
      expression: "appointment.lastname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.lastnameError
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 phone-box"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "phone",
      "readonly": _vm.existing_patient,
      "disabled": _vm.appointment.status === 'cancel'
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.phoneError
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "type": "email",
      "readonly": _vm.existing_patient,
      "placeholder": _vm.$t('message.appointment.email_placeholder'),
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.email),
      callback: function($$v) {
        _vm.appointment.email = $$v
      },
      expression: "appointment.email"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.emailError
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('bs-input', {
    attrs: {
      "readonly": _vm.existing_patient,
      "placeholder": _vm.$t('message.appointment.hn'),
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.hn),
      callback: function($$v) {
        _vm.appointment.hn = $$v
      },
      expression: "appointment.hn"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "locale",
      "placeholder": _vm.$t('message.appointment.locale_placeholder'),
      "options": _vm.locale_options,
      "allow-empty": false,
      "disabled": _vm.appointment.status === 'cancel',
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.locale),
      callback: function($$v) {
        _vm.appointment.locale = $$v
      },
      expression: "appointment.locale"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "service",
      "placeholder": _vm.$t('message.appointment.service_placeholder'),
      "options": _vm.service_options,
      "allow-empty": true,
      "disabled": _vm.appointment.status === 'cancel',
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "select": _vm.changeAppointmentService
    },
    model: {
      value: (_vm.appointment.service),
      callback: function($$v) {
        _vm.appointment.service = $$v
      },
      expression: "appointment.service"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('bs-input', {
    staticClass: "input-min",
    attrs: {
      "type": "Number",
      "min": "10",
      "max": "1440",
      "step": 5,
      "placeholder": _vm.$t('message.appointment.duration_placeholder'),
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.duration),
      callback: function($$v) {
        _vm.appointment.duration = _vm._n($$v)
      },
      expression: "appointment.duration"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.appointment.duration_unit')))])])])], 1)]), _vm._v(" "), (_vm.appointment.comment) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.addition')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.appointment.comment))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_vm._l((_vm.templates.remark_templates), function(rt) {
    return _c('button', {
      key: rt.name,
      staticClass: "btn btn-secondary btn-sm btn-remark-template",
      attrs: {
        "type": "button",
        "disabled": _vm.appointment.status === 'cancel'
      },
      on: {
        "click": function($event) {
          _vm.appendRemark(rt.text)
        }
      }
    }, [_vm._v(_vm._s(rt.name))])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm btn-success",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openRemarkEditor($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])], 2), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "placeholder": ("" + (_vm.$t('message.appointment.remark_placeholder'))),
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.remark),
      callback: function($$v) {
        _vm.appointment.remark = $$v
      },
      expression: "appointment.remark"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('bs-input', {
    attrs: {
      "type": "textarea",
      "placeholder": ("" + (_vm.$t('message.appointment.admin_remark'))),
      "disabled": _vm.appointment.status === 'cancel'
    },
    model: {
      value: (_vm.appointment.admin_note),
      callback: function($$v) {
        _vm.appointment.admin_note = $$v
      },
      expression: "appointment.admin_note"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.sms_feedback_to_patient),
      expression: "appointment.sms_feedback_to_patient"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.appointment.sms_feedback_to_patient) ? _vm._i(_vm.appointment.sms_feedback_to_patient, null) > -1 : (_vm.appointment.sms_feedback_to_patient)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.appointment.sms_feedback_to_patient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.appointment.sms_feedback_to_patient = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.appointment.sms_feedback_to_patient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appointment.sms_feedback_to_patient = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("ส่ง Sms ถาม Feedback หลังมารักษา")])])])]), _vm._v(" "), (_vm.appointment.status) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewAppointmentDetail(_vm.appointment.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.view_more')))])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": _vm.closeAppointmentModal
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.close')))]), _vm._v(" "), (_vm.appointment.status !== 'cancel') ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.saveAppointment($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.editMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.save')))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1), _vm._v(" "), (_vm.editMode && _vm.appointment.status !== 'cancel') ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-action",
    on: {
      "click": function($event) {
        _vm.cancelAppointment(_vm.appointment.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.appointment.cancel_appointment')))]) : _vm._e()])])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "dateModal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('div', {
    staticClass: "date-form"
  }, [_c('label', [_vm._v("Select a date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.dateConfig,
      "placeholder": "Select date",
      "name": "date"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "title": "Toggle",
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }, [_c('span', {
    staticClass: "sr-only",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Toggle")])])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.gotoDate($event)
      }
    }
  }, [_vm._v("Ok")])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "smsConfirmModalForCalendar",
    staticClass: "sms-confirm-modal",
    attrs: {
      "icon": "info",
      "title": "ยืนยันการเปลี่ยนแปลงนัดหมาย?"
    },
    on: {
      "close": function($event) {
        _vm.cancelUpdateAppointmentTime()
      }
    }
  }, [_vm._v("\n    คุณแน่ใจว่าต้องการเปลี่ยนแปลงนัดหมาย?\n    "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateReq.sms_confirmation),
      expression: "updateReq.sms_confirmation"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "defaultCheck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.updateReq.sms_confirmation) ? _vm._i(_vm.updateReq.sms_confirmation, "") > -1 : (_vm.updateReq.sms_confirmation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.updateReq.sms_confirmation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.updateReq.sms_confirmation = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.updateReq.sms_confirmation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.updateReq.sms_confirmation = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "defaultCheck1"
    }
  }, [_vm._v("\n        ส่ง SMS ยืนยันไปที่คนไข้\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.updateAppointmentTime(_vm.updateReq, true)
      }
    },
    slot: "button"
  }, [_vm._v("ยืนยัน")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.$refs.smsConfirmModalForCalendar.close()
      }
    },
    slot: "button"
  }, [_vm._v("ยกเลิก")])]), _vm._v(" "), _c('sweet-modal', {
    ref: "smsConfirmModalForFormChange",
    staticClass: "sms-confirm-modal",
    attrs: {
      "icon": "info",
      "title": "ยืนยันการเปลี่ยนแปลงนัดหมาย?"
    }
  }, [_vm._v("\n    คุณแน่ใจว่าต้องการเปลี่ยนแปลงนัดหมาย?\n    "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updateReq.sms_confirmation),
      expression: "updateReq.sms_confirmation"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "defaultCheck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.updateReq.sms_confirmation) ? _vm._i(_vm.updateReq.sms_confirmation, "") > -1 : (_vm.updateReq.sms_confirmation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.updateReq.sms_confirmation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.updateReq.sms_confirmation = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.updateReq.sms_confirmation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.updateReq.sms_confirmation = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "defaultCheck1"
    }
  }, [_vm._v("\n        ส่ง SMS ยืนยันไปที่คนไข้\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.confirmAppointmentFormChange(_vm.updateReq)
      }
    },
    slot: "button"
  }, [_vm._v("ยืนยัน")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.$refs.smsConfirmModalForFormChange.close()
      }
    },
    slot: "button"
  }, [_vm._v("ยกเลิก")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.displayNavbar) ? _c('header', {
    staticClass: "app-header navbar"
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container plan-payment-confirmation"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('step', {
    attrs: {
      "currentStep": 3,
      "maxStep": 3
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v("กรอกรายละเอียด")]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v("การชำระเงิน")]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v("ยืนยัน")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v("ยืนยัน")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.selectedPlan.name) + " ")]), _vm._v(" "), _c('br'), _vm._v(" \n                    " + _vm._s(_vm.selectedPlan.detail) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedPlan.duration))]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price)))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("ค่าธรรมเนียม (3.8%)")]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.creditCardFee)))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("รวมทั้งหมด")]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price + _vm.creditCardFee)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {}, [_c('p', [_vm._v(_vm._s(_vm.creditCardDetail.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$guser.user.email))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$guser.user.patient.phone))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.creditCardDetail.city))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.creditCardDetail.postal_code))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row payment-footer"
  }, [_c('div', {
    staticClass: "col-6 form-group text-left"
  }, [_c('router-link', {
    staticClass: "btn btn-link btn-lg",
    attrs: {
      "to": _vm.backLink + _vm.addAppParams
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('action_message.back')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 form-group text-right"
  }, [_c('button', {
    staticClass: "btn btn-store btn-lg",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.confirm
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin fa-fw"
  }) : _vm._e(), _vm._v(" ยืนยัน "), _c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "doneModal",
    attrs: {
      "icon": "success",
      "title": "Done",
      "overlay-theme": "dark"
    },
    on: {
      "close": function($event) {
        _vm.goToSuccessPage()
      }
    }
  }, [_vm._v("\n    You have been subscribed to Zeekdoc\n    "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": function($event) {
        _vm.closeDoneModal()
      }
    },
    slot: "button"
  }, [_vm._v("Ok")])]), _vm._v(" "), _c('sweet-modal', {
    ref: "errorModal",
    attrs: {
      "icon": "error",
      "title": "Something went wrong",
      "overlay-theme": "dark"
    }
  }, [_vm._v("\n    Something went wrong with your payment, please contact admin (027156633)\n    "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": function($event) {
        _vm.closeErrorModal()
      }
    },
    slot: "button"
  }, [_vm._v("Ok")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("สมัครแพลนการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Detail")]), _vm._v(" "), _c('th', [_vm._v("ระยะเวลา")]), _vm._v(" "), _c('th', [_vm._v("ราคา")])])])
}]}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container plan-payment"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('step', {
    attrs: {
      "currentStep": 2,
      "maxStep": 3
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v("กรอกรายละเอียด")]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v("การชำระเงิน")]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v("ยืนยัน")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v("วิธีการชำระเงิน")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 payment-creditcard"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditCardDetail.number),
      expression: "creditCardDetail.number"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:16'),
      expression: "'required|digits:16'"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.errors.has('ccnumber')
    },
    attrs: {
      "type": "text",
      "id": "ccnumber",
      "placeholder": "4242 4242 4242 4242",
      "maxlength": "16",
      "name": "ccnumber"
    },
    domProps: {
      "value": (_vm.creditCardDetail.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.creditCardDetail.number = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-4"
  }, [_c('label', {
    attrs: {
      "for": "ccmonth"
    }
  }, [_vm._v("Month")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditCardDetail.expiration_month),
      expression: "creditCardDetail.expiration_month"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.errors.has('ccmonth')
    },
    attrs: {
      "id": "ccmonth",
      "name": "ccmonth"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.creditCardDetail.expiration_month = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("11")]), _vm._v(" "), _c('option', [_vm._v("12")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-4"
  }, [_c('label', {
    attrs: {
      "for": "ccyear"
    }
  }, [_vm._v("Year")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditCardDetail.expiration_year),
      expression: "creditCardDetail.expiration_year"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.errors.has('ccyear')
    },
    attrs: {
      "id": "ccyear",
      "name": "ccyear"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.creditCardDetail.expiration_year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('option', [_vm._v(_vm._s(year))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cvv"
    }
  }, [_vm._v("CVV/CVC")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditCardDetail.security_code),
      expression: "creditCardDetail.security_code"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:3'),
      expression: "'required|digits:3'"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.errors.has('cvv')
    },
    attrs: {
      "type": "text",
      "id": "cvv",
      "placeholder": "123",
      "maxlength": "3",
      "name": "cvv"
    },
    domProps: {
      "value": (_vm.creditCardDetail.security_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.creditCardDetail.security_code = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditCardDetail.name),
      expression: "creditCardDetail.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.errors.has('name')
    },
    attrs: {
      "type": "text",
      "id": "fullname",
      "placeholder": "Fullname",
      "name": "name"
    },
    domProps: {
      "value": (_vm.creditCardDetail.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.creditCardDetail.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-8"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditCardDetail.city),
      expression: "creditCardDetail.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.errors.has('city')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter your city",
      "name": "city"
    },
    domProps: {
      "value": (_vm.creditCardDetail.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.creditCardDetail.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "postal-code"
    }
  }, [_vm._v("Postal Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditCardDetail.postal_code),
      expression: "creditCardDetail.postal_code"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.errors.has('postalCode')
    },
    attrs: {
      "type": "text",
      "placeholder": "Postal Code",
      "name": "postalCode"
    },
    domProps: {
      "value": (_vm.creditCardDetail.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.creditCardDetail.postal_code = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row payment-footer"
  }, [_c('div', {
    staticClass: "col-4 form-group text-left"
  }, [_c('router-link', {
    staticClass: "btn btn-link btn-lg",
    attrs: {
      "to": _vm.backLink + _vm.addAppParams
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('action_message.back')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4 text-center"
  }, [_c('div', {
    staticClass: "total-price-box"
  }, [_c('p', {
    staticClass: "total-price-title"
  }, [_vm._v("ยอดรวม")]), _vm._v(" "), _c('p', {
    staticClass: "total-price-amount"
  }, [_c('strong', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price + _vm.creditCardFee)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 form-group text-right"
  }, [_c('button', {
    staticClass: "btn btn-store btn-lg",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.submitAndNext()
      }
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin fa-fw"
  }) : _vm._e(), _vm._v(" ต่อไป "), _c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "errorModal",
    attrs: {
      "icon": "error",
      "title": "Please check payment detail",
      "overlay-theme": "dark"
    }
  }, [_vm._v("\n    Please check your payment detail\n    "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    },
    slot: "button"
  }, [_vm._v("Ok")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("สมัครแพลนการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "ccnumber"
    }
  }, [_vm._v("Credit Card Number "), _c('i', {
    staticClass: "fa fa-credit-card",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-right payment-gateway"
  }, [_c('span', [_vm._v("Supported by ")]), _c('img', {
    attrs: {
      "src": "/static/img/plans/omise.svg"
    }
  })])])
}]}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container plan-payment"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('step', {
    attrs: {
      "currentStep": 1,
      "maxStep": 3
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v("กรอกรายละเอียด")]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v("การชำระเงิน")]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v("ยืนยัน")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v("รายละเอียดบริการ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.selectedPlan.name) + " ")]), _vm._v(" "), _c('br'), _vm._v(" \n                    " + _vm._s(_vm.selectedPlan.detail) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedPlan.duration))]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price)))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("ค่าธรรมเนียม (3.8%)")]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.creditCardFee)))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("รวมทั้งหมด")]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price + _vm.creditCardFee)))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 form-group text-left"
  }, [_c('router-link', {
    staticClass: "btn btn-link btn-lg",
    attrs: {
      "to": '/package'
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('action_message.back')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 form-group text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-store btn-lg",
    attrs: {
      "to": _vm.step2Link + _vm.addAppParams
    }
  }, [_vm._v("ต่อไป "), _c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("สมัครแพลนการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('h6')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Detail")]), _vm._v(" "), _c('th', [_vm._v("ระยะเวลา")]), _vm._v(" "), _c('th', [_vm._v("ราคา")])])])
}]}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.dataset.length > 0) ? _c('table', {
    staticClass: "table table-bordered doctor-education"
  }, [_c('tbody', _vm._l((_vm.dataset), function(d, index) {
    return _c('tr', {
      key: index
    }, [(index != _vm.editIndex) ? _c('td', [_c('div', {
      staticClass: "doctor-education-element"
    }, [_c('i', {
      staticClass: "fa fa-graduation-cap",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(d))])])]) : _vm._e(), _vm._v(" "), (index != _vm.editIndex) ? _c('td', {
      staticClass: "edit-element"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      on: {
        "click": function($event) {
          _vm.editData(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (index == _vm.editIndex) ? _c('td', [_c('div', {
      staticClass: "doctor-education-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dataset[index]),
        expression: "dataset[index]"
      }],
      ref: "editData",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.dataset[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.dataset,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.dataset[index] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "confirm"
    }, [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.saveData(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('action_message.ok')))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.removeData(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))])])])]) : _vm._e(), _vm._v(" "), (index == _vm.editIndex) ? _c('td', {
      staticClass: "edit-element"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]) : _vm._e()])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "doctor-education-add clearfix"
  }, [_c('span', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add-edu",
    on: {
      "click": _vm.addData
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('action_message.add')))])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "doctor-eduication-ex"
  })])
}]}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [(_vm.$route.query.action === 'edit') ? _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_edit')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_new')))]), _vm._v(" "), _c('step', {
    attrs: {
      "currentStep": 1,
      "maxStep": 5
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.personal_info')))]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.experience')))]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.schedules')))]), _vm._v(" "), _c('div', {
    slot: "4"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.education')))]), _vm._v(" "), _c('div', {
    slot: "5"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.other_info')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.personal_info')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_general.name_th')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "prefix-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.prefix')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_th.prefix),
      expression: "doctor_profile_th.prefix"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "prfix-th",
      "placeholder": _vm.$t('message.doctor_general.prefix_placeholder_th')
    },
    domProps: {
      "value": (_vm.doctor_profile_th.prefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_th.prefix = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "firstname-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.firstname')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_th.firstname),
      expression: "doctor_profile_th.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "firstname-th",
      "placeholder": _vm.$t('message.doctor_general.firstname')
    },
    domProps: {
      "value": (_vm.doctor_profile_th.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_th.firstname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "lastname-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.lastname')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_th.lastname),
      expression: "doctor_profile_th.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "lastname-th",
      "placeholder": _vm.$t('message.doctor_general.lastname')
    },
    domProps: {
      "value": (_vm.doctor_profile_th.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_th.lastname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_general.name_en')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "prefix-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.prefix')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_en.prefix),
      expression: "doctor_profile_en.prefix"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "prefix-en",
      "placeholder": _vm.$t('message.doctor_general.prefix_placeholder_en')
    },
    domProps: {
      "value": (_vm.doctor_profile_en.prefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_en.prefix = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "firstname-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.firstname')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_en.firstname),
      expression: "doctor_profile_en.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "firstname-en",
      "placeholder": _vm.$t('message.doctor_general.firstname')
    },
    domProps: {
      "value": (_vm.doctor_profile_en.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_en.firstname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "lastname-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.lastname')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_en.lastname),
      expression: "doctor_profile_en.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "lastname-en",
      "placeholder": _vm.$t('message.doctor_general.lastname')
    },
    domProps: {
      "value": (_vm.doctor_profile_en.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_en.lastname = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_general.gender')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "gender-select"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.gender),
      expression: "doctor.gender"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio1",
      "value": "m"
    },
    domProps: {
      "checked": _vm._q(_vm.doctor.gender, "m")
    },
    on: {
      "__c": function($event) {
        _vm.doctor.gender = "m"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-male fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.doctor_general.male')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.gender),
      expression: "doctor.gender"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio2",
      "value": "f"
    },
    domProps: {
      "checked": _vm._q(_vm.doctor.gender, "f")
    },
    on: {
      "__c": function($event) {
        _vm.doctor.gender = "f"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-female fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.doctor_general.female')) + "\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_general.image')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('drop-zone', {
    staticClass: "crop-profile-image-dropzone",
    class: {
      'profile-image-active': _vm.isProfileImage
    },
    attrs: {
      "placeholder": _vm.profileImagePlaceholder
    },
    on: {
      "fileChange": _vm.profileImageFileChange
    }
  }), _vm._v(" "), _c('img', {
    ref: "crop-profile-image",
    staticClass: "crop-profile-image",
    attrs: {
      "src": _vm.profile_image_src
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_general.albums')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    attrs: {
      "id": "alblum-wrapper"
    }
  }, [_vm._l((_vm.doctor.images), function(img) {
    return (!img.is_active) ? _c('div', {
      key: img.id,
      staticClass: "image-in-alblum-wrapper"
    }, [_c('i', {
      staticClass: "fa fa-2x fa-times remove-image-from-alblum",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.removeImageFromAlblum(img.id)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "image-in-alblum",
      attrs: {
        "src": img.file_thumb
      }
    })]) : _vm._e()
  }), _vm._v(" "), _c('vue-core-image-upload', {
    class: ['btn', 'btn-primary', 'btn-upload-image'],
    attrs: {
      "crop": false,
      "max-file-size": 5242880,
      "input-of-file": "image",
      "url": _vm.profile_upload_album
    },
    on: {
      "imageuploaded": _vm.imageAlblumUploaded
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-plus plus-image",
    attrs: {
      "title": "remove image",
      "aria-hidden": "true"
    }
  })])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg"
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), (_vm.$route.query.action === 'edit') ? _c('button', {
    staticClass: "btn btn-delete btn-right btn-lg",
    on: {
      "click": _vm.deleteDoctor
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "crop-modal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-croppie', {
    ref: "croppieRef",
    attrs: {
      "enableOrientation": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelCrop($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.confirmCrop($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.ok')))])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_address.title')))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_address.address')))]), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.clinic_address.address_th'),
      "placeholder": _vm.$t('message.clinic_address.address_th')
    },
    model: {
      value: (_vm.clinic.th.b_addr),
      callback: function($$v) {
        _vm.clinic.th.b_addr = $$v
      },
      expression: "clinic.th.b_addr"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.clinic_address.address_en'),
      "placeholder": _vm.$t('message.clinic_address.address_en')
    },
    model: {
      value: (_vm.clinic.en.b_addr),
      callback: function($$v) {
        _vm.clinic.en.b_addr = $$v
      },
      expression: "clinic.en.b_addr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "provice"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_address.province')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "provice",
      "placeholder": _vm.$t('message.clinic_address.province'),
      "options": _vm.refProvinces,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selectedProvince),
      callback: function($$v) {
        _vm.selectedProvince = $$v
      },
      expression: "selectedProvince"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "district"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_address.district')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "district",
      "placeholder": _vm.$t('message.clinic_address.district'),
      "options": _vm.refDistricts,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selectedDistrict),
      callback: function($$v) {
        _vm.selectedDistrict = $$v
      },
      expression: "selectedDistrict"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_address.insurances')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "insurances",
      "placeholder": _vm.$t('message.clinic_address.insurances'),
      "options": _vm.allInsurances,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.selectedInsurance),
      callback: function($$v) {
        _vm.selectedInsurance = $$v
      },
      expression: "selectedInsurance"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_address.contact_info')))]), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.clinic_address.email'),
      "placeholder": _vm.$t('message.clinic_address.email')
    },
    model: {
      value: (_vm.clinic.clinic_email),
      callback: function($$v) {
        _vm.clinic.clinic_email = $$v
      },
      expression: "clinic.clinic_email"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.clinic_address.website'),
      "placeholder": _vm.$t('message.clinic_address.website')
    },
    model: {
      value: (_vm.clinic.website),
      callback: function($$v) {
        _vm.clinic.website = $$v
      },
      expression: "clinic.website"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.clinic_address.facebook'),
      "placeholder": _vm.$t('message.clinic_address.facebook')
    },
    model: {
      value: (_vm.clinic.facebook),
      callback: function($$v) {
        _vm.clinic.facebook = $$v
      },
      expression: "clinic.facebook"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_address.clinic_map')))]), _vm._v(" "), _c('gmap-autocomplete', {
    staticClass: "place-input form-control",
    attrs: {
      "placeholder": _vm.$t('message.clinic_address.nearby_search'),
      "select-first-on-enter": true
    },
    on: {
      "place_changed": function($event) {
        _vm.updatePlace($event)
      }
    }
  }), _vm._v(" "), _c('google-map', {
    attrs: {
      "center": _vm.mapCenter,
      "map-type-id": "terrain",
      "zoom": 15
    },
    on: {
      "update:center": function($event) {
        _vm.mapCenter = $event
      }
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.markPosition,
      "clickable": true,
      "draggable": true
    },
    on: {
      "update:position": function($event) {
        _vm.markPosition = $event
      },
      "dragend": _vm.setPosition
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _vm._t("loader")], 2)])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.selectedPriceList), function(price) {
    return _c('div', {
      key: price.name,
      staticClass: "col-sm-4",
      class: {
        'margin-top-20': _vm.$route.query.app
      }
    }, [_c('div', {
      staticClass: "pricing"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n              " + _vm._s(price.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "thumbnail"
    }, [_c('div', {
      staticClass: "thumbnail icon"
    }, [_c('img', {
      attrs: {
        "src": price.image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "sub-title"
    }, [_vm._v("\n                " + _vm._s(price.price) + "\n                "), _c('span', [_vm._v(_vm._s(price.subPrice))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(price.priceDetail)
      }
    })]), _vm._v(" "), _c('ul', _vm._l((price.features), function(feature) {
      return _c('li', {
        key: feature.name
      }, [_c('div', {
        class: {
          'fa': true, 'fa-check': feature.checked, 'fa-close': !feature.checked
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(feature.name)
        }
      })])
    })), _vm._v(" "), _c('router-link', {
      staticClass: "sign-up-btn",
      attrs: {
        "to": price.link + _vm.addAppParams
      }
    }, [_vm._v("\n                สมัคร\n              ")])], 1)])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("เลือก Plan ของคุณ")])])
}]}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("89.9%")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs my-3"
  }, [_c('div', {
    staticClass: "progress-bar bg-success",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("12.124")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs my-3"
  }, [_c('div', {
    staticClass: "progress-bar bg-info",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("$98.111,00")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs my-3"
  }, [_c('div', {
    staticClass: "progress-bar bg-warning",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("2 TB")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs my-3"
  }, [_c('div', {
    staticClass: "progress-bar bg-danger",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-primary"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("89.9%")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-white progress-xs my-3"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-warning"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("12.124")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-white progress-xs my-3"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("$98.111,00")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-white progress-xs my-3"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-info"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h4 m-0"
  }, [_vm._v("2 TB")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum...")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-white progress-xs my-3"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet enim.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-primary mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-laptop bg-info p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-info mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-moon-o bg-warning p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-warning mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-bell bg-danger p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-danger mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-primary mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer px-3 py-2"
  }, [_c('a', {
    staticClass: "font-weight-bold font-xs btn-block text-muted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View More "), _c('i', {
    staticClass: "fa fa-angle-right float-right font-lg"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-laptop bg-info p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-info mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer px-3 py-2"
  }, [_c('a', {
    staticClass: "font-weight-bold font-xs btn-block text-muted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View More "), _c('i', {
    staticClass: "fa fa-angle-right float-right font-lg"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-moon-o bg-warning p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-warning mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer px-3 py-2"
  }, [_c('a', {
    staticClass: "font-weight-bold font-xs btn-block text-muted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View More "), _c('i', {
    staticClass: "fa fa-angle-right float-right font-lg"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-3 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-bell bg-danger p-3 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-danger mb-0 mt-2"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer px-3 py-2"
  }, [_c('a', {
    staticClass: "font-weight-bold font-xs btn-block text-muted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View More "), _c('i', {
    staticClass: "fa fa-angle-right float-right font-lg"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-cogs bg-primary p-4 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-primary mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-laptop bg-info p-4 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-info mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-moon-o bg-warning p-4 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-warning mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-bell bg-danger p-4 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-danger mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-cogs bg-primary p-4 px-5 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-primary mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-laptop bg-info p-4 px-5 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-info mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-moon-o bg-warning p-4 px-5 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-warning mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block p-0 clearfix"
  }, [_c('i', {
    staticClass: "fa fa-bell bg-danger p-4 px-5 font-2xl mr-3 float-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "h5 text-danger mb-0 pt-3"
  }, [_vm._v("$1.999,50")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("Income")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "social-box facebook"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("89k")]), _vm._v(" "), _c('span', [_vm._v("friends")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("459")]), _vm._v(" "), _c('span', [_vm._v("feeds")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "social-box twitter"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("973k")]), _vm._v(" "), _c('span', [_vm._v("followers")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("1.792")]), _vm._v(" "), _c('span', [_vm._v("tweets")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "social-box linkedin"
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("500+")]), _vm._v(" "), _c('span', [_vm._v("contacts")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("292")]), _vm._v(" "), _c('span', [_vm._v("feeds")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "social-box google-plus"
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("894")]), _vm._v(" "), _c('span', [_vm._v("followers")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("92")]), _vm._v(" "), _c('span', [_vm._v("circles")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-group"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-people"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("87.500")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Visitors")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs mt-3 mb-0"
  }, [_c('div', {
    staticClass: "progress-bar bg-info",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-user-follow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("385")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("New Clients")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs mt-3 mb-0"
  }, [_c('div', {
    staticClass: "progress-bar bg-success",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-basket-loaded"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("1238")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Products sold")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs mt-3 mb-0"
  }, [_c('div', {
    staticClass: "progress-bar bg-warning",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-pie-chart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("28%")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Returning Visitors")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs mt-3 mb-0"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-speedometer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("5:34:11")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Avg. Time")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs mt-3 mb-0"
  }, [_c('div', {
    staticClass: "progress-bar bg-danger",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-people"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("87.500")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Visitors")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs mt-3 mb-0"
  }, [_c('div', {
    staticClass: "progress-bar bg-info",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-user-follow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("385")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("New Clients")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs mt-3 mb-0"
  }, [_c('div', {
    staticClass: "progress-bar bg-success",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-basket-loaded"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("1238")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Products sold")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs mt-3 mb-0"
  }, [_c('div', {
    staticClass: "progress-bar bg-warning",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-pie-chart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("28%")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Returning Visitors")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs mt-3 mb-0"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-speedometer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("5:34:11")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Avg. Time")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs mt-3 mb-0"
  }, [_c('div', {
    staticClass: "progress-bar bg-danger",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-speech"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("972")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs mt-3 mb-0"
  }, [_c('div', {
    staticClass: "progress-bar bg-info",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card card-inverse card-info"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-people"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("87.500")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Visitors")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-white progress-xs mt-3"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card card-inverse card-success"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-user-follow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("385")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("New Clients")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-white progress-xs mt-3"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card card-inverse card-warning"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-basket-loaded"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("1238")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Products sold")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-white progress-xs mt-3"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card card-inverse card-primary"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-pie-chart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("28%")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Returning Visitors")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-white progress-xs mt-3"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-speedometer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("5:34:11")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Avg. Time")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-white progress-xs mt-3"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-2"
  }, [_c('div', {
    staticClass: "card card-inverse card-info"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-right mb-4"
  }, [_c('i', {
    staticClass: "icon-speech"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h4 mb-0"
  }, [_vm._v("972")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-white progress-xs mt-3"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])])])])
}]}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body clinic-leave-wrapper"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.leave.title')))]), _vm._v(" "), _c('button', {
    staticClass: "add-leave btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.newLeave($event)
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('action_message.add')))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group toggle_view_group",
    attrs: {
      "role": "group",
      "aria-label": ""
    }
  }, [(!_vm.showCalendar) ? _c('button', {
    staticClass: "btn btn-sq-border",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCalendarView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" " + _vm._s(_vm.$t('message.leave.calendar')))]) : _vm._e(), _vm._v(" "), (_vm.showCalendar) ? _c('button', {
    staticClass: "btn btn-sq-border",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showListView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" " + _vm._s(_vm.$t('message.leave.list')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('bs-input', {
    attrs: {
      "placeholder": _vm.$t('message.leave.search_doctor')
    },
    model: {
      value: (_vm.doctorSearchQ),
      callback: function($$v) {
        _vm.doctorSearchQ = $$v
      },
      expression: "doctorSearchQ"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showCalendar),
      expression: "!showCalendar"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(!_vm.$ismobile()) ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', {
    attrs: {
      "width": "100%"
    }
  }, [(_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.leave.date')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.leave.name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.leave.remark')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "10%"
    }
  })]) : _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.leave.date')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.leave.remark')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "10%"
    }
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.displayLeaveList.data), function(leave) {
    return _c('tr', {
      key: leave.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [(leave.all_day) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm._f("formatDateFull")(leave.start_time)))]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateFull")(leave.end_time)))])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm._f("formatDateTimeFull")(leave.start_time)))]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateTimeFull")(leave.end_time)))])])]), _vm._v(" "), (_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('td', [_c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openDoctor(leave.doctor_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.getDoctorName(leave)))])]), _vm._v(" "), _c('small', {
      staticClass: "text-one-ellipsis"
    }, [_vm._v(_vm._s(_vm.getDoctorSpecialty(leave)))])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-justify"
    }, [_c('span', [_vm._v(_vm._s(_vm.viewContent(leave.description, !leave.showMoreContent)))]), _vm._v(" "), (leave.moreContentEnable) ? _c('a', {
      staticClass: "view-more-btn",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleMoreContent(leave)
        }
      }
    }, [_vm._v(_vm._s(leave.showMoreContent ? _vm.$t('action_message.close') : _vm.$t('action_message.more')))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      on: {
        "click": function($event) {
          _vm.editLeave(leave)
        }
      }
    }, [_c('small', [_vm._v(" " + _vm._s(_vm.$t('action_message.edit')))])])])])])
  }), _vm._v(" "), (_vm.loaded && _vm.displayLeaveList.data.length === 0) ? _c('tr', [_c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.leave.no_leave')))])])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('tr', [_c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])]) : _vm._e()], 2)])]) : _c('div', [_c('div', {
    staticClass: "leave-list-container"
  }, _vm._l((_vm.displayLeaveList.data), function(leave) {
    return _c('div', {
      key: leave.id,
      staticClass: "card leave-list-content"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('div', {
      staticClass: "row"
    }, [(leave.all_day) ? _c('span', {
      staticClass: "col-12 app-id"
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.leave.date')) + ": " + _vm._s(_vm._f("formatDateFull")(leave.start_time)) + " - " + _vm._s(_vm._f("formatDateFull")(leave.end_time)) + "\n                  ")]) : _c('span', {
      staticClass: "col-12 app-id"
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.leave.date')) + ": " + _vm._s(_vm._f("formatDateTimeFull")(leave.start_time)) + " - " + _vm._s(_vm._f("formatDateTimeFull")(leave.end_time)) + "\n                  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('h5', {
      staticClass: "app-doctor"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openDoctor(leave.doctor_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.getDoctorName(leave)))])]), _vm._v(" "), _c('span', {
      staticClass: "app-remark"
    }, [_vm._v(_vm._s(_vm.viewContent(leave.description, !leave.showMoreContent)))]), _vm._v(" "), (leave.moreContentEnable) ? _c('a', {
      staticClass: "view-more-btn",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleMoreContent(leave)
        }
      }
    }, [_vm._v(_vm._s(leave.showMoreContent ? _vm.$t('action_message.close') : _vm.$t('action_message.more')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.editLeave(leave)
        }
      }
    }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('action_message.edit')))])])])])])
  })), _vm._v(" "), (_vm.loaded && _vm.displayLeaveList.data.length === 0) ? _c('h6', {
    staticClass: "text-center alert alert-warning"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.leave.no_leave')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCalendar),
      expression: "showCalendar"
    }],
    staticClass: "row"
  }, [_vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    attrs: {
      "id": "leaveCalendar"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
}]}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card mx-4"
  }, [_c('div', {
    staticClass: "card-block p-4"
  }, [_c('h1', [_vm._v("Register")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Create your account")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("@")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-4"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Repeat password"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Create Account")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer p-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-facebook",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("facebook")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-twitter",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("twitter")])])])])])])])])])])
}]}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          3d Switch\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-3d switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-3d switch-secondary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-3d switch-success"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-3d switch-warning"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-3d switch-info"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-3d switch-danger"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch default\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-default switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-secondary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-success"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-warning"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-info"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-danger"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch default - pills\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-default switch-pill switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-secondary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-success"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-warning"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-info"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-danger"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch outline\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-default switch-primary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-secondary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-success-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-warning-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-info-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-danger-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch outline - pills\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-default switch-pill switch-primary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-secondary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-success-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-warning-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-info-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-danger-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch outline alternative\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-default switch-primary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-secondary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-success-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-warning-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-info-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-danger-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch outline alternative - pills\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-default switch-pill switch-primary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-secondary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-success-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-warning-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-info-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-danger-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with text\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-text switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-secondary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-success"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-warning"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-info"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-danger"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with text - pills\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-secondary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-warning"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-info"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-danger"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with text outline\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-text switch-primary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-secondary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-success-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-warning-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-info-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-danger-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with text outline - pills\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-primary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-secondary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-success-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-warning-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-info-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-danger-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with text outline alternative\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-text switch-primary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-secondary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-success-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-warning-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-info-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-danger-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with text outline alternative - pills\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-primary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-secondary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-success-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-warning-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-info-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-danger-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with icon\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-icon switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-secondary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-success"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-warning"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-info"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-danger"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with icon - pills\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-icon switch-pill switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-secondary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-success"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-warning"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-info"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-danger"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with icon outline\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-icon switch-primary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-secondary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-success-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-warning-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-info-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-danger-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with icon outline - pills\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-icon switch-pill switch-primary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-secondary-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-success-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-warning-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-info-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-danger-outline"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with icon outline alternative\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-icon switch-primary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-secondary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-success-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-warning-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-info-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-danger-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Switch with icon outline alternative - pills\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('label', {
    staticClass: "switch switch-icon switch-pill switch-primary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-secondary-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-success-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-warning-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-info-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n             \n          "), _c('label', {
    staticClass: "switch switch-icon switch-pill switch-danger-outline-alt"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "&#xf00c",
      "data-off": "&#xf00d"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Sizes\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block p-0"
  }, [_c('table', {
    staticClass: "table table-hover table-striped table-align-middle mb-0"
  }, [_c('thead', [_c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("Example")]), _vm._v(" "), _c('th', [_vm._v("CSS Class")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n                  Large\n                ")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])]), _vm._v(" "), _c('td', [_vm._v("\n                  Add following class "), _c('code', [_vm._v(".switch-lg")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  Normal\n                ")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "switch switch-3d switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])]), _vm._v(" "), _c('td', [_vm._v("\n                  -\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  Small\n                ")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "switch switch-sm switch-3d switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])]), _vm._v(" "), _c('td', [_vm._v("\n                  Add following class "), _c('code', [_vm._v(".switch-sm")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  Extra small\n                ")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "switch switch-xs switch-3d switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])]), _vm._v(" "), _c('td', [_vm._v("\n                  Add following class "), _c('code', [_vm._v(".switch-sm")])])])])])])])])])])
}]}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message) ? _c('div', {
    staticClass: "error-message-text"
  }, [_vm._v(" \n  " + _vm._s(_vm.message) + "\n")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('a', {
    attrs: {
      "href": "https://zeekdoc.com"
    }
  }, [_vm._v("Zeekdoc")]), _vm._v(" © 2017 Zeekdoc Co., Ltd,\n  \n")])
}]}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-wrapper"
  }, [_c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.article.title')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAddPanel),
      expression: "!showAddPanel"
    }],
    staticClass: "add-service btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.enterCreateAritcle($event)
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('action_message.add')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddPanel),
      expression: "showAddPanel"
    }],
    staticClass: "add-service btn btn-info",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddPanel = !_vm.showAddPanel
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.list')))])]), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "article-list-wrapper"
  }, [_c('bs-input', {
    attrs: {
      "placeholder": _vm.$t('message.article.search_article')
    },
    model: {
      value: (_vm.q),
      callback: function($$v) {
        _vm.q = $$v
      },
      expression: "q"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.show')))]), _vm._v(" " + _vm._s(_vm.paginator.from) + " - " + _vm._s(_vm.paginator.to) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.from')))]), _vm._v(" " + _vm._s(_vm.paginator.total) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.rows')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.prev_page_url && _vm.reloadArticle(_vm.paginator.prev_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.prev')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.next_page_url && _vm.reloadArticle(_vm.paginator.next_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.next')))])]), _vm._v(" "), (_vm.filtered_articles.length > 0) ? _c('div', [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.filtered_articles), function(a, index) {
    return _c('div', {
      key: a,
      staticClass: "articles-container"
    }, [_c('div', {
      staticClass: "articles-content"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [(a.writer_image) ? _c('img', {
      staticClass: "writer-image",
      attrs: {
        "src": ""
      }
    }) : _c('div', {
      staticClass: "no-writer-image"
    }, [_c('i', {
      staticClass: "fa fa-user-md fa-2x"
    })]), _vm._v(" "), _c('div', {
      staticClass: "writer-name"
    }, [_vm._v(_vm._s(a.name))]), _vm._v(" "), _c('div', {
      staticClass: "badge",
      class: {
        'badge-default': a.status === 'unpublished', 'badge-success': a.status === 'published'
      }
    }, [_vm._v(_vm._s(a.status))]), _vm._v(" "), _c('div', {
      staticClass: "articles-actions"
    }, [_c('i', {
      staticClass: "btn btn-sm btn-info fa fa-pencil-square-o",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.editArticle(a)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [(a.featured_image) ? _c('div', {
      staticClass: "image-wrapper"
    }, [_c('img', {
      staticClass: "item-image",
      attrs: {
        "src": a.featured_image,
        "alt": "Image"
      }
    })]) : _c('div', {
      staticClass: "no-article-image"
    }, [_c('i', {
      staticClass: "fa fa-file-image-o fa-5x"
    })]), _vm._v(" "), _c('h4', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(a.title))]), _vm._v(" "), _c('h6', {
      staticClass: "card-subtitle mb-2 text-muted"
    }, [_vm._v(_vm._s(a.created_at))])])])])])
  }))], 1) : _c('h6', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.article.no_article')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddPanel),
      expression: "showAddPanel"
    }],
    staticClass: "article-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.article.title_article_add')))]), _vm._v(" "), _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom",
    attrs: {
      "required": "",
      "label": _vm.$t('message.article.name'),
      "placeholder": _vm.$t('message.article.name_placeholder')
    },
    model: {
      value: (_vm.article.title),
      callback: function($$v) {
        _vm.article.title = $$v
      },
      expression: "article.title"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1), _vm._v(" "), _c('div', [_c('ckeditor', {
    attrs: {
      "id": "article-content",
      "config": _vm.ckeditorConfig
    },
    model: {
      value: (_vm.article.content),
      callback: function($$v) {
        _vm.article.content = $$v
      },
      expression: "article.content"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.content
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('message.article.featured_image')))]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "featured-image-group"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-times remove-featured-image",
    class: {
      'remove-featured-image-active': _vm.isFeaturedImage
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.removeFeatureImage
    }
  }), _vm._v(" "), _c('drop-zone', {
    staticClass: "featured-image-dropzone",
    class: {
      'featured-image-active': _vm.isFeaturedImage
    },
    attrs: {
      "placeholder": _vm.featuredImagePlaceholder
    },
    on: {
      "fileChange": _vm.featuredImageFileChange
    }
  }), _vm._v(" "), _c('img', {
    ref: "featured-image-preview",
    staticClass: "featured-image-preview",
    attrs: {
      "src": _vm.featured_image_preview
    }
  })], 1), _vm._v(" "), _c('bs-input', {
    staticClass: "link-image-input",
    attrs: {
      "label": _vm.$t('message.article.or_use_link')
    },
    model: {
      value: (_vm.article.featured_image),
      callback: function($$v) {
        _vm.article.featured_image = $$v
      },
      expression: "article.featured_image"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.article.author')))]), _vm._v(" "), _c('div', {
    staticClass: "written-by-select"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.owner_by_doctor),
      expression: "owner_by_doctor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio1"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.owner_by_doctor, true)
    },
    on: {
      "__c": function($event) {
        _vm.owner_by_doctor = true
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-user-md fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.article.doctor')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.owner_by_doctor),
      expression: "owner_by_doctor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio2"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.owner_by_doctor, false)
    },
    on: {
      "__c": function($event) {
        _vm.owner_by_doctor = false
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-hospital-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.article.clinic')) + "\n                ")])]), _vm._v(" "), (_vm.owner_by_doctor) ? _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "doctor",
      "placeholder": "",
      "options": _vm.doctor_list,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_doctor),
      callback: function($$v) {
        _vm.selected_doctor = $$v
      },
      expression: "selected_doctor"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "status-by-select"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.article.status')))]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.status),
      expression: "article.status"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "inlineRadio1",
      "value": "unpublished"
    },
    domProps: {
      "checked": _vm._q(_vm.article.status, "unpublished")
    },
    on: {
      "__c": function($event) {
        _vm.article.status = "unpublished"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.article.unpublished')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.status),
      expression: "article.status"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "inlineRadio2",
      "value": "published"
    },
    domProps: {
      "checked": _vm._q(_vm.article.status, "published")
    },
    on: {
      "__c": function($event) {
        _vm.article.status = "published"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.article.published')) + "\n                ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.enterListView($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addArticle($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.editMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.add')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-article-action",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeArticle($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container direct-payment"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v("รายละเอียดบริการ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table summary-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.selectedPlan.name) + " ")]), _vm._v(" "), _c('br'), _vm._v(" \n                    " + _vm._s(_vm.selectedPlan.detail) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedPlan.duration))]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price)))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("รวมทั้งหมด")]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price)))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center inform-transfer"
  }, [_c('p', [_vm._v("จำนวนเงิน ฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price)))]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-success"
  }, [_vm._v("แจ้งการชำระแล้วเงินที่ Email: zeekdoc@yahoo.com หรือ โทร 092-462-6633 (ฟ้า)")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("ชำระค่าบริการ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Detail")]), _vm._v(" "), _c('th', [_vm._v("ระยะเวลา")]), _vm._v(" "), _c('th', [_vm._v("ราคา")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('h4', {
    staticClass: "text-center direct-detail-title"
  }, [_vm._v("ชำระค่าบริการโดยการโอนเงินที่บัญชี")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('div', {
    staticClass: "direct-detail"
  }, [_c('img', {
    staticClass: "bank-logo",
    attrs: {
      "src": "/static/img/kbank.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bank-detail"
  }, [_c('p', {
    staticClass: "bank-name"
  }, [_vm._v("ธนาคารกสิกรไทย (K-BANK)")]), _vm._v(" "), _c('p', {
    staticClass: "account-number"
  }, [_vm._v("เลขที่บัญชี: 008-1-22010-7")]), _vm._v(" "), _c('p', {
    staticClass: "account-name"
  }, [_vm._v("ชื่อบัญชี: บจก. ซีคด็อก")])])])])
}]}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sweet-modal-tab', {
      active: _vm.active
    }]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "id": "new"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("20 New Icons in 4.5")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth-b fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth-b\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-codiepie fa-lg mt-4"
  }), _c('br'), _vm._v("codiepie\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-credit-card-alt fa-lg mt-4"
  }), _c('br'), _vm._v("credit-card-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-edge fa-lg mt-4"
  }), _c('br'), _vm._v("edge\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fort-awesome fa-lg mt-4"
  }), _c('br'), _vm._v("fort-awesome\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hashtag fa-lg mt-4"
  }), _c('br'), _vm._v("hashtag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mixcloud fa-lg mt-4"
  }), _c('br'), _vm._v("mixcloud\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-modx fa-lg mt-4"
  }), _c('br'), _vm._v("modx\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pause-circle fa-lg mt-4"
  }), _c('br'), _vm._v("pause-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pause-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("pause-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-percent fa-lg mt-4"
  }), _c('br'), _vm._v("percent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-product-hunt fa-lg mt-4"
  }), _c('br'), _vm._v("product-hunt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reddit-alien fa-lg mt-4"
  }), _c('br'), _vm._v("reddit-alien\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-scribd fa-lg mt-4"
  }), _c('br'), _vm._v("scribd\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag fa-lg mt-4"
  }), _c('br'), _vm._v("shopping-bag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shopping-basket fa-lg mt-4"
  }), _c('br'), _vm._v("shopping-basket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle fa-lg mt-4"
  }), _c('br'), _vm._v("stop-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("stop-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-usb fa-lg mt-4"
  }), _c('br'), _vm._v("usb\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "web-application"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Web Application Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-adjust fa-lg mt-4"
  }), _c('br'), _vm._v("adjust\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-anchor fa-lg mt-4"
  }), _c('br'), _vm._v("anchor\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-archive fa-lg mt-4"
  }), _c('br'), _vm._v("archive\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-area-chart fa-lg mt-4"
  }), _c('br'), _vm._v("area-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows fa-lg mt-4"
  }), _c('br'), _vm._v("arrows\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-h fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-h\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-v fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-v\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-asterisk fa-lg mt-4"
  }), _c('br'), _vm._v("asterisk\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-at fa-lg mt-4"
  }), _c('br'), _vm._v("at\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-automobile fa-lg mt-4"
  }), _c('br'), _vm._v("automobile "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-balance-scale fa-lg mt-4"
  }), _c('br'), _vm._v("balance-scale\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ban fa-lg mt-4"
  }), _c('br'), _vm._v("ban\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bank fa-lg mt-4"
  }), _c('br'), _vm._v("bank "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart fa-lg mt-4"
  }), _c('br'), _vm._v("bar-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o fa-lg mt-4"
  }), _c('br'), _vm._v("bar-chart-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-barcode fa-lg mt-4"
  }), _c('br'), _vm._v("barcode\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bars fa-lg mt-4"
  }), _c('br'), _vm._v("bars\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-0 fa-lg mt-4"
  }), _c('br'), _vm._v("battery-0 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-1 fa-lg mt-4"
  }), _c('br'), _vm._v("battery-1 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-2 fa-lg mt-4"
  }), _c('br'), _vm._v("battery-2 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-3 fa-lg mt-4"
  }), _c('br'), _vm._v("battery-3 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-4 fa-lg mt-4"
  }), _c('br'), _vm._v("battery-4 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-empty fa-lg mt-4"
  }), _c('br'), _vm._v("battery-empty\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-full fa-lg mt-4"
  }), _c('br'), _vm._v("battery-full\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-half fa-lg mt-4"
  }), _c('br'), _vm._v("battery-half\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-quarter fa-lg mt-4"
  }), _c('br'), _vm._v("battery-quarter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-three-quarters fa-lg mt-4"
  }), _c('br'), _vm._v("battery-three-quarters\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bed fa-lg mt-4"
  }), _c('br'), _vm._v("bed\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-beer fa-lg mt-4"
  }), _c('br'), _vm._v("beer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bell fa-lg mt-4"
  }), _c('br'), _vm._v("bell\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bell-o fa-lg mt-4"
  }), _c('br'), _vm._v("bell-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bell-slash fa-lg mt-4"
  }), _c('br'), _vm._v("bell-slash\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bell-slash-o fa-lg mt-4"
  }), _c('br'), _vm._v("bell-slash-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bicycle fa-lg mt-4"
  }), _c('br'), _vm._v("bicycle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-binoculars fa-lg mt-4"
  }), _c('br'), _vm._v("binoculars\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-birthday-cake fa-lg mt-4"
  }), _c('br'), _vm._v("birthday-cake\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth-b fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth-b\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bolt fa-lg mt-4"
  }), _c('br'), _vm._v("bolt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bomb fa-lg mt-4"
  }), _c('br'), _vm._v("bomb\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-book fa-lg mt-4"
  }), _c('br'), _vm._v("book\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bookmark fa-lg mt-4"
  }), _c('br'), _vm._v("bookmark\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o fa-lg mt-4"
  }), _c('br'), _vm._v("bookmark-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-briefcase fa-lg mt-4"
  }), _c('br'), _vm._v("briefcase\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bug fa-lg mt-4"
  }), _c('br'), _vm._v("bug\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-building fa-lg mt-4"
  }), _c('br'), _vm._v("building\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-building-o fa-lg mt-4"
  }), _c('br'), _vm._v("building-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bullhorn fa-lg mt-4"
  }), _c('br'), _vm._v("bullhorn\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bullseye fa-lg mt-4"
  }), _c('br'), _vm._v("bullseye\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bus fa-lg mt-4"
  }), _c('br'), _vm._v("bus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cab fa-lg mt-4"
  }), _c('br'), _vm._v("cab "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calculator fa-lg mt-4"
  }), _c('br'), _vm._v("calculator\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar fa-lg mt-4"
  }), _c('br'), _vm._v("calendar\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o fa-lg mt-4"
  }), _c('br'), _vm._v("calendar-check-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar-minus-o fa-lg mt-4"
  }), _c('br'), _vm._v("calendar-minus-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o fa-lg mt-4"
  }), _c('br'), _vm._v("calendar-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o fa-lg mt-4"
  }), _c('br'), _vm._v("calendar-plus-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar-times-o fa-lg mt-4"
  }), _c('br'), _vm._v("calendar-times-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-camera fa-lg mt-4"
  }), _c('br'), _vm._v("camera\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-camera-retro fa-lg mt-4"
  }), _c('br'), _vm._v("camera-retro\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-car fa-lg mt-4"
  }), _c('br'), _vm._v("car\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-left fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-right fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cart-arrow-down fa-lg mt-4"
  }), _c('br'), _vm._v("cart-arrow-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cart-plus fa-lg mt-4"
  }), _c('br'), _vm._v("cart-plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc fa-lg mt-4"
  }), _c('br'), _vm._v("cc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-certificate fa-lg mt-4"
  }), _c('br'), _vm._v("certificate\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check fa-lg mt-4"
  }), _c('br'), _vm._v("check\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg mt-4"
  }), _c('br'), _vm._v("check-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("check-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-square fa-lg mt-4"
  }), _c('br'), _vm._v("check-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("check-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-child fa-lg mt-4"
  }), _c('br'), _vm._v("child\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-lg mt-4"
  }), _c('br'), _vm._v("circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-lg mt-4"
  }), _c('br'), _vm._v("circle-o-notch\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle-thin fa-lg mt-4"
  }), _c('br'), _vm._v("circle-thin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-lg mt-4"
  }), _c('br'), _vm._v("clock-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-clone fa-lg mt-4"
  }), _c('br'), _vm._v("clone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-close fa-lg mt-4"
  }), _c('br'), _vm._v("close "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cloud fa-lg mt-4"
  }), _c('br'), _vm._v("cloud\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cloud-download fa-lg mt-4"
  }), _c('br'), _vm._v("cloud-download\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload fa-lg mt-4"
  }), _c('br'), _vm._v("cloud-upload\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-code fa-lg mt-4"
  }), _c('br'), _vm._v("code\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-code-fork fa-lg mt-4"
  }), _c('br'), _vm._v("code-fork\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-coffee fa-lg mt-4"
  }), _c('br'), _vm._v("coffee\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cog fa-lg mt-4"
  }), _c('br'), _vm._v("cog\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cogs fa-lg mt-4"
  }), _c('br'), _vm._v("cogs\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-comment fa-lg mt-4"
  }), _c('br'), _vm._v("comment\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-comment-o fa-lg mt-4"
  }), _c('br'), _vm._v("comment-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-commenting fa-lg mt-4"
  }), _c('br'), _vm._v("commenting\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-commenting-o fa-lg mt-4"
  }), _c('br'), _vm._v("commenting-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-comments fa-lg mt-4"
  }), _c('br'), _vm._v("comments\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-comments-o fa-lg mt-4"
  }), _c('br'), _vm._v("comments-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-compass fa-lg mt-4"
  }), _c('br'), _vm._v("compass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-copyright fa-lg mt-4"
  }), _c('br'), _vm._v("copyright\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-creative-commons fa-lg mt-4"
  }), _c('br'), _vm._v("creative-commons\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-credit-card fa-lg mt-4"
  }), _c('br'), _vm._v("credit-card\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-credit-card-alt fa-lg mt-4"
  }), _c('br'), _vm._v("credit-card-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-crop fa-lg mt-4"
  }), _c('br'), _vm._v("crop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-crosshairs fa-lg mt-4"
  }), _c('br'), _vm._v("crosshairs\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cube fa-lg mt-4"
  }), _c('br'), _vm._v("cube\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cubes fa-lg mt-4"
  }), _c('br'), _vm._v("cubes\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cutlery fa-lg mt-4"
  }), _c('br'), _vm._v("cutlery\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dashboard fa-lg mt-4"
  }), _c('br'), _vm._v("dashboard "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-database fa-lg mt-4"
  }), _c('br'), _vm._v("database\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-desktop fa-lg mt-4"
  }), _c('br'), _vm._v("desktop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-diamond fa-lg mt-4"
  }), _c('br'), _vm._v("diamond\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("dot-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-download fa-lg mt-4"
  }), _c('br'), _vm._v("download\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg mt-4"
  }), _c('br'), _vm._v("edit "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h fa-lg mt-4"
  }), _c('br'), _vm._v("ellipsis-h\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v fa-lg mt-4"
  }), _c('br'), _vm._v("ellipsis-v\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-lg mt-4"
  }), _c('br'), _vm._v("envelope\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o fa-lg mt-4"
  }), _c('br'), _vm._v("envelope-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-envelope-square fa-lg mt-4"
  }), _c('br'), _vm._v("envelope-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eraser fa-lg mt-4"
  }), _c('br'), _vm._v("eraser\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-exchange fa-lg mt-4"
  }), _c('br'), _vm._v("exchange\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-exclamation fa-lg mt-4"
  }), _c('br'), _vm._v("exclamation\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle fa-lg mt-4"
  }), _c('br'), _vm._v("exclamation-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-lg mt-4"
  }), _c('br'), _vm._v("exclamation-triangle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-external-link fa-lg mt-4"
  }), _c('br'), _vm._v("external-link\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-external-link-square fa-lg mt-4"
  }), _c('br'), _vm._v("external-link-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eye fa-lg mt-4"
  }), _c('br'), _vm._v("eye\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eye-slash fa-lg mt-4"
  }), _c('br'), _vm._v("eye-slash\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eyedropper fa-lg mt-4"
  }), _c('br'), _vm._v("eyedropper\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fax fa-lg mt-4"
  }), _c('br'), _vm._v("fax\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-feed fa-lg mt-4"
  }), _c('br'), _vm._v("feed "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-female fa-lg mt-4"
  }), _c('br'), _vm._v("female\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fighter-jet fa-lg mt-4"
  }), _c('br'), _vm._v("fighter-jet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-archive-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-archive-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-audio-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-audio-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-code-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-code-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-excel-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-image-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-movie-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-movie-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-pdf-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-photo-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-photo-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-picture-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-picture-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-powerpoint-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-powerpoint-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-sound-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-sound-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-video-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-video-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-word-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-word-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-zip-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-zip-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-film fa-lg mt-4"
  }), _c('br'), _vm._v("film\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-filter fa-lg mt-4"
  }), _c('br'), _vm._v("filter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fire fa-lg mt-4"
  }), _c('br'), _vm._v("fire\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fire-extinguisher fa-lg mt-4"
  }), _c('br'), _vm._v("fire-extinguisher\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flag fa-lg mt-4"
  }), _c('br'), _vm._v("flag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flag-checkered fa-lg mt-4"
  }), _c('br'), _vm._v("flag-checkered\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg mt-4"
  }), _c('br'), _vm._v("flag-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flash fa-lg mt-4"
  }), _c('br'), _vm._v("flash "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flask fa-lg mt-4"
  }), _c('br'), _vm._v("flask\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-folder fa-lg mt-4"
  }), _c('br'), _vm._v("folder\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-folder-o fa-lg mt-4"
  }), _c('br'), _vm._v("folder-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-folder-open fa-lg mt-4"
  }), _c('br'), _vm._v("folder-open\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-folder-open-o fa-lg mt-4"
  }), _c('br'), _vm._v("folder-open-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-lg mt-4"
  }), _c('br'), _vm._v("frown-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-futbol-o fa-lg mt-4"
  }), _c('br'), _vm._v("futbol-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gamepad fa-lg mt-4"
  }), _c('br'), _vm._v("gamepad\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gavel fa-lg mt-4"
  }), _c('br'), _vm._v("gavel\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gear fa-lg mt-4"
  }), _c('br'), _vm._v("gear "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gears fa-lg mt-4"
  }), _c('br'), _vm._v("gears "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gift fa-lg mt-4"
  }), _c('br'), _vm._v("gift\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-glass fa-lg mt-4"
  }), _c('br'), _vm._v("glass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-globe fa-lg mt-4"
  }), _c('br'), _vm._v("globe\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap fa-lg mt-4"
  }), _c('br'), _vm._v("graduation-cap\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-group fa-lg mt-4"
  }), _c('br'), _vm._v("group "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-grab-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-grab-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-lizard-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-lizard-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-paper-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-paper-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-peace-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-peace-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-pointer-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-rock-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-rock-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-scissors-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-scissors-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-spock-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-spock-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-stop-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-stop-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hashtag fa-lg mt-4"
  }), _c('br'), _vm._v("hashtag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hdd-o fa-lg mt-4"
  }), _c('br'), _vm._v("hdd-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-headphones fa-lg mt-4"
  }), _c('br'), _vm._v("headphones\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heart fa-lg mt-4"
  }), _c('br'), _vm._v("heart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heart-o fa-lg mt-4"
  }), _c('br'), _vm._v("heart-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat fa-lg mt-4"
  }), _c('br'), _vm._v("heartbeat\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-history fa-lg mt-4"
  }), _c('br'), _vm._v("history\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-home fa-lg mt-4"
  }), _c('br'), _vm._v("home\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hotel fa-lg mt-4"
  }), _c('br'), _vm._v("hotel "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-1 fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-1 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-2 fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-2 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-3 fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-3 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-end fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-end\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-half fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-half\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-o fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-start fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-start\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-i-cursor fa-lg mt-4"
  }), _c('br'), _vm._v("i-cursor\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-image fa-lg mt-4"
  }), _c('br'), _vm._v("image "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-inbox fa-lg mt-4"
  }), _c('br'), _vm._v("inbox\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-industry fa-lg mt-4"
  }), _c('br'), _vm._v("industry\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-info fa-lg mt-4"
  }), _c('br'), _vm._v("info\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-info-circle fa-lg mt-4"
  }), _c('br'), _vm._v("info-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-institution fa-lg mt-4"
  }), _c('br'), _vm._v("institution "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-key fa-lg mt-4"
  }), _c('br'), _vm._v("key\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-keyboard-o fa-lg mt-4"
  }), _c('br'), _vm._v("keyboard-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-language fa-lg mt-4"
  }), _c('br'), _vm._v("language\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-laptop fa-lg mt-4"
  }), _c('br'), _vm._v("laptop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-leaf fa-lg mt-4"
  }), _c('br'), _vm._v("leaf\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-legal fa-lg mt-4"
  }), _c('br'), _vm._v("legal "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-lemon-o fa-lg mt-4"
  }), _c('br'), _vm._v("lemon-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-level-down fa-lg mt-4"
  }), _c('br'), _vm._v("level-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-level-up fa-lg mt-4"
  }), _c('br'), _vm._v("level-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-life-bouy fa-lg mt-4"
  }), _c('br'), _vm._v("life-bouy "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-life-buoy fa-lg mt-4"
  }), _c('br'), _vm._v("life-buoy "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-life-ring fa-lg mt-4"
  }), _c('br'), _vm._v("life-ring\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-life-saver fa-lg mt-4"
  }), _c('br'), _vm._v("life-saver "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o fa-lg mt-4"
  }), _c('br'), _vm._v("lightbulb-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-line-chart fa-lg mt-4"
  }), _c('br'), _vm._v("line-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-location-arrow fa-lg mt-4"
  }), _c('br'), _vm._v("location-arrow\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-lock fa-lg mt-4"
  }), _c('br'), _vm._v("lock\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-magic fa-lg mt-4"
  }), _c('br'), _vm._v("magic\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-magnet fa-lg mt-4"
  }), _c('br'), _vm._v("magnet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mail-forward fa-lg mt-4"
  }), _c('br'), _vm._v("mail-forward "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mail-reply fa-lg mt-4"
  }), _c('br'), _vm._v("mail-reply "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mail-reply-all fa-lg mt-4"
  }), _c('br'), _vm._v("mail-reply-all "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-male fa-lg mt-4"
  }), _c('br'), _vm._v("male\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-map fa-lg mt-4"
  }), _c('br'), _vm._v("map\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-lg mt-4"
  }), _c('br'), _vm._v("map-marker\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-map-o fa-lg mt-4"
  }), _c('br'), _vm._v("map-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-map-pin fa-lg mt-4"
  }), _c('br'), _vm._v("map-pin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-map-signs fa-lg mt-4"
  }), _c('br'), _vm._v("map-signs\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-meh-o fa-lg mt-4"
  }), _c('br'), _vm._v("meh-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-microphone fa-lg mt-4"
  }), _c('br'), _vm._v("microphone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-microphone-slash fa-lg mt-4"
  }), _c('br'), _vm._v("microphone-slash\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus fa-lg mt-4"
  }), _c('br'), _vm._v("minus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle fa-lg mt-4"
  }), _c('br'), _vm._v("minus-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus-square fa-lg mt-4"
  }), _c('br'), _vm._v("minus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("minus-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mobile fa-lg mt-4"
  }), _c('br'), _vm._v("mobile\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mobile-phone fa-lg mt-4"
  }), _c('br'), _vm._v("mobile-phone "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-money fa-lg mt-4"
  }), _c('br'), _vm._v("money\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-moon-o fa-lg mt-4"
  }), _c('br'), _vm._v("moon-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mortar-board fa-lg mt-4"
  }), _c('br'), _vm._v("mortar-board "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-motorcycle fa-lg mt-4"
  }), _c('br'), _vm._v("motorcycle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mouse-pointer fa-lg mt-4"
  }), _c('br'), _vm._v("mouse-pointer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-music fa-lg mt-4"
  }), _c('br'), _vm._v("music\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-navicon fa-lg mt-4"
  }), _c('br'), _vm._v("navicon "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-newspaper-o fa-lg mt-4"
  }), _c('br'), _vm._v("newspaper-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-object-group fa-lg mt-4"
  }), _c('br'), _vm._v("object-group\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-object-ungroup fa-lg mt-4"
  }), _c('br'), _vm._v("object-ungroup\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paint-brush fa-lg mt-4"
  }), _c('br'), _vm._v("paint-brush\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane fa-lg mt-4"
  }), _c('br'), _vm._v("paper-plane\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o fa-lg mt-4"
  }), _c('br'), _vm._v("paper-plane-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paw fa-lg mt-4"
  }), _c('br'), _vm._v("paw\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pencil fa-lg mt-4"
  }), _c('br'), _vm._v("pencil\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square fa-lg mt-4"
  }), _c('br'), _vm._v("pencil-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("pencil-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-percent fa-lg mt-4"
  }), _c('br'), _vm._v("percent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-phone fa-lg mt-4"
  }), _c('br'), _vm._v("phone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-phone-square fa-lg mt-4"
  }), _c('br'), _vm._v("phone-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-photo fa-lg mt-4"
  }), _c('br'), _vm._v("photo "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-picture-o fa-lg mt-4"
  }), _c('br'), _vm._v("picture-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart fa-lg mt-4"
  }), _c('br'), _vm._v("pie-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plane fa-lg mt-4"
  }), _c('br'), _vm._v("plane\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plug fa-lg mt-4"
  }), _c('br'), _vm._v("plug\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-lg mt-4"
  }), _c('br'), _vm._v("plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg mt-4"
  }), _c('br'), _vm._v("plus-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-square fa-lg mt-4"
  }), _c('br'), _vm._v("plus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("plus-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-power-off fa-lg mt-4"
  }), _c('br'), _vm._v("power-off\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-print fa-lg mt-4"
  }), _c('br'), _vm._v("print\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-puzzle-piece fa-lg mt-4"
  }), _c('br'), _vm._v("puzzle-piece\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-qrcode fa-lg mt-4"
  }), _c('br'), _vm._v("qrcode\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-question fa-lg mt-4"
  }), _c('br'), _vm._v("question\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-question-circle fa-lg mt-4"
  }), _c('br'), _vm._v("question-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-quote-left fa-lg mt-4"
  }), _c('br'), _vm._v("quote-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-quote-right fa-lg mt-4"
  }), _c('br'), _vm._v("quote-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-random fa-lg mt-4"
  }), _c('br'), _vm._v("random\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-recycle fa-lg mt-4"
  }), _c('br'), _vm._v("recycle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-lg mt-4"
  }), _c('br'), _vm._v("refresh\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-registered fa-lg mt-4"
  }), _c('br'), _vm._v("registered\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-remove fa-lg mt-4"
  }), _c('br'), _vm._v("remove "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reorder fa-lg mt-4"
  }), _c('br'), _vm._v("reorder "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reply fa-lg mt-4"
  }), _c('br'), _vm._v("reply\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reply-all fa-lg mt-4"
  }), _c('br'), _vm._v("reply-all\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-retweet fa-lg mt-4"
  }), _c('br'), _vm._v("retweet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-road fa-lg mt-4"
  }), _c('br'), _vm._v("road\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rocket fa-lg mt-4"
  }), _c('br'), _vm._v("rocket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rss fa-lg mt-4"
  }), _c('br'), _vm._v("rss\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rss-square fa-lg mt-4"
  }), _c('br'), _vm._v("rss-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-search fa-lg mt-4"
  }), _c('br'), _vm._v("search\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-search-minus fa-lg mt-4"
  }), _c('br'), _vm._v("search-minus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-search-plus fa-lg mt-4"
  }), _c('br'), _vm._v("search-plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-send fa-lg mt-4"
  }), _c('br'), _vm._v("send "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-send-o fa-lg mt-4"
  }), _c('br'), _vm._v("send-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-server fa-lg mt-4"
  }), _c('br'), _vm._v("server\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share fa-lg mt-4"
  }), _c('br'), _vm._v("share\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-lg mt-4"
  }), _c('br'), _vm._v("share-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-alt-square fa-lg mt-4"
  }), _c('br'), _vm._v("share-alt-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-square fa-lg mt-4"
  }), _c('br'), _vm._v("share-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("share-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shield fa-lg mt-4"
  }), _c('br'), _vm._v("shield\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ship fa-lg mt-4"
  }), _c('br'), _vm._v("ship\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag fa-lg mt-4"
  }), _c('br'), _vm._v("shopping-bag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shopping-basket fa-lg mt-4"
  }), _c('br'), _vm._v("shopping-basket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart fa-lg mt-4"
  }), _c('br'), _vm._v("shopping-cart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sign-in fa-lg mt-4"
  }), _c('br'), _vm._v("sign-in\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sign-out fa-lg mt-4"
  }), _c('br'), _vm._v("sign-out\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-signal fa-lg mt-4"
  }), _c('br'), _vm._v("signal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sitemap fa-lg mt-4"
  }), _c('br'), _vm._v("sitemap\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sliders fa-lg mt-4"
  }), _c('br'), _vm._v("sliders\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-smile-o fa-lg mt-4"
  }), _c('br'), _vm._v("smile-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-soccer-ball-o fa-lg mt-4"
  }), _c('br'), _vm._v("soccer-ball-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort fa-lg mt-4"
  }), _c('br'), _vm._v("sort\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-alpha-asc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-alpha-desc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-amount-asc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-amount-asc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-amount-desc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-amount-desc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-asc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-asc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-desc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-desc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-down fa-lg mt-4"
  }), _c('br'), _vm._v("sort-down "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-asc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-numeric-asc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-desc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-numeric-desc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-up fa-lg mt-4"
  }), _c('br'), _vm._v("sort-up "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-space-shuttle fa-lg mt-4"
  }), _c('br'), _vm._v("space-shuttle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-lg mt-4"
  }), _c('br'), _vm._v("spinner\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-spoon fa-lg mt-4"
  }), _c('br'), _vm._v("spoon\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-square fa-lg mt-4"
  }), _c('br'), _vm._v("square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star fa-lg mt-4"
  }), _c('br'), _vm._v("star\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star-half fa-lg mt-4"
  }), _c('br'), _vm._v("star-half\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star-half-empty fa-lg mt-4"
  }), _c('br'), _vm._v("star-half-empty "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star-half-full fa-lg mt-4"
  }), _c('br'), _vm._v("star-half-full "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star-half-o fa-lg mt-4"
  }), _c('br'), _vm._v("star-half-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star-o fa-lg mt-4"
  }), _c('br'), _vm._v("star-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note fa-lg mt-4"
  }), _c('br'), _vm._v("sticky-note\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note-o fa-lg mt-4"
  }), _c('br'), _vm._v("sticky-note-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-street-view fa-lg mt-4"
  }), _c('br'), _vm._v("street-view\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-suitcase fa-lg mt-4"
  }), _c('br'), _vm._v("suitcase\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sun-o fa-lg mt-4"
  }), _c('br'), _vm._v("sun-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-support fa-lg mt-4"
  }), _c('br'), _vm._v("support "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tablet fa-lg mt-4"
  }), _c('br'), _vm._v("tablet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tachometer fa-lg mt-4"
  }), _c('br'), _vm._v("tachometer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tag fa-lg mt-4"
  }), _c('br'), _vm._v("tag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tags fa-lg mt-4"
  }), _c('br'), _vm._v("tags\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tasks fa-lg mt-4"
  }), _c('br'), _vm._v("tasks\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-taxi fa-lg mt-4"
  }), _c('br'), _vm._v("taxi\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-television fa-lg mt-4"
  }), _c('br'), _vm._v("television\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-terminal fa-lg mt-4"
  }), _c('br'), _vm._v("terminal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumb-tack fa-lg mt-4"
  }), _c('br'), _vm._v("thumb-tack\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-down fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ticket fa-lg mt-4"
  }), _c('br'), _vm._v("ticket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-times fa-lg mt-4"
  }), _c('br'), _vm._v("times\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-times-circle fa-lg mt-4"
  }), _c('br'), _vm._v("times-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("times-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tint fa-lg mt-4"
  }), _c('br'), _vm._v("tint\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-down fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-down "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-left fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-left "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-off fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-off\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-on fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-on\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-right fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-right "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-up fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-up "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-trademark fa-lg mt-4"
  }), _c('br'), _vm._v("trademark\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg mt-4"
  }), _c('br'), _vm._v("trash\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-trash-o fa-lg mt-4"
  }), _c('br'), _vm._v("trash-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tree fa-lg mt-4"
  }), _c('br'), _vm._v("tree\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-trophy fa-lg mt-4"
  }), _c('br'), _vm._v("trophy\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-truck fa-lg mt-4"
  }), _c('br'), _vm._v("truck\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tty fa-lg mt-4"
  }), _c('br'), _vm._v("tty\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tv fa-lg mt-4"
  }), _c('br'), _vm._v("tv "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-umbrella fa-lg mt-4"
  }), _c('br'), _vm._v("umbrella\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-university fa-lg mt-4"
  }), _c('br'), _vm._v("university\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-unlock fa-lg mt-4"
  }), _c('br'), _vm._v("unlock\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt fa-lg mt-4"
  }), _c('br'), _vm._v("unlock-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-unsorted fa-lg mt-4"
  }), _c('br'), _vm._v("unsorted "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-upload fa-lg mt-4"
  }), _c('br'), _vm._v("upload\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user fa-lg mt-4"
  }), _c('br'), _vm._v("user\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user-plus fa-lg mt-4"
  }), _c('br'), _vm._v("user-plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user-secret fa-lg mt-4"
  }), _c('br'), _vm._v("user-secret\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user-times fa-lg mt-4"
  }), _c('br'), _vm._v("user-times\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-users fa-lg mt-4"
  }), _c('br'), _vm._v("users\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-video-camera fa-lg mt-4"
  }), _c('br'), _vm._v("video-camera\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-volume-down fa-lg mt-4"
  }), _c('br'), _vm._v("volume-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-volume-off fa-lg mt-4"
  }), _c('br'), _vm._v("volume-off\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-volume-up fa-lg mt-4"
  }), _c('br'), _vm._v("volume-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-warning fa-lg mt-4"
  }), _c('br'), _vm._v("warning "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wheelchair fa-lg mt-4"
  }), _c('br'), _vm._v("wheelchair\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wifi fa-lg mt-4"
  }), _c('br'), _vm._v("wifi\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wrench fa-lg mt-4"
  }), _c('br'), _vm._v("wrench\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "hand"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Hand Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-grab-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-grab-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-lizard-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-lizard-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-left fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-right fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-paper-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-paper-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-peace-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-peace-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-pointer-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-rock-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-rock-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-scissors-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-scissors-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-spock-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-spock-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-stop-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-stop-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-down fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-up\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "transportation"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Transportation Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ambulance fa-lg mt-4"
  }), _c('br'), _vm._v("ambulance\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-automobile fa-lg mt-4"
  }), _c('br'), _vm._v("automobile "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bicycle fa-lg mt-4"
  }), _c('br'), _vm._v("bicycle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bus fa-lg mt-4"
  }), _c('br'), _vm._v("bus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cab fa-lg mt-4"
  }), _c('br'), _vm._v("cab "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-car fa-lg mt-4"
  }), _c('br'), _vm._v("car\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fighter-jet fa-lg mt-4"
  }), _c('br'), _vm._v("fighter-jet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-motorcycle fa-lg mt-4"
  }), _c('br'), _vm._v("motorcycle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plane fa-lg mt-4"
  }), _c('br'), _vm._v("plane\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rocket fa-lg mt-4"
  }), _c('br'), _vm._v("rocket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ship fa-lg mt-4"
  }), _c('br'), _vm._v("ship\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-space-shuttle fa-lg mt-4"
  }), _c('br'), _vm._v("space-shuttle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-subway fa-lg mt-4"
  }), _c('br'), _vm._v("subway\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-taxi fa-lg mt-4"
  }), _c('br'), _vm._v("taxi\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-train fa-lg mt-4"
  }), _c('br'), _vm._v("train\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-truck fa-lg mt-4"
  }), _c('br'), _vm._v("truck\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wheelchair fa-lg mt-4"
  }), _c('br'), _vm._v("wheelchair\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "gender"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Gender Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-genderless fa-lg mt-4"
  }), _c('br'), _vm._v("genderless\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-intersex fa-lg mt-4"
  }), _c('br'), _vm._v("intersex "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mars fa-lg mt-4"
  }), _c('br'), _vm._v("mars\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mars-double fa-lg mt-4"
  }), _c('br'), _vm._v("mars-double\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mars-stroke fa-lg mt-4"
  }), _c('br'), _vm._v("mars-stroke\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mars-stroke-h fa-lg mt-4"
  }), _c('br'), _vm._v("mars-stroke-h\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mars-stroke-v fa-lg mt-4"
  }), _c('br'), _vm._v("mars-stroke-v\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mercury fa-lg mt-4"
  }), _c('br'), _vm._v("mercury\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-neuter fa-lg mt-4"
  }), _c('br'), _vm._v("neuter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-transgender fa-lg mt-4"
  }), _c('br'), _vm._v("transgender\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-transgender-alt fa-lg mt-4"
  }), _c('br'), _vm._v("transgender-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-venus fa-lg mt-4"
  }), _c('br'), _vm._v("venus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-venus-double fa-lg mt-4"
  }), _c('br'), _vm._v("venus-double\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-venus-mars fa-lg mt-4"
  }), _c('br'), _vm._v("venus-mars\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "file-type"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("File Type Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file fa-lg mt-4"
  }), _c('br'), _vm._v("file\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-archive-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-archive-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-audio-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-audio-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-code-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-code-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-excel-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-image-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-movie-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-movie-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-pdf-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-photo-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-photo-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-picture-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-picture-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-powerpoint-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-powerpoint-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-sound-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-sound-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-text fa-lg mt-4"
  }), _c('br'), _vm._v("file-text\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-text-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-video-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-video-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-word-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-word-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-zip-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-zip-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "spinner"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Spinner Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('ul', {
    staticClass: "fa-ul"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-info-circle fa-li"
  }), _vm._v("\n            These icons work great with the "), _c('code', [_vm._v("fa-spin")]), _vm._v(" class.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-lg mt-4"
  }), _c('br'), _vm._v("circle-o-notch\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cog fa-lg mt-4"
  }), _c('br'), _vm._v("cog\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gear fa-lg mt-4"
  }), _c('br'), _vm._v("gear "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-lg mt-4"
  }), _c('br'), _vm._v("refresh\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-lg mt-4"
  }), _c('br'), _vm._v("spinner\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "form-control"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Form Control Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-square fa-lg mt-4"
  }), _c('br'), _vm._v("check-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("check-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-lg mt-4"
  }), _c('br'), _vm._v("circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("dot-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus-square fa-lg mt-4"
  }), _c('br'), _vm._v("minus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("minus-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-square fa-lg mt-4"
  }), _c('br'), _vm._v("plus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("plus-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-square fa-lg mt-4"
  }), _c('br'), _vm._v("square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("square-o\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "payment"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Payment Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-amex fa-lg mt-4"
  }), _c('br'), _vm._v("cc-amex\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-diners-club fa-lg mt-4"
  }), _c('br'), _vm._v("cc-diners-club\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-discover fa-lg mt-4"
  }), _c('br'), _vm._v("cc-discover\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-jcb fa-lg mt-4"
  }), _c('br'), _vm._v("cc-jcb\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-mastercard fa-lg mt-4"
  }), _c('br'), _vm._v("cc-mastercard\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-paypal fa-lg mt-4"
  }), _c('br'), _vm._v("cc-paypal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-stripe fa-lg mt-4"
  }), _c('br'), _vm._v("cc-stripe\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-visa fa-lg mt-4"
  }), _c('br'), _vm._v("cc-visa\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-credit-card fa-lg mt-4"
  }), _c('br'), _vm._v("credit-card\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-credit-card-alt fa-lg mt-4"
  }), _c('br'), _vm._v("credit-card-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-google-wallet fa-lg mt-4"
  }), _c('br'), _vm._v("google-wallet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paypal fa-lg mt-4"
  }), _c('br'), _vm._v("paypal\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "chart"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Chart Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-area-chart fa-lg mt-4"
  }), _c('br'), _vm._v("area-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart fa-lg mt-4"
  }), _c('br'), _vm._v("bar-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o fa-lg mt-4"
  }), _c('br'), _vm._v("bar-chart-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-line-chart fa-lg mt-4"
  }), _c('br'), _vm._v("line-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart fa-lg mt-4"
  }), _c('br'), _vm._v("pie-chart\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "currency"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Currency Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bitcoin fa-lg mt-4"
  }), _c('br'), _vm._v("bitcoin "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-btc fa-lg mt-4"
  }), _c('br'), _vm._v("btc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cny fa-lg mt-4"
  }), _c('br'), _vm._v("cny "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dollar fa-lg mt-4"
  }), _c('br'), _vm._v("dollar "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eur fa-lg mt-4"
  }), _c('br'), _vm._v("eur\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-euro fa-lg mt-4"
  }), _c('br'), _vm._v("euro "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gbp fa-lg mt-4"
  }), _c('br'), _vm._v("gbp\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gg fa-lg mt-4"
  }), _c('br'), _vm._v("gg\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gg-circle fa-lg mt-4"
  }), _c('br'), _vm._v("gg-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ils fa-lg mt-4"
  }), _c('br'), _vm._v("ils\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-inr fa-lg mt-4"
  }), _c('br'), _vm._v("inr\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-jpy fa-lg mt-4"
  }), _c('br'), _vm._v("jpy\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-krw fa-lg mt-4"
  }), _c('br'), _vm._v("krw\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-money fa-lg mt-4"
  }), _c('br'), _vm._v("money\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rmb fa-lg mt-4"
  }), _c('br'), _vm._v("rmb "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rouble fa-lg mt-4"
  }), _c('br'), _vm._v("rouble "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rub fa-lg mt-4"
  }), _c('br'), _vm._v("rub\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ruble fa-lg mt-4"
  }), _c('br'), _vm._v("ruble "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rupee fa-lg mt-4"
  }), _c('br'), _vm._v("rupee "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shekel fa-lg mt-4"
  }), _c('br'), _vm._v("shekel "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sheqel fa-lg mt-4"
  }), _c('br'), _vm._v("sheqel "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-try fa-lg mt-4"
  }), _c('br'), _vm._v("try\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-turkish-lira fa-lg mt-4"
  }), _c('br'), _vm._v("turkish-lira "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-usd fa-lg mt-4"
  }), _c('br'), _vm._v("usd\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-won fa-lg mt-4"
  }), _c('br'), _vm._v("won "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-yen fa-lg mt-4"
  }), _c('br'), _vm._v("yen "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "text-editor"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Text Editor Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-align-center fa-lg mt-4"
  }), _c('br'), _vm._v("align-center\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-align-justify fa-lg mt-4"
  }), _c('br'), _vm._v("align-justify\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-align-left fa-lg mt-4"
  }), _c('br'), _vm._v("align-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-align-right fa-lg mt-4"
  }), _c('br'), _vm._v("align-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bold fa-lg mt-4"
  }), _c('br'), _vm._v("bold\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chain fa-lg mt-4"
  }), _c('br'), _vm._v("chain "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chain-broken fa-lg mt-4"
  }), _c('br'), _vm._v("chain-broken\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-clipboard fa-lg mt-4"
  }), _c('br'), _vm._v("clipboard\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-columns fa-lg mt-4"
  }), _c('br'), _vm._v("columns\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-copy fa-lg mt-4"
  }), _c('br'), _vm._v("copy "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cut fa-lg mt-4"
  }), _c('br'), _vm._v("cut "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dedent fa-lg mt-4"
  }), _c('br'), _vm._v("dedent "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eraser fa-lg mt-4"
  }), _c('br'), _vm._v("eraser\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file fa-lg mt-4"
  }), _c('br'), _vm._v("file\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-text fa-lg mt-4"
  }), _c('br'), _vm._v("file-text\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-text-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-files-o fa-lg mt-4"
  }), _c('br'), _vm._v("files-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o fa-lg mt-4"
  }), _c('br'), _vm._v("floppy-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-font fa-lg mt-4"
  }), _c('br'), _vm._v("font\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-header fa-lg mt-4"
  }), _c('br'), _vm._v("header\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-indent fa-lg mt-4"
  }), _c('br'), _vm._v("indent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-italic fa-lg mt-4"
  }), _c('br'), _vm._v("italic\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-link fa-lg mt-4"
  }), _c('br'), _vm._v("link\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-list fa-lg mt-4"
  }), _c('br'), _vm._v("list\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-lg mt-4"
  }), _c('br'), _vm._v("list-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-list-ol fa-lg mt-4"
  }), _c('br'), _vm._v("list-ol\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-list-ul fa-lg mt-4"
  }), _c('br'), _vm._v("list-ul\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-outdent fa-lg mt-4"
  }), _c('br'), _vm._v("outdent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paperclip fa-lg mt-4"
  }), _c('br'), _vm._v("paperclip\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paragraph fa-lg mt-4"
  }), _c('br'), _vm._v("paragraph\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paste fa-lg mt-4"
  }), _c('br'), _vm._v("paste "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-repeat fa-lg mt-4"
  }), _c('br'), _vm._v("repeat\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rotate-left fa-lg mt-4"
  }), _c('br'), _vm._v("rotate-left "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rotate-right fa-lg mt-4"
  }), _c('br'), _vm._v("rotate-right "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-save fa-lg mt-4"
  }), _c('br'), _vm._v("save "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-scissors fa-lg mt-4"
  }), _c('br'), _vm._v("scissors\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-strikethrough fa-lg mt-4"
  }), _c('br'), _vm._v("strikethrough\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-subscript fa-lg mt-4"
  }), _c('br'), _vm._v("subscript\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-superscript fa-lg mt-4"
  }), _c('br'), _vm._v("superscript\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-table fa-lg mt-4"
  }), _c('br'), _vm._v("table\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-text-height fa-lg mt-4"
  }), _c('br'), _vm._v("text-height\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-text-width fa-lg mt-4"
  }), _c('br'), _vm._v("text-width\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-th fa-lg mt-4"
  }), _c('br'), _vm._v("th\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-th-large fa-lg mt-4"
  }), _c('br'), _vm._v("th-large\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-th-list fa-lg mt-4"
  }), _c('br'), _vm._v("th-list\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-underline fa-lg mt-4"
  }), _c('br'), _vm._v("underline\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-undo fa-lg mt-4"
  }), _c('br'), _vm._v("undo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-unlink fa-lg mt-4"
  }), _c('br'), _vm._v("unlink "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "directional"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Directional Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-lg mt-4"
  }), _c('br'), _vm._v("angle-double-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left fa-lg mt-4"
  }), _c('br'), _vm._v("angle-double-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right fa-lg mt-4"
  }), _c('br'), _vm._v("angle-double-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-lg mt-4"
  }), _c('br'), _vm._v("angle-double-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-down fa-lg mt-4"
  }), _c('br'), _vm._v("angle-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-lg mt-4"
  }), _c('br'), _vm._v("angle-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-lg mt-4"
  }), _c('br'), _vm._v("angle-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-up fa-lg mt-4"
  }), _c('br'), _vm._v("angle-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-down fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-left fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-o-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-right fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-o-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-up fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-down fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-up fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows fa-lg mt-4"
  }), _c('br'), _vm._v("arrows\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-h fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-h\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-v fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-v\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-down fa-lg mt-4"
  }), _c('br'), _vm._v("caret-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-left fa-lg mt-4"
  }), _c('br'), _vm._v("caret-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-right fa-lg mt-4"
  }), _c('br'), _vm._v("caret-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-left fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-right fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-up fa-lg mt-4"
  }), _c('br'), _vm._v("caret-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-circle-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-circle-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-right fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-circle-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-up fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-circle-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-down fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-up fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-exchange fa-lg mt-4"
  }), _c('br'), _vm._v("exchange\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-left fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-right fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-down fa-lg mt-4"
  }), _c('br'), _vm._v("long-arrow-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left fa-lg mt-4"
  }), _c('br'), _vm._v("long-arrow-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-right fa-lg mt-4"
  }), _c('br'), _vm._v("long-arrow-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-up fa-lg mt-4"
  }), _c('br'), _vm._v("long-arrow-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-down fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-down "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-left fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-left "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-right fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-right "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-up fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-up "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "video-player"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Video Player Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-backward fa-lg mt-4"
  }), _c('br'), _vm._v("backward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-compress fa-lg mt-4"
  }), _c('br'), _vm._v("compress\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eject fa-lg mt-4"
  }), _c('br'), _vm._v("eject\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-expand fa-lg mt-4"
  }), _c('br'), _vm._v("expand\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fast-backward fa-lg mt-4"
  }), _c('br'), _vm._v("fast-backward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fast-forward fa-lg mt-4"
  }), _c('br'), _vm._v("fast-forward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-forward fa-lg mt-4"
  }), _c('br'), _vm._v("forward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pause fa-lg mt-4"
  }), _c('br'), _vm._v("pause\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pause-circle fa-lg mt-4"
  }), _c('br'), _vm._v("pause-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pause-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("pause-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-play fa-lg mt-4"
  }), _c('br'), _vm._v("play\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-play-circle fa-lg mt-4"
  }), _c('br'), _vm._v("play-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("play-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-random fa-lg mt-4"
  }), _c('br'), _vm._v("random\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-step-backward fa-lg mt-4"
  }), _c('br'), _vm._v("step-backward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-step-forward fa-lg mt-4"
  }), _c('br'), _vm._v("step-forward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stop fa-lg mt-4"
  }), _c('br'), _vm._v("stop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle fa-lg mt-4"
  }), _c('br'), _vm._v("stop-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("stop-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-youtube-play fa-lg mt-4"
  }), _c('br'), _vm._v("youtube-play\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "brand"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Brand Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Warning!")]), _vm._v("\n        Apparently, Adblock Plus can remove Font Awesome brand icons with their \"Remove Social\n        Media Buttons\" setting. We will not use hacks to force them to display. Please\n        "), _c('a', {
    staticClass: "alert-link",
    attrs: {
      "href": "https://adblockplus.org/en/bugs"
    }
  }, [_vm._v("report an issue with Adblock Plus")]), _vm._v(" if you believe this to be\n        an error. To work around this, you'll need to modify the social icon class names.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-500px fa-lg mt-4"
  }), _c('br'), _vm._v("500px\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-adn fa-lg mt-4"
  }), _c('br'), _vm._v("adn\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-amazon fa-lg mt-4"
  }), _c('br'), _vm._v("amazon\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-android fa-lg mt-4"
  }), _c('br'), _vm._v("android\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angellist fa-lg mt-4"
  }), _c('br'), _vm._v("angellist\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-apple fa-lg mt-4"
  }), _c('br'), _vm._v("apple\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-behance fa-lg mt-4"
  }), _c('br'), _vm._v("behance\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-behance-square fa-lg mt-4"
  }), _c('br'), _vm._v("behance-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bitbucket fa-lg mt-4"
  }), _c('br'), _vm._v("bitbucket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bitbucket-square fa-lg mt-4"
  }), _c('br'), _vm._v("bitbucket-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bitcoin fa-lg mt-4"
  }), _c('br'), _vm._v("bitcoin "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-black-tie fa-lg mt-4"
  }), _c('br'), _vm._v("black-tie\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth-b fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth-b\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-btc fa-lg mt-4"
  }), _c('br'), _vm._v("btc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-buysellads fa-lg mt-4"
  }), _c('br'), _vm._v("buysellads\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-amex fa-lg mt-4"
  }), _c('br'), _vm._v("cc-amex\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-diners-club fa-lg mt-4"
  }), _c('br'), _vm._v("cc-diners-club\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-discover fa-lg mt-4"
  }), _c('br'), _vm._v("cc-discover\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-jcb fa-lg mt-4"
  }), _c('br'), _vm._v("cc-jcb\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-mastercard fa-lg mt-4"
  }), _c('br'), _vm._v("cc-mastercard\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-paypal fa-lg mt-4"
  }), _c('br'), _vm._v("cc-paypal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-stripe fa-lg mt-4"
  }), _c('br'), _vm._v("cc-stripe\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-visa fa-lg mt-4"
  }), _c('br'), _vm._v("cc-visa\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chrome fa-lg mt-4"
  }), _c('br'), _vm._v("chrome\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-codepen fa-lg mt-4"
  }), _c('br'), _vm._v("codepen\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-codiepie fa-lg mt-4"
  }), _c('br'), _vm._v("codiepie\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-connectdevelop fa-lg mt-4"
  }), _c('br'), _vm._v("connectdevelop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-contao fa-lg mt-4"
  }), _c('br'), _vm._v("contao\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-css3 fa-lg mt-4"
  }), _c('br'), _vm._v("css3\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dashcube fa-lg mt-4"
  }), _c('br'), _vm._v("dashcube\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-delicious fa-lg mt-4"
  }), _c('br'), _vm._v("delicious\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-deviantart fa-lg mt-4"
  }), _c('br'), _vm._v("deviantart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-digg fa-lg mt-4"
  }), _c('br'), _vm._v("digg\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dribbble fa-lg mt-4"
  }), _c('br'), _vm._v("dribbble\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dropbox fa-lg mt-4"
  }), _c('br'), _vm._v("dropbox\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-drupal fa-lg mt-4"
  }), _c('br'), _vm._v("drupal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-edge fa-lg mt-4"
  }), _c('br'), _vm._v("edge\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-empire fa-lg mt-4"
  }), _c('br'), _vm._v("empire\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-expeditedssl fa-lg mt-4"
  }), _c('br'), _vm._v("expeditedssl\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-lg mt-4"
  }), _c('br'), _vm._v("facebook\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-facebook-f fa-lg mt-4"
  }), _c('br'), _vm._v("facebook-f "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-facebook-official fa-lg mt-4"
  }), _c('br'), _vm._v("facebook-official\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-facebook-square fa-lg mt-4"
  }), _c('br'), _vm._v("facebook-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-firefox fa-lg mt-4"
  }), _c('br'), _vm._v("firefox\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flickr fa-lg mt-4"
  }), _c('br'), _vm._v("flickr\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fonticons fa-lg mt-4"
  }), _c('br'), _vm._v("fonticons\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fort-awesome fa-lg mt-4"
  }), _c('br'), _vm._v("fort-awesome\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-forumbee fa-lg mt-4"
  }), _c('br'), _vm._v("forumbee\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-foursquare fa-lg mt-4"
  }), _c('br'), _vm._v("foursquare\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ge fa-lg mt-4"
  }), _c('br'), _vm._v("ge "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-get-pocket fa-lg mt-4"
  }), _c('br'), _vm._v("get-pocket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gg fa-lg mt-4"
  }), _c('br'), _vm._v("gg\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gg-circle fa-lg mt-4"
  }), _c('br'), _vm._v("gg-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-git fa-lg mt-4"
  }), _c('br'), _vm._v("git\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-git-square fa-lg mt-4"
  }), _c('br'), _vm._v("git-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-github fa-lg mt-4"
  }), _c('br'), _vm._v("github\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-github-alt fa-lg mt-4"
  }), _c('br'), _vm._v("github-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-github-square fa-lg mt-4"
  }), _c('br'), _vm._v("github-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gittip fa-lg mt-4"
  }), _c('br'), _vm._v("gittip "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-google fa-lg mt-4"
  }), _c('br'), _vm._v("google\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-google-plus fa-lg mt-4"
  }), _c('br'), _vm._v("google-plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-google-plus-square fa-lg mt-4"
  }), _c('br'), _vm._v("google-plus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-google-wallet fa-lg mt-4"
  }), _c('br'), _vm._v("google-wallet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gratipay fa-lg mt-4"
  }), _c('br'), _vm._v("gratipay\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hacker-news fa-lg mt-4"
  }), _c('br'), _vm._v("hacker-news\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-houzz fa-lg mt-4"
  }), _c('br'), _vm._v("houzz\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-html5 fa-lg mt-4"
  }), _c('br'), _vm._v("html5\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-lg mt-4"
  }), _c('br'), _vm._v("instagram\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-internet-explorer fa-lg mt-4"
  }), _c('br'), _vm._v("internet-explorer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ioxhost fa-lg mt-4"
  }), _c('br'), _vm._v("ioxhost\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-joomla fa-lg mt-4"
  }), _c('br'), _vm._v("joomla\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-jsfiddle fa-lg mt-4"
  }), _c('br'), _vm._v("jsfiddle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-lastfm fa-lg mt-4"
  }), _c('br'), _vm._v("lastfm\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-lastfm-square fa-lg mt-4"
  }), _c('br'), _vm._v("lastfm-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-leanpub fa-lg mt-4"
  }), _c('br'), _vm._v("leanpub\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-lg mt-4"
  }), _c('br'), _vm._v("linkedin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-linkedin-square fa-lg mt-4"
  }), _c('br'), _vm._v("linkedin-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-linux fa-lg mt-4"
  }), _c('br'), _vm._v("linux\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-maxcdn fa-lg mt-4"
  }), _c('br'), _vm._v("maxcdn\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-meanpath fa-lg mt-4"
  }), _c('br'), _vm._v("meanpath\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-medium fa-lg mt-4"
  }), _c('br'), _vm._v("medium\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mixcloud fa-lg mt-4"
  }), _c('br'), _vm._v("mixcloud\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-modx fa-lg mt-4"
  }), _c('br'), _vm._v("modx\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-odnoklassniki fa-lg mt-4"
  }), _c('br'), _vm._v("odnoklassniki\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-odnoklassniki-square fa-lg mt-4"
  }), _c('br'), _vm._v("odnoklassniki-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-opencart fa-lg mt-4"
  }), _c('br'), _vm._v("opencart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-openid fa-lg mt-4"
  }), _c('br'), _vm._v("openid\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-opera fa-lg mt-4"
  }), _c('br'), _vm._v("opera\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-optin-monster fa-lg mt-4"
  }), _c('br'), _vm._v("optin-monster\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pagelines fa-lg mt-4"
  }), _c('br'), _vm._v("pagelines\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paypal fa-lg mt-4"
  }), _c('br'), _vm._v("paypal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pied-piper fa-lg mt-4"
  }), _c('br'), _vm._v("pied-piper\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pied-piper-alt fa-lg mt-4"
  }), _c('br'), _vm._v("pied-piper-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pinterest fa-lg mt-4"
  }), _c('br'), _vm._v("pinterest\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pinterest-p fa-lg mt-4"
  }), _c('br'), _vm._v("pinterest-p\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pinterest-square fa-lg mt-4"
  }), _c('br'), _vm._v("pinterest-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-product-hunt fa-lg mt-4"
  }), _c('br'), _vm._v("product-hunt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-qq fa-lg mt-4"
  }), _c('br'), _vm._v("qq\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ra fa-lg mt-4"
  }), _c('br'), _vm._v("ra "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rebel fa-lg mt-4"
  }), _c('br'), _vm._v("rebel\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reddit fa-lg mt-4"
  }), _c('br'), _vm._v("reddit\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reddit-alien fa-lg mt-4"
  }), _c('br'), _vm._v("reddit-alien\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reddit-square fa-lg mt-4"
  }), _c('br'), _vm._v("reddit-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-renren fa-lg mt-4"
  }), _c('br'), _vm._v("renren\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-safari fa-lg mt-4"
  }), _c('br'), _vm._v("safari\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-scribd fa-lg mt-4"
  }), _c('br'), _vm._v("scribd\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sellsy fa-lg mt-4"
  }), _c('br'), _vm._v("sellsy\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-lg mt-4"
  }), _c('br'), _vm._v("share-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-alt-square fa-lg mt-4"
  }), _c('br'), _vm._v("share-alt-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shirtsinbulk fa-lg mt-4"
  }), _c('br'), _vm._v("shirtsinbulk\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-simplybuilt fa-lg mt-4"
  }), _c('br'), _vm._v("simplybuilt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-skyatlas fa-lg mt-4"
  }), _c('br'), _vm._v("skyatlas\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-skype fa-lg mt-4"
  }), _c('br'), _vm._v("skype\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-slack fa-lg mt-4"
  }), _c('br'), _vm._v("slack\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-slideshare fa-lg mt-4"
  }), _c('br'), _vm._v("slideshare\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-soundcloud fa-lg mt-4"
  }), _c('br'), _vm._v("soundcloud\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-spotify fa-lg mt-4"
  }), _c('br'), _vm._v("spotify\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stack-exchange fa-lg mt-4"
  }), _c('br'), _vm._v("stack-exchange\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stack-overflow fa-lg mt-4"
  }), _c('br'), _vm._v("stack-overflow\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-steam fa-lg mt-4"
  }), _c('br'), _vm._v("steam\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-steam-square fa-lg mt-4"
  }), _c('br'), _vm._v("steam-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stumbleupon fa-lg mt-4"
  }), _c('br'), _vm._v("stumbleupon\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stumbleupon-circle fa-lg mt-4"
  }), _c('br'), _vm._v("stumbleupon-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tencent-weibo fa-lg mt-4"
  }), _c('br'), _vm._v("tencent-weibo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-trello fa-lg mt-4"
  }), _c('br'), _vm._v("trello\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tripadvisor fa-lg mt-4"
  }), _c('br'), _vm._v("tripadvisor\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tumblr fa-lg mt-4"
  }), _c('br'), _vm._v("tumblr\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tumblr-square fa-lg mt-4"
  }), _c('br'), _vm._v("tumblr-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-twitch fa-lg mt-4"
  }), _c('br'), _vm._v("twitch\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-lg mt-4"
  }), _c('br'), _vm._v("twitter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-twitter-square fa-lg mt-4"
  }), _c('br'), _vm._v("twitter-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-usb fa-lg mt-4"
  }), _c('br'), _vm._v("usb\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-viacoin fa-lg mt-4"
  }), _c('br'), _vm._v("viacoin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-vimeo fa-lg mt-4"
  }), _c('br'), _vm._v("vimeo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-vimeo-square fa-lg mt-4"
  }), _c('br'), _vm._v("vimeo-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-vine fa-lg mt-4"
  }), _c('br'), _vm._v("vine\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-vk fa-lg mt-4"
  }), _c('br'), _vm._v("vk\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wechat fa-lg mt-4"
  }), _c('br'), _vm._v("wechat "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-weibo fa-lg mt-4"
  }), _c('br'), _vm._v("weibo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-weixin fa-lg mt-4"
  }), _c('br'), _vm._v("weixin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp fa-lg mt-4"
  }), _c('br'), _vm._v("whatsapp\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wikipedia-w fa-lg mt-4"
  }), _c('br'), _vm._v("wikipedia-w\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-windows fa-lg mt-4"
  }), _c('br'), _vm._v("windows\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wordpress fa-lg mt-4"
  }), _c('br'), _vm._v("wordpress\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-xing fa-lg mt-4"
  }), _c('br'), _vm._v("xing\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-xing-square fa-lg mt-4"
  }), _c('br'), _vm._v("xing-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-y-combinator fa-lg mt-4"
  }), _c('br'), _vm._v("y-combinator\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-y-combinator-square fa-lg mt-4"
  }), _c('br'), _vm._v("y-combinator-square "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-yahoo fa-lg mt-4"
  }), _c('br'), _vm._v("yahoo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-yc fa-lg mt-4"
  }), _c('br'), _vm._v("yc "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-yc-square fa-lg mt-4"
  }), _c('br'), _vm._v("yc-square "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-yelp fa-lg mt-4"
  }), _c('br'), _vm._v("yelp\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-youtube fa-lg mt-4"
  }), _c('br'), _vm._v("youtube\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-youtube-play fa-lg mt-4"
  }), _c('br'), _vm._v("youtube-play\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-youtube-square fa-lg mt-4"
  }), _c('br'), _vm._v("youtube-square\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-success mt-4"
  }, [_c('ul', {
    staticClass: "margin-bottom-none padding-left-lg"
  }, [_c('li', [_vm._v("All brand icons are trademarks of their respective owners.")]), _vm._v(" "), _c('li', [_vm._v("The use of these trademarks does not indicate endorsement of the trademark holder by Font Awesome, nor vice versa.")]), _vm._v(" "), _c('li', [_vm._v("Brand icons should only be used to represent the company or product to which they refer.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "medical"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Medical Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ambulance fa-lg mt-4"
  }), _c('br'), _vm._v("ambulance\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-h-square fa-lg mt-4"
  }), _c('br'), _vm._v("h-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heart fa-lg mt-4"
  }), _c('br'), _vm._v("heart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heart-o fa-lg mt-4"
  }), _c('br'), _vm._v("heart-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat fa-lg mt-4"
  }), _c('br'), _vm._v("heartbeat\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hospital-o fa-lg mt-4"
  }), _c('br'), _vm._v("hospital-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-medkit fa-lg mt-4"
  }), _c('br'), _vm._v("medkit\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-square fa-lg mt-4"
  }), _c('br'), _vm._v("plus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stethoscope fa-lg mt-4"
  }), _c('br'), _vm._v("stethoscope\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user-md fa-lg mt-4"
  }), _c('br'), _vm._v("user-md\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wheelchair fa-lg mt-4"
  }), _c('br'), _vm._v("wheelchair\n        ")])])])])])
}]}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('AppHeader'), _vm._v(" "), _c('div', {
    staticClass: "app-body",
    class: {
      'no-margin': _vm.$route.query.app
    }
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fluid container-nobreadcrumb"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('AppAside')], 1), _vm._v(" "), _c('AppFooter')], 1)
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('div', {
    staticClass: "animated fadeIn setting-container step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.settings.title')))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.settings.notification')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.sms_confirmation),
      expression: "clinic.sms_confirmation"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.sms_confirmation) ? _vm._i(_vm.clinic.sms_confirmation, null) > -1 : (_vm.clinic.sms_confirmation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.sms_confirmation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.sms_confirmation = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.sms_confirmation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.sms_confirmation = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.notify_when_appointment')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.sms_active),
      expression: "clinic.sms_active"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.sms_active) ? _vm._i(_vm.clinic.sms_active, null) > -1 : (_vm.clinic.sms_active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.sms_active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.sms_active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.sms_active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.sms_active = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.notify_sms')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.first_sms_reminder),
      expression: "clinic.first_sms_reminder"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.first_sms_reminder) ? _vm._i(_vm.clinic.first_sms_reminder, null) > -1 : (_vm.clinic.first_sms_reminder)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.first_sms_reminder,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.first_sms_reminder = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.first_sms_reminder = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.first_sms_reminder = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.notify_before_one_day')) + " " + _vm._s(_vm.$t('message.settings.time')))]), _vm._v(" "), _c('vue-timepicker', {
    model: {
      value: (_vm.clinic.first_reminder_time_p),
      callback: function($$v) {
        _vm.clinic.first_reminder_time_p = $$v
      },
      expression: "clinic.first_reminder_time_p"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.second_sms_reminder),
      expression: "clinic.second_sms_reminder"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.second_sms_reminder) ? _vm._i(_vm.clinic.second_sms_reminder, null) > -1 : (_vm.clinic.second_sms_reminder)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.second_sms_reminder,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.second_sms_reminder = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.second_sms_reminder = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.second_sms_reminder = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.notify_appointment_day')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.credit_remain')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.clinic.sms_credit))])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])]), _vm._v(" "), _c('h6', [_vm._v("การนัดหมาย Online")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.appointment_active),
      expression: "clinic.appointment_active"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.appointment_active) ? _vm._i(_vm.clinic.appointment_active, null) > -1 : (_vm.clinic.appointment_active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.appointment_active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.appointment_active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.appointment_active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.appointment_active = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Online Appointment")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.instant_booking),
      expression: "clinic.instant_booking"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.instant_booking) ? _vm._i(_vm.clinic.instant_booking, null) > -1 : (_vm.clinic.instant_booking)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.instant_booking,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.instant_booking = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.instant_booking = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.instant_booking = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Instant Booking")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.instant_booking_sms_confirmation),
      expression: "clinic.instant_booking_sms_confirmation"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.instant_booking_sms_confirmation) ? _vm._i(_vm.clinic.instant_booking_sms_confirmation, null) > -1 : (_vm.clinic.instant_booking_sms_confirmation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.instant_booking_sms_confirmation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.instant_booking_sms_confirmation = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.instant_booking_sms_confirmation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.instant_booking_sms_confirmation = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("ส่ง SMS confirm เมื่อมี Instant Booking")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.forward_to_clinic_email),
      expression: "clinic.forward_to_clinic_email"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.forward_to_clinic_email) ? _vm._i(_vm.clinic.forward_to_clinic_email, null) > -1 : (_vm.clinic.forward_to_clinic_email)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.forward_to_clinic_email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.forward_to_clinic_email = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.forward_to_clinic_email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.forward_to_clinic_email = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.new_appointment_fwd_to_mail')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Emails อื่นๆ (สำหรับการรับแจ้งเตือนนัดหมาย)")]), _vm._v(" "), _c('doctor-single-input', {
    attrs: {
      "dataset": _vm.clinic.clinic_email,
      "description": _vm.$t('message.settings.email')
    },
    on: {
      "update:dataset": [function($event) {
        _vm.clinic.clinic_email = $event
      }, function (v) { return _vm.clinic.clinic_email = v; }]
    }
  }), _vm._v(" "), _c('doctor-array-input', {
    attrs: {
      "dataset": _vm.clinic.emails,
      "description": _vm.$t('message.settings.email')
    },
    on: {
      "update:dataset": [function($event) {
        _vm.clinic.emails = $event
      }, function (v) { return _vm.clinic.emails = v; }]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.auto_match_ehr_patient),
      expression: "clinic.auto_match_ehr_patient"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.auto_match_ehr_patient) ? _vm._i(_vm.clinic.auto_match_ehr_patient, null) > -1 : (_vm.clinic.auto_match_ehr_patient)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.auto_match_ehr_patient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.auto_match_ehr_patient = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.auto_match_ehr_patient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.auto_match_ehr_patient = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.auto_create_patient')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm",
    slot: "loader"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "icon": "success"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 d-flex justify-content-start"
  }, [_c('h2', {
    staticClass: "p-2"
  }, [_vm._v(_vm._s(_vm.$t('message.report.title')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form ml-auto p-2",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "date-filter",
      "options": _vm.dateFilterOptions,
      "multiple": false,
      "allow-empty": false,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selectedDateFilter),
      callback: function($$v) {
        _vm.selectedDateFilter = $$v
      },
      expression: "selectedDateFilter"
    }
  })], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-center"
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "margin": "auto"
    }
  }, [_c('dot-loader', {
    attrs: {
      "size": "60px"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('message.report.view_and_appointment')))])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item group-item-box"
  }, [_c('tabs', {
    staticClass: "appointmentStatTab",
    attrs: {
      "nav-style": "tabs",
      "justified": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('tab', {
    attrs: {
      "header": ("<h6 class='apm-cnt-title'>นัดหมาย</h6><h2>" + (_vm.appointmentStatChartData.count) + "</h2>")
    }
  }, [_c('report-line-chart', {
    staticClass: "chart-wrapper px-3",
    staticStyle: {
      "height": "12rem"
    },
    attrs: {
      "chartData": _vm.appointmentStatChartData
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": ("<h6 class='apm-cnt-title'>ผู้เยี่ยมชม</h6><h2>" + (_vm.viewStatChartData.count) + "</h2>")
    }
  }, [_c('report-line-chart', {
    staticClass: "chart-wrapper px-3",
    staticStyle: {
      "height": "12rem"
    },
    attrs: {
      "chartData": _vm.viewStatChartData
    }
  })], 1)], 1)], 1)])])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('message.report.status_summary')))])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item group-item-box"
  }, [_c('tabs', {
    staticClass: "appointmentStatusStatTab",
    attrs: {
      "nav-style": "tabs",
      "justified": ""
    }
  }, [_c('tab', {
    attrs: {
      "header": ("<h6 class='apm-status-cnt-title'>" + (_vm.$t('message.report.status_pending')) + "</h6><h2>" + (_vm.getAppointmentStatusCount('pending')) + "</h2>")
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": ("<h6 class='apm-status-cnt-title'>" + (_vm.$t('message.report.status_checkin')) + "</h6><h2>" + (_vm.getAppointmentStatusCount('checkin')) + "</h2>")
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": ("<h6 class='apm-status-cnt-title'>" + (_vm.$t('message.report.status_cancel')) + "</h6><h2>" + (_vm.getAppointmentStatusCount('cancel')) + "</h2>")
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": ("<h6 class='apm-status-cnt-title'>" + (_vm.$t('message.report.status_scheduled')) + "</h6><h2>" + (_vm.getAppointmentStatusCount('scheduled')) + "</h2>")
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('message.report.visitor_detail')))])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item group-item-box gender-progress-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('i', {
    staticClass: "fa fa-male",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('message.report.male')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar male-progress",
    style: ({
      width: (_vm.malePercent + "%")
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": _vm.malePercent
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('i', {
    staticClass: "fa fa-female",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('message.report.female')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar female-progress",
    style: ({
      width: (_vm.femalePercent + "%")
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": _vm.femalePercent
    }
  })])])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('message.report.article')))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('message.report.popular_article')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('message.report.article_visitor')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.stats.articleStat), function(article, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-truncate"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openPath(("" + (article.path)))
        }
      }
    }, [_vm._v(_vm._s(article.title))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(article.count))])])
  }), _vm._v(" "), (_vm.stats.articleStat.length === 0) ? _c('tr', [_c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.report.no_article')))])])]) : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic() && !_vm.loading) ? _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('message.report.popular_doctor')))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('message.report.doctor_rank')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('message.report.doctor_name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('message.report.doctor_appointment_count')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.orderedDoctorStat), function(doctor, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center align-middle"
    }, [_vm._v(_vm._s(index + 1) + _vm._s(_vm._f("pluralize")(index + 1, 'st', 'nd', 'rd', 'th')))]), _vm._v(" "), _c('td', {
      staticClass: "text-truncate"
    }, [_c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openPath(("/doctor/" + (doctor.doctor_id)))
        }
      }
    }, [_vm._v(_vm._s(_vm.getDoctorName(doctor)))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_vm._v(_vm._s(doctor.appointment_count))])])
  }), _vm._v(" "), (_vm.orderedDoctorStat.length === 0) ? _c('tr', [_vm._m(0)]) : _vm._e()], 2)])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', [_vm._v("ไม่พบหมอ")])])
}]}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container schedule-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.schedules.title')))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.schedules.schedule_for')) + _vm._s(_vm.clinic.th.clinic_name))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group",
    on: {
      "click": function($event) {
        _vm.checkFeature()
      }
    }
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.appointment_active),
      expression: "clinic.appointment_active"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.appointment_active) ? _vm._i(_vm.clinic.appointment_active, null) > -1 : (_vm.clinic.appointment_active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.appointment_active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.appointment_active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.appointment_active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.appointment_active = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('message.schedules.online_appointment_on')))]), _vm._v(" "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$guser.isPremiumAccount()) ? _c('div', {
    staticClass: "disable-bg"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.instant_booking),
      expression: "clinic.instant_booking"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.instant_booking) ? _vm._i(_vm.clinic.instant_booking, null) > -1 : (_vm.clinic.instant_booking)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.instant_booking,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.instant_booking = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.instant_booking = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.instant_booking = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Instant Booking")]), _vm._v(" "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$guser.isPremiumAccount()) ? _c('div', {
    staticClass: "disable-bg"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.schedules.select_time_slot')))])]), _vm._v(" "), _c('working-schedule', {
    attrs: {
      "schedules": _vm.clinic.schedules,
      "clinic_id": _vm.clinic.id,
      "time_slots": _vm.slotData.time_slots,
      "booking_per_slot": _vm.slotData.booking_per_slot
    },
    on: {
      "scheduleChanged": _vm.updateSchedules
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _vm._t("loader")], 2)])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "lockModal",
    attrs: {
      "icon": "info",
      "title": "ฟังชั้นนี้ถูกปิดการใช้งานอยู่",
      "overlay-theme": "dark"
    }
  }, [_c('p', [_vm._v("ฟังชั้นนี้ถูกปิดการใช้งานอยู่ ต้องการปลดล๊อกกรุณากดปุ่ม unlock ด้านล่าง")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.gotoPlanPage()
      }
    }
  }, [(!_vm.isActive) ? _c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" Unlock")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appointment-detail-wrapper"
  }, [(_vm.dataLoaded) ? _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 title-section"
  }, [_c('h4', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(this.$t('message.appointment.title_edit')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('bs-dropdown', {
    staticClass: "confirm-btn-lg",
    attrs: {
      "text": _vm.appointment.status,
      "type": _vm.dropdownStatus,
      "disabled": _vm.isCancelAppointment
    }
  }, [(_vm.appointment.status !== 'checkin') ? _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-success",
    on: {
      "click": function($event) {
        _vm.changeStatus('scheduled')
      }
    }
  }, [_vm._v(_vm._s(this.$t('message.appointment.status_scheduled')))])]) : _vm._e(), _vm._v(" "), (_vm.appointment.status !== 'pending' && _vm.appointment.status !== 'checkin') ? _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-success",
    on: {
      "click": function($event) {
        _vm.changeStatus('checkin')
      }
    }
  }, [_vm._v(_vm._s(this.$t('message.appointment.status_checkin')))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-danger",
    on: {
      "click": function($event) {
        _vm.changeStatus('cancel ')
      }
    }
  }, [_vm._v(_vm._s(this.$t('message.appointment.status_cancel')))])])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', {
    attrs: {
      "for": "fp"
    }
  }, [_vm._v(_vm._s(this.$t('message.appointment.label_date_time_appointment')))]), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "id": "fp",
      "config": _vm.fpConfig,
      "required": ""
    },
    model: {
      value: (_vm.appointment.appointment_time),
      callback: function($$v) {
        _vm.appointment.appointment_time = $$v
      },
      expression: "appointment.appointment_time"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.doctor')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "doctor",
      "placeholder": this.$t('message.appointment.doctor_placeholder'),
      "options": _vm.doctor_options,
      "allow-empty": true,
      "disabled": _vm.isCancelAppointment,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.doctor),
      callback: function($$v) {
        _vm.appointment.doctor = $$v
      },
      expression: "appointment.doctor"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.doctorIdError
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient_type),
      expression: "patient_type"
    }],
    ref: "patient_type_a",
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "patient_type",
      "value": "noexists",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.patient_type, "noexists")
    },
    on: {
      "__c": function($event) {
        _vm.patient_type = "noexists"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.appointment.new_patient')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient_type),
      expression: "patient_type"
    }],
    ref: "patient_type_b",
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "patient_type",
      "value": "exists",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.patient_type, "exists")
    },
    on: {
      "__c": function($event) {
        _vm.patient_type = "exists"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.appointment.old_patient')) + "\n            ")])])]), _vm._v(" "), (_vm.isExistingPatient) ? _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "patient",
      "placeholder": this.$t('message.appointment.search_patient_placeholder'),
      "options": _vm.patient_list,
      "allow-empty": true,
      "disabled": _vm.isCancelAppointment,
      "loading": _vm.patientLoading,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getPatients
    },
    model: {
      value: (_vm.selected_patient),
      callback: function($$v) {
        _vm.selected_patient = $$v
      },
      expression: "selected_patient"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.prefix')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "prefix",
      "placeholder": this.$t('message.appointment.prefix_placeholder'),
      "options": _vm.prefix_options,
      "allow-empty": true,
      "disabled": _vm.isCancelAppointment,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.prefix),
      callback: function($$v) {
        _vm.appointment.prefix = $$v
      },
      expression: "appointment.prefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "readonly": _vm.isExistingPatient,
      "label": this.$t('message.appointment.firstname'),
      "placeholder": this.$t('message.appointment.firstname_placeholder'),
      "required": "",
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.firstname),
      callback: function($$v) {
        _vm.appointment.firstname = $$v
      },
      expression: "appointment.firstname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.firstnameError
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "readonly": _vm.isExistingPatient,
      "label": this.$t('message.appointment.lastname'),
      "placeholder": this.$t('message.appointment.lastname_placeholder'),
      "required": "",
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.lastname),
      callback: function($$v) {
        _vm.appointment.lastname = $$v
      },
      expression: "appointment.lastname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.lastnameError
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    attrs: {
      "readonly": _vm.isExistingPatient,
      "label": this.$t('message.appointment.hn'),
      "placeholder": this.$t('message.appointment.hn'),
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.hn),
      callback: function($$v) {
        _vm.appointment.hn = $$v
      },
      expression: "appointment.hn"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body phone-section"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.phone')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.phone),
      expression: "appointment.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "phone",
      "readonly": _vm.isExistingPatient,
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "value": (_vm.appointment.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.appointment.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.phoneError
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "readonly": _vm.isExistingPatient,
      "label": this.$t('message.appointment.email'),
      "type": "email",
      "placeholder": this.$t('message.appointment.email_placeholder'),
      "required": "",
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.email),
      callback: function($$v) {
        _vm.appointment.email = $$v
      },
      expression: "appointment.email"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.emailError
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.seen_doctor')))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.seen_doctor),
      expression: "appointment.seen_doctor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "seen_doctor",
      "value": "1",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.seen_doctor, "1")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.seen_doctor = "1"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.have')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.seen_doctor),
      expression: "appointment.seen_doctor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "seen_doctor",
      "value": "0",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.seen_doctor, "0")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.seen_doctor = "0"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.have_not')) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.medical_record')))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.has_medical_record),
      expression: "appointment.has_medical_record"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "has_medical_record",
      "value": "1",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.has_medical_record, "1")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.has_medical_record = "1"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.have_yes')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.has_medical_record),
      expression: "appointment.has_medical_record"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "has_medical_record",
      "value": "0",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.has_medical_record, "0")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.has_medical_record = "0"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.have_no')) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.booking_for')))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.for),
      expression: "appointment.for"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "for",
      "value": "myself",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.for, "myself")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.for = "myself"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.myself')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.for),
      expression: "appointment.for"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "for",
      "value": "other",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.for, "other")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.for = "other"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.another')) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    attrs: {
      "label": this.$t('message.appointment.id_card'),
      "readonly": _vm.isExistingPatient,
      "placeholder": this.$t('message.appointment.id_card'),
      "required": "",
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.id_card),
      callback: function($$v) {
        _vm.appointment.id_card = $$v
      },
      expression: "appointment.id_card"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', {
    attrs: {
      "for": "fp"
    }
  }, [_vm._v(_vm._s(this.$t('message.appointment.birthdate')))]), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "id": "fp",
      "config": _vm.fpConfigBirthday,
      "required": ""
    },
    model: {
      value: (_vm.appointment.birthday),
      callback: function($$v) {
        _vm.appointment.birthday = $$v
      },
      expression: "appointment.birthday"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.service')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "service",
      "placeholder": this.$t('message.appointment.service_placeholder'),
      "options": _vm.service_options,
      "allow-empty": true,
      "disabled": _vm.isCancelAppointment,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.service),
      callback: function($$v) {
        _vm.appointment.service = $$v
      },
      expression: "appointment.service"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.duration')))]), _vm._v(" "), _c('bs-input', {
    staticClass: "input-min",
    attrs: {
      "type": "Number",
      "min": "15",
      "max": "1440",
      "step": 15,
      "placeholder": this.$t('message.appointment.duration_placeholder'),
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.duration),
      callback: function($$v) {
        _vm.appointment.duration = _vm._n($$v)
      },
      expression: "appointment.duration"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(this.$t('message.appointment.duration_unit')))])])])], 1)])]), _vm._v(" "), (_vm.appointment.comment) ? _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.addition')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.appointment.comment))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.locale')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "locale",
      "placeholder": _vm.$t('message.appointment.locale_placeholder'),
      "options": _vm.locale_options,
      "allow-empty": false,
      "disabled": _vm.isCancelAppointment,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.locale),
      callback: function($$v) {
        _vm.appointment.locale = $$v
      },
      expression: "appointment.locale"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', [_vm._l((_vm.templates.remark_templates), function(rt) {
    return _c('button', {
      key: rt.name,
      staticClass: "btn btn-secondary btn-sm btn-remark-template",
      attrs: {
        "type": "button",
        "disabled": _vm.isCancelAppointment
      },
      on: {
        "click": function($event) {
          _vm.appendRemark(rt.text)
        }
      }
    }, [_vm._v(_vm._s(rt.name))])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm btn-success",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openRemarkEditor($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])], 2), _vm._v(" "), _c('bs-input', {
    ref: "remark",
    attrs: {
      "type": "textarea",
      "label": this.$t('message.appointment.remark'),
      "placeholder": this.$t('message.appointment.remark_placeholder'),
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.remark),
      callback: function($$v) {
        _vm.appointment.remark = $$v
      },
      expression: "appointment.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    attrs: {
      "type": "textarea",
      "label": this.$t('message.appointment.admin_remark'),
      "placeholder": this.$t('message.appointment.admin_remark_placeholder'),
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.admin_note),
      callback: function($$v) {
        _vm.appointment.admin_note = $$v
      },
      expression: "appointment.admin_note"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body form-group action-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(this.$t('action_message.back')))]), _vm._v(" "), (!_vm.isCancelAppointment) ? _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAppointment
    }
  }, [_vm._v(_vm._s(this.$t('action_message.save')))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])])]) : _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 offset-md-5"
  }, [_c('dot-loader', {
    attrs: {
      "loading": true,
      "size": "60px"
    }
  })], 1)])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "remarkModal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('remark-editor', {
    attrs: {
      "remarks": _vm.templates.remark_templates
    },
    on: {
      "update:remarks": function($event) {
        _vm.templates.remark_templates = $event
      },
      "closeEditor": _vm.closeRemarkModal,
      "submitRemark": _vm.updateRemarks
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-dot v-dot1",
    style: (_vm.spinnerBasicStyle)
  }, [_c('div', {
    staticClass: "v-dot v-dot2",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-dot v-dot3",
    style: (_vm.spinnerStyle)
  })])])
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.dashboard.title')))])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-center"
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "margin": "auto"
    }
  }, [_c('dot-loader', {
    attrs: {
      "size": "60px"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.notificationShow && !_vm.loading) ? _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('message.dashboard.notification')))])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, _vm._l((_vm.notifications), function(notiItem) {
    return _c('li', {
      key: notiItem.id,
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "noti-item-card"
    }, [_c('p', {
      staticClass: "noti-item-message mb-0",
      domProps: {
        "innerHTML": _vm._s(notiItem.message)
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "noti-item-btn btn btn-warning btn-lg",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.actionProcess(notiItem.type)
        }
      }
    }, [_vm._v(_vm._s(notiItem.action))])])])
  }))])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('message.dashboard.appointment_m')))])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('h6', {
    staticClass: "apm-cnt-title"
  }, [_vm._v(_vm._s(_vm.$t('message.dashboard.appointment')))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.appointmentStatChartData.count))]), _vm._v(" "), _c('dashboard-line-chart', {
    staticClass: "chart-wrapper px-3",
    staticStyle: {
      "height": "12rem"
    },
    attrs: {
      "chartData": _vm.appointmentStatChartData
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.gotoAppointments($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.dashboard.view_all_appointment')))])])])])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('message.dashboard.visitor_m')))])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('h6', {
    staticClass: "apm-cnt-title"
  }, [_vm._v(_vm._s(_vm.$t('message.dashboard.visitor')))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.viewStatChartData.count))]), _vm._v(" "), _c('dashboard-line-chart', {
    staticClass: "chart-wrapper px-3",
    staticStyle: {
      "height": "12rem"
    },
    attrs: {
      "chartData": _vm.viewStatChartData
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.gotoAppointments($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.dashboard.view_all_visitor')))])])])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropzone-box"
  }, [_c('input', {
    staticClass: "dropzone-input-file",
    attrs: {
      "type": "file",
      "name": _vm.uploadFieldName,
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileChange
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.placeholder)
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [(_vm.$route.query.action === 'edit') ? _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_edit')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_new')))]), _vm._v(" "), _c('step', {
    attrs: {
      "currentStep": 5,
      "maxStep": 5
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.personal_info')))]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.experience')))]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.schedules')))]), _vm._v(" "), _c('div', {
    slot: "4"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.education')))]), _vm._v(" "), _c('div', {
    slot: "5"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.other_info')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.other_info')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_info.language')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "languages",
      "placeholder": _vm.$t('message.doctor_info.language_placeholder'),
      "options": _vm.language_list,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_languages),
      callback: function($$v) {
        _vm.selected_languages = $$v
      },
      expression: "selected_languages"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_info.video_links')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "step-subheader"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_info.youtube_link')))])])]), _vm._v(" "), _c('doctor-array-input', {
    attrs: {
      "dataset": _vm.doctor.th.video_links,
      "description": _vm.$t('message.doctor_info.youtube_link')
    },
    on: {
      "update:dataset": [function($event) {
        _vm.doctor.th.video_links = $event
      }, function (v) { return _vm.doctor.th.video_links = v; }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    on: {
      "click": function($event) {
        _vm.checkFeature()
      }
    }
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_info.addition_info')) + " "), (!_vm.isActive) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    on: {
      "click": function($event) {
        _vm.checkFeature()
      }
    }
  }, [_c('p', {
    staticClass: "step-subheader"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_info.addition_info_th')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    on: {
      "click": function($event) {
        _vm.checkFeature()
      }
    }
  }, [_c('ckeditor', {
    attrs: {
      "config": _vm.ckeditorConfig
    },
    model: {
      value: (_vm.doctor.th.info),
      callback: function($$v) {
        _vm.doctor.th.info = $$v
      },
      expression: "doctor.th.info"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "editor-lock"
  }, [(!_vm.isActive) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    on: {
      "click": function($event) {
        _vm.checkFeature()
      }
    }
  }, [_c('p', {
    staticClass: "step-subheader"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_info.addition_info_en')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    on: {
      "click": function($event) {
        _vm.checkFeature()
      }
    }
  }, [_c('ckeditor', {
    attrs: {
      "config": _vm.ckeditorConfig
    },
    model: {
      value: (_vm.doctor.en.info),
      callback: function($$v) {
        _vm.doctor.en.info = $$v
      },
      expression: "doctor.en.info"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "editor-lock"
  }, [(!_vm.isActive) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), (_vm.$route.query.action === 'edit') ? _c('button', {
    staticClass: "btn btn-delete btn-right btn-lg",
    on: {
      "click": _vm.deleteDoctor
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])], 1)]), _vm._v(" "), _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "icon": "success"
    }
  }, [(_vm.editMode) ? _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_info.save_success')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_info.create_success')))])]), _vm._v(" "), _c('sweet-modal', {
    ref: "infoLockModal",
    attrs: {
      "icon": "info",
      "title": "ฟังชั้นนี้ถูกปิดการใช้งานอยู่",
      "overlay-theme": "dark"
    }
  }, [_c('p', [_vm._v("ฟังชั้นนี้ถูกปิดการใช้งานอยู่ ต้องการปลดล๊อกกรุณากดปุ่ม unlock ด้านล่าง")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.gotoPlanPage()
      }
    }
  }, [(!_vm.isActive) ? _c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" Unlock")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body clinic-service-wrapper"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.services.title')))]), _vm._v(" "), (!_vm.showAddPanel) ? _c('button', {
    staticClass: "add-service btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddPanel = !_vm.showAddPanel;
        _vm.editMode = false;
        _vm.clearFormError();
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('action_message.add')))]) : _vm._e(), _vm._v(" "), (_vm.showAddPanel) ? _c('button', {
    staticClass: "add-service btn btn-info",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddPanel = !_vm.showAddPanel;
        _vm.service = Object.assign({}, _vm.defaultService);
        _vm.clearFormError()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.list')))]) : _vm._e()]), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "service-wrapper"
  }, [(!!_vm.services.length > 0) ? _c('div', [_c('draggable', {
    on: {
      "end": _vm.onServiceDraggableEnd
    },
    model: {
      value: (_vm.services),
      callback: function($$v) {
        _vm.services = $$v
      },
      expression: "services"
    }
  }, [_c('transition-group', _vm._l((_vm.services), function(s, index) {
    return _c('div', {
      key: index,
      staticClass: "service-container"
    }, [_c('div', {
      staticClass: "service-content",
      on: {
        "click": function($event) {
          _vm.editService(s)
        }
      }
    }, [_c('h6', [_vm._v(_vm._s(s.th.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(s.th.description))]), _vm._v(" "), (s.is_price_range) ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.price')))]), _vm._v(" " + _vm._s(s.price_from) + " - " + _vm._s(s.price_to) + "\n                  ")]) : _vm._e(), _vm._v(" "), (s.is_price_from) ? _c('div', [_c('strong', [_vm._v("ราคาเริ่มต้น ")]), _vm._v(" " + _vm._s(s.price_from) + "\n                  ")]) : _vm._e(), _vm._v(" "), (!s.is_price_range && !s.is_price_from) ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.price')))]), _vm._v(" " + _vm._s(s.price) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "service-actions"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      on: {
        "click": function($event) {
          _vm.editService(s)
        }
      }
    }), _vm._v(" "), (!_vm.$ismobile()) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('action_message.edit')))])]) : _vm._e()])])
  }))], 1)], 1) : _c('h6', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.services.no_services')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.showAddPanel) ? _c('div', {
    staticClass: "service-form"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.services.add_new_service')))]), _vm._v(" "), _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom",
    attrs: {
      "label": _vm.$t('message.services.service_name_th'),
      "placeholder": _vm.$t('message.services.service_name_th')
    },
    model: {
      value: (_vm.service.th.name),
      callback: function($$v) {
        _vm.service.th.name = $$v
      },
      expression: "service.th.name"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['th.name']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1), _vm._v(" "), _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom",
    attrs: {
      "label": _vm.$t('message.services.service_name_en'),
      "placeholder": _vm.$t('message.services.service_name_en')
    },
    model: {
      value: (_vm.service.en.name),
      callback: function($$v) {
        _vm.service.en.name = $$v
      },
      expression: "service.en.name"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['en.name']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.services.select_duration')))]), _vm._v(" "), _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom input-min",
    attrs: {
      "type": "Number",
      "min": "1",
      "max": "59",
      "placeholder": _vm.$t('message.services.service_duration')
    },
    model: {
      value: (_vm.service.duration),
      callback: function($$v) {
        _vm.service.duration = $$v
      },
      expression: "service.duration"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.minutes')))])])]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.duration
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.services.price')) + "  \n          "), _c('div', {
    staticClass: "form-check form-check-inline",
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceOption),
      expression: "priceOption"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "basicInlineRadios",
      "value": "price_default"
    },
    domProps: {
      "checked": _vm._q(_vm.priceOption, "price_default")
    },
    on: {
      "__c": function($event) {
        _vm.priceOption = "price_default"
      }
    }
  }), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceOption),
      expression: "priceOption"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "basicInlineRadios",
      "value": "price_range"
    },
    domProps: {
      "checked": _vm._q(_vm.priceOption, "price_range")
    },
    on: {
      "__c": function($event) {
        _vm.priceOption = "price_range"
      }
    }
  }), _c('label', {
    staticClass: "form-check-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.services.price_range')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceOption),
      expression: "priceOption"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "basicInlineRadios",
      "value": "price_from"
    },
    domProps: {
      "checked": _vm._q(_vm.priceOption, "price_from")
    },
    on: {
      "__c": function($event) {
        _vm.priceOption = "price_from"
      }
    }
  }), _vm._m(1)])]), _vm._v(" "), (!_vm.service.is_price_range && !_vm.service.is_price_from) ? _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom input-price-range",
    attrs: {
      "placeholder": _vm.$t('message.services.price')
    },
    model: {
      value: (_vm.service.price),
      callback: function($$v) {
        _vm.service.price = $$v
      },
      expression: "service.price"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.baht')))])])]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.price
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.service.is_price_range) ? _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom input-price-range",
    attrs: {
      "placeholder": _vm.$t('message.services.price_from')
    },
    model: {
      value: (_vm.service.price_from),
      callback: function($$v) {
        _vm.service.price_from = $$v
      },
      expression: "service.price_from"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.baht')) + " (" + _vm._s(_vm.$t('message.services.price_from')) + ")")])])]), _vm._v(" "), _c('bs-input', {
    staticClass: "remove-padding-bottom input-price-range",
    attrs: {
      "placeholder": _vm.$t('message.services.price_to')
    },
    model: {
      value: (_vm.service.price_to),
      callback: function($$v) {
        _vm.service.price_to = $$v
      },
      expression: "service.price_to"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.baht')) + " (" + _vm._s(_vm.$t('message.services.price_to')) + ")")])])]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.price_from
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.price_10
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.service.is_price_from) ? _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom input-price-range",
    attrs: {
      "placeholder": _vm.$t('message.services.price_from')
    },
    model: {
      value: (_vm.service.price_from),
      callback: function($$v) {
        _vm.service.price_from = $$v
      },
      expression: "service.price_from"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.baht')) + " (" + _vm._s(_vm.$t('message.services.price_from')) + ")")])])]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.price_from
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.price_10
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.services.service_detail')))]), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "label": _vm.$t('message.services.service_detail_th'),
      "placeholder": _vm.$t('message.services.service_detail_th')
    },
    model: {
      value: (_vm.service.th.description),
      callback: function($$v) {
        _vm.service.th.description = $$v
      },
      expression: "service.th.description"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "label": _vm.$t('message.services.service_detail_en'),
      "placeholder": _vm.$t('message.services.service_detail_en')
    },
    model: {
      value: (_vm.service.en.description),
      callback: function($$v) {
        _vm.service.en.description = $$v
      },
      expression: "service.en.description"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": _vm.cancelAddingService
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": _vm.addService
    }
  }, [_vm._v(_vm._s(_vm.editMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.add')))]), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-service-action",
    on: {
      "click": _vm.removeService
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _vm._t("loader")], 2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form-check-label"
  }, [_c('span', [_vm._v("ปรกติ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form-check-label"
  }, [_c('span', [_vm._v("ราคาเริ่มต้น")])])
}]}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('dropdown', {
    attrs: {
      "text": "Action",
      "type": "primary"
    }
  }, [_c('div', {
    staticClass: "dropdown-menu",
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])], 1), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "input1-group3",
      "name": "input1-group3",
      "placeholder": "Username"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "input2-group3",
      "name": "input2-group3",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('dropdown', {
    attrs: {
      "text": "Action",
      "type": "primary"
    }
  }, [_c('div', {
    staticClass: "dropdown-menu",
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('dropdown', {
    attrs: {
      "type": "primary"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    slot: "before"
  }, [_vm._v("Segmented")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])], 1), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "input3-group3",
      "name": "input3-group3",
      "placeholder": ".."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('dropdown', {
    attrs: {
      "text": "Action",
      "type": "primary"
    }
  }, [_c('div', {
    staticClass: "dropdown-menu",
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])], 1)])])])])]), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Credit Card")]), _vm._v(" "), _c('small', [_vm._v("Form")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Enter your name"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ccnumber"
    }
  }, [_vm._v("Credit Card Number")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "ccnumber",
      "placeholder": "0000 0000 0000 0000"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "ccmonth"
    }
  }, [_vm._v("Month")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "ccmonth"
    }
  }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("11")]), _vm._v(" "), _c('option', [_vm._v("12")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "ccyear"
    }
  }, [_vm._v("Year")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "ccyear"
    }
  }, [_c('option', [_vm._v("2014")]), _vm._v(" "), _c('option', [_vm._v("2015")]), _vm._v(" "), _c('option', [_vm._v("2016")]), _vm._v(" "), _c('option', [_vm._v("2017")]), _vm._v(" "), _c('option', [_vm._v("2018")]), _vm._v(" "), _c('option', [_vm._v("2019")]), _vm._v(" "), _c('option', [_vm._v("2020")]), _vm._v(" "), _c('option', [_vm._v("2021")]), _vm._v(" "), _c('option', [_vm._v("2022")]), _vm._v(" "), _c('option', [_vm._v("2023")]), _vm._v(" "), _c('option', [_vm._v("2024")]), _vm._v(" "), _c('option', [_vm._v("2025")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cvv"
    }
  }, [_vm._v("CVV/CVC")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "cvv",
      "placeholder": "123"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Company")]), _vm._v(" "), _c('small', [_vm._v("Form")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "company",
      "placeholder": "Enter your company name"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "vat"
    }
  }, [_vm._v("VAT")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "vat",
      "placeholder": "PL1234567890"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "street"
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "street",
      "placeholder": "Enter street name"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-8"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "city",
      "placeholder": "Enter your city"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "postal-code"
    }
  }, [_vm._v("Postal Code")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "postal-code",
      "placeholder": "Postal Code"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "country",
      "placeholder": "Country name"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Basic Form")]), _vm._v(" Elements\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Static")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("Username")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "text-input"
    }
  }, [_vm._v("Text Input")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "text-input",
      "name": "text-input",
      "placeholder": "Text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("This is a help text")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "email-input"
    }
  }, [_vm._v("Email Input")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email-input",
      "name": "email-input",
      "placeholder": "Enter Email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter your email")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "password-input"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password-input",
      "name": "password-input",
      "placeholder": "Password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter a complex password")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "disabled-input"
    }
  }, [_vm._v("Disabled Input")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "disabled-input",
      "name": "disabled-input",
      "placeholder": "Disabled",
      "disabled": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "textarea-input"
    }
  }, [_vm._v("Textarea")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "id": "textarea-input",
      "name": "textarea-input",
      "rows": "9",
      "placeholder": "Content.."
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "select",
      "name": "select"
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Please select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option #1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option #2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Option #3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Select Large")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    staticClass: "form-control form-control-lg",
    attrs: {
      "id": "select",
      "name": "select"
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Please select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option #1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option #2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Option #3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Select Small")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "id": "select",
      "name": "select"
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Please select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option #1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option #2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Option #3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Disabled Select")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "disabledSelect",
      "disabled": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Please select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option #1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option #2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Option #3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "multiple-select"
    }
  }, [_vm._v("Multiple select")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "multiple-select",
      "name": "multiple-select",
      "size": "5",
      "multiple": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option #1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option #2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Option #3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Option #4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Option #5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Option #6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Option #7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Option #8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Option #9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Option #10")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Radios")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "for": "radio1"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "radio1",
      "name": "radios",
      "value": "option1"
    }
  }), _vm._v(" Option 1\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "for": "radio2"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "radio2",
      "name": "radios",
      "value": "option2"
    }
  }), _vm._v(" Option 2\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "for": "radio3"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "radio3",
      "name": "radios",
      "value": "option3"
    }
  }), _vm._v(" Option 3\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Inline Radios")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "inline-radio1"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "inline-radio1",
      "name": "inline-radios",
      "value": "option1"
    }
  }), _vm._v(" One\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "inline-radio2"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "inline-radio2",
      "name": "inline-radios",
      "value": "option2"
    }
  }), _vm._v(" Two\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "inline-radio3"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "inline-radio3",
      "name": "inline-radios",
      "value": "option3"
    }
  }), _vm._v(" Three\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Checkboxes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    attrs: {
      "for": "checkbox1"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "checkbox1",
      "name": "checkbox1",
      "value": "option1"
    }
  }), _vm._v(" Option 1\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    attrs: {
      "for": "checkbox2"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "checkbox2",
      "name": "checkbox2",
      "value": "option2"
    }
  }), _vm._v(" Option 2\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    attrs: {
      "for": "checkbox3"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "checkbox3",
      "name": "checkbox3",
      "value": "option3"
    }
  }), _vm._v(" Option 3\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Inline Checkboxes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "checkbox-inline",
    attrs: {
      "for": "inline-checkbox1"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "inline-checkbox1",
      "name": "inline-checkbox1",
      "value": "option1"
    }
  }), _vm._v("One\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline",
    attrs: {
      "for": "inline-checkbox2"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "inline-checkbox2",
      "name": "inline-checkbox2",
      "value": "option2"
    }
  }), _vm._v("Two\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline",
    attrs: {
      "for": "inline-checkbox3"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "inline-checkbox3",
      "name": "inline-checkbox3",
      "value": "option3"
    }
  }), _vm._v("Three\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "file-input"
    }
  }, [_vm._v("File input")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "file-input",
      "name": "file-input"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "file-multiple-input"
    }
  }, [_vm._v("Multiple File input")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "file-multiple-input",
      "name": "file-multiple-input",
      "multiple": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Inline")]), _vm._v(" Form\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-inline",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputName2"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "exampleInputName2",
      "placeholder": "Jane Doe"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputEmail2"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "exampleInputEmail2",
      "placeholder": "jane.doe@example.com"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Horizontal")]), _vm._v(" Form\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "hf-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "hf-email",
      "name": "hf-email",
      "placeholder": "Enter Email.."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter your email")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label",
    attrs: {
      "for": "hf-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "hf-password",
      "name": "hf-password",
      "placeholder": "Enter Password.."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter your password")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Normal")]), _vm._v(" Form\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "nf-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "nf-email",
      "name": "nf-email",
      "placeholder": "Enter Email.."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter your email")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "nf-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "nf-password",
      "name": "nf-password",
      "placeholder": "Enter Password.."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter your password")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Input "), _c('strong', [_vm._v("Grid")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-3"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-6"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-7"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-8"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-9"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-10"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-11"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-11"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-sm-12"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Login")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Input "), _c('strong', [_vm._v("Sizes")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-5 form-control-label",
    attrs: {
      "for": "input-small"
    }
  }, [_vm._v("Small Input")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "id": "input-small",
      "name": "input-small",
      "placeholder": ".form-control-sm"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-5 form-control-label",
    attrs: {
      "for": "input-normal"
    }
  }, [_vm._v("Normal Input")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "input-normal",
      "name": "input-normal",
      "placeholder": "Normal"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-5 form-control-label",
    attrs: {
      "for": "input-large"
    }
  }, [_vm._v("Large Input")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "input-large",
      "name": "input-large",
      "placeholder": ".form-control-lg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Validation states")]), _vm._v(" Form\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group has-success"
  }, [_c('label', {
    staticClass: "form-form-control-label",
    attrs: {
      "for": "inputSuccess1"
    }
  }, [_vm._v("Input with success")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSuccess1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-warning"
  }, [_c('label', {
    staticClass: "form-form-control-label",
    attrs: {
      "for": "inputWarning1"
    }
  }, [_vm._v("Input with warning")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWarning1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-danger"
  }, [_c('label', {
    staticClass: "form-form-control-label",
    attrs: {
      "for": "inputError1"
    }
  }, [_vm._v("Input with error")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputError1"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Validation states")]), _vm._v(" with optional icons\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group has-success"
  }, [_c('label', {
    staticClass: "form-form-control-label",
    attrs: {
      "for": "inputSuccess2"
    }
  }, [_vm._v("Input with success")]), _vm._v(" "), _c('input', {
    staticClass: "form-control form-control-success",
    attrs: {
      "type": "text",
      "id": "inputSuccess2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-warning"
  }, [_c('label', {
    staticClass: "form-form-control-label",
    attrs: {
      "for": "inputWarning2"
    }
  }, [_vm._v("Input with warning")]), _vm._v(" "), _c('input', {
    staticClass: "form-control form-control-warning",
    attrs: {
      "type": "text",
      "id": "inputWarning2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-danger has-feedback"
  }, [_c('label', {
    staticClass: "form-form-control-label",
    attrs: {
      "for": "inputError2"
    }
  }, [_vm._v("Input with error")]), _vm._v(" "), _c('input', {
    staticClass: "form-control form-control-danger",
    attrs: {
      "type": "text",
      "id": "inputError2"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Icon/Text")]), _vm._v(" Groups\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "input1-group1",
      "name": "input1-group1",
      "placeholder": "Username"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "input2-group1",
      "name": "input2-group1",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-euro"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "input3-group1",
      "name": "input3-group1",
      "placeholder": ".."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Buttons")]), _vm._v(" Groups\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "input1-group2",
      "name": "input1-group2",
      "placeholder": "Username"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "input2-group2",
      "name": "input2-group2",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Submit")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "input3-group2",
      "name": "input3-group2",
      "placeholder": "Search"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Dropdowns")]), _vm._v(" Groups\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Use the grid for big devices! "), _c('small', [_c('code', [_vm._v(".col-lg-*")]), _vm._v(" "), _c('code', [_vm._v(".col-md-*")]), _vm._v(" "), _c('code', [_vm._v(".col-sm-*")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-md-8"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-md-4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-md-7"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-md-5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-md-6"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-md-6"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-md-5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-md-7"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-md-4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-md-8"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Input Grid for small devices! "), _c('small', [_c('code', [_vm._v(".col-*")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-8"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-7"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-6"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-6"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-8"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ".col-4"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Example Form\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username3",
      "name": "username3"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email3",
      "name": "email3"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password3",
      "name": "password3"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-asterisk"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-actions"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Example Form\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username2",
      "name": "username2",
      "placeholder": "Username"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email2",
      "name": "email2",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password2",
      "name": "password2",
      "placeholder": "Password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-asterisk"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-actions"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Example Form\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username",
      "name": "username",
      "placeholder": "Username"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": "Email"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-asterisk"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "password",
      "placeholder": "Password"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-actions"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v("Form Elements\n          "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    staticClass: "btn-setting",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-settings"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-minimize",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-arrow-up"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-2orizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "prependedInput"
    }
  }, [_vm._v("Prepended text")]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "input-prepend input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("@")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "prependedInput",
      "size": "16",
      "type": "text"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_vm._v("Here's some help text")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "appendedInput"
    }
  }, [_vm._v("Appended text")]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "appendedInput",
      "size": "16",
      "type": "text"
    }
  }), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Here's more help text")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "appendedPrependedInput"
    }
  }, [_vm._v("Append and prepend")]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "input-prepend input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "appendedPrependedInput",
      "size": "16",
      "type": "text"
    }
  }), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "appendedInputButton"
    }
  }, [_vm._v("Append with button")]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "appendedInputButton",
      "size": "16",
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Go!")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "appendedInputButtons"
    }
  }, [_vm._v("Two-button append")]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "appendedInputButtons",
      "size": "16",
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Options")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])])])])])])])
}]}

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [(_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('dashboard');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.isActive()
    },
    attrs: {
      "to": {
        path: '/dashboard',
        query: _vm.$route.query
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.dashboard')) + " "), (!_vm.isActive()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": [function($event) {
        _vm.checkFeature('calendar');
        _vm.handleMenuClick($event)
      }, function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }]
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/appointment',
        query: {
          status: 'pending',
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-clock"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.appointment_pending')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPending) ? _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v(_vm._s(_vm.pendingSize))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('calendar');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/appointments',
        query: {
          status: 'scheduled',
          viewType: 'daily',
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.appointments')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('calendar');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/appointments',
        query: {
          status: 'scheduled',
          viewType: 'daily',
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.appointments')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('leave');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.isActive()
    },
    attrs: {
      "to": {
        path: '/clinic/leave',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-times-o"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.clinic_leave')) + " "), (!_vm.isActive()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('leave');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": '/doctor/leave'
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-times-o"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.clinic_leave')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/broadcast',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.sms_broadcast')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor() || _vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/article',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.article')) + " ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor() || _vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('feedback');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/feedback',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.feedback')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor() || _vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('report');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/report',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.report')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('patient');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/patient',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.patient')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item nav-dropdown active open",
    attrs: {
      "tag": "li",
      "to": {
        path: ''
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle"
  }, [_c('i', {
    staticClass: "fa fa-hospital-o"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.clinic_info')))]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/clinic/general',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.menu.clinic_information')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/clinic/clinic_address',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.menu.clinic_address')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/clinic/schedules',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('message.menu.clinic_schedule')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/clinic/services',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('message.menu.clinic_services')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('settings');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.isActive()
    },
    attrs: {
      "to": {
        path: '/clinic/setting',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('message.menu.clinic_settings')) + " "), (!_vm.isActive()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/doctor/step1/me'
    }
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.doctor')) + " ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/doctor/setting'
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.clinic_settings')) + " ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/clinic/doctors',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.doctors')) + " ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": _vm.handleMenuClick
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": _vm.clinicUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.clinic_view')) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": _vm.handleMenuClick
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": _vm.doctorUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.doctor_view')) + " ")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": _vm.signout
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.sign_out')))])])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "lockModal",
    attrs: {
      "icon": "info",
      "title": "ฟังชั้นนี้ถูกปิดการใช้งานอยู่",
      "overlay-theme": "dark"
    }
  }, [_c('p', [_vm._v("ฟังชั้นนี้ถูกปิดการใช้งานอยู่ ต้องการปลดล๊อกกรุณากดปุ่ม unlock ด้านล่าง")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.gotoPlanPage()
      }
    }
  }, [(!_vm.isActive()) ? _c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" Unlock")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audio', {
    attrs: {
      "src": "/static/audio/notification.mp3",
      "preload": "auto",
      "id": "player"
    }
  }, [_c('p', [_vm._v("Your browser does not support the "), _c('code', [_vm._v("audio")]), _vm._v(" element.")])])
}]}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.clinic.step_title')))]), _vm._v(" "), _c('step-bar', {
    attrs: {
      "currentStep": _vm.currentStepNumber,
      "maxStep": 5
    },
    on: {
      "step_clicked": _vm.gotoStep
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic.step_info')))]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic.step_address')))]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic.step_schedule')))]), _vm._v(" "), _c('div', {
    slot: "4"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic.step_services')))]), _vm._v(" "), _c('div', {
    slot: "5"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic.step_doctors')))])])], 1), _vm._v(" "), (_vm.clinicReady) ? _c('div', {
    staticClass: "component-wrapper"
  }, [_c(_vm.currentStep, {
    tag: "component",
    attrs: {
      "clinic": _vm.clinic
    },
    on: {
      "update:clinic": function($event) {
        _vm.clinic = $event
      },
      "finishStep": _vm.finishStep,
      "cancelChange": _vm.cancelChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "icon": "success"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.clinic.create_clinic_success')))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body clinic-leave-wrapper"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [(_vm.isEditMode) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.leave.title_edit')))]) : _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.leave.title_add')))])]), _vm._v(" "), (_vm.preLoaded) ? _c('div', {
    staticClass: "leave-form"
  }, [(_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('message.leave.doctor')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "doctor",
      "placeholder": _vm.$t('message.leave.doctor_placeholder'),
      "options": _vm.doctor_options,
      "allow-empty": true,
      "disabled": _vm.isEditMode,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.leave.doctor),
      callback: function($$v) {
        _vm.leave.doctor = $$v
      },
      expression: "leave.doctor"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.doctor_id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('div', {
    staticClass: "form-divider"
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "allDayCheckBox"
  }, [_c('div', {
    staticClass: "squaredThree"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leave.all_day),
      expression: "leave.all_day"
    }],
    attrs: {
      "type": "checkbox",
      "value": "None",
      "id": "allday"
    },
    domProps: {
      "checked": Array.isArray(_vm.leave.all_day) ? _vm._i(_vm.leave.all_day, "None") > -1 : (_vm.leave.all_day)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.leave.all_day,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "None",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.leave.all_day = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.leave.all_day = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.leave.all_day = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "allday"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "allDayLabel"
  }, [_vm._v(_vm._s(_vm.$t('message.leave.all_time')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('message.leave.leave_date')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    attrs: {
      "placeholder": _vm.$t('message.leave.leave_date_placeholder'),
      "config": _vm.fpConfig
    },
    model: {
      value: (_vm.selectedDateTime.start_date),
      callback: function($$v) {
        _vm.selectedDateTime.start_date = $$v
      },
      expression: "selectedDateTime.start_date"
    }
  })], 1), _vm._v(" "), (!_vm.leave.all_day) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    attrs: {
      "placeholder": _vm.$t('message.leave.leave_time_placeholder'),
      "config": _vm.fpTimeConfig
    },
    model: {
      value: (_vm.selectedDateTime.start_time),
      callback: function($$v) {
        _vm.selectedDateTime.start_time = $$v
      },
      expression: "selectedDateTime.start_time"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.start_time
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('message.leave.to')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    attrs: {
      "placeholder": _vm.$t('message.leave.leave_date_placeholder'),
      "config": _vm.fpConfig
    },
    model: {
      value: (_vm.selectedDateTime.end_date),
      callback: function($$v) {
        _vm.selectedDateTime.end_date = $$v
      },
      expression: "selectedDateTime.end_date"
    }
  })], 1), _vm._v(" "), (!_vm.leave.all_day) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    attrs: {
      "placeholder": _vm.$t('message.leave.leave_time_placeholder'),
      "config": _vm.fpTimeConfig
    },
    model: {
      value: (_vm.selectedDateTime.end_time),
      callback: function($$v) {
        _vm.selectedDateTime.end_time = $$v
      },
      expression: "selectedDateTime.end_time"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.end_time
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "label": _vm.$t('message.leave.remark'),
      "placeholder": _vm.$t('message.leave.remark')
    },
    model: {
      value: (_vm.leave.description),
      callback: function($$v) {
        _vm.leave.description = $$v
      },
      expression: "leave.description"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": _vm.cancelLeave
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": _vm.addLeave
    }
  }, [_vm._v(_vm._s(_vm.isEditMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.add')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1), _vm._v(" "), (_vm.isEditMode) ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-leave-action",
    on: {
      "click": _vm.removeLeave
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])], 1) : _c('div', {
    staticClass: "btn btn-sm text-center detail-loader"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('div', {
    staticClass: "animated fadeIn setting-container step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.settings.title')))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.settings.feedback')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.show_review),
      expression: "doctor.show_review"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.doctor.show_review) ? _vm._i(_vm.doctor.show_review, null) > -1 : (_vm.doctor.show_review)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.doctor.show_review,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.doctor.show_review = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.doctor.show_review = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.doctor.show_review = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.show_feedback')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.settings.search')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group premium-feature",
    class: {
      'disable': !_vm.$guser.isPremiumAccount()
    }
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.search_active),
      expression: "doctor.search_active"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.$guser.isPremiumAccount()
    },
    domProps: {
      "checked": Array.isArray(_vm.doctor.search_active) ? _vm._i(_vm.doctor.search_active, null) > -1 : (_vm.doctor.search_active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.doctor.search_active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.doctor.search_active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.doctor.search_active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.doctor.search_active = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.settings.search_display')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm",
    slot: "loader"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "icon": "success"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container plan-payment"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v("รายละเอียดบริการ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.doctor.subscriptions), function(sub) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(sub.id))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.plans[sub.plan_id - 1].name)), _c('br'), _vm._v("\n                  " + _vm._s(_vm.plans[sub.plan_id - 1].detail)), _c('br'), _vm._v("\n                  " + _vm._s(_vm.plans[sub.plan_id - 1].duration)), _c('br')]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sub.started_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sub.expired_at))]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _vm._m(3, true)])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("My subscription")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Detail")]), _vm._v(" "), _c('th', [_vm._v("Start Date")]), _vm._v(" "), _c('th', [_vm._v("Expired Date")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Bill")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v(" Active")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Receipt")])])
}]}

/***/ }),
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[490]);


// WEBPACK FOOTER //
// static/js/app.1bb9683c0629cb42e69b.js